webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(80);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(178), __esModule: true };

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177).Buffer))

/***/ }),
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(5);
var normalizeHeaderName = __webpack_require__(154);
var enhanceError = __webpack_require__(77);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(74);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(74);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(108)))

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(277)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(179), __esModule: true };

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(185), __esModule: true };

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(84);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(23)
  , TAG = __webpack_require__(4)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(49)
  , ITERATOR  = __webpack_require__(4)('iterator')
  , Iterators = __webpack_require__(21);
module.exports = __webpack_require__(2).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var settle = __webpack_require__(147);
var cookies = __webpack_require__(150);
var buildURL = __webpack_require__(81);
var buildFullPath = __webpack_require__(145);
var parseHeaders = __webpack_require__(155);
var isURLSameOrigin = __webpack_require__(153);
var createError = __webpack_require__(76);
var defaults = __webpack_require__(30);
var Cancel = __webpack_require__(29);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(77);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.24.0"
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_number_is_integer__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_object_keys__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_object_keys__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "models", function() { return models; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "crc16", function() { return crc16; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hex", function() { return hex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unhex", function() { return unhex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyValid", function() { return keyValid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return validate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "frame", function() { return frame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseQuery", function() { return parseQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseAck", function() { return parseAck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backup", function() { return backup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restore", function() { return restore; });







var models = {
  B3: { keys: 3, text: 30, label: '3 键' },
  B4: { keys: 4, text: 10, label: '长条 4 键' },
  C4: { keys: 4, text: 10, label: '4 键旋钮', knob: true },
  B6: { keys: 6, text: 10, label: '6 键' }
};
__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_object_keys___default()(models).forEach(function (type) {
  var m = models[type];m.type = type;m.baseLength = m.keys * (m.text + 9) + 2;m.length = m.baseLength + (m.knob ? 24 : 0);m.textOff = m.keys * 3;m.mixOff = m.textOff + m.keys * m.text;m.lightOff = m.mixOff + m.keys * 5;m.brightnessOff = m.lightOff + m.keys + 1;if (m.knob) {
    m.knobOff = m.baseLength;m.knobMixOff = m.knobOff + 9;
  }
});
function crc16(bytes) {
  var crc = 65535;var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator___default()(bytes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var v = _step.value;
      crc ^= v << 8;for (var j = 0; j < 8; j++) {
        crc = (crc & 32768 ? crc << 1 ^ 0x1021 : crc << 1) & 65535;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return crc;
}
function hex(bytes) {
  return __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(bytes, function (v) {
    return v.toString(16).padStart(2, '0').toUpperCase();
  }).join('');
}
function unhex(s) {
  if (!/^(?:[0-9A-F]{2})+$/i.test(s)) throw Error('配置数据不是有效十六进制');return Uint8Array.from(s.match(/../g), function (v) {
    return parseInt(v, 16);
  });
}
function keyValid(v) {
  return v === 255 || v >= 32 && v <= 126 || v >= 128 && v <= 135 || v >= 176 && v <= 179 || v >= 193 && v <= 235 || v === 237 || v >= 240 && v <= 251;
}
function validate(type, p) {
  var m = models[type];if (!m || !p || p.length !== m.length) throw Error('配置型号或长度不匹配');
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator___default()(p), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var v = _step2.value;
      if (!__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_number_is_integer___default()(v) || v < 0 || v > 255) throw Error('配置包含无效字节');
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  for (var i = 0; i < m.keys; i++) {
    var f = p[m.keys + i],
        _v = p[2 * m.keys + i];
    if (f > 4 || _v !== 255 && _v > 3) throw Error('按键 ' + (i + 1) + ' 的功能参数无效');
    if (f === 0 && !keyValid(p[i])) throw Error('按键 ' + (i + 1) + ' 的键码不受支持');
    if ((f === 2 || f === 3) && p[i] !== 255) throw Error('按键 ' + (i + 1) + ' 的配置格式错误');
    if (f === 4 && ![1, 2, 4].includes(p[i])) throw Error('鼠标键码错误');
  }
  for (var _i = m.textOff; _i < m.mixOff; _i++) {
    var _v2 = p[_i];if (_v2 !== 255 && (_v2 < 32 || _v2 > 126) && ![9, 10, 13].includes(_v2)) throw Error('字符串包含不受支持字符，字节偏移 ' + _i);
  }
  for (var _i2 = m.mixOff; _i2 < m.lightOff; _i2++) {
    if (!keyValid(p[_i2])) throw Error('组合键包含未知或不可打印键码，字节偏移 ' + _i2);
  }if (p[m.lightOff] > 4) throw Error('灯效模式错误');
  for (var _i3 = 1; _i3 <= m.keys; _i3++) {
    if (p[m.lightOff + _i3] > 7) throw Error('灯光颜色错误');
  }if (m.knob) {
    for (var _i4 = 0; _i4 < 3; _i4++) {
      var off = m.knobOff + _i4 * 3,
          _v3 = p[off],
          _f = p[off + 1],
          x = p[off + 2];
      if (_f > 5) throw Error('旋钮动作 ' + (_i4 + 1) + ' 的功能类型错误');
      if ((_f === 0 || _f === 2) && (!keyValid(_v3) || x !== 255)) throw Error('旋钮键盘动作格式错误');
      if (_f === 1 && (_v3 === 255 || x !== 255 && x > 3)) throw Error('旋钮多媒体动作格式错误');
      if (_f === 3 && (_v3 > 1 || x !== 255)) throw Error('旋钮滚轮动作格式错误');
      if (_f === 4 && (![1, 2, 4].includes(_v3) || x !== 255 && x > 3)) throw Error('旋钮鼠标动作格式错误');
      if (_f === 5 && (_v3 !== 255 || x !== 255)) throw Error('旋钮组合键格式错误');
    }
    for (var _i5 = m.knobMixOff; _i5 < m.length; _i5++) {
      if (!keyValid(p[_i5])) throw Error('旋钮组合键包含无效键码');
    }
  }
  return p;
}
function frame(type, p) {
  validate(type, p);var body = Uint8Array.from([7, parseInt(type, 16), p.length].concat(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray___default()(p))),
      crc = crc16(body);return Uint8Array.from([2].concat(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray___default()(body), [crc & 255, crc >> 8, 3]));
}
function parseQuery(line) {
  var x = /^Q62:(B3|B4|C4|B6):([0-9A-F]{2}):([0-9A-F]+):([0-9A-F]{4})$/i.exec(line);
  if (!x) throw Error('回复格式不匹配。此网页仅支持三键、长条四键、四键旋钮和六键 V6.2 配套测试固件');
  var type = x[1].toUpperCase(),
      status = parseInt(x[2], 16),
      payload = unhex(x[3]);
  if (status > 3) throw Error('未知存储状态');
  if (crc16([parseInt(type, 16), 7, status].concat(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_toConsumableArray___default()(payload))) !== parseInt(x[4], 16)) throw Error('设备回读 CRC 校验失败');
  validate(type, payload);return { type: type, status: status, payload: payload };
}
function parseAck(line) {
  var messages = { C: '配置传输校验失败', V: '设备拒绝了无效配置', W: '写入或回读验证失败；原运行设置未切换，但 Flash 可能已进入恢复状态', B: '请松开所有按键并等待鼠标连点结束后重试', F: '配置帧不完整' };
  if (line === 'S62:1') return true;
  var x = /^S62:([CVWBF])$/.exec(line);if (x) throw Error(messages[x[1]]);
  throw Error('保存回复格式错误');
}
function backup(type, payload, status) {
  validate(type, payload);return { format: 'keypad-config', version: 1, deviceType: type, firmwareProtocol: 7, storageStatus: status, createdAt: new Date().toISOString(), payload: __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(payload), crc16: hex([crc16(payload) >> 8, crc16(payload) & 255]) };
}
function restore(value, type) {
  if (!value || value.format !== 'keypad-config' || value.version !== 1 || value.deviceType !== type) throw Error('备份格式或设备型号不匹配');
  if (!Array.isArray(value.payload)) throw Error('备份缺少配置');
  validate(type, value.payload);
  var expected = hex([crc16(value.payload) >> 8, crc16(value.payload) & 255]);
  if (value.crc16 !== expected) throw Error('备份校验失败');
  return Uint8Array.from(value.payload);
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(183), __esModule: true };

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(46);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(258);


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(21)
  , ITERATOR   = __webpack_require__(4)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(10);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(4)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(24)
  , invoke             = __webpack_require__(194)
  , html               = __webpack_require__(87)
  , cel                = __webpack_require__(51)
  , global             = __webpack_require__(6)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(23)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__);


var _index;

/* harmony default export */ __webpack_exports__["a"] = ({
    index: (_index = {
        pageTitle: 'USB Custom Keyboard Configuration Tool',
        more: 'More',
        about: 'About',
        aboutBuildTime: 'Program build time: ',
        factoryTest: 'Factory Test',
        readStatus: 'Read status',
        autoRefresh: 'Auto refresh 0.5s',
        factoryLedTip: 'Observe the keyboard LEDs: normally red/green should alternate slowly every 0.5 s. If one LED is off, check the corresponding LED.',
        factoryAbnormal: 'Abnormal: no IO connection detected (no key / no USB / no charging / battery below 2V)',
        factoryPassPrefix: 'Passed: all ',
        factoryPassSuffix: ' keys pressed, battery OK',
        factoryItem: 'Item',
        factoryValue: 'Status',
        factoryResult: 'Result',
        factoryPassShort: 'Pass',
        factoryFailShort: 'Fail',
        factoryWait: 'Waiting',
        factoryNote: 'Protocol: send 02 46, device returns FT1 status. Supports D2 BLE 2-key / D6 3-mode 6-key / D9 9-key firmware.',
        factoryKey: 'Key ',
        factoryPressed: 'Pressed',
        factoryReleased: 'Released',
        factoryReleasedDetected: 'Released (detected)',
        factoryBatteryAdc: 'Battery ADC',
        factoryUsbVcc: 'USB VCC pin',
        factoryUsbHigh: 'High / USB present',
        factoryUsbLow: 'Low / no USB',
        factoryCharging: 'Charging',
        factoryNotCharging: 'Not charging',
        factoryLedRed: 'Red LED',
        factoryLedGreen: 'Green LED',
        factoryOn: 'On',
        factoryOff: 'Off',
        factoryBle: 'BLE connection',
        factoryConnected: 'Connected',
        factoryDisconnected: 'Disconnected',
        factoryRf24: '2.4G connection',
        factoryNotEnabled: 'Not enabled',
        factoryPaRaw: 'PA raw',
        factoryPbRaw: 'PB raw',
        factoryMode: 'Mode',
        schematicTitle: 'Key layout',
        knobLabel: 'Knob',
        firmware1: 'Firmware 1',
        firmware2: 'Firmware 2',
        firmware3: 'Firmware 3',
        firmware4: 'Firmware 4',
        videoTitle: '3-key video tutorial',
        videoUnsupported: 'Your browser does not support video playback',
        connectionTip1: 'Note: 3-mode wireless keyboard configuration requires connecting the keyboard with a USB cable. Select',
        connectionTip2: 'or',
        connectionTip3: ', do not select',
        connectionTip4: '(this is the receiver).',
        factoryConnectFirst: 'Connect the device first',
        connecting: 'Connecting to keyboard…',
        selectSerialPort: 'Select the serial port and wait for the device to respond',
        errPageConfig: 'The key configuration area for this model could not be created',
        errReplyTimeoutUnknown: 'Device response timed out. Reconnect and retry; the save result is unknown.',
        errDisconnected: 'Device disconnected',
        errEmptyReply: 'Device returned an empty response',
        errReadbackMismatch: 'Stored readback does not match the saved configuration; save cannot be confirmed.',
        errConfirmTimeout: 'Timed out waiting for device confirmation. Reconnect and retry.',
        errNoAck: 'No device confirmation received. Reconnect and retry.',
        errFactoryFormat: 'Invalid factory test response: ',
        errNoResponse: 'No response from device. Reconnect and retry.',
        back: 'Back',
        loopInterval: 'Loop Interval',
        helpTitle: 'Help',
        helpTips0: 'Introduction of 5 key modes:',
        helpTips1: '1.Common key:Define a key of the 3-key keyboard as a common key that can be input, such as 1, 2, 3, a, b, c, ?, space, etc.',
        helpTips1_1: 'Note: If you input uppercase letters or !@#$% keys, it is actually triggered by Shift+corresponding keys!',
        helpTips2: '2.Function key:Define a key on the 3-key keyboard as a function key such as Ctrl, Alt, Win, Command, and Enter',
        helpTips2_1: 'F13-F24 are special function keys, which are not available on ordinary keyboards, and can be used as custom shortcut keys in the software to prevent conflicts!',
        helpTips3: '3.Media key:Define a key on the 3-key keyboard as a media key such as volume up, brightness up, and open browser',
        helpTips4: '4.Combination key:Define a key on a 3-key keyboard as a combination of 2-5 keys, such as one-key Ctrl+c, one-key Win+l, one-key Ctrl+Alt+Delete, etc.',
        helpTips5: '5.String:Define a button of the 3-key keyboard as an input string, such as one-key input user name, one-key input select * from, etc.',
        helpTips6: '6.Mouse:Define a button of the 3-key keyboard as mouse button click, mouse movement, scroll wheel, etc.',
        helpButton: 'Help',
        troubleshootTitle: 'Keyboard not responding? Troubleshoot step by step',
        troubleshoot1: 'Browser',
        troubleshoot1_desc: 'Must use Chrome or Edge (version 103+), accessed via https or localhost; Safari and Firefox do not support serial ports and cannot connect.',
        troubleshoot2: 'Access Method',
        troubleshoot2_desc: 'Do not open the HTML file directly by double-clicking (file:// cannot use serial ports), please access via URL.',
        troubleshoot3: '"Connect" button does not pop up selection window',
        troubleshoot3_desc: 'Most likely a USB cable issue — try a different cable (some cables only charge, not transfer data), try a different USB port, and plug directly into the host if possible, avoiding docking stations.',
        troubleshoot4: 'Device not found in pop-up',
        troubleshoot4_desc: 'Confirm the system has recognized the serial device (VID 0x1209 / PID 0xC550), then try reconnecting the keyboard.',
        troubleshoot5: 'Port occupied, connection failed',
        troubleshoot5_desc: 'Close programs that may occupy the serial port (serial assistant, Arduino IDE, other programming/key remapping tools) and try again.',
        troubleshoot6: 'Connected successfully but cannot read configuration / firmware out of date',
        troubleshoot6_desc: 'Update the firmware as prompted before configuring.',
        troubleshoot7: 'Abnormal after multiple plug/unplug',
        troubleshoot7_desc: 'Refresh the page (F5), reconnect the keyboard, and try again.',
        windowsTipsTitle: 'Windows / Company Computer Tips',
        windowsTips1: 'When the bottom-right shows "Unknown USB device", it means Windows failed to read device information — this is not a web configuration or browser issue; try a direct USB port, a known-good cable, and test on another computer.',
        windowsTips2: 'If only the company computer cannot recognize it while other computers work fine, contact your IT department to check USB device control or whitelist; do not disable USB Root Hub or USB Controller system devices.',
        windowsTips3: 'When "Unknown USB device" appears in Device Manager, right-click and select "Uninstall device" then reconnect; if the option "Delete the driver software for this device" appears, do NOT check it.',
        windowsTips4: 'After saving parameters, it is recommended to reconnect the keyboard, then use an online keyboard tester to confirm the keys work as expected.',
        macTipsTitle: 'Mac User Configuration Notes',
        macTips1: 'Browser',
        macTips1_desc: 'Use Mac version Chrome or Edge (103+), Safari does not support serial port connection.',
        macTips2: 'Modifier Key Mapping',
        macTips2_desc: 'Mac\'s Command (⌘) and Windows\' Win use the same keycode; select "Left Win/Command" when configuring.',
        macTips3: 'Copy/Paste',
        macTips3_desc: 'Windows uses Ctrl+C/V, Mac uses Command+C/V (in combination key mode, select "Left Win/Command" + c/v; there are also Mac presets in "Common Shortcuts").',
        macTips4: 'Lock Screen',
        macTips4_desc: 'Windows uses Win+L, Mac uses Control+Command+Q (see "Mac Lock Screen" in "Common Shortcuts").',
        macTips5: 'Screenshot',
        macTips5_desc: 'Windows uses Win+Shift+S, Mac uses Shift+Command+3/4 (see "Mac Quick Screenshot" in "Common Shortcuts").',
        macTips6: 'First Connection',
        macTips6_desc: 'A serial port authorization window will pop up on first connection; select the device and click Allow. If no pop-up appears, your browser version may be too old.',
        connButtonText1: 'Connect Custom Keyboard',
        timerConfig: 'Timer Trigger Configuration',
        triggerMode: 'Trigger Mode',
        triggerModeManual: 'Manual Trigger',
        triggerModeTimer: 'Timer Trigger',
        triggerModeBoth: 'Manual & Timer Trigger',
        hour: 'Hour',
        minute: 'Minute',
        second: 'Second',
        keyAllLabel: 'When the 3 keys are pressed at the same time, they act as an independent keys',
        keyAllTrue: 'On',
        keyAllFalse: 'Off',
        b3key1: 'Key1',
        b3key2: 'Key2',
        b3key3: 'Key3',
        b3keyall: 'All Keys',
        deviceTypeLabel: 'Device Type',
        deviceVersionLabel: 'Firmware Version',
        configSeqLabel: 'Config Sequence',
        backlightTitle: 'Backlight',
        backlightMode: 'Mode',
        backlightMode0: 'Off',
        backlightMode1: 'Always On',
        backlightMode2: 'Press On',
        backlightMode3: 'Flowing',
        backlightMode4: 'Breathing',
        backlightColor1: 'LED 1 Color',
        backlightColor2: 'LED 2 Color',
        backlightColor3: 'LED 3 Color',
        backlightBrightness: 'Brightness',
        colorBlue: 'Blue',
        colorGreen: 'Green',
        colorRed: 'Red',
        colorYellow: 'Yellow',
        colorCyan: 'Cyan',
        colorPurple: 'Purple',
        colorWhite: 'White',
        keyTestLabel: 'Keyboard Key Test Online',
        keyTestUrl: 'https://keyboard.bmcx.com/',
        keyTestLabel2: 'Online Keyboard Test',
        keyTestUrl2: 'https://www.853295.com/',
        keyTestLabel3: 'Mouse Button Test',
        keyTestUrl3: 'https://cps-check.com/cn/mouse-buttons-test',
        keyTestLabel4: 'Mouse Test Tool',
        keyTestUrl4: 'https://www.mousetester.cn/',
        keyTestPrompt: 'Click to go to online keyboard test website →',
        c4key1: 'Key 1',
        c4key2: 'Key 2',
        c4key3: 'Key 3',
        c4key4: 'Key 4',
        ec11Title: 'Knob Settings',
        ec11CW: 'CW Rotation',
        ec11CCW: 'CCW Rotation',
        ec11Btn: 'Button Press',
        ec11FuncKey: 'Keyboard',
        ec11FuncMedia: 'Media',
        ec11FuncMouse: 'Mouse Click',
        ec11FuncFn: 'Function Key',
        ec11FuncScroll: 'Mouse Wheel',
        ec11FuncMix: 'Combination Key',
        ec11ScrollUp: 'Scroll Up',
        ec11ScrollDown: 'Scroll Down',
        ec11KeyCode: 'Key Code',
        ec11MouseLeft: 'Left',
        ec11MouseMiddle: 'Middle',
        ec11MouseRight: 'Right',
        ec11ClickSingle: 'Single Click',
        ec11ClickContinuous: 'Continuous Click',
        ec11ClickPress: 'Press',
        backlightColor4: 'LED 4 Color',
        b6key1: 'Key 1',
        b6key2: 'Key 2',
        b6key3: 'Key 3',
        b6key4: 'Key 4',
        b6key5: 'Key 5',
        b6key6: 'Key 6',
        backlightColor5: 'LED 5 Color',
        backlightColor6: 'LED 6 Color',
        b4key1: 'Key 1',
        b4key2: 'Key 2',
        b4key3: 'Key 3',
        b4key4: 'Key 4',
        d2key1: 'Key 1',
        d2key2: 'Key 2',
        d2RunModeTitle: 'Bluetooth Mode',
        d2RunMode: 'Run Mode',
        d2RunModeKeyboard: 'Keyboard Mode',
        d2RunModePage: 'Page Mode',
        d2ModeTipKbd: 'Keyboard Mode: ',
        d2ModeTipKbdDesc: 'Both USB and Bluetooth work, can connect to a PC or phone as a standard keyboard;',
        d2ModeTipPage: 'Page Mode: ',
        d2ModeTipPageDesc: 'Mainly for Bluetooth connection to mobile devices for page-turning / swiping / media control.',
        d2PageAction: 'Page Action',
        d2PagePrev: 'Volume Keys',
        d2PageNext: 'Left/Right Swipe',
        d2PagePlayPause: 'Up/Down Scroll',
        d2PageHome: 'Music Control',
        d2PageTableTitle: 'Page Action Description',
        d2TableFirmware: 'Firmware',
        d2TableFunction: 'Function',
        d2TableScenario: 'Usage Scenario',
        d2Firm1Func: 'Volume Key Control',
        d2Firm1Scenario: 'Turn pages on Android/HarmonyOS e-book readers (some apps require volume-key page-turn enabled), native camera photo/video capture',
        d2Firm2Func: 'Horizontal Left/Right Swipe',
        d2Firm2Scenario: 'iPhone novel page turn left/right, iPad landscape short-video swiping',
        d2Firm3Func: 'Vertical Up/Down Swipe',
        d2Firm3Scenario: 'Short-video scrolling (double-tap any key to pause playback); iPad landscape novel page turn',
        d2Firm4Func: 'Music Playback Control',
        d2Firm4Scenario: 'Prev/Next track in music player; double-tap any key to pause/resume music',
        d2NotesTitle: 'Instructions & Notes',
        d2Note1: 'iPhone users: enable Settings → Accessibility → Zoom. If the screen becomes abnormal, restore with a 3-finger double-tap.',
        d2Note2: 'Yue Xing Tong users: scan QR code for dedicated mode usage.',
        d2Note3: 'Some long-battery iReader semi-closed e-readers, iPhone WeChat Reading / Apple Books: scan QR code for alternate page mode usage.',
        e6ModeTitle: 'Connection Mode',
        e6DeviceMode: 'Mode',
        e6ModeBle: 'Bluetooth Mode',
        e6ModeRf24: '2.4G Mode',
        e6ModeUsb: 'USB Mode',
        e6ModeTip: 'Tip: After selecting the connection mode, re-plug USB or restart the keyboard to take effect. Bluetooth is low-power wireless; 2.4G requires a 2.4G receiver; USB is wired.',
        e6key1: 'Key 1',
        e6key2: 'Key 2',
        e6key3: 'Key 3',
        e6key4: 'Key 4',
        e6key5: 'Key 5',
        e6key6: 'Key 6',
        d9key7: 'Key 7',
        d9key8: 'Key 8',
        d9key9: 'Key 9',
        changeLog5: '2024.11.2 Updated to threekey_v7.0.hex Added press mouse when long press',
        changeLog4: '2024.7.12 Updated to threekey_v6.0.hex Added press enter after string input',
        changeLog3: '2023.6.16 Updated to threekey_v5.1.hex fix key2 string mode bug and some settings cannot saved bug',
        changeLog1: '2023.5.4 Updated to threekey_v5.0.hex, add setting it as a mouse',
        changeLog1_1: 'How to update',
        changeLog2: '2023.4.25 Updated to threekey_v4.1.hex, which fixes the problem that when Windows presses the key immediately after connecting the keyboard, the key does not work',
        changeLog2_1: 'How to update',
        videoText: 'Video',
        keyTest: 'Online Keyboard Testing Sites',
        mouseTest: 'Online Mouse Testing Sites',
        openSource: 'All software and hardware of the project are open source',
        backToIndex: 'Back to topyuan.top',
        submit: 'Save Parameters',
        browserErr: 'Please use Chrome or Edge browser version 103 or above to access this page via https!',
        firmwareErr: 'The currently connected 3-key keyboard is not the latest firmware and does not support mouse settings, please update!!<br/><br/>New version:<br/>5.0 Added mouse<br/>4.1 fix bugs<br/>4.0 Added a combination of up to 5 keys, press three keys at the same time to one new key<br/>',
        firmwareErrv5: 'The currently connected 3-key keyboard is not the latest firmware and does not support press enter after string input settings, please update!!<br/><br/>New version:<br/>6.0 Added press enter after string input<br/>',
        firmwareErrv6: 'The currently connected 3-key keyboard is not the latest firmware and does not support press mouse when long press, please update!!<br/><br/>New version:<br/>7.0 Added press mouse when long press<br/>',
        tip: 'Notice',
        updateHelp: 'Update tutorial',
        updateNo: 'Not updated yet, return',
        redirecting: 'Redirecting...please wait',
        connFirst: 'Please connect the keyboard first',
        disconnect: 'Disconnect',
        success: 'Setting successful!',
        saveFailed: 'Setting failed: data verification or saving did not pass. Please try again.',
        firmwareErr1: 'The currently connected 3-key keyboard is not the latest firmware, please update!!<br/><br/>New version:<br/>5.0 Added mouse<br/>4.1 fix bugs<br/>4.0 Added a combination of up to 5 keys, press three keys at the same time to one new key<br/>',
        updateNo1: 'Not updated for now, change the key first (redirect to the old version key change page)',
        conError1: 'The port is occupied, the connection failed!',
        conError2: 'Connection failed, reason:',
        conError3: 'Disconnect failed! Please refresh the page!',
        howtoaddress: 'https://topyuan.top/3key/howtoupdate',
        shortcutTitle: 'Shortcut Keys',
        shortcutTip: 'How to Configure',
        shortcutTipDesc: 'Select a key → Set to "Combination Key" mode → Configure modifier keys (Ctrl/Win/Alt/Shift) + normal key below. E.g. Ctrl+C: select "Left Ctrl" as modifier, input "c" as key.',
        submitTipTitle: 'Important',
        submitTipDesc: 'After making changes, click the "Save Parameters" button at the bottom of the page to save settings to the device.',
        scGroupEdit: 'Common Editing',
        scGroupWin: 'Window & System',
        scGroupText: 'Text & Rich Text',
        scGroupBrowser: 'Browser',
        scGroupDev: 'Developer Tools',
        scCopy: 'Copy',
        scPaste: 'Paste',
        scCut: 'Cut',
        scUndo: 'Undo',
        scRedo: 'Redo',
        scSelectAll: 'Select All',
        scSave: 'Save',
        scFind: 'Find',
        scReplace: 'Replace',
        scPrint: 'Print',
        scSwitchWin: 'Switch Window',
        scDesktop: 'Show Desktop',
        scExplorer: 'Open File Explorer',
        scLock: 'Lock Computer',
        scSettings: 'Open Settings',
        scSearch: 'Search',
        scCloseWin: 'Close Window',
        scFullscreen: 'Fullscreen',
        scScreenshot: 'Screenshot (Full)',
        scSnipping: 'Screenshot (Region)',
        scBold: 'Bold',
        scItalic: 'Italic',
        scUnderline: 'Underline',
        scSelectWord: 'Select Word',
        scHome: 'Jump to Home',
        scEnd: 'Jump to End',
        scDelete: 'Delete',
        scNewTab: 'New Tab',
        scCloseTab: 'Close Tab',
        scSwitchTab: 'Switch Tab',
        scReopenTab: 'Reopen Closed Tab',
        scBookmark: 'Add Bookmark',
        scRefresh: 'Refresh',
        scHardRefresh: 'Hard Refresh (Clear Cache)',
        scDevTools: 'Developer Tools',
        scDevTools2: 'DevTools (Alt)',
        scDebug: 'Start Debugging',
        scTerminal: 'Terminal',
        scCommandPalette: 'Command Palette',
        scNewWin: 'New Window',
        scGroupIDE: 'IDE / Editor (Cursor/VS Code)',
        scDeleteLine: 'Delete Line',
        scSelectNext: 'Select Next Occurrence'
    }, __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scSelectAll', 'Select All Occurrences'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scMoveLine', 'Move Line Up/Down'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scComment', 'Toggle Comment'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scRename', 'Rename Symbol'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGlobalSearch', 'Search in Files'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExplorer', 'File Explorer'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoToLine', 'Go to Line'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFormat', 'Format Code'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scSuggest', 'Trigger Suggestion'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scQuickFix', 'Quick Fix'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scToggleSidebar', 'Toggle Sidebar'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoToSymbol', 'Go to Symbol'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIChat', 'AI Chat'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatSubmit', 'Submit Prompt & Generate'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatNewline', 'Newline only (no send)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatClear', 'Clear current chat context'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatUndo', 'Undo last AI generated code'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatRetry', 'Regenerate last answer (Retry)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatStop', 'Stop AI generation'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAICode', 'Code AI Operations'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeSidebar', 'Open AI sidebar to explain/modify code'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeInline', 'Inline AI edit/complete/refactor'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeSelectBlock', 'Select entire function/code block'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeAccept', 'Accept AI single-line completion'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeReject', 'Reject AI completion & rollback'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeRefactor', 'Refactor selected code'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIFile', 'File & Project AI'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileCmdPalette', 'Open global command palette'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileOpen', 'Open project file'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileSearch', 'Global search with AI'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileExplorer', 'Show/Hide file explorer'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileTerminal', 'Open terminal'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIWin', 'Window & Session'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinNew', 'New blank chat window'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinSwitch', 'Switch between chat tabs'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinClose', 'Close current chat tab'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinHistory', 'Switch chat history context'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupZoom', 'View Zoom'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomIn', 'Zoom In (enlarge view/font)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomOut', 'Zoom Out (reduce view/font)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomReset', 'Reset Zoom (restore 100%)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOffice', 'Office Software'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteValue', 'Paste as Value (value only)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteFormat', 'Paste Format'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteLink', 'Paste as Link'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFormulaBar', 'Show/Hide Formula Bar'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPivotTable', 'Create Pivot Table'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFillDown', 'Fill Down'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupNav', 'Quick Navigation'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoBack', 'Go Back (previous page)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoForward', 'Go Forward (next page)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scQuickSave', 'Save As'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scRun', 'Run (execute program/macro)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scTaskManager', 'Open Task Manager'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scCycleApps', 'Cycle through open apps'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupZoomShort', 'View Zoom'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeWord', 'Word / WPS Writer'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordNewDoc', 'New blank document'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordOpenDoc', 'Open document'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordSaveAs', 'Save document as'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordFindNext', 'Find next occurrence'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordGoToPage', 'Go To (page/bookmark)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordInsertLink', 'Insert hyperlink'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordInsertPageBreak', 'Insert page break'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordSelectPara', 'Select entire paragraph'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWord1_5Line', 'Set 1.5 line spacing'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordCenterAlign', 'Center-align paragraph'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordLeftAlign', 'Left-align paragraph'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordRightAlign', 'Right-align paragraph'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordJustifyAlign', 'Justify paragraph'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordBold', 'Bold'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordUnderline', 'Underline'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordItalic', 'Italic'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeExcel', 'Excel / WPS Spreadsheet'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSumAuto', 'Auto Sum (Alt+=)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFillRight', 'Fill Right (Ctrl+R)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFillDown', 'Fill Down (Ctrl+D)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelPasteValue', 'Paste as Value (value only)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelPasteFormat', 'Paste format (format painter copy)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelInsertRow', 'Insert entire row (Ctrl+Shift+=)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelDeleteRow', 'Delete entire row (Ctrl+-)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelToggleFilter', 'Toggle Filter on/off'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelGoToCell', 'Go To (F5)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelNameBox', 'Go to Name Box'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelTodayDate', 'Insert today date (Ctrl+;)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelNowTime', 'Insert current time (Ctrl+Shift+:)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSelectAllRegion', 'Select current data region (Ctrl+A)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelEditCell', 'Edit cell (F2)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSwitchSheet', 'Switch sheet (Ctrl+PageDown)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFreezePane', 'Freeze Panes'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeCommon', 'WPS / Office Common'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeNewFile', 'New file'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeOpenFile', 'Open file'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeSave', 'Save'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeSaveAs', 'Save As'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficePrint', 'Print'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeCloseFile', 'Close current file'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeUndo', 'Undo'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeRedo', 'Redo / Repeat'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeFind', 'Find'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeReplace', 'Replace'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeFullScreen', 'Full screen'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoomPlus', 'Zoom in'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoomMinus', 'Zoom out'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoom100', 'Zoom to 100%'), _index),
    keyConfig: {
        keyDes1: 'Common key',
        keyDes2: 'Function key',
        keyDes3: 'Media key',
        keyDes4: 'Combination key',
        keyDes5: 'String',
        keyDes6: 'Mouse',
        select: 'Please choose',
        mix1: 'Add a function key',
        mix2: 'Add a common key',
        mix3: 'Delete a combination key',
        mix4: 'Reset the combination key',
        mix5: 'Common combination keys',
        mixtip: 'The following are common key combinations, which can be quickly set. If you don’t know what to set, you can check it out , I will update it irregularly.',
        mixcommon1: 'Combination key',
        mixcommon2: 'Description',
        mixcommon3: 'Operate',
        set: 'Set up',
        inputErr: 'Input error',
        selectErr: 'Select error',
        mixErr: 'The combination key is at least 2 key combination!',
        mixErr1: 'Combination key No.',
        mixErr2: ' select error',
        mixErr3: ' input error',
        textErr: 'String cannot be empty',
        textErr1: 'String input error, there is no such key',
        setErr: 'Setting error',
        delErr: 'Can no longer be deleted!',
        mixMaxErr: 'Supports up to 5 key combinations!',
        mixAdd: 'Please add function keys or common keys',
        mixMax5: 'All the above key combinations, support up to 5 keys',
        holdTip: 'Trigger continuously when long press',
        holdPressTip: 'Press mouse when long press',
        doubleClick: 'Double Click',
        stringEnter: 'Press enter after input',
        move: 'Moving distance',
        strong: 'Intensity',
        normalKeyTip: 'Supports numbers, letters, spaces and common symbols',
        normalKeyLowercaseHint: 'Please type letters in lowercase (e.g. c, v) to work properly; uppercase may not work',
        mediaKeyTip: 'Power, Sleep, Screen Saver etc. depend on system ACPI drivers and may not work on all PCs',
        mouses: ['Left Click', 'Middle Click', 'Right Click', 'Random Move', 'Move Up', 'Move Down', 'Move Left', 'Move Right', 'Scroll Wheel Up', 'Scroll Wheel Down'],
        functionkeys: ["Left Ctrl", "Left Shift", "Left Alt", "Left Win/Command", "Right Ctrl", "Right Shift", "Right Alt", "Right Win/Command", "Up", "Down", "Left", "Right", "Backspace", "Tab", "Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(num pad)", "*(num pad)", "-(num pad)", "+(num pad)", "Enter(num pad)", "1(num pad)", "2(num pad)", "3(num pad)", "4(num pad)", "5(num pad)", "6(num pad)", "7(num pad)", "8(num pad)", "9(num pad)", "0(num pad)", ".(num pad)"],
        mediakeys: ["Next", "Previous", "Stop", "Play/Pause", "Pause", "Volume Mute", "Volume Up", "Volume Down", "Brightness Up", "Brightness Down", "Open Music", "Open Email", "Open Calculator", "Open Explorer", "Open Browser", "Browser Back", "Browser forward", "Browser Refresh", "Browser bookmarks", "Power", "Sleep", "Record", "Fast Forward", "Rewind", "Screen Saver"],
        quickSetting: 'Quick Setup',
        quickToggleHint: 'Click a shortcut card above to configure',
        quickSearchPlaceholder: 'Search shortcuts (e.g. Copy, Paste, Zoom, Ctrl+Shift+V...)',
        quickTip1: '💡 Tip: Click a card below to quickly set this key to the shortcut.',
        quickTip2: 'Can\'t find the shortcut? Try setting it manually in "Combination Key" mode, or contact customer support!',
        quickSetSuccess: 'Quickly set to: ',
        quickCategoryAll: 'All',
        quickCategoryEdit: 'Editing',
        quickCategorySystem: 'System',
        quickCategoryBrowser: 'Browser',
        quickCategoryOffice: 'Office',
        quickCategoryIDE: 'Dev',
        quickCategoryZoom: 'Zoom',
        quickCategoryMedia: 'Media',
        notSet: 'Not Set',
        videoTutorial: 'Video Tutorial'
    },
    rf24Pair: {
        entry: '2.4G Pairing',
        title: '2.4G Pairing',
        hint: 'Plug in the receiver, open this page, put the keyboard into pairing mode, then search and pair.',
        warningTitle: 'Do not pair a keyboard that is already working normally',
        warningDesc: '2.4G pairing is only for the first connection between a keyboard and receiver. Do not pair an already working keyboard again, or the connection may be interrupted and require re-pairing.',
        serialUnsupported: 'This browser does not support Web Serial. Use Chrome / Edge or another Chromium-based browser.',
        connect: 'Connect receiver',
        disconnect: 'Disconnect',
        connected: 'Receiver connected',
        receiverId: 'Receiver ID',
        currentPair: 'Current pairing',
        runState: 'Status',
        protocolVersion: 'Protocol version',
        paired: 'Paired',
        unpaired: 'Not paired',
        scanning: 'Scanning…',
        search: 'Search 2.4G devices',
        refresh: 'Refresh',
        remaining: 'Remaining',
        cancelSearch: 'Cancel search',
        deviceId: 'Device ID',
        model: 'Model',
        actions: 'Action',
        pair: 'Pair',
        scanHint: 'Scanning. Switch the target keyboard to 2.4G mode and hold KEY1 + KEY2 for about 3 seconds to enter pairing mode…',
        ledHint: 'The red and green LEDs flashing rapidly together indicate pairing mode.',
        searchHint: 'Click “Search 2.4G devices”. The receiver will scan for nearby keyboards of this series in pairing mode.',
        step1: 'Confirm device',
        step2: 'Switch address',
        step3: 'Verify connection',
        successHint: 'Pairing successful. The keyboard green LED flashes rapidly.',
        unpair: 'Unpair',
        refreshState: 'Refresh status',
        stateIdle: 'Idle',
        stateScanning: 'Scanning',
        statePairing: 'Pairing',
        stateSuccess: 'Paired',
        stateFailed: 'Pairing failed',
        stateUnknown: 'Unknown',
        timeout: 'Receiver response timed out',
        connectFailed: 'Connection failed: ',
        scanStarted: 'Scan started. Put the target keyboard into pairing mode.',
        scanFailed: 'Scan failed: ',
        pairRequestFailed: 'Pairing request failed. Search again and retry.',
        selected: 'Selected ',
        selectedSuffix: ', switching communication address…',
        pairFailed: 'Pairing failed: ',
        pairSuccess: 'Pairing successful! The receiver switched to the new address; the keyboard green LED flashes rapidly.',
        pairRestore: 'Pairing failed and the previous pairing was restored. Make sure the keyboard is still in pairing mode and retry.',
        cancelled: 'Cancelled.',
        unpairWarning: 'Unpairing will disconnect the current keyboard from the receiver. You must search and pair again to restore the 2.4G connection. Do not unpair unless necessary!',
        unpairTitle: 'Warning: unpair 2.4G connection?',
        unpairConfirm: 'Yes, unpair',
        unpairCancel: 'Cancel',
        unpairCancelled: 'Unpairing cancelled.',
        unpairDone: 'Unpaired. Search and pair again.',
        unpairFailed: 'Unpair failed: '
    }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__);


var _index;

/* harmony default export */ __webpack_exports__["a"] = ({
    index: (_index = {
        pageTitle: 'USB自定义键盘配置工具',
        more: '更多',
        about: '关于',
        aboutBuildTime: '当前程序编译时间：',
        factoryTest: '出厂测试',
        readStatus: '读取状态',
        autoRefresh: '自动刷新 0.5s',
        factoryLedTip: '请观察键盘红绿灯：正常应每 0.5 秒红/绿交替慢闪；如果某个灯不亮，请检查对应 LED。',
        factoryAbnormal: '异常：未检测到 IO 连接（无按键 / 无 USB / 无充电 / 电池低于 2V）',
        factoryPassPrefix: '测试通过：',
        factoryPassSuffix: ' 个按键全部按下，电池正常',
        factoryItem: '检测项',
        factoryValue: '状态',
        factoryResult: '结果',
        factoryPassShort: '通过',
        factoryFailShort: '未通过',
        factoryWait: '待检测',
        factoryNote: '协议：发送 02 46，设备返回 FT1 状态行。支持 D2 蓝牙 2 键 / D6 三模 6 键 / D9 9 键固件。',
        factoryKey: '按键',
        factoryPressed: '按下',
        factoryReleased: '松开',
        factoryReleasedDetected: '松开（已检测）',
        factoryBatteryAdc: '电池 ADC',
        factoryUsbVcc: 'USB VCC 引脚',
        factoryUsbHigh: '高 / 有 USB',
        factoryUsbLow: '低 / 无 USB',
        factoryCharging: '充电中',
        factoryNotCharging: '未充电',
        factoryLedRed: '红灯 LED',
        factoryLedGreen: '绿灯 LED',
        factoryOn: '亮',
        factoryOff: '灭',
        factoryBle: '蓝牙连接',
        factoryConnected: '已连接',
        factoryDisconnected: '未连接',
        factoryRf24: '2.4G 连接',
        factoryNotEnabled: '未启用',
        factoryPaRaw: 'PA 原始值',
        factoryPbRaw: 'PB 原始值',
        factoryMode: '模式',
        schematicTitle: '按键示意图',
        knobLabel: '旋钮',
        firmware1: '固件一',
        firmware2: '固件二',
        firmware3: '固件三',
        firmware4: '固件四',
        videoTitle: '三键视频教程',
        videoUnsupported: '您的浏览器不支持视频播放',
        connectionTip1: '提示：三模无线键盘配置需要使用 USB 线连接键盘进行配置，请选择',
        connectionTip2: '或',
        connectionTip3: '，不要选择',
        connectionTip4: '（此为接收头）。',
        factoryConnectFirst: '请先连接设备',
        connecting: '正在连接键盘中…',
        selectSerialPort: '请选择串行端口并等待设备响应',
        errPageConfig: '页面未能建立对应型号的按键配置区',
        errReplyTimeoutUnknown: '设备回复超时，请重新连接；本次保存结果未知',
        errDisconnected: '设备已断开',
        errEmptyReply: '设备返回了空回复',
        errReadbackMismatch: '持久化回读与保存内容不一致，不能确认保存成功',
        errConfirmTimeout: '等待设备确认超时，请重新连接',
        errNoAck: '未收到设备确认，请重新连接后重试',
        errFactoryFormat: '出厂测试回复格式不正确: ',
        errNoResponse: '设备无响应，请重新连接',
        back: '返回',
        loopInterval: '循环间隔',
        helpTitle: '帮助',
        helpTips0: '5种按键模式介绍:',
        helpTips1: '1.普通键:将3键键盘某一按键按键定义为如1、2、3、a、b、c、?、空格等可输入的普通按键',
        helpTips1_1: '注意:普通键如果输入大写字母或!@#$%等按键 实际是通过Shift+对应按键触发!',
        helpTips2: '2.功能键:将3键键盘某一按键按键定义为Ctrl、Alt、Win、Command、回车等功能按键',
        helpTips2_1: 'F13-F24为特殊功能按键,普通键盘并没有,可以作为软件内的自定义快捷键,防冲突使用!',
        helpTips3: '3.多媒体键:将3键键盘某一按键按键定义为音量加、亮度加、打开浏览器等多媒体按键',
        helpTips4: '4.组合键:将3键键盘某一按键按键定义为2键-5键组合,如一键Ctrl+c、一键Win+l、一键Ctrl+Alt+Delete等组合按键',
        helpTips5: '5.字符串:将3键键盘某一按键按键定义为输入字符串,如一键输入用户名、一键输入select * from等',
        helpTips6: '6.鼠标:将3键键盘某一按键按键定义为鼠标按键点击、鼠标移动、滚轮滑动等',
        helpButton: '查看帮助',
        troubleshootTitle: '键盘插上没反应？逐项排查',
        troubleshoot1: '浏览器',
        troubleshoot1_desc: '必须用 Chrome 或 Edge（103 版本以上），通过 https 或 localhost 访问；Safari、Firefox 不支持串口，无法连接。',
        troubleshoot2: '访问方式',
        troubleshoot2_desc: '不要直接双击网页文件打开（file:// 无法使用串口），请通过网址访问。',
        troubleshoot3: '点“连接”没弹出选择窗口',
        troubleshoot3_desc: '多为 USB线问题——换一条数据线（有的线只充电不传数据）、换一个USB口，尽量直插主机不用扩展坞。',
        troubleshoot4: '弹窗里找不到设备',
        troubleshoot4_desc: '确认系统已识别到串口设备（VID 0x1209 / PID 0xC550），重新插拔键盘后再试。',
        troubleshoot5: '端口被占用、连接失败',
        troubleshoot5_desc: '关闭可能占用串口的程序（串口助手、Arduino IDE、其他烧录/改键工具）后重试。',
        troubleshoot6: '连接成功但读不到配置/提示固件过旧',
        troubleshoot6_desc: '按提示更新固件后再配置。',
        troubleshoot7: '多次插拔后异常',
        troubleshoot7_desc: '刷新页面（F5），重新插拔键盘后再连接。',
        windowsTipsTitle: 'Windows / 公司电脑提示',
        windowsTips1: '右下角提示“无法识别的 USB 设备”时，说明Windows在读取设备信息时失败，不是网页配置或浏览器设置的问题；请先换直插USB口、换一条确认能传数据的线，并在另一台电脑测试。',
        windowsTips2: '若只有公司电脑无法识别、其他电脑正常，请联系公司IT检查 USB外设管控或白名单；请勿禁用USB Root Hub、USB控制器等系统设备。',
        windowsTips3: '设备管理器出现“未知 USB 设备”时，可右键选择“卸载设备”后重新插拔；如出现“删除此设备的驱动程序”选项，不要勾选。',
        windowsTips4: '保存参数后，建议重新插拔键盘，再用“在线键盘测试”确认按键已经按预期生效。',
        macTipsTitle: 'Mac 用户配置注意事项',
        macTips1: '浏览器',
        macTips1_desc: '用Mac版 Chrome 或 Edge（103 以上），Safari 不支持串口连接。',
        macTips2: '修饰键对应',
        macTips2_desc: 'Mac的 Command（⌘）与Windows的 Win 是同一个键码，配置时选“左Win/Command”即可。',
        macTips3: '复制粘贴',
        macTips3_desc: 'Windows是 Ctrl+C/V，Mac是 Command+C/V（组合键里把修饰键选成“左Win/Command” + c/v；“常用组合键”里也有Mac版可直接套用）。',
        macTips4: '锁屏',
        macTips4_desc: 'Windows是 Win+L，Mac是 Control+Command+Q（见“常用组合键”里的“Mac锁屏”）。',
        macTips5: '截图',
        macTips5_desc: 'Windows是 Win+Shift+S，Mac是 Shift+Command+3/4（见“常用组合键”里的“Mac快速截图”）。',
        macTips6: '首次连接',
        macTips6_desc: '首次连接会弹出串口授权窗口，选择设备并点允许即可；若没有弹窗，多为浏览器版本过旧。',
        connButtonText1: '连接自定义键盘',
        timerConfig: '定时触发配置',
        triggerMode: '触发模式',
        triggerModeManual: '手动触发',
        triggerModeTimer: '定时触发',
        triggerModeBoth: '手动及定时触发',
        hour: '时',
        minute: '分',
        second: '秒',
        keyAllLabel: '3键同时按下时,作为独立按键',
        keyAllTrue: '开',
        keyAllFalse: '关',
        b3key1: '按键1',
        b3key2: '按键2',
        b3key3: '按键3',
        b3keyall: '三键同按',
        deviceTypeLabel: '设备类型',
        deviceVersionLabel: '固件版本',
        configSeqLabel: '配置序号',
        backlightTitle: '背光设置',
        backlightMode: '背光模式',
        backlightMode0: '关闭',
        backlightMode1: '常亮',
        backlightMode2: '按键亮',
        backlightMode3: '流水灯',
        backlightMode4: '呼吸灯',
        backlightColor1: '1号灯颜色',
        backlightColor2: '2号灯颜色',
        backlightColor3: '3号灯颜色',
        backlightBrightness: '亮度',
        colorBlue: '蓝',
        colorGreen: '绿',
        colorRed: '红',
        colorYellow: '黄',
        colorCyan: '青',
        colorPurple: '紫',
        colorWhite: '白',
        keyTestLabel: '键盘按键在线测试',
        keyTestUrl: 'https://keyboard.bmcx.com/',
        keyTestLabel2: '在线键盘测试',
        keyTestUrl2: 'https://www.853295.com/',
        keyTestLabel3: '鼠标按键在线测试',
        keyTestUrl3: 'https://cps-check.com/cn/mouse-buttons-test',
        keyTestLabel4: '鼠标测试工具',
        keyTestUrl4: 'https://www.mousetester.cn/',
        keyTestPrompt: '点击前往在线键盘测试网站 →',
        c4key1: '按键1',
        c4key2: '按键2',
        c4key3: '按键3',
        c4key4: '按键4',
        ec11Title: '旋钮设置',
        ec11CW: '顺时针旋转',
        ec11CCW: '逆时针旋转',
        ec11Btn: '中键按下',
        ec11FuncKey: '键盘按键',
        ec11FuncMedia: '多媒体键',
        ec11FuncMouse: '鼠标点击',
        ec11FuncFn: '功能键',
        ec11FuncScroll: '鼠标滚轮',
        ec11FuncMix: '组合键',
        ec11ScrollUp: '向上滚轮',
        ec11ScrollDown: '向下滚轮',
        ec11KeyCode: '键码',
        ec11MouseLeft: '左键',
        ec11MouseMiddle: '中键',
        ec11MouseRight: '右键',
        ec11ClickSingle: '单次点击',
        ec11ClickContinuous: '持续点击',
        ec11ClickPress: '按下',
        backlightColor4: '4号灯颜色',
        b6key1: '按键1',
        b6key2: '按键2',
        b6key3: '按键3',
        b6key4: '按键4',
        b6key5: '按键5',
        b6key6: '按键6',
        backlightColor5: '5号灯颜色',
        backlightColor6: '6号灯颜色',
        b4key1: '按键1',
        b4key2: '按键2',
        b4key3: '按键3',
        b4key4: '按键4',
        d2key1: '按键1',
        d2key2: '按键2',
        d2RunModeTitle: '蓝牙模式',
        d2RunMode: '运行模式',
        d2RunModeKeyboard: '键盘模式',
        d2RunModePage: '翻页模式',
        d2ModeTipKbd: '键盘模式：',
        d2ModeTipKbdDesc: 'USB / 蓝牙均可用，可连接电脑和手机，作为标准键盘使用；',
        d2ModeTipPage: '翻页模式：',
        d2ModeTipPageDesc: '主要用于蓝牙连接手机等移动设备，实现翻页 / 滑屏 / 媒体控制。',
        d2PageAction: '翻页动作',
        d2PagePrev: '音量键翻页',
        d2PageNext: '左右滑屏',
        d2PagePlayPause: '上下滑屏',
        d2PageHome: '音乐切换',
        d2PageTableTitle: '翻页动作说明',
        d2TableFirmware: '固件号',
        d2TableFunction: '功能说明',
        d2TableScenario: '使用场景',
        d2Firm1Func: '音量键控制',
        d2Firm1Scenario: '安卓/鸿蒙电子书阅读器小说翻页(部分软件需打开音量键翻页选项)、手机原相机拍照录像',
        d2Firm2Func: '横向左右划动屏幕',
        d2Firm2Scenario: '苹果手机左右小说翻页、iPad横屏时刷短视频',
        d2Firm3Func: '竖向上下滑屏屏幕',
        d2Firm3Scenario: '手机刷短视频(任意键快速双击可暂停播放视频)、iPad横屏时左右小说翻页',
        d2Firm4Func: '音乐播放控制',
        d2Firm4Scenario: '音乐播放器上下切歌，任意键双击暂停播放音乐',
        d2NotesTitle: '使用说明 & 注意事项',
        d2Note1: '苹果用户：需打开<设置-辅助功能-缩放>，若造成屏幕异常，请三指双击屏幕恢复',
        d2Note2: '阅星瞳用户：可扫二维码获取阅星瞳专用模式用法',
        d2Note3: '部分掌阅长续航版本的半封闭阅读器、苹果手机的微信读书、苹果图书：可扫二维码获取备用翻页模式用法',
        e6ModeTitle: '三模选择',
        e6DeviceMode: '连接模式',
        e6ModeBle: '蓝牙模式',
        e6ModeRf24: '2.4G 模式',
        e6ModeUsb: 'USB 模式',
        e6ModeTip: '提示：选择连接模式后需重新插拔 USB 或重启键盘生效。蓝牙模式为低功耗无线连接；2.4G 模式需配合 2.4G 接收头使用；USB 模式为有线连接。',
        e6key1: '按键1',
        e6key2: '按键2',
        e6key3: '按键3',
        e6key4: '按键4',
        e6key5: '按键5',
        e6key6: '按键6',
        d9key7: '按键7',
        d9key8: '按键8',
        d9key9: '按键9',
        changeLog5: '2024.11.2 软件更新为threekey_v7.0.hex 新增长按时按住鼠标设置',
        changeLog4: '2024.7.12 软件更新为threekey_v6.0.hex 新增输入字符串后回车换行设置',
        changeLog3: '2023.6.16 软件更新为threekey_v5.1.hex 修复key2字符串模式记忆bug 修复三键按下部分设置不能记忆',
        changeLog1: '2023.5.4 软件更新为threekey_v5.0.hex 新增设置为鼠标功能',
        changeLog1_1: '如何更新',
        changeLog2: '2023.4.25 软件更新为threekey_v4.1.hex 修复了windows在刚连接键盘就立刻按键的情形 按键失效问题',
        changeLog2_1: '如何更新',
        videoText: '视频介绍',
        keyTest: '在线键盘测试网站',
        mouseTest: '在线鼠标测试网站',
        openSource: '项目软硬件全部开源',
        backToIndex: '回到topyuan.top首页',
        submit: '保存参数',
        browserErr: '请使用103以上版本Chrome或Edge浏览器,https方式访问此页面!',
        firmwareErr: '当前连接的3键键盘不是最新固件,不支持鼠标设置,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        firmwareErrv5: '当前连接的3键键盘不是最新固件,不支持输入字符串后加回车换行,请更新!!<br/><br/>新版本:<br/>6.0 新增输入字符串后回车换行设置<br/>',
        firmwareErrv6: '当前连接的3键键盘不是最新固件,不支持长按时按住鼠标,请更新!!<br/><br/>新版本:<br/>7.0 新增长按时按住鼠标设置<br/>',
        tip: '提示',
        updateHelp: '更新教程',
        updateNo: '暂不更新,返回',
        redirecting: '正在跳转....请稍后',
        connFirst: '请先连接键盘',
        disconnect: '断开连接',
        success: '设置成功!',
        saveFailed: '设置失败：数据校验或保存未通过，请重试。',
        firmwareErr1: '当前连接的3键键盘不是最新固件,请更新!!<br/><br/>新版本:<br/>5.0 新增鼠标设置功能<br/>4.1 修复bug<br/>4.0 新增最多5键的组合键 三键同时按下设置<br/>',
        updateNo1: '暂不更新,先改键(跳转到旧版改键页)',
        conError1: '端口已占用,连接失败!',
        conError2: '连接失败,原因:',
        conError3: '断开连接失败!请刷新页面!',
        howtoaddress: 'https://topyuan.top/3key/howtoupdate',
        shortcutTitle: '快捷键参考',
        shortcutTip: '配置建议',
        shortcutTipDesc: '选择一个按键 → 设置为"组合键"模式 → 在下方配置对应的修饰键(Ctrl/Win/Alt/Shift)+普通键。例如 Ctrl+C：修饰键选"左Ctrl"，按键输入"c"。',
        submitTipTitle: '重要提示',
        submitTipDesc: '设置完成后，请点击页面底部的蓝色"保存参数"按钮，将当前设置保存到设备中。',
        scGroupEdit: '常用编辑',
        scGroupWin: '窗口与系统',
        scGroupText: '文本与富文本',
        scGroupBrowser: '浏览器',
        scGroupDev: '开发工具',
        scCopy: '复制',
        scPaste: '粘贴',
        scCut: '剪切',
        scUndo: '撤销',
        scRedo: '重做',
        scSelectAll: '全选',
        scSave: '保存',
        scFind: '查找',
        scReplace: '替换',
        scPrint: '打印',
        scSwitchWin: '切换窗口',
        scDesktop: '显示桌面',
        scExplorer: '打开文件管理器',
        scLock: '锁定电脑',
        scSettings: '打开设置',
        scSearch: '搜索',
        scCloseWin: '关闭窗口',
        scFullscreen: '全屏',
        scScreenshot: '截图(全屏)',
        scSnipping: '截图(区域)',
        scBold: '加粗',
        scItalic: '斜体',
        scUnderline: '下划线',
        scSelectWord: '选中单词',
        scHome: '跳到文档开头',
        scEnd: '跳到文档结尾',
        scDelete: '删除',
        scNewTab: '新建标签页',
        scCloseTab: '关闭标签页',
        scSwitchTab: '切换标签页',
        scReopenTab: '恢复关闭标签页',
        scBookmark: '添加书签',
        scRefresh: '刷新',
        scHardRefresh: '强制刷新(清除缓存)',
        scDevTools: '开发者工具',
        scDevTools2: '开发者工具(备选)',
        scDebug: '开始调试',
        scTerminal: '终端',
        scCommandPalette: '命令面板',
        scNewWin: '新建窗口',
        scGroupIDE: 'IDE / 编辑器 (Cursor/VS Code)',
        scDeleteLine: '删除行',
        scSelectNext: '选中下一个相同词'
    }, __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scSelectAll', '选中所有相同词'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scMoveLine', '移动行上下'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scComment', '注释/取消注释'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scRename', '重命名符号'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGlobalSearch', '全局搜索'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExplorer', '文件资源管理器'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoToLine', '跳转到行'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFormat', '格式化代码'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scSuggest', '触发建议/补全'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scQuickFix', '快速修复'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scToggleSidebar', '切换侧边栏'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoToSymbol', '跳转到符号'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIChat', 'AI 对话聊天'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatSubmit', '提交 Prompt，发送 AI 生成'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatNewline', '仅换行，不发送'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatClear', '清空当前对话全部上下文'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatUndo', '撤销上一轮 AI 生成代码'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatRetry', '重新生成上一次回答（重试）'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIChatStop', '终止 AI 当前正在生成的内容'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAICode', '选中代码后 AI 操作'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeSidebar', '唤起 AI 侧边栏，解释/修改选中代码'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeInline', 'Inline AI，代码行内编辑/补全/重构'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeSelectBlock', '选中整段函数/代码块'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeAccept', '接受 AI 给出的单行代码补全'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeReject', '拒绝 AI 补全，回退'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAICodeRefactor', '重构选中代码（优化逻辑、修复 bug）'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIFile', '文件与工程全局 AI'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileCmdPalette', '打开全局命令面板（所有 AI 功能入口）'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileOpen', '打开工程文件'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileSearch', '全局工程搜索（可结合 AI 检索代码）'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileExplorer', '显示/隐藏左侧工程目录'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIFileTerminal', '调出终端'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupAIWin', '窗口与会话快捷'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinNew', '新建空白对话窗口'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinSwitch', '切换多个对话标签'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinClose', '关闭当前对话标签'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scAIWinHistory', '切换历史对话上下文'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupZoom', '视图缩放'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomIn', '放大(放大视图/字体)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomOut', '缩小(缩小视图/字体)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scZoomReset', '重置缩放(恢复100%)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOffice', '办公软件'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteValue', '粘贴成数值(仅值无格式)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteFormat', '粘贴格式'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPasteLink', '粘贴为链接'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFormulaBar', '显示/隐藏编辑栏'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scPivotTable', '创建数据透视表'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scFillDown', '向下填充'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupNav', '快速导航'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoBack', '后退(返回上一页)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGoForward', '前进(进入下一页)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scQuickSave', '另存为'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scRun', '运行(执行程序/宏)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scTaskManager', '打开任务管理器'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scCycleApps', '循环切换应用程序'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupZoomShort', '视图缩放'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeWord', 'Word / WPS文字'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordNewDoc', '新建空白文档'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordOpenDoc', '打开文档'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordSaveAs', '另存为文档'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordFindNext', '查找下一处'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordGoToPage', '定位(跳转到页/书签)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordInsertLink', '插入超链接'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordInsertPageBreak', '插入分页符'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordSelectPara', '选中整个段落'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWord1_5Line', '设置1.5倍行距'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordCenterAlign', '段落居中对齐'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordLeftAlign', '段落左对齐'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordRightAlign', '段落右对齐'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordJustifyAlign', '段落两端对齐'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordBold', '加粗'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordUnderline', '下划线'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scWordItalic', '斜体'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeExcel', 'Excel / WPS表格'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSumAuto', '自动求和(Alt+=)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFillRight', '向右填充(Ctrl+R)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFillDown', '向下填充(Ctrl+D)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelPasteValue', '粘贴成数值(仅值)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelPasteFormat', '粘贴格式(格式刷复制)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelInsertRow', '插入整行(Ctrl+Shift+=)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelDeleteRow', '删除整行(Ctrl+-)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelToggleFilter', '开启/关闭筛选'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelGoToCell', '定位(Goto, F5)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelNameBox', '跳转到名称框'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelTodayDate', '插入当前日期(Ctrl+;)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelNowTime', '插入当前时间(Ctrl+Shift+:)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSelectAllRegion', '选中当前数据区域(Ctrl+A)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelEditCell', '进入单元格编辑(F2)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelSwitchSheet', '切换工作表(Ctrl+PageDown)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scExcelFreezePane', '冻结窗格(Alt+W+F)'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scGroupOfficeCommon', 'WPS / Office通用'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeNewFile', '新建文件'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeOpenFile', '打开文件'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeSave', '保存'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeSaveAs', '另存为'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficePrint', '打印'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeCloseFile', '关闭当前文件'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeUndo', '撤销'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeRedo', '重做/恢复'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeFind', '查找'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeReplace', '替换'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeFullScreen', '全屏显示'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoomPlus', '视图放大'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoomMinus', '视图缩小'), __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()(_index, 'scOfficeZoom100', '缩放到100%'), _index),
    keyConfig: {
        keyDes1: '普通键',
        keyDes2: '功能键',
        keyDes3: '多媒体键',
        keyDes4: '组合键',
        keyDes5: '字符串',
        keyDes6: '鼠标',
        select: '请选择',
        mix1: '增加功能键',
        mix2: '增加普通键',
        mix3: '删除组合键',
        mix4: '重置组合键',
        mix5: '常用组合键',
        mixtip: '以下为常见组合键,可快速设置,不知道设成啥可以看看,不定期更新',
        mixcommon1: '组合键',
        mixcommon2: '描述',
        mixcommon3: '操作',
        set: '设置',
        inputErr: '输入错误',
        selectErr: '选择错误',
        mixErr: '组合键至少为2键组合!',
        mixErr1: '组合键第',
        mixErr2: '位选择错误',
        mixErr3: '位输入错误',
        textErr: '字符串不能为空',
        textErr1: '字符串输入错误，无此键位',
        setErr: '设置错误',
        delErr: '已无法再删除!',
        mixMaxErr: '最多支持5个按键组合!',
        mixAdd: '请增加功能键或普通键',
        mixMax5: '以上所有按键组合,最多支持5键',
        holdTip: '长按时连续触发',
        holdPressTip: '长按时按住鼠标',
        doubleClick: '双击',
        stringEnter: '输入后按Enter换行',
        move: '移动距离',
        strong: '力度',
        normalKeyTip: '支持数字、英文字母、空格及常用符号',
        normalKeyLowercaseHint: '字母请输入小写（如 c、v）才能生效，大写可能无效',
        mediaKeyTip: '电源、睡眠、屏保等部分按键依赖系统ACPI驱动，可能无法在所有电脑上生效',
        mouses: ['左键点击', '中键点击', '右键点击', '随机移动位置', '向上移动', '向下移动', '向左移动', '向右移动', '向上滚轮', '向下滚轮'],
        functionkeys: ["左Ctrl", "左Shift", "左Alt", "左Win/Command", "右Ctrl", "右Shift", "右Alt", "右Win/Command", "向上", "向下", "向左", "向右", "Backspace", "Tab", "回车Enter", "ESC", "Insert", "Delete", "Page Up", "Page Down", "Home", "End", "Caps Lock", "Print Screen", "Scroll Lock", "Pause Break", "Num Lock", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "F10", "F11", "F12", "F13", "F14", "F15", "F16", "F17", "F18", "F19", "F20", "F21", "F22", "F23", "F24", "Menu", "/(小键盘)", "*(小键盘)", "-(小键盘)", "+(小键盘)", "Enter(小键盘)", "1(小键盘)", "2(小键盘)", "3(小键盘)", "4(小键盘)", "5(小键盘)", "6(小键盘)", "7(小键盘)", "8(小键盘)", "9(小键盘)", "0(小键盘)", ".(小键盘)"],
        mediakeys: ["下一首", "上一首", "停止播放", "播放/暂停", "暂停", "静音", "音量增加", "音量减少", "屏幕亮度增加", "屏幕亮度减少", "打开音乐软件", "打开Email软件", "打开计算器", "打开文件管理器", "打开浏览器", "浏览器后退", "浏览器前进", "浏览器刷新", "浏览器书签", "电源键", "睡眠键", "录制", "快进", "回放", "屏保"],
        quickSetting: '快速设置',
        quickToggleHint: '点击上方快捷键卡片即可一键配置',
        quickSearchPlaceholder: '搜索快捷键 (如：复制、粘贴、放大、Ctrl+Shift+V...)',
        quickTip1: '💡 小贴士：点击下方卡片即可一键设置该按键为对应快捷键。',
        quickTip2: '找不到想要的快捷键？试试在「组合键」模式里手动设置，或联系客服指导！',
        quickSetSuccess: '已快速设置：',
        quickCategoryAll: '全部',
        quickCategoryEdit: '编辑',
        quickCategorySystem: '系统',
        quickCategoryBrowser: '浏览器',
        quickCategoryOffice: '办公',
        quickCategoryIDE: '开发',
        quickCategoryZoom: '缩放',
        quickCategoryMedia: '多媒体',
        notSet: '未设置',
        videoTutorial: '视频教程'
    },
    rf24Pair: {
        entry: '2.4G 配对',
        title: '2.4G 配对',
        hint: '插入接收头后打开本页面，让键盘进入配对模式，即可搜索并指定配对。',
        warningTitle: '正常使用的键盘请勿再次配对',
        warningDesc: '2.4G 配对仅用于键盘第一次与接收头建立连接。已能正常使用的键盘请勿重复配对，否则可能导致连接中断，需要重新配对。',
        serialUnsupported: '当前浏览器不支持 Web Serial，请使用 Chrome / Edge 等基于 Chromium 的浏览器',
        connect: '连接接收头',
        disconnect: '断开',
        connected: '已连接接收头',
        receiverId: '接收头 ID',
        currentPair: '当前配对',
        runState: '运行状态',
        protocolVersion: '协议版本',
        paired: '已配对',
        unpaired: '未配对',
        scanning: '搜索中…',
        search: '搜索 2.4G 设备',
        refresh: '刷新',
        remaining: '剩余',
        cancelSearch: '取消搜索',
        deviceId: '设备 ID',
        model: '型号',
        actions: '操作',
        pair: '配对',
        scanHint: '正在搜索，请将目标键盘切到 2.4G 模式并按住 KEY1 + KEY2 约 3 秒进入配对模式…',
        ledHint: '红灯、绿灯连续快速闪烁即进入配对模式。',
        searchHint: '点击“搜索 2.4G 设备”，接收头会扫描附近处于配对模式的本系列键盘。',
        step1: '确认设备',
        step2: '切换通信地址',
        step3: '连接验证',
        successHint: '配对成功，键盘绿灯快速闪烁。',
        unpair: '解除配对',
        refreshState: '刷新状态',
        stateIdle: '空闲',
        stateScanning: '搜索中',
        statePairing: '配对中',
        stateSuccess: '配对成功',
        stateFailed: '配对失败',
        stateUnknown: '未知',
        timeout: '接收头响应超时',
        connectFailed: '连接失败: ',
        scanStarted: '搜索已开始，请让目标键盘进入配对模式。',
        scanFailed: '搜索失败: ',
        pairRequestFailed: '配对请求失败，请重新搜索后再试。',
        selected: '已选定 ',
        selectedSuffix: '，正在切换通信地址…',
        pairFailed: '配对失败: ',
        pairSuccess: '配对成功！接收头已切换到新的通信地址，键盘绿灯快速闪烁。',
        pairRestore: '配对失败，已恢复原配对。请确认键盘仍在配对模式后重试。',
        cancelled: '已取消。',
        unpairWarning: '解除配对会断开当前键盘与接收头的配对关系，解除后必须重新搜索并配对才能恢复 2.4G 连接。请勿随意解除配对！',
        unpairTitle: '警告：确认解除 2.4G 配对？',
        unpairConfirm: '我确认解除',
        unpairCancel: '取消',
        unpairCancelled: '已取消解除配对。',
        unpairDone: '已解除配对，请重新搜索并配对。',
        unpairFailed: '解除配对失败: '
    }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return zh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return en; });
var zh = {
  title: '配置与保存', pageTitle: 'USB 自定义键盘配置工具', eyebrow: '自定义小键盘 · V6.2 R2', subtitle: '三键 / 长条四键 / 四键旋钮 / 六键 · 配置、灯光与按键测试',
  connect: '连接键盘', disconnect: '断开连接', help: '查看帮助', reference: '快捷键参考', test: '按键测试', close: '关闭',
  notice: '设置完成后，请点击“保存并回读验证”，再测试实际按键效果。',
  modelNames: { B3: '3 键', B4: '长条 4 键', C4: '4 键旋钮', B6: '6 键' }, protocol: '协议 07', connectHint: '请连接 V6.2 配套固件',
  phases: { disconnected: '未连接', connecting: '连接中', reading: '读取中', ready: '已读取', dirty: '未保存', saving: '保存并验证中', saved: '保存成功', error: '操作失败' },
  legacy: '检测到无 CRC 的旧格式配置。请先导出并核对内容；保存时会迁移格式。',
  damaged: '设备中的配置损坏或不受支持，当前显示默认值。原始 Flash 尚未覆盖；以下导出不包含损坏的原始数据。',
  blank: '设备尚无已提交配置，当前显示默认值。', saved: '设备写入验证通过，网页回读的持久化配置与提交内容一致。',
  refresh: '重新读取设备', export: '导出当前编辑', import: '导入备份', diagnostics: '导出诊断信息', key: '按键 {n}',
  knobs: ['旋钮顺时针', '旋钮逆时针', '旋钮中键'], lighting: '灯光', mode: '模式', brightness: '亮度',
  lightModes: ['关闭', '常亮', '按键亮', '流水灯', '呼吸灯'], colors: ['关闭', '蓝', '绿', '红', '黄', '青', '紫', '白'],
  unsaved: '有未保存的编辑。导入或导出不会自动写入设备。', savingHint: '保存期间请勿拔出键盘。', save: '保存并回读验证',
  emptyTitle: '先连接，再设置', empty: '通过本机启动器打开本页，使用桌面 Chrome / Edge 连接键盘。', emptyHint: '快捷键参考、帮助和按键测试也可以在未连接时使用。',
  confirmConnect: '连接并读取设备会丢弃当前未保存的编辑，是否继续？', confirmConnectTitle: '确认连接',
  serialUnsupported: '当前浏览器不支持 Web Serial，请使用支持该功能的桌面 Chrome 或 Edge。',
  invalidKey: '请先修正按键 {n} 的输入', invalidKnob: '请先修正{label}的输入', invalidAction: '{label}不支持该动作类型',
  confirmRead: '重新读取会丢弃尚未保存的编辑，是否继续？', confirmReadTitle: '确认重新读取',
  confirmSave: '本次保存会覆盖或迁移设备中的旧记录。请先导出并核对设置；原始坏数据将无法从此页面恢复。', confirmSaveTitle: '确认保存',
  exported: '已导出当前编辑；导出不代表已保存到设备', oversized: '备份文件过大', confirmImport: '导入会替换当前未保存的编辑，是否继续？', confirmImportTitle: '确认导入', imported: '备份已导入，尚未写入设备',
  diagnosticNote: '不包含完整按键内容、原始 DataFlash 或完整串口流；CRC 不是配置备份。',
  diagram: '按键与灯光示意', diagramHint: '点击按键卡片定位设置。颜色和功能显示当前编辑，保存后才会应用到实物。',
  diagramFooter: '按键按编号示意；灯光为颜色预览，不代表实测亮度或实时硬件状态。', off: '灯已关闭', selected: '正在编辑', editKey: '编辑{label}',
  tester: {
    subtitle: '无需联网，直接查看浏览器收到的输入。', start: '开始测试', stop: '停止测试', clear: '清空记录', active: '正在接收', paused: '已暂停', idle: '未开始',
    focus: '点击“开始测试”后，在此区域测试实际按键。', listening: '测试中：请按下键盘按键，或把鼠标放在此处测试点击与滚轮。',
    focusHint: '离开测试区自动暂停；按 Esc 退出。测试输入不会修改上方配置。',
    scope: '会记录所有键盘和鼠标送到本页的事件，无法区分来自哪个设备或哪个实体按键。',
    limits: '音量、静音、Win/Command、Alt+Tab 等可能由系统截获。请同时查看系统音量条或目标软件；没有网页记录不代表硬件故障。部分系统快捷键仍可能生效。',
    draft: '你有尚未保存的编辑。实物仍按设备中已保存的配置工作。',
    down: '按下', up: '松开', repeat: '重复', wheel: '滚轮', text: '字符串输入预览', textHint: '仅预览浏览器键值形成的文本（最近 500 字符）；测试字符串时请切换英文输入法。',
    textEmpty: '普通字母、数字、空格、Tab、Enter 将显示在这里', held: '当前按住', none: '无', history: '最近事件', empty: '尚无事件',
    total: '按下次数', repeats: '重复次数', mouse: '鼠标事件', event: '事件', value: '键值 / 组合', code: '键位代码', time: '时间',
    mouseNames: ['左键', '中键', '右键', '侧键 1', '侧键 2'], upWheel: '向上', downWheel: '向下', leftWheel: '向左', rightWheel: '向右',
    space: '空格', hint: '记录只保留在本页内存中，最多 80 条；清空或刷新后移除。计数是浏览器事件数，不是旋钮物理格数。'
  },
  support: {
    search: '搜索快捷键或用途', empty: '没有匹配的快捷键', referenceHint: '组合键模式中选择修饰键，再输入普通键；各按键卡片的“快速设置”可一键填入常用组合。不同系统和软件可能使用不同快捷键。',
    categories: ['常用编辑', '文本与办公', '窗口与系统', 'Mac 常用'],
    copy: '复制', paste: '粘贴', cut: '剪切', undo: '撤销', redo: '重做', all: '全选', save: '保存', find: '查找', print: '打印', new: '新建', open: '打开', bold: '加粗', italic: '斜体', underline: '下划线', home: '跳到文首', end: '跳到文末', switch: '切换窗口', desktop: '显示桌面', explorer: '文件资源管理器', lock: '锁定电脑', screenshot: '区域截图', forceQuit: '强制退出应用',
    helpIntro: '从连接到验证，按下面的步骤完成配置。所有参考和测试功能均可离线使用。',
    sections: [{ title: '1. 连接键盘', text: '解压整个离线包，双击“启动网页.cmd”，保持启动窗口开启。用桌面 Chrome / Edge 打开本机页面，点击“连接键盘”并选择设备。其他串口助手或配置页面占用端口时，请先关闭它们。' }, { title: '2. 配置按键和旋钮', text: '点击示意图可跳到对应按键。可设置普通键、功能键、多媒体、组合键、字符串或鼠标；旋钮额外支持顺时针、逆时针、中键和滚轮动作。字符串：三键每键 30 字节，其余每键 10 字节，支持 ASCII、Tab 和换行。' }, { title: '3. 设置灯光', text: '选择模式、各按键颜色和亮度。示意图立即预览编辑颜色；预览不是硬件状态回传。亮度为 0、颜色为关闭或模式为关闭时，灯光示意熄灭。' }, { title: '4. 保存并核对', text: '松开实体按键，点击“保存并回读验证”，看到“保存成功”后拔插并重新读取。导入只替换编辑内容，不自动写入；建议保存正常配置的 JSON 备份。' }, { title: '5. 按键测试', text: '点击“开始测试”，在测试区检查按下、松开、组合键、字符串和鼠标事件。离开测试区自动暂停。音量和系统快捷键请在系统或目标软件中观察实际效果；测试区无法确认按键属于哪台设备。' }, { title: '遇到连接或保存问题', text: '确认选择了对应型号，使用本包网页；关闭占用串口的软件后重连。保存失败请先保留提示和诊断信息。损坏配置显示的默认值不是恢复出的旧设置；保存中途断电仍可能丢失配置。' }, { title: 'Windows 与 Mac', text: 'Win 与 Mac Command 使用同一个修饰键编码。Mac 复制粘贴通常使用 Command+C/V，可在组合键中选左 Win/Command。快捷键是否生效还取决于操作系统和当前应用。' }]
  }
};
var en = {
  title: 'Configure & save', pageTitle: 'USB Keypad Configurator', eyebrow: 'CUSTOM KEYPAD · V6.2 R2', subtitle: '3-key / 4-key bar / 4-key + knob / 6-key · Configuration, lighting & input test',
  connect: 'Connect keypad', disconnect: 'Disconnect', help: 'Help', reference: 'Shortcut reference', test: 'Key test', close: 'Close', notice: 'After editing, click “Save & verify” before testing the physical keys.',
  modelNames: { B3: '3-key', B4: '4-key bar', C4: '4-key + knob', B6: '6-key' }, protocol: 'Protocol 07', connectHint: 'Connect a matching V6.2 keypad',
  phases: { disconnected: 'Disconnected', connecting: 'Connecting', reading: 'Reading', ready: 'Loaded', dirty: 'Unsaved', saving: 'Saving & verifying', saved: 'Saved', error: 'Operation failed' },
  legacy: 'A legacy configuration without CRC was found. Export and check it before saving; saving migrates its format.',
  damaged: 'Stored configuration is damaged or unsupported. Defaults are displayed. Raw Flash has not been overwritten; exports do not include the damaged raw data.', blank: 'No committed configuration was found. Defaults are displayed.', saved: 'Device verification passed and the stored readback matches the submitted configuration.',
  refresh: 'Read device again', export: 'Export current edits', import: 'Import backup', diagnostics: 'Export diagnostics', key: 'Key {n}', knobs: ['Knob clockwise', 'Knob counterclockwise', 'Knob push'], lighting: 'Lighting', mode: 'Mode', brightness: 'Brightness',
  lightModes: ['Off', 'Always on', 'On keypress', 'Chase', 'Breathing'], colors: ['Off', 'Blue', 'Green', 'Red', 'Yellow', 'Cyan', 'Purple', 'White'],
  unsaved: 'You have unsaved edits. Importing or exporting does not write to the device.', savingHint: 'Keep the keypad plugged in while saving.', save: 'Save & verify', emptyTitle: 'Connect, then configure', empty: 'Open this page with the local launcher and connect in desktop Chrome / Edge.', emptyHint: 'Shortcut reference, help and input testing are also available without a serial connection.',
  confirmConnect: 'Connecting and reading will discard unsaved edits. Continue?', confirmConnectTitle: 'Connect device', serialUnsupported: 'Web Serial is unavailable. Please use a supported desktop Chrome or Edge browser.', invalidKey: 'Please correct the input for key {n}', invalidKnob: 'Please correct the input for {label}', invalidAction: '{label} does not support this action',
  confirmRead: 'Reading the device will discard unsaved edits. Continue?', confirmReadTitle: 'Read device', confirmSave: 'This will overwrite or migrate the stored record. Export and check your settings first; the original damaged data cannot be restored from this page.', confirmSaveTitle: 'Save configuration', exported: 'Current edits exported; this does not mean they are saved to the device', oversized: 'The backup file is too large', confirmImport: 'Importing will replace your unsaved edits. Continue?', confirmImportTitle: 'Import backup', imported: 'Backup imported; not yet written to the device', diagnosticNote: 'Does not include full key content, raw DataFlash or the complete serial stream; a CRC is not a backup.',
  diagram: 'Key & lighting preview', diagramHint: 'Click a key to find its settings. Colors and actions show current edits and apply to hardware only after saving.', diagramFooter: 'Keys are shown by number. Colors are a preview, not measured brightness or live hardware feedback.', off: 'Light off', selected: 'Editing', editKey: 'Edit {label}',
  tester: { subtitle: 'See input received by this browser, fully offline.', start: 'Start test', stop: 'Stop test', clear: 'Clear log', active: 'Listening', paused: 'Paused', idle: 'Not started', focus: 'Click “Start test”, then try your physical keys here.', listening: 'Listening: press keys, or keep the pointer here to test mouse buttons and scrolling.', focusHint: 'Leaving this area pauses the test; press Esc to exit. Test input does not edit your configuration.', scope: 'Events from all keyboards and mice reaching this page are shown. The browser cannot identify the device or physical keypad key.', limits: 'Volume, mute, Win/Command, Alt+Tab and other shortcuts may be intercepted by the system. Also check the system volume indicator or target app; no browser event does not mean a hardware fault. Some system shortcuts may still take effect.', draft: 'You have unsaved edits. The physical device still uses its saved configuration.', down: 'Down', up: 'Up', repeat: 'Repeat', wheel: 'Wheel', text: 'String input preview', textHint: 'Text formed from browser key values (last 500 characters). Use an English input method to test strings.', textEmpty: 'Letters, numbers, Space, Tab and Enter appear here', held: 'Currently held', none: 'None', history: 'Recent events', empty: 'No events yet', total: 'Key downs', repeats: 'Repeats', mouse: 'Mouse events', event: 'Event', value: 'Key / combination', code: 'Key code', time: 'Time', mouseNames: ['Left', 'Middle', 'Right', 'Side 1', 'Side 2'], upWheel: 'Up', downWheel: 'Down', leftWheel: 'Left', rightWheel: 'Right', space: 'Space', hint: 'Only the latest 80 events are held in this page’s memory; clear or refresh to remove them. Counts are browser events, not physical knob detents.' },
  support: { search: 'Search shortcut or action', empty: 'No matching shortcuts', referenceHint: 'In Combination mode, select a modifier and a normal key. “Quick settings” in each key editor can fill common combinations. Shortcuts depend on your system and application.', categories: ['Editing', 'Text & office', 'Windows & system', 'Mac essentials'], copy: 'Copy', paste: 'Paste', cut: 'Cut', undo: 'Undo', redo: 'Redo', all: 'Select all', save: 'Save', find: 'Find', print: 'Print', new: 'New', open: 'Open', bold: 'Bold', italic: 'Italic', underline: 'Underline', home: 'Start of document', end: 'End of document', switch: 'Switch applications', desktop: 'Show desktop', explorer: 'File Explorer', lock: 'Lock computer', screenshot: 'Capture selection', forceQuit: 'Force quit applications', helpIntro: 'Follow these steps to connect, configure and verify. All reference and test features work offline.', sections: [{ title: '1. Connect the keypad', text: 'Extract the complete offline package, run 启动网页.cmd and leave its window open. In desktop Chrome / Edge, open the local page, click “Connect keypad” and select the device. Close other serial tools or configurator tabs that hold the port.' }, { title: '2. Configure keys and the knob', text: 'Click a preview key to jump to its editor. Configure normal keys, function keys, media, combinations, strings or mouse actions. Knob models also provide clockwise, counterclockwise, push and wheel actions. Strings allow 30 bytes per key on the 3-key model, or 10 on other models; ASCII, Tab and line breaks are supported.' }, { title: '3. Set lighting', text: 'Select a mode, per-key colors and brightness. The diagram previews your edits; it is not hardware feedback. Brightness zero, an Off color or Off mode makes the corresponding preview light dark.' }, { title: '4. Save and verify', text: 'Release the physical keys and click “Save & verify”. After success, unplug, reconnect and read again. Importing only replaces the editor contents; it does not save automatically. Keep a JSON backup of known-good settings.' }, { title: '5. Test input', text: 'Click “Start test” to check key downs, releases, combinations, strings and mouse events. Leaving the area pauses testing. Observe volume and system shortcuts in the system or target app; the tester cannot determine which device sent an event.' }, { title: 'Connection or save problems', text: 'Check the model and use the matching configurator. Close other serial applications and reconnect. Keep the error and diagnostic information if saving fails. Defaults shown for damaged storage are not recovered settings; power loss during saving can still lose the configuration.' }, { title: 'Windows and Mac', text: 'Win and Mac Command share a modifier code. On Mac, copy/paste normally use Command+C/V; select Left Win/Command in a combination. Shortcut behavior depends on the operating system and focused application.' }] }
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    },
    empty: {
      description: 'No Data'
    }
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(225);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(262)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./index.css", function() {
			var newContent = require("!!../../../css-loader/index.js!../../../postcss-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-i18n v6.1.3 
 * (c) 2017 kazuya kawaguchi
 * Released under the MIT License.
 */
/*  */

/**
 * utilites
 */

function warn (msg, err) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-i18n] ' + msg);
    if (err) {
      console.warn(err.stack);
    }
  }
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}



function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

var toString = Object.prototype.toString;
var OBJECT_STRING = '[object Object]';
function isPlainObject (obj) {
  return toString.call(obj) === OBJECT_STRING
}

function isNull (val) {
  return val === null || val === undefined
}

function parseArgs () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  var locale = null;
  var params = null;
  if (args.length === 1) {
    if (isObject(args[0]) || Array.isArray(args[0])) {
      params = args[0];
    } else if (typeof args[0] === 'string') {
      locale = args[0];
    }
  } else if (args.length === 2) {
    if (typeof args[0] === 'string') {
      locale = args[0];
    }
    if (isObject(args[1]) || Array.isArray(args[1])) {
      params = args[1];
    }
  }

  return { locale: locale, params: params }
}

function getOldChoiceIndexFixed (choice) {
  return choice
    ? choice > 1
      ? 1
      : 0
    : 1
}

function getChoiceIndex (choice, choicesLength) {
  choice = Math.abs(choice);

  if (choicesLength === 2) { return getOldChoiceIndexFixed(choice) }

  return choice ? Math.min(choice, 2) : 0
}

function fetchChoice (message, choice) {
  if (!message && typeof message !== 'string') { return null }
  var choices = message.split('|');

  choice = getChoiceIndex(choice, choices.length);
  if (!choices[choice]) { return message }
  return choices[choice].trim()
}

function looseClone (obj) {
  return JSON.parse(JSON.stringify(obj))
}

/*  */

function extend (Vue) {
  Vue.prototype.$t = function (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var i18n = this.$i18n;
    return i18n._t.apply(i18n, [ key, i18n.locale, i18n.messages, this ].concat( values ))
  };

  Vue.prototype.$tc = function (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

    var i18n = this.$i18n;
    return i18n._tc.apply(i18n, [ key, i18n.locale, i18n.messages, this, choice ].concat( values ))
  };

  Vue.prototype.$te = function (key, locale) {
    var i18n = this.$i18n;
    return i18n._te(key, i18n.locale, i18n.messages, locale)
  };
}

/*  */

var mixin = {
  beforeCreate: function beforeCreate () {
    var this$1 = this;

    var options = this.$options;
    options.i18n = options.i18n || (options.__i18n ? {} : null);

    if (options.i18n) {
      if (options.i18n instanceof VueI18n) {
        this._i18n = options.i18n;
        this._i18nWatcher = this._i18n.watchI18nData(function () { return this$1.$forceUpdate(); });
      } else if (isPlainObject(options.i18n)) {
        // component local i18n
        if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
          options.i18n.root = this.$root.$i18n;
          options.i18n.silentTranslationWarn = this.$root.$i18n.silentTranslationWarn;
        }

        // init locale messages via custom blocks
        if (options.__i18n) {
          try {
            options.i18n.messages = JSON.parse(options.__i18n);
          } catch (e) {
            if (false) {
              warn("Cannot parse locale messages via custom blocks.");
            }
          }
        }

        this._i18n = new VueI18n(options.i18n);
        this._i18nWatcher = this._i18n.watchI18nData(function () { return this$1.$forceUpdate(); });

        if (options.i18n.sync === undefined || !!options.i18n.sync) {
          this._localeWatcher = this.$i18n.watchLocale(function () { return this$1.$forceUpdate(); });
        }
      } else {
        if (false) {
          warn("Cannot be interpreted 'i18n' option.");
        }
      }
    } else if (this.$root && this.$root.$i18n && this.$root.$i18n instanceof VueI18n) {
      // root i18n
      this._i18n = this.$root.$i18n;
      this._i18nWatcher = this._i18n.watchI18nData(function () { return this$1.$forceUpdate(); });
    }
  },

  beforeDestroy: function beforeDestroy () {
    if (!this._i18n) { return }

    if (this._i18nWatcher) {
      this._i18nWatcher();
      delete this._i18nWatcher;
    }

    if (this._localeWatcher) {
      this._localeWatcher();
      delete this._localeWatcher;
    }

    this._i18n = null;
  }
};

var Vue;

function install (_Vue) {
  Vue = _Vue;

  var version = (Vue.version && Number(Vue.version.split('.')[0])) || -1;
  if (false) {
    warn('already installed.');
    return
  }
  install.installed = true;

  if (false) {
    warn(("vue-i18n (" + (install.version) + ") need to use Vue 2.0 or later (Vue: " + (Vue.version) + ")."));
    return
  }

  Object.defineProperty(Vue.prototype, '$i18n', {
    get: function get () { return this._i18n }
  });

  extend(Vue);
  Vue.mixin(mixin);

  // use object-based merge strategy
  var strats = Vue.config.optionMergeStrategies;
  strats.i18n = strats.methods;
}

/*  */

var BaseFormatter = function BaseFormatter (options) {
  if ( options === void 0 ) options = {};

  this._options = options;
};

var prototypeAccessors$1 = { options: {} };

prototypeAccessors$1.options.get = function () { return this._options };

BaseFormatter.prototype.format = function format (message) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  return template.apply(void 0, [ message ].concat( values ))
};

Object.defineProperties( BaseFormatter.prototype, prototypeAccessors$1 );

/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;

/**
 * template
 *
 * @param {String} string
 * @param {Array} ...values
 * @return {String}
 */

function template (str) {
  var values = [], len = arguments.length - 1;
  while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  if (values.length === 1 && typeof values[0] === 'object') {
    values = values[0];
  } else {
    values = {};
  }

  if (!values || !values.hasOwnProperty) {
    values = {};
  }

  return str.replace(RE_NARGS, function (match, prefix, i, index) {
    var result;

    if (str[index - 1] === '{' &&
      str[index + match.length] === '}') {
      return i
    } else {
      result = hasOwn(values, i) ? values[i] : match;
      if (isNull(result)) {
        return ''
      }

      return result
    }
  })
}

/*  */

/**
 *  Path paerser
 *  - Inspired:
 *    Vue.js Path parser
 */

// cache
var pathCache = Object.create(null);

// actions
var APPEND = 0;
var PUSH = 1;
var INC_SUB_PATH_DEPTH = 2;
var PUSH_SUB_PATH = 3;

// states
var BEFORE_PATH = 0;
var IN_PATH = 1;
var BEFORE_IDENT = 2;
var IN_IDENT = 3;
var IN_SUB_PATH = 4;
var IN_SINGLE_QUOTE = 5;
var IN_DOUBLE_QUOTE = 6;
var AFTER_PATH = 7;
var ERROR = 8;

var pathStateMachine = [];

pathStateMachine[BEFORE_PATH] = {
  'ws': [BEFORE_PATH],
  'ident': [IN_IDENT, APPEND],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[IN_PATH] = {
  'ws': [IN_PATH],
  '.': [BEFORE_IDENT],
  '[': [IN_SUB_PATH],
  'eof': [AFTER_PATH]
};

pathStateMachine[BEFORE_IDENT] = {
  'ws': [BEFORE_IDENT],
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND]
};

pathStateMachine[IN_IDENT] = {
  'ident': [IN_IDENT, APPEND],
  '0': [IN_IDENT, APPEND],
  'number': [IN_IDENT, APPEND],
  'ws': [IN_PATH, PUSH],
  '.': [BEFORE_IDENT, PUSH],
  '[': [IN_SUB_PATH, PUSH],
  'eof': [AFTER_PATH, PUSH]
};

pathStateMachine[IN_SUB_PATH] = {
  "'": [IN_SINGLE_QUOTE, APPEND],
  '"': [IN_DOUBLE_QUOTE, APPEND],
  '[': [IN_SUB_PATH, INC_SUB_PATH_DEPTH],
  ']': [IN_PATH, PUSH_SUB_PATH],
  'eof': ERROR,
  'else': [IN_SUB_PATH, APPEND]
};

pathStateMachine[IN_SINGLE_QUOTE] = {
  "'": [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_SINGLE_QUOTE, APPEND]
};

pathStateMachine[IN_DOUBLE_QUOTE] = {
  '"': [IN_SUB_PATH, APPEND],
  'eof': ERROR,
  'else': [IN_DOUBLE_QUOTE, APPEND]
};

/**
 * Check if an expression is a literal value.
 */

var literalValueRE = /^\s?(true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function isLiteral (exp) {
  return literalValueRE.test(exp)
}

/**
 * Strip quotes from a string
 */

function stripQuotes (str) {
  var a = str.charCodeAt(0);
  var b = str.charCodeAt(str.length - 1);
  return a === b && (a === 0x22 || a === 0x27)
    ? str.slice(1, -1)
    : str
}

/**
 * Determine the type of a character in a keypath.
 */

function getPathCharType (ch) {
  if (ch === undefined || ch === null) { return 'eof' }

  var code = ch.charCodeAt(0);

  switch (code) {
    case 0x5B: // [
    case 0x5D: // ]
    case 0x2E: // .
    case 0x22: // "
    case 0x27: // '
    case 0x30: // 0
      return ch

    case 0x5F: // _
    case 0x24: // $
    case 0x2D: // -
      return 'ident'

    case 0x20: // Space
    case 0x09: // Tab
    case 0x0A: // Newline
    case 0x0D: // Return
    case 0xA0:  // No-break space
    case 0xFEFF:  // Byte Order Mark
    case 0x2028:  // Line Separator
    case 0x2029:  // Paragraph Separator
      return 'ws'
  }

  // a-z, A-Z
  if ((code >= 0x61 && code <= 0x7A) || (code >= 0x41 && code <= 0x5A)) {
    return 'ident'
  }

  // 1-9
  if (code >= 0x31 && code <= 0x39) { return 'number' }

  return 'else'
}

/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */

function formatSubPath (path) {
  var trimmed = path.trim();
  // invalid leading 0
  if (path.charAt(0) === '0' && isNaN(path)) { return false }

  return isLiteral(trimmed) ? stripQuotes(trimmed) : '*' + trimmed
}

/**
 * Parse a string path into an array of segments
 */

function parse (path) {
  var keys = [];
  var index = -1;
  var mode = BEFORE_PATH;
  var subPathDepth = 0;
  var c;
  var key;
  var newChar;
  var type;
  var transition;
  var action;
  var typeMap;
  var actions = [];

  actions[PUSH] = function () {
    if (key !== undefined) {
      keys.push(key);
      key = undefined;
    }
  };

  actions[APPEND] = function () {
    if (key === undefined) {
      key = newChar;
    } else {
      key += newChar;
    }
  };

  actions[INC_SUB_PATH_DEPTH] = function () {
    actions[APPEND]();
    subPathDepth++;
  };

  actions[PUSH_SUB_PATH] = function () {
    if (subPathDepth > 0) {
      subPathDepth--;
      mode = IN_SUB_PATH;
      actions[APPEND]();
    } else {
      subPathDepth = 0;
      key = formatSubPath(key);
      if (key === false) {
        return false
      } else {
        actions[PUSH]();
      }
    }
  };

  function maybeUnescapeQuote () {
    var nextChar = path[index + 1];
    if ((mode === IN_SINGLE_QUOTE && nextChar === "'") ||
      (mode === IN_DOUBLE_QUOTE && nextChar === '"')) {
      index++;
      newChar = '\\' + nextChar;
      actions[APPEND]();
      return true
    }
  }

  while (mode !== null) {
    index++;
    c = path[index];

    if (c === '\\' && maybeUnescapeQuote()) {
      continue
    }

    type = getPathCharType(c);
    typeMap = pathStateMachine[mode];
    transition = typeMap[type] || typeMap['else'] || ERROR;

    if (transition === ERROR) {
      return // parse error
    }

    mode = transition[0];
    action = actions[transition[1]];
    if (action) {
      newChar = transition[2];
      newChar = newChar === undefined
        ? c
        : newChar;
      if (action() === false) {
        return
      }
    }

    if (mode === AFTER_PATH) {
      return keys
    }
  }
}

/**
 * External parse that check for a cache hit first
 */

function parsePath (path) {
  var hit = pathCache[path];
  if (!hit) {
    hit = parse(path);
    if (hit) {
      pathCache[path] = hit;
    }
  }
  return hit || []
}





function empty (target) {
  if (target === null || target === undefined) { return true }

  if (Array.isArray(target)) {
    if (target.length > 0) { return false }
    if (target.length === 0) { return true }
  } else if (isPlainObject(target)) {
    for (var key in target) {
      if (hasOwn(target, key)) { return false }
    }
  }

  return true
}

/**
 * Get path value from path string
 */
function getPathValue (obj, path) {
  if (!isObject(obj)) { return null }

  var paths = parsePath(path);
  if (empty(paths)) {
    return null
  } else {
    var length = paths.length;
    var ret = null;
    var last = obj;
    var i = 0;
    while (i < length) {
      var value = last[paths[i]];
      if (value === undefined) {
        last = null;
        break
      }
      last = value;
      i++;
    }

    ret = last;
    return ret
  }
}

/*  */

var VueI18n = function VueI18n (options) {
  if ( options === void 0 ) options = {};

  var locale = options.locale || 'en-US';
  var fallbackLocale = options.fallbackLocale || 'en-US';
  var messages = options.messages || {};
  this._vm = null;
  this._formatter = options.formatter || new BaseFormatter();
  this._missing = options.missing || null;
  this._root = options.root || null;
  this._sync = options.sync === undefined ? true : !!options.sync;
  this._fallbackRoot = options.fallbackRoot === undefined
    ? true
    : !!options.fallbackRoot;
  this._silentTranslationWarn = options.silentTranslationWarn === undefined
    ? false
    : !!options.silentTranslationWarn;

  this._exist = function (message, key) {
    if (!message || !key) { return false }
    return !isNull(getPathValue(message, key))
  };

  this._initVM({ locale: locale, fallbackLocale: fallbackLocale, messages: messages });
};

var prototypeAccessors = { vm: {},messages: {},locale: {},fallbackLocale: {},missing: {},formatter: {},silentTranslationWarn: {} };

VueI18n.prototype._initVM = function _initVM (data) {
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  this._vm = new Vue({ data: data });
  Vue.config.silent = silent;
};

VueI18n.prototype.watchI18nData = function watchI18nData (fn) {
  return this._vm.$watch('$data', function () {
    fn && fn();
  }, { deep: true })
};

VueI18n.prototype.watchLocale = function watchLocale (fn) {
  if (!this._sync || !this._root) { return null }
  var target = this._vm;
  return this._root.vm.$watch('locale', function (val) {
    target.$set(target, 'locale', val);
    fn && fn();
  }, { immediate: true })
};

prototypeAccessors.vm.get = function () { return this._vm };

prototypeAccessors.messages.get = function () { return looseClone(this._vm.messages) };

prototypeAccessors.locale.get = function () { return this._vm.locale };
prototypeAccessors.locale.set = function (locale) {
  this._vm.$set(this._vm, 'locale', locale);
};

prototypeAccessors.fallbackLocale.get = function () { return this._vm.fallbackLocale };
prototypeAccessors.fallbackLocale.set = function (locale) {
  this._vm.$set(this._vm, 'fallbackLocale', locale);
};

prototypeAccessors.missing.get = function () { return this._missing };
prototypeAccessors.missing.set = function (handler) { this._missing = handler; };

prototypeAccessors.formatter.get = function () { return this._formatter };
prototypeAccessors.formatter.set = function (formatter) { this._formatter = formatter; };

prototypeAccessors.silentTranslationWarn.get = function () { return this._silentTranslationWarn };
prototypeAccessors.silentTranslationWarn.set = function (silent) { this._silentTranslationWarn = silent; };

VueI18n.prototype._warnDefault = function _warnDefault (locale, key, result, vm) {
  if (!isNull(result)) { return result }
  if (this.missing) {
    this.missing.apply(null, [locale, key, vm]);
  } else {
    if (false) {
      warn(
        "Cannot translate the value of keypath '" + key + "'. " +
        'Use the value of keypath as default.'
      );
    }
  }
  return key
};

VueI18n.prototype._isFallbackRoot = function _isFallbackRoot (val) {
  return !val && !isNull(this._root) && this._fallbackRoot
};

VueI18n.prototype._interpolate = function _interpolate (message, key, values) {
    var this$1 = this;

  if (!message) { return null }

  var pathRet = getPathValue(message, key);
  if (Array.isArray(pathRet)) { return pathRet }

  var ret;
  if (isNull(pathRet)) {
    if (isPlainObject(message)) {
      ret = message[key];
      if (typeof ret !== 'string') {
        if (false) {
          warn(("Value of key '" + key + "' is not a string!"));
        }
        return null
      }
    } else {
      return null
    }
  } else {
    if (typeof pathRet === 'string') {
      ret = pathRet;
    } else {
      if (false) {
        warn(("Value of key '" + key + "' is not a string!"));
      }
      return null
    }
  }

  // Check for the existance of links within the translated string
  if (ret.indexOf('@:') >= 0) {
    // Match all the links within the local
    // We are going to replace each of
    // them with its translation
    var matches = ret.match(/(@:[\w|.]+)/g);
    for (var idx in matches) {
      var link = matches[idx];
      // Remove the leading @:
      var linkPlaceholder = link.substr(2);
      // Translate the link
      var translatedstring = this$1._interpolate(message, linkPlaceholder, values);
      // Replace the link with the translated string
      ret = ret.replace(link, translatedstring);
    }
  }

  return !values ? ret : this._format(ret, values)
};

VueI18n.prototype._format = function _format (message) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  return (ref = this._formatter).format.apply(ref, [ message ].concat( values ))
    var ref;
};

VueI18n.prototype._translate = function _translate (messages, locale, fallback, key, args) {
  var res = null;
  res = this._interpolate(messages[locale], key, args);
  if (!isNull(res)) { return res }

  res = this._interpolate(messages[fallback], key, args);
  if (!isNull(res)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with '" + fallback + "' locale."));
    }
    return res
  } else {
    return null
  }
};

VueI18n.prototype._t = function _t (key, _locale, messages, host) {
    var values = [], len = arguments.length - 4;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 4 ];

  if (!key) { return '' }

  var parsedArgs = parseArgs.apply(void 0, values);
  var locale = parsedArgs.locale || _locale;

  var ret = this._translate(messages, locale, this.fallbackLocale, key, parsedArgs.params);
  if (this._isFallbackRoot(ret)) {
    if (false) {
      warn(("Fall back to translate the keypath '" + key + "' with root locale."));
    }
    if (!this._root) { throw Error('unexpected error') }
      return (ref = this._root).t.apply(ref, [ key ].concat( values ))
  } else {
    return this._warnDefault(locale, key, ret, host)
  }
    var ref;
};

VueI18n.prototype.t = function t (key) {
    var values = [], len = arguments.length - 1;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

  return (ref = this)._t.apply(ref, [ key, this.locale, this.messages, null ].concat( values ))
    var ref;
};

VueI18n.prototype._tc = function _tc (key, _locale, messages, host, choice) {
    var values = [], len = arguments.length - 5;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 5 ];

  if (!key) { return '' }
  if (choice !== undefined) {
    return fetchChoice((ref = this)._t.apply(ref, [ key, _locale, messages, host ].concat( values )), choice)
  } else {
    return (ref$1 = this)._t.apply(ref$1, [ key, _locale, messages, host ].concat( values ))
  }
    var ref;
    var ref$1;
};

VueI18n.prototype.tc = function tc (key, choice) {
    var values = [], len = arguments.length - 2;
    while ( len-- > 0 ) values[ len ] = arguments[ len + 2 ];

  return (ref = this)._tc.apply(ref, [ key, this.locale, this.messages, null, choice ].concat( values ))
    var ref;
};

VueI18n.prototype._te = function _te (key, locale, messages) {
    var args = [], len = arguments.length - 3;
    while ( len-- > 0 ) args[ len ] = arguments[ len + 3 ];

  var _locale = parseArgs.apply(void 0, args).locale || locale;
  return this._exist(messages[_locale], key)
};

VueI18n.prototype.te = function te (key, locale) {
  return this._te(key, this.locale, this.messages, locale)
};

VueI18n.prototype.getLocaleMessage = function getLocaleMessage (locale) {
  return looseClone(this._vm.messages[locale])
};

VueI18n.prototype.setLocaleMessage = function setLocaleMessage (locale, message) {
  this._vm.messages[locale] = message;
};

VueI18n.prototype.mergeLocaleMessage = function mergeLocaleMessage (locale, message) {
  this._vm.messages[locale] = Vue.util.extend(this.getLocaleMessage(locale), message);
};

Object.defineProperties( VueI18n.prototype, prototypeAccessors );

VueI18n.install = install;
VueI18n.version = '6.1.3';

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueI18n);
}

/* harmony default export */ __webpack_exports__["a"] = (VueI18n);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d452c8f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(274)
}
var normalizeComponent = __webpack_require__(42)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d452c8f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d452c8f_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(141);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var bind = __webpack_require__(80);
var Axios = __webpack_require__(143);
var mergeConfig = __webpack_require__(78);
var defaults = __webpack_require__(30);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(29);
axios.CancelToken = __webpack_require__(142);
axios.isCancel = __webpack_require__(75);
axios.VERSION = __webpack_require__(79).version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(156);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(152);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(29);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var buildURL = __webpack_require__(81);
var InterceptorManager = __webpack_require__(144);
var dispatchRequest = __webpack_require__(146);
var mergeConfig = __webpack_require__(78);
var validator = __webpack_require__(157);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(151);
var combineURLs = __webpack_require__(149);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var transformData = __webpack_require__(148);
var isCancel = __webpack_require__(75);
var defaults = __webpack_require__(30);
var Cancel = __webpack_require__(29);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(76);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);
var defaults = __webpack_require__(30);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(5);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var VERSION = __webpack_require__(79).version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_classCallCheck__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_createClass__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_KeyConfig_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_KeyboardTester_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Rf24Pair_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stability_codec_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stability_legacy_bridge_js__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_video_tutorial_mp4__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_video_tutorial_mp4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_video_tutorial_mp4__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: { KeyConfig: __WEBPACK_IMPORTED_MODULE_7__components_KeyConfig_vue__["a" /* default */], KeyboardTester: __WEBPACK_IMPORTED_MODULE_8__components_KeyboardTester_vue__["a" /* default */], Rf24Pair: __WEBPACK_IMPORTED_MODULE_9__components_Rf24Pair_vue__["a" /* default */] },
  methods: {
    // CRC-16/CCITT-FALSE: poly=0x1021, init=0xFFFF, xorout=0x0000
    crc16Ccitt: function crc16Ccitt(data, start, endExclusive) {
      var crc = 0xffff;
      for (var i = start; i < endExclusive; i++) {
        crc ^= data[i] << 8;
        for (var bit = 0; bit < 8; bit++) {
          crc = crc & 0x8000 ? crc << 1 ^ 0x1021 : crc << 1;
          crc &= 0xffff;
        }
      }
      return crc;
    },
    getV62KeyRefs: function getV62KeyRefs(type) {
      var _this = this;

      var names = {
        B3: ['b3key1config', 'b3key2config', 'b3key3config'],
        B4: ['b4key1config', 'b4key2config', 'b4key3config', 'b4key4config'],
        C4: ['c4key1config', 'c4key2config', 'c4key3config', 'c4key4config'],
        B6: ['b6key1config', 'b6key2config', 'b6key3config', 'b6key4config', 'b6key5config', 'b6key6config']
      };
      return (names[type] || []).map(function (name) {
        return _this.$refs[name];
      });
    },
    applyV62Lighting: function applyV62Lighting(type, lighting) {
      if (type === 'B3') {
        this.backlightMode = lighting.mode;

        var _lighting$colors = __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray___default()(lighting.colors, 3);

        this.backlightColor1 = _lighting$colors[0];
        this.backlightColor2 = _lighting$colors[1];
        this.backlightColor3 = _lighting$colors[2];

        this.backlightBrightness = lighting.brightness;
      } else if (type === 'B4') {
        this.backlightModeB4 = lighting.mode;

        var _lighting$colors2 = __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray___default()(lighting.colors, 4);

        this.backlightColorB4_1 = _lighting$colors2[0];
        this.backlightColorB4_2 = _lighting$colors2[1];
        this.backlightColorB4_3 = _lighting$colors2[2];
        this.backlightColorB4_4 = _lighting$colors2[3];

        this.backlightBrightnessB4 = lighting.brightness;
      } else if (type === 'C4') {
        this.backlightModeC4 = lighting.mode;

        var _lighting$colors3 = __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray___default()(lighting.colors, 4);

        this.backlightColorC4_1 = _lighting$colors3[0];
        this.backlightColorC4_2 = _lighting$colors3[1];
        this.backlightColorC4_3 = _lighting$colors3[2];
        this.backlightColorC4_4 = _lighting$colors3[3];

        this.backlightBrightnessC4 = lighting.brightness;
      } else if (type === 'B6') {
        this.backlightModeB6 = lighting.mode;

        var _lighting$colors4 = __WEBPACK_IMPORTED_MODULE_6_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_slicedToArray___default()(lighting.colors, 6);

        this.backlightColorB6_1 = _lighting$colors4[0];
        this.backlightColorB6_2 = _lighting$colors4[1];
        this.backlightColorB6_3 = _lighting$colors4[2];
        this.backlightColorB6_4 = _lighting$colors4[3];
        this.backlightColorB6_5 = _lighting$colors4[4];
        this.backlightColorB6_6 = _lighting$colors4[5];

        this.backlightBrightnessB6 = lighting.brightness;
      }
    },
    applyV62Snapshot: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(snapshot) {
        var _this2 = this;

        var view, refs, dirs;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                view = __WEBPACK_IMPORTED_MODULE_11__stability_legacy_bridge_js__["a" /* decodePayload */](snapshot.type, snapshot.payload);

                this.v62Protocol = true;
                this.v62Status = snapshot.status;
                this.deviceType = snapshot.type;
                this.deviceVersion = '07';
                _context.next = 7;
                return this.$nextTick();

              case 7:
                refs = this.getV62KeyRefs(snapshot.type);

                if (!(refs.length !== view.keys.length || refs.some(function (ref) {
                  return !ref;
                }))) {
                  _context.next = 10;
                  break;
                }

                throw Error(this.$t('index.errPageConfig'));

              case 10:
                view.keys.forEach(function (item, index) {
                  return refs[index].setKey(item.key, item.func, item.extra, item.text, item.mix);
                });
                this.applyV62Lighting(snapshot.type, view.lighting);
                if (snapshot.type === 'C4') {
                  dirs = ['CW', 'CCW', 'Btn'];

                  view.knobs.forEach(function (item, index) {
                    var name = 'ec11' + dirs[index];
                    _this2[name + '_key'] = item.key;
                    _this2[name + '_func'] = item.func;
                    _this2[name + '_keyF'] = item.extra;
                    _this2[name + '_keyMix'] = item.mix.slice();
                  });
                  this.initEc11UI();
                  this.updateC4KeyDescs();
                } else if (snapshot.type === 'B3') this.updateB3KeyDescs();else if (snapshot.type === 'B4') this.updateB4KeyDescs();else if (snapshot.type === 'B6') this.updateB6KeyDescs();
                this.getCommonData();
                if (snapshot.status === 1) this.$message.warning(this.$t('workspace.legacy'));else if (snapshot.status === 2) this.$message.warning(this.$t('workspace.damaged'));else if (snapshot.status === 3) this.$message.warning(this.$t('workspace.blank'));

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function applyV62Snapshot(_x) {
        return _ref.apply(this, arguments);
      }

      return applyV62Snapshot;
    }(),
    v62Lighting: function v62Lighting() {
      if (this.deviceType === 'B3') return { mode: this.backlightMode, colors: [this.backlightColor1, this.backlightColor2, this.backlightColor3], brightness: this.backlightBrightness };
      if (this.deviceType === 'B4') return { mode: this.backlightModeB4, colors: [this.backlightColorB4_1, this.backlightColorB4_2, this.backlightColorB4_3, this.backlightColorB4_4], brightness: this.backlightBrightnessB4 };
      if (this.deviceType === 'C4') return { mode: this.backlightModeC4, colors: [this.backlightColorC4_1, this.backlightColorC4_2, this.backlightColorC4_3, this.backlightColorC4_4], brightness: this.backlightBrightnessC4 };
      return { mode: this.backlightModeB6, colors: [this.backlightColorB6_1, this.backlightColorB6_2, this.backlightColorB6_3, this.backlightColorB6_4, this.backlightColorB6_5, this.backlightColorB6_6], brightness: this.backlightBrightnessB6 };
    },
    collectV62Knob: function collectV62Knob(dir) {
      var name = 'ec11' + dir;
      var func = this[name + '_func'];
      var item = { key: this.getEc11Key(dir), func: func, extra: this.getEc11KeyF(dir), mix: [255, 255, 255, 255, 255] };
      if (func !== 5) return item;
      var count = this[name + '_mixCount'];
      if (count < 2) throw Error((dir === 'CW' ? this.$t('index.ec11CW') : dir === 'CCW' ? this.$t('index.ec11CCW') : this.$t('index.ec11Btn')) + this.$t('keyConfig.mixErr'));
      var show = this[name + '_mixShowArray'],
          select = this[name + '_mixFuncSelectValue'],
          texts = this[name + '_mixText'];
      for (var i = 0; i < count; i++) {
        if (show[i]) {
          if (select[i] === '') throw Error(this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr2'));
          item.mix[i] = select[i];
        } else {
          if (texts[i].length !== 1 || texts[i].charCodeAt(0) > 255) throw Error(this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3'));
          item.mix[i] = texts[i].charCodeAt(0);
        }
      }
      return item;
    },
    collectV62Payload: function collectV62Payload() {
      var _this3 = this;

      var results = this.getV62KeyRefs(this.deviceType).map(function (ref, index) {
        var value = ref && ref.getResult();
        if (!value) throw Error(_this3.$t('workspace.invalidKey', { n: index + 1 }));
        return value;
      });
      var knobs = this.deviceType === 'C4' ? [this.collectV62Knob('CW'), this.collectV62Knob('CCW'), this.collectV62Knob('Btn')] : undefined;
      return __WEBPACK_IMPORTED_MODULE_11__stability_legacy_bridge_js__["b" /* buildPayload */](this.deviceType, results, this.v62Lighting(), knobs);
    },
    readV62Line: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(timeout) {
        var _this4 = this;

        var timer, result, line;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timer = void 0;
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a.race([this.reader.read(), new __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  timer = setTimeout(function () {
                    return reject(Error(_this4.$t('index.errReplyTimeoutUnknown')));
                  }, timeout || 8000);
                })]);

              case 4:
                result = _context2.sent;

                if (!result.done) {
                  _context2.next = 7;
                  break;
                }

                throw Error(this.$t('index.errDisconnected'));

              case 7:
                line = (result.value || '').trim();

                if (line) {
                  _context2.next = 10;
                  break;
                }

                throw Error(this.$t('index.errEmptyReply'));

              case 10:
                return _context2.abrupt('return', line);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](1);
                _context2.prev = 15;
                _context2.next = 18;
                return this.disconnectSerial();

              case 18:
                _context2.next = 22;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t1 = _context2['catch'](15);

              case 22:
                throw _context2.t0;

              case 23:
                _context2.prev = 23;
                clearTimeout(timer);return _context2.finish(23);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 13, 23, 26], [15, 20]]);
      }));

      function readV62Line(_x2) {
        return _ref2.apply(this, arguments);
      }

      return readV62Line;
    }(),
    saveV62: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payload, snapshot;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.savingV62) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                this.savingV62 = true;
                _context3.prev = 3;
                payload = this.collectV62Payload();
                _context3.next = 7;
                return this.writer.write(__WEBPACK_IMPORTED_MODULE_10__stability_codec_js__["frame"](this.deviceType, payload));

              case 7:
                _context3.t0 = __WEBPACK_IMPORTED_MODULE_10__stability_codec_js__;
                _context3.next = 10;
                return this.readV62Line(8000);

              case 10:
                _context3.t1 = _context3.sent;

                _context3.t0.parseAck.call(_context3.t0, _context3.t1);

                _context3.next = 14;
                return this.sendQuery();

              case 14:
                _context3.t2 = __WEBPACK_IMPORTED_MODULE_10__stability_codec_js__;
                _context3.next = 17;
                return this.readV62Line(8000);

              case 17:
                _context3.t3 = _context3.sent;
                snapshot = _context3.t2.parseQuery.call(_context3.t2, _context3.t3);

                if (!(snapshot.type !== this.deviceType || snapshot.status !== 0 || __WEBPACK_IMPORTED_MODULE_10__stability_codec_js__["hex"](snapshot.payload) !== __WEBPACK_IMPORTED_MODULE_10__stability_codec_js__["hex"](payload))) {
                  _context3.next = 21;
                  break;
                }

                throw Error(this.$t('index.errReadbackMismatch'));

              case 21:
                _context3.next = 23;
                return this.applyV62Snapshot(snapshot);

              case 23:
                this.$message({ message: this.$t('index.success'), type: 'success', duration: 5000, showClose: true, customClass: 'success-message' });
                _context3.next = 43;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t4 = _context3['catch'](3);

                this.$message({ message: _context3.t4.message || String(_context3.t4), type: 'error', duration: 7000, showClose: true });

                if (!/超时|断开|timeout|timed out|disconnect|Network|InvalidState/i.test(_context3.t4.message || String(_context3.t4))) {
                  _context3.next = 43;
                  break;
                }

                _context3.prev = 30;
                _context3.next = 33;
                return this.disconnectSerial();

              case 33:
                _context3.next = 37;
                break;

              case 35:
                _context3.prev = 35;
                _context3.t5 = _context3['catch'](30);

              case 37:
                this.sendLabel = true;this.deviceType = '';this.v62Protocol = false;
                this.sendText = this.$t('index.connFirst');this.conButton = this.$t('index.connButtonText1');this.conButtonType = 'primary';

              case 43:
                _context3.prev = 43;
                this.savingV62 = false;return _context3.finish(43);

              case 46:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 26, 43, 46], [30, 35]]);
      }));

      function saveV62() {
        return _ref3.apply(this, arguments);
      }

      return saveV62;
    }(),
    conClick: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _this5 = this;

        var wasV62;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(this.savingV62 || this.deviceConnecting)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                if (!(this.sendLabel == false)) {
                  _context4.next = 14;
                  break;
                }

                wasV62 = this.v62Protocol;

                this.sendLabel = true;
                this.sendText = this.$t('index.connFirst');
                this.conButton = this.$t('index.connButtonText1');
                this.conButtonType = "primary";
                if (this.deviceType === 'B3') {
                  this.$refs.b3key1config.keyReset();
                  this.$refs.b3key2config.keyReset();
                  this.$refs.b3key3config.keyReset();
                } else if (this.deviceType === 'C4') {
                  this.$refs.c4key1config.keyReset();
                  this.$refs.c4key2config.keyReset();
                  this.$refs.c4key3config.keyReset();
                  this.$refs.c4key4config.keyReset();
                } else if (this.deviceType === 'B6') {
                  this.$refs.b6key1config.keyReset();
                  this.$refs.b6key2config.keyReset();
                  this.$refs.b6key3config.keyReset();
                  this.$refs.b6key4config.keyReset();
                  this.$refs.b6key5config.keyReset();
                  this.$refs.b6key6config.keyReset();
                } else if (this.deviceType === 'D2') {
                  this.$refs.d2key1config.keyReset();
                  this.$refs.d2key2config.keyReset();
                } else if (this.deviceType === 'B4') {
                  this.$refs.b4key1config.keyReset();
                  this.$refs.b4key2config.keyReset();
                  this.$refs.b4key3config.keyReset();
                  this.$refs.b4key4config.keyReset();
                } else if (this.deviceType === 'E6' || this.deviceType === 'D6' || this.deviceType === 'D9') {
                  this.$refs.e6key1config.keyReset();
                  this.$refs.e6key2config.keyReset();
                  this.$refs.e6key3config.keyReset();
                  this.$refs.e6key4config.keyReset();
                  this.$refs.e6key5config.keyReset();
                  this.$refs.e6key6config.keyReset();
                  if (this.deviceType === 'D9') {
                    if (this.$refs.e6key7config) this.$refs.e6key7config.keyReset();
                    if (this.$refs.e6key8config) this.$refs.e6key8config.keyReset();
                    if (this.$refs.e6key9config) this.$refs.e6key9config.keyReset();
                  }
                } else {
                  this.$refs.key1config.keyReset();
                }
                this.deviceType = '';
                this.v62Protocol = false;
                if (wasV62) this.disconnectSerial();else this.sendDisconnect().then(function () {
                  _this5.disconnectSerial();
                });
                _context4.next = 27;
                break;

              case 14:
                if (!navigator.serial) {
                  _context4.next = 26;
                  break;
                }

                this.deviceConnecting = true;
                this.serialPortSelected = false;
                _context4.prev = 17;
                _context4.next = 20;
                return this.connectSerial();

              case 20:
                _context4.prev = 20;

                this.deviceConnecting = false;
                this.serialPortSelected = false;
                return _context4.finish(20);

              case 24:
                _context4.next = 27;
                break;

              case 26:
                alert(this.$t('index.browserErr'));

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[17,, 20, 24]]);
      }));

      function conClick() {
        return _ref4.apply(this, arguments);
      }

      return conClick;
    }(),
    sendCommit: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var data, r1, i;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = new Uint8Array([0x02, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0xff, 0x00, 0x03]);
                r1 = this.$refs.key1config.getResult();

                if (r1) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return');

              case 4:

                // 地址0: key
                data[1] = r1.keyCode;
                // 地址1: keyfunc
                data[2] = r1.funcCode;
                // 地址2: keyf
                data[3] = r1.mediaExtraCode;
                // 地址3-32: custStr (30字节)
                for (i = 0; i < 30; i++) {
                  data[4 + i] = r1.stringCode[i];
                }
                // 地址33-37: keymix (5字节)
                for (i = 0; i < 5; i++) {
                  data[34 + i] = r1.mixCode[i];
                }
                // 地址38: triggerMode
                data[39] = this.triggerMode;
                // 地址39: timerHour
                data[40] = this.timerHour;
                // 地址40: timerMinute
                data[41] = this.timerMinute;
                // 地址41: timerSecond
                data[42] = this.timerSecond;

                //console.log(data);
                _context5.next = 15;
                return this.writer.write(data);

              case 15:
                this.commitSent = true;

              case 16:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function sendCommit() {
        return _ref5.apply(this, arguments);
      }

      return sendCommit;
    }(),
    sendQuery: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                data = new Uint8Array([0x02, 0x03]);
                _context6.next = 3;
                return this.writer.write(data);

              case 3:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function sendQuery() {
        return _ref6.apply(this, arguments);
      }

      return sendQuery;
    }(),
    sendDisconnect: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                data = new Uint8Array([0x03, 0x01]);
                _context7.next = 3;
                return this.writer.write(data);

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sendDisconnect() {
        return _ref7.apply(this, arguments);
      }

      return sendDisconnect;
    }(),
    sendCommitB3: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var b3Version, r1, r2, r3, data, i, b3Crc, _data;

        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                b3Version = parseInt(this.deviceVersion, 10);
                r1 = this.$refs.b3key1config.getResult();

                if (r1) {
                  _context8.next = 4;
                  break;
                }

                return _context8.abrupt('return');

              case 4:
                r2 = this.$refs.b3key2config.getResult();

                if (r2) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt('return');

              case 7:
                r3 = this.$refs.b3key3config.getResult();

                if (r3) {
                  _context8.next = 10;
                  break;
                }

                return _context8.abrupt('return');

              case 10:
                if (!(!isNaN(b3Version) && b3Version >= 1)) {
                  _context8.next = 41;
                  break;
                }

                data = new Uint8Array(151);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = r1.keyCode;
                data[2] = r2.keyCode;
                data[3] = r3.keyCode;
                data[4] = r1.funcCode;
                data[5] = r2.funcCode;
                data[6] = r3.funcCode;
                data[7] = r1.mediaExtraCode;
                data[8] = r2.mediaExtraCode;
                data[9] = r3.mediaExtraCode;
                for (i = 0; i < 30; i++) {
                  data[10 + i] = r1.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  data[40 + i] = r2.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  data[70 + i] = r3.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[100 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[105 + i] = r2.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[110 + i] = r3.mixCode[i];
                }data[115] = this.backlightMode;
                data[116] = this.backlightColor1;
                data[117] = this.backlightColor2;
                data[118] = this.backlightColor3;
                data[119] = this.backlightBrightness;
                if (b3Version >= 6) {
                  b3Crc = this.crc16Ccitt(data, 1, 120);

                  data[120] = b3Crc & 0xff;
                  data[121] = b3Crc >> 8 & 0xff;
                }
                data[150] = 0x03;
                _context8.next = 38;
                return this.writer.write(data);

              case 38:
                this.commitSent = true;
                _context8.next = 68;
                break;

              case 41:
                _data = new Uint8Array(155);

                _data.fill(0xff);
                _data[0] = 0x02;
                _data[1] = r1.keyCode;
                _data[2] = r2.keyCode;
                _data[3] = r3.keyCode;
                _data[4] = r1.funcCode;
                _data[5] = r2.funcCode;
                _data[6] = r3.funcCode;
                _data[7] = r1.mediaExtraCode;
                _data[8] = r2.mediaExtraCode;
                _data[9] = r3.mediaExtraCode;
                for (i = 0; i < 30; i++) {
                  _data[10 + i] = r1.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  _data[40 + i] = r2.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  _data[70 + i] = r3.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  _data[100 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  _data[105 + i] = r2.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  _data[110 + i] = r3.mixCode[i];
                }_data[115] = this.b3keyall;
                _data[116] = this.b3keyallfunc;
                _data[117] = this.b3keyallf;
                for (i = 0; i < 5; i++) {
                  _data[148 + i] = this.b3keyallmix[i];
                }_data[153] = this.keyallmode;
                _data[154] = 0x03;
                _context8.next = 67;
                return this.writer.write(_data);

              case 67:
                this.commitSent = true;

              case 68:
                this.updateB3KeyDescs();

              case 69:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sendCommitB3() {
        return _ref8.apply(this, arguments);
      }

      return sendCommitB3;
    }(),
    sendClick: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!this.savingV62) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt('return');

              case 2:
                if (!this.v62Protocol) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 5;
                return this.saveV62();

              case 5:
                return _context9.abrupt('return');

              case 6:
                this.savingV62 = true;
                this.commitSent = false;
                _context9.prev = 8;

                if (!(this.deviceType === 'B3')) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 12;
                return this.sendCommitB3();

              case 12:
                _context9.next = 41;
                break;

              case 14:
                if (!(this.deviceType === 'C4')) {
                  _context9.next = 19;
                  break;
                }

                _context9.next = 17;
                return this.sendCommitC4();

              case 17:
                _context9.next = 41;
                break;

              case 19:
                if (!(this.deviceType === 'B6')) {
                  _context9.next = 24;
                  break;
                }

                _context9.next = 22;
                return this.sendCommitB6();

              case 22:
                _context9.next = 41;
                break;

              case 24:
                if (!(this.deviceType === 'D2')) {
                  _context9.next = 29;
                  break;
                }

                _context9.next = 27;
                return this.sendCommitD2();

              case 27:
                _context9.next = 41;
                break;

              case 29:
                if (!(this.deviceType === 'B4')) {
                  _context9.next = 34;
                  break;
                }

                _context9.next = 32;
                return this.sendCommitB4();

              case 32:
                _context9.next = 41;
                break;

              case 34:
                if (!(this.deviceType === 'E6' || this.deviceType === 'D6' || this.deviceType === 'D9')) {
                  _context9.next = 39;
                  break;
                }

                _context9.next = 37;
                return this.sendCommitD6();

              case 37:
                _context9.next = 41;
                break;

              case 39:
                _context9.next = 41;
                return this.sendCommit();

              case 41:
                if (this.commitSent) {
                  _context9.next = 43;
                  break;
                }

                return _context9.abrupt('return');

              case 43:
                _context9.next = 45;
                return this.waitAckAndNotify();

              case 45:
                _context9.next = 50;
                break;

              case 47:
                _context9.prev = 47;
                _context9.t0 = _context9['catch'](8);

                this.$message({
                  message: _context9.t0.message || String(_context9.t0),
                  type: "error",
                  duration: 7000,
                  showClose: true
                });

              case 50:
                _context9.prev = 50;

                this.savingV62 = false;
                return _context9.finish(50);

              case 53:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[8, 47, 50, 53]]);
      }));

      function sendClick() {
        return _ref9.apply(this, arguments);
      }

      return sendClick;
    }(),
    waitAckAndNotify: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var _this6 = this;

        var saved, value, timer, result, received, reasons;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                saved = false;
                value = '';
                timer = null;
                _context10.prev = 3;
                _context10.next = 6;
                return __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a.race([this.reader.read(), new __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  timer = setTimeout(function () {
                    return reject(new Error(_this6.$t('index.errConfirmTimeout')));
                  }, 5000);
                })]);

              case 6:
                result = _context10.sent;

                if (!result.done) {
                  _context10.next = 9;
                  break;
                }

                throw new Error(this.$t('index.errDisconnected'));

              case 9:
                value = result.value || '';
                _context10.next = 23;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](3);

                this.$message({
                  message: _context10.t0.message || String(_context10.t0),
                  type: "error",
                  duration: 7000,
                  showClose: true
                });
                _context10.prev = 15;
                _context10.next = 18;
                return this.disconnectSerial();

              case 18:
                _context10.next = 22;
                break;

              case 20:
                _context10.prev = 20;
                _context10.t1 = _context10['catch'](15);

              case 22:
                return _context10.abrupt('return');

              case 23:
                _context10.prev = 23;

                if (timer) clearTimeout(timer);
                return _context10.finish(23);

              case 26:
                if (value.trim() === "1") {
                  saved = true;
                  this.$message({
                    message: this.$t('index.success'),
                    type: "success",
                    duration: 5000,
                    showClose: true,
                    customClass: 'success-message'
                  });
                } else if (/^T:\d+$/.test(value.trim())) {
                  received = parseInt(value.trim().slice(2), 10);

                  this.$message({ message: '设备只收到 ' + received + ' / 262 字节配置帧', type: "error", duration: 7000, showClose: true });
                } else if (['C', 'V', 'E', 'M', 'T'].includes(value.trim())) {
                  reasons = { C: '设备收到帧但 CRC 校验失败', V: '设备拒绝了参数配置', E: 'Flash 配置写入或回读校验失败', M: '设备模式写入或回读校验失败', T: '设备收到的配置帧不完整' };

                  this.$message({ message: reasons[value.trim()], type: "error", duration: 7000, showClose: true });
                } else if (value.trim() === "0") {
                  this.$message({
                    message: this.$t('index.saveFailed'),
                    type: "error",
                    duration: 5000,
                    showClose: true
                  });
                } else {
                  this.$message({
                    message: this.$t('index.errNoAck'),
                    type: "error",
                    duration: 7000,
                    showClose: true
                  });
                }
                if (saved && (this.deviceType === 'E6' || this.deviceType === 'D6' || this.deviceType === 'D9') && this.e6DeviceModeAtLoad !== null && this.e6DeviceMode !== this.e6DeviceModeAtLoad) {
                  setTimeout(function () {
                    return window.location.reload();
                  }, 1200);
                }

              case 28:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 12, 23, 26], [15, 20]]);
      }));

      function waitAckAndNotify() {
        return _ref10.apply(this, arguments);
      }

      return waitAckAndNotify;
    }(),
    sendCommitD2: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee11() {
        var r1, r2, data, i;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                r1 = this.$refs.d2key1config.getResult();

                if (r1) {
                  _context11.next = 3;
                  break;
                }

                return _context11.abrupt('return');

              case 3:
                r2 = this.$refs.d2key2config.getResult();

                if (r2) {
                  _context11.next = 6;
                  break;
                }

                return _context11.abrupt('return');

              case 6:
                data = new Uint8Array(151);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = 0xD2;
                data[2] = parseInt(this.deviceVersion, 10) || 0;
                data[3] = r1.keyCode;data[4] = r2.keyCode;
                data[5] = r1.funcCode;data[6] = r2.funcCode;
                data[7] = r1.mediaExtraCode;data[8] = r2.mediaExtraCode;
                for (i = 0; i < 30; i++) {
                  data[9 + i] = r1.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  data[39 + i] = r2.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[69 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[74 + i] = r2.mixCode[i];
                }data[79] = this.d2RunMode;
                data[80] = this.d2PageAction;
                data[150] = 0x03;
                _context11.next = 26;
                return this.writer.write(data);

              case 26:
                this.commitSent = true;

              case 27:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function sendCommitD2() {
        return _ref11.apply(this, arguments);
      }

      return sendCommitD2;
    }(),
    sendCommitB6: function () {
      var _ref12 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee12() {
        var b6Version, r1, r2, r3, r4, r5, r6, data, i, b6Crc;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                b6Version = parseInt(this.deviceVersion, 10);

                if (!(isNaN(b6Version) || b6Version < 0)) {
                  _context12.next = 3;
                  break;
                }

                return _context12.abrupt('return');

              case 3:
                r1 = this.$refs.b6key1config.getResult();

                if (r1) {
                  _context12.next = 6;
                  break;
                }

                return _context12.abrupt('return');

              case 6:
                r2 = this.$refs.b6key2config.getResult();

                if (r2) {
                  _context12.next = 9;
                  break;
                }

                return _context12.abrupt('return');

              case 9:
                r3 = this.$refs.b6key3config.getResult();

                if (r3) {
                  _context12.next = 12;
                  break;
                }

                return _context12.abrupt('return');

              case 12:
                r4 = this.$refs.b6key4config.getResult();

                if (r4) {
                  _context12.next = 15;
                  break;
                }

                return _context12.abrupt('return');

              case 15:
                r5 = this.$refs.b6key5config.getResult();

                if (r5) {
                  _context12.next = 18;
                  break;
                }

                return _context12.abrupt('return');

              case 18:
                r6 = this.$refs.b6key6config.getResult();

                if (r6) {
                  _context12.next = 21;
                  break;
                }

                return _context12.abrupt('return');

              case 21:
                data = new Uint8Array(b6Version >= 6 ? 120 : 118);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = r1.keyCode;data[2] = r2.keyCode;data[3] = r3.keyCode;
                data[4] = r4.keyCode;data[5] = r5.keyCode;data[6] = r6.keyCode;
                data[7] = r1.funcCode;data[8] = r2.funcCode;data[9] = r3.funcCode;
                data[10] = r4.funcCode;data[11] = r5.funcCode;data[12] = r6.funcCode;
                data[13] = r1.mediaExtraCode;data[14] = r2.mediaExtraCode;data[15] = r3.mediaExtraCode;
                data[16] = r4.mediaExtraCode;data[17] = r5.mediaExtraCode;data[18] = r6.mediaExtraCode;
                for (i = 0; i < 10; i++) {
                  data[19 + i] = r1.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[29 + i] = r2.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[39 + i] = r3.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[49 + i] = r4.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[59 + i] = r5.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[69 + i] = r6.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[79 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[84 + i] = r2.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[89 + i] = r3.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[94 + i] = r4.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[99 + i] = r5.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[104 + i] = r6.mixCode[i];
                }data[109] = this.backlightModeB6;
                data[110] = this.backlightColorB6_1;
                data[111] = this.backlightColorB6_2;
                data[112] = this.backlightColorB6_3;
                data[113] = this.backlightColorB6_4;
                data[114] = this.backlightColorB6_5;
                data[115] = this.backlightColorB6_6;
                data[116] = this.backlightBrightnessB6;
                if (b6Version >= 6) {
                  b6Crc = this.crc16Ccitt(data, 1, 117);

                  data[117] = b6Crc & 0xff;
                  data[118] = b6Crc >> 8 & 0xff;
                  data[119] = 0x03;
                } else {
                  data[117] = 0x03;
                }
                _context12.next = 65;
                return this.writer.write(data);

              case 65:
                this.commitSent = true;
                this.updateB6KeyDescs();

              case 67:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function sendCommitB6() {
        return _ref12.apply(this, arguments);
      }

      return sendCommitB6;
    }(),
    sendCommitE6: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var r1, r2, r3, r4, r5, r6, data, i;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                r1 = this.$refs.e6key1config.getResult();

                if (r1) {
                  _context13.next = 3;
                  break;
                }

                return _context13.abrupt('return');

              case 3:
                r2 = this.$refs.e6key2config.getResult();

                if (r2) {
                  _context13.next = 6;
                  break;
                }

                return _context13.abrupt('return');

              case 6:
                r3 = this.$refs.e6key3config.getResult();

                if (r3) {
                  _context13.next = 9;
                  break;
                }

                return _context13.abrupt('return');

              case 9:
                r4 = this.$refs.e6key4config.getResult();

                if (r4) {
                  _context13.next = 12;
                  break;
                }

                return _context13.abrupt('return');

              case 12:
                r5 = this.$refs.e6key5config.getResult();

                if (r5) {
                  _context13.next = 15;
                  break;
                }

                return _context13.abrupt('return');

              case 15:
                r6 = this.$refs.e6key6config.getResult();

                if (r6) {
                  _context13.next = 18;
                  break;
                }

                return _context13.abrupt('return');

              case 18:
                data = new Uint8Array(151);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = 0xE6;
                data[2] = parseInt(this.deviceVersion, 10) || 0;
                data[3] = r1.keyCode;data[4] = r2.keyCode;
                data[5] = r1.funcCode;data[6] = r2.funcCode;
                data[7] = r1.mediaExtraCode;data[8] = r2.mediaExtraCode;
                for (i = 0; i < 30; i++) {
                  data[9 + i] = r1.stringCode[i];
                }for (i = 0; i < 30; i++) {
                  data[39 + i] = r2.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[69 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[74 + i] = r2.mixCode[i];
                }data[79] = this.e6RunMode;
                data[80] = this.e6PageAction;
                data[81] = r3.keyCode;data[82] = r4.keyCode;data[83] = r5.keyCode;data[84] = r6.keyCode;
                data[85] = r3.funcCode;data[86] = r4.funcCode;data[87] = r5.funcCode;data[88] = r6.funcCode;
                data[89] = r3.mediaExtraCode;data[90] = r4.mediaExtraCode;data[91] = r5.mediaExtraCode;data[92] = r6.mediaExtraCode;
                for (i = 0; i < 5; i++) {
                  data[93 + i] = r3.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[98 + i] = r4.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[103 + i] = r5.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[108 + i] = r6.mixCode[i];
                }data[113] = this.e6DeviceMode;
                data[150] = 0x03;
                _context13.next = 55;
                return this.writer.write(data);

              case 55:
                this.commitSent = true;
                this.updateE6KeyDescs();

              case 57:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function sendCommitE6() {
        return _ref13.apply(this, arguments);
      }

      return sendCommitE6;
    }(),
    sendCommitD6: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var r1, r2, r3, r4, r5, r6, isD9, r7, r8, r9, isD6, textLen, cfgLen, data, str1Off, str2Off, mix1Off, mix2Off, runOff, pageOff, key3Off, funcOff, extraOff, mix3Off, str3Off, d9Off, i, d6Crc, offset;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                r1 = this.$refs.e6key1config.getResult();

                if (r1) {
                  _context14.next = 3;
                  break;
                }

                return _context14.abrupt('return');

              case 3:
                r2 = this.$refs.e6key2config.getResult();

                if (r2) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt('return');

              case 6:
                r3 = this.$refs.e6key3config.getResult();

                if (r3) {
                  _context14.next = 9;
                  break;
                }

                return _context14.abrupt('return');

              case 9:
                r4 = this.$refs.e6key4config.getResult();

                if (r4) {
                  _context14.next = 12;
                  break;
                }

                return _context14.abrupt('return');

              case 12:
                r5 = this.$refs.e6key5config.getResult();

                if (r5) {
                  _context14.next = 15;
                  break;
                }

                return _context14.abrupt('return');

              case 15:
                r6 = this.$refs.e6key6config.getResult();

                if (r6) {
                  _context14.next = 18;
                  break;
                }

                return _context14.abrupt('return');

              case 18:
                isD9 = this.deviceType === 'D9';
                r7 = null, r8 = null, r9 = null;

                if (!isD9) {
                  _context14.next = 30;
                  break;
                }

                r7 = this.$refs.e6key7config.getResult();

                if (r7) {
                  _context14.next = 24;
                  break;
                }

                return _context14.abrupt('return');

              case 24:
                r8 = this.$refs.e6key8config.getResult();

                if (r8) {
                  _context14.next = 27;
                  break;
                }

                return _context14.abrupt('return');

              case 27:
                r9 = this.$refs.e6key9config.getResult();

                if (r9) {
                  _context14.next = 30;
                  break;
                }

                return _context14.abrupt('return');

              case 30:
                // D6: 178 字节; D9: 262 字节(完整 3 键扩展); E6 仍为 30 字节字符串
                isD6 = this.deviceType === 'D6' || isD9;
                textLen = isD6 ? 20 : 30;
                cfgLen = 54 + 6 * textLen + (isD9 ? 84 : 0);
                data = new Uint8Array(cfgLen + 4);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = isD9 ? 0xD9 : 0xD6; // [1] 设备类型
                data[2] = parseInt(this.deviceVersion, 10) || 0; // [2] 版本
                data[3] = this.e6TimeSeq & 0xff; // [3] 时间序号
                data[4] = this.e6DeviceMode; // [4] 三模选择
                data[5] = r1.keyCode;data[6] = r2.keyCode; // [5][6]
                data[7] = r1.funcCode;data[8] = r2.funcCode;
                data[9] = r1.mediaExtraCode;data[10] = r2.mediaExtraCode;
                str1Off = 11;
                str2Off = str1Off + textLen;
                mix1Off = str2Off + textLen;
                mix2Off = mix1Off + 5;
                runOff = mix2Off + 5;
                pageOff = runOff + 1;
                key3Off = pageOff + 1;
                funcOff = key3Off + 4;
                extraOff = funcOff + 4;
                mix3Off = extraOff + 4;
                str3Off = mix3Off + 20;
                d9Off = str3Off + 4 * textLen;

                for (i = 0; i < textLen; i++) {
                  data[str1Off + i] = r1.stringCode[i];data[str2Off + i] = r2.stringCode[i];
                }
                for (i = 0; i < 5; i++) {
                  data[mix1Off + i] = r1.mixCode[i];data[mix2Off + i] = r2.mixCode[i];
                }
                data[runOff] = this.e6RunMode;
                data[pageOff] = this.e6PageAction;
                data[key3Off] = r3.keyCode;data[key3Off + 1] = r4.keyCode;data[key3Off + 2] = r5.keyCode;data[key3Off + 3] = r6.keyCode;
                data[funcOff] = r3.funcCode;data[funcOff + 1] = r4.funcCode;data[funcOff + 2] = r5.funcCode;data[funcOff + 3] = r6.funcCode;
                data[extraOff] = r3.mediaExtraCode;data[extraOff + 1] = r4.mediaExtraCode;data[extraOff + 2] = r5.mediaExtraCode;data[extraOff + 3] = r6.mediaExtraCode;
                for (i = 0; i < 5; i++) {
                  data[mix3Off + i] = r3.mixCode[i];data[mix3Off + 5 + i] = r4.mixCode[i];data[mix3Off + 10 + i] = r5.mixCode[i];data[mix3Off + 15 + i] = r6.mixCode[i];
                }
                for (i = 0; i < textLen; i++) {
                  data[str3Off + i] = r3.stringCode[i];data[str3Off + textLen + i] = r4.stringCode[i];data[str3Off + 2 * textLen + i] = r5.stringCode[i];data[str3Off + 3 * textLen + i] = r6.stringCode[i];
                }
                if (isD9) {
                  data[d9Off] = r7.keyCode;data[d9Off + 1] = r8.keyCode;data[d9Off + 2] = r9.keyCode;
                  data[d9Off + 3] = r7.funcCode;data[d9Off + 4] = r8.funcCode;data[d9Off + 5] = r9.funcCode;
                  data[d9Off + 6] = r7.mediaExtraCode;data[d9Off + 7] = r8.mediaExtraCode;data[d9Off + 8] = r9.mediaExtraCode;
                  for (i = 0; i < 5; i++) {
                    data[d9Off + 9 + i] = r7.mixCode[i];
                    data[d9Off + 14 + i] = r8.mixCode[i];
                    data[d9Off + 19 + i] = r9.mixCode[i];
                  }
                  for (i = 0; i < textLen; i++) {
                    data[d9Off + 24 + i] = r7.stringCode[i];
                    data[d9Off + 24 + textLen + i] = r8.stringCode[i];
                    data[d9Off + 24 + 2 * textLen + i] = r9.stringCode[i];
                  }
                }
                d6Crc = this.crc16Ccitt(data, 1, cfgLen + 1); // CRC 覆盖偏移 1~cfgLen

                data[cfgLen + 1] = d6Crc & 0xff;
                data[cfgLen + 2] = d6Crc >> 8 & 0xff;
                data[cfgLen + 3] = 0x03;

                if (!isD9) {
                  _context14.next = 91;
                  break;
                }

                offset = 0;

              case 83:
                if (!(offset < data.length)) {
                  _context14.next = 89;
                  break;
                }

                _context14.next = 86;
                return this.writer.write(data.subarray(offset, Math.min(offset + 64, data.length)));

              case 86:
                offset += 64;
                _context14.next = 83;
                break;

              case 89:
                _context14.next = 93;
                break;

              case 91:
                _context14.next = 93;
                return this.writer.write(data);

              case 93:
                this.commitSent = true;
                this.updateE6KeyDescs();

              case 95:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function sendCommitD6() {
        return _ref14.apply(this, arguments);
      }

      return sendCommitD6;
    }(),
    sendCommitB4: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee15() {
        var b4Version, r1, r2, r3, r4, data, i, b4Crc;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                b4Version = parseInt(this.deviceVersion, 10) || 0;
                r1 = this.$refs.b4key1config.getResult();

                if (r1) {
                  _context15.next = 4;
                  break;
                }

                return _context15.abrupt('return');

              case 4:
                r2 = this.$refs.b4key2config.getResult();

                if (r2) {
                  _context15.next = 7;
                  break;
                }

                return _context15.abrupt('return');

              case 7:
                r3 = this.$refs.b4key3config.getResult();

                if (r3) {
                  _context15.next = 10;
                  break;
                }

                return _context15.abrupt('return');

              case 10:
                r4 = this.$refs.b4key4config.getResult();

                if (r4) {
                  _context15.next = 13;
                  break;
                }

                return _context15.abrupt('return');

              case 13:
                data = new Uint8Array(b4Version >= 6 ? 82 : 80);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = r1.keyCode;data[2] = r2.keyCode;data[3] = r3.keyCode;data[4] = r4.keyCode;
                data[5] = r1.funcCode;data[6] = r2.funcCode;data[7] = r3.funcCode;data[8] = r4.funcCode;
                data[9] = r1.mediaExtraCode;data[10] = r2.mediaExtraCode;data[11] = r3.mediaExtraCode;data[12] = r4.mediaExtraCode;
                for (i = 0; i < 10; i++) {
                  data[13 + i] = r1.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[23 + i] = r2.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[33 + i] = r3.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[43 + i] = r4.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[53 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[58 + i] = r2.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[63 + i] = r3.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[68 + i] = r4.mixCode[i];
                }data[73] = this.backlightModeB4;
                data[74] = this.backlightColorB4_1;
                data[75] = this.backlightColorB4_2;
                data[76] = this.backlightColorB4_3;
                data[77] = this.backlightColorB4_4;
                data[78] = this.backlightBrightnessB4;
                if (b4Version >= 6) {
                  b4Crc = this.crc16Ccitt(data, 1, 79);

                  data[79] = b4Crc & 0xff;
                  data[80] = b4Crc >> 8 & 0xff;
                  data[81] = 0x03;
                } else {
                  data[79] = 0x03;
                }
                _context15.next = 45;
                return this.writer.write(data);

              case 45:
                this.commitSent = true;
                this.updateB4KeyDescs();

              case 47:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function sendCommitB4() {
        return _ref15.apply(this, arguments);
      }

      return sendCommitB4;
    }(),
    sendCommitC4: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var _this7 = this;

        var r1, r2, r3, r4, c4Version, frameSize, data, i, writeMix, bt, cw, ccw, bt2;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                r1 = this.$refs.c4key1config.getResult();

                if (r1) {
                  _context16.next = 3;
                  break;
                }

                return _context16.abrupt('return');

              case 3:
                r2 = this.$refs.c4key2config.getResult();

                if (r2) {
                  _context16.next = 6;
                  break;
                }

                return _context16.abrupt('return');

              case 6:
                r3 = this.$refs.c4key3config.getResult();

                if (r3) {
                  _context16.next = 9;
                  break;
                }

                return _context16.abrupt('return');

              case 9:
                r4 = this.$refs.c4key4config.getResult();

                if (r4) {
                  _context16.next = 12;
                  break;
                }

                return _context16.abrupt('return');

              case 12:
                c4Version = parseInt(this.deviceVersion, 10) || 0;
                frameSize = c4Version >= 3 ? 104 : c4Version === 2 ? 94 : 89;
                data = new Uint8Array(frameSize);

                data.fill(0xff);
                data[0] = 0x02;
                data[1] = r1.keyCode;data[2] = r2.keyCode;data[3] = r3.keyCode;data[4] = r4.keyCode;
                data[5] = r1.funcCode;data[6] = r2.funcCode;data[7] = r3.funcCode;data[8] = r4.funcCode;
                data[9] = r1.mediaExtraCode;data[10] = r2.mediaExtraCode;data[11] = r3.mediaExtraCode;data[12] = r4.mediaExtraCode;
                for (i = 0; i < 10; i++) {
                  data[13 + i] = r1.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[23 + i] = r2.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[33 + i] = r3.stringCode[i];
                }for (i = 0; i < 10; i++) {
                  data[43 + i] = r4.stringCode[i];
                }for (i = 0; i < 5; i++) {
                  data[53 + i] = r1.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[58 + i] = r2.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[63 + i] = r3.mixCode[i];
                }for (i = 0; i < 5; i++) {
                  data[68 + i] = r4.mixCode[i];
                }data[73] = this.backlightModeC4;
                data[74] = this.backlightColorC4_1;
                data[75] = this.backlightColorC4_2;
                data[76] = this.backlightColorC4_3;
                data[77] = this.backlightColorC4_4;
                data[78] = this.backlightBrightnessC4;
                data[79] = this.getEc11Key('CW');data[80] = this.ec11CW_func;data[81] = this.getEc11KeyF('CW');
                data[82] = this.getEc11Key('CCW');data[83] = this.ec11CCW_func;data[84] = this.getEc11KeyF('CCW');
                data[85] = this.getEc11Key('Btn');data[86] = this.ec11Btn_func;data[87] = this.getEc11KeyF('Btn');

                writeMix = function writeMix(func, mCount, mShowArr, mSelVal, mText, baseAddr, dirLabel) {
                  if (func !== 5) return true;
                  if (mCount < 2) {
                    _this7.$message.error(dirLabel + _this7.$t('keyConfig.mixErr'));
                    return false;
                  }
                  for (var m = 0; m < mCount; m++) {
                    if (mShowArr[m]) {
                      if (mSelVal[m] === '') {
                        _this7.$message.error(dirLabel + _this7.$t('keyConfig.mixErr1') + (m + 1) + _this7.$t('keyConfig.mixErr2'));
                        return false;
                      }
                      data[baseAddr + m] = mSelVal[m];
                    } else {
                      if (mText[m].length != 1) {
                        _this7.$message.error(dirLabel + _this7.$t('keyConfig.mixErr1') + (m + 1) + _this7.$t('keyConfig.mixErr3'));
                        return false;
                      }
                      var mt = mText[m].charCodeAt(0);
                      if (mt < 0 || mt > 255) {
                        _this7.$message.error(dirLabel + _this7.$t('keyConfig.mixErr1') + (m + 1) + _this7.$t('keyConfig.mixErr3'));
                        return false;
                      }
                      data[baseAddr + m] = mt;
                    }
                  }
                  return true;
                };

                if (!(c4Version >= 3)) {
                  _context16.next = 66;
                  break;
                }

                if (writeMix(this.ec11Btn_func, this.ec11Btn_mixCount, this.ec11Btn_mixShowArray, this.ec11Btn_mixFuncSelectValue, this.ec11Btn_mixText, 88, this.$t('index.ec11Btn'))) {
                  _context16.next = 56;
                  break;
                }

                return _context16.abrupt('return');

              case 56:
                if (this.ec11Btn_func === 5) {
                  for (bt = 0; bt < 5; bt++) {
                    this.ec11Btn_keyMix[bt] = data[88 + bt];
                  }
                }

                if (writeMix(this.ec11CW_func, this.ec11CW_mixCount, this.ec11CW_mixShowArray, this.ec11CW_mixFuncSelectValue, this.ec11CW_mixText, 93, this.$t('index.ec11CW'))) {
                  _context16.next = 59;
                  break;
                }

                return _context16.abrupt('return');

              case 59:
                if (this.ec11CW_func === 5) {
                  for (cw = 0; cw < 5; cw++) {
                    this.ec11CW_keyMix[cw] = data[93 + cw];
                  }
                }

                if (writeMix(this.ec11CCW_func, this.ec11CCW_mixCount, this.ec11CCW_mixShowArray, this.ec11CCW_mixFuncSelectValue, this.ec11CCW_mixText, 98, this.$t('index.ec11CCW'))) {
                  _context16.next = 62;
                  break;
                }

                return _context16.abrupt('return');

              case 62:
                if (this.ec11CCW_func === 5) {
                  for (ccw = 0; ccw < 5; ccw++) {
                    this.ec11CCW_keyMix[ccw] = data[98 + ccw];
                  }
                }
                data[103] = 0x03;
                _context16.next = 74;
                break;

              case 66:
                if (!(c4Version === 2)) {
                  _context16.next = 73;
                  break;
                }

                if (writeMix(this.ec11Btn_func, this.ec11Btn_mixCount, this.ec11Btn_mixShowArray, this.ec11Btn_mixFuncSelectValue, this.ec11Btn_mixText, 88, this.$t('index.ec11Btn'))) {
                  _context16.next = 69;
                  break;
                }

                return _context16.abrupt('return');

              case 69:
                if (this.ec11Btn_func === 5) {
                  for (bt2 = 0; bt2 < 5; bt2++) {
                    this.ec11Btn_keyMix[bt2] = data[88 + bt2];
                  }
                }
                data[93] = 0x03;
                _context16.next = 74;
                break;

              case 73:
                data[88] = 0x03;

              case 74:
                _context16.next = 76;
                return this.writer.write(data);

              case 76:
                this.commitSent = true;
                this.updateC4KeyDescs();

              case 78:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function sendCommitC4() {
        return _ref16.apply(this, arguments);
      }

      return sendCommitC4;
    }(),
    getEc11Key: function getEc11Key(dir) {
      if (dir === 'CW') {
        if (this.ec11CW_func === 0) return this.ec11CW_keyChar.length > 0 ? this.ec11CW_keyChar.charCodeAt(0) : 0xff;
        if (this.ec11CW_func === 1) return this.ec11CW_mediaVal & 0xFF;
        if (this.ec11CW_func === 2) return this.ec11CW_fnVal;
        if (this.ec11CW_func === 3) return this.ec11CW_scrollDir;
        if (this.ec11CW_func === 4) return this.ec11CW_mouseBtn;
        if (this.ec11CW_func === 5) return 0xff;
      } else if (dir === 'CCW') {
        if (this.ec11CCW_func === 0) return this.ec11CCW_keyChar.length > 0 ? this.ec11CCW_keyChar.charCodeAt(0) : 0xff;
        if (this.ec11CCW_func === 1) return this.ec11CCW_mediaVal & 0xFF;
        if (this.ec11CCW_func === 2) return this.ec11CCW_fnVal;
        if (this.ec11CCW_func === 3) return this.ec11CCW_scrollDir;
        if (this.ec11CCW_func === 4) return this.ec11CCW_mouseBtn;
        if (this.ec11CCW_func === 5) return 0xff;
      } else if (dir === 'Btn') {
        if (this.ec11Btn_func === 0) return this.ec11Btn_keyChar.length > 0 ? this.ec11Btn_keyChar.charCodeAt(0) : 0xff;
        if (this.ec11Btn_func === 1) return this.ec11Btn_mediaVal & 0xFF;
        if (this.ec11Btn_func === 2) return this.ec11Btn_fnVal;
        if (this.ec11Btn_func === 3) return this.ec11Btn_scrollDir;
        if (this.ec11Btn_func === 4) return this.ec11Btn_mouseBtn;
        if (this.ec11Btn_func === 5) return 0xff;
      }
      return 0xff;
    },
    getEc11KeyF: function getEc11KeyF(dir) {
      if (dir === 'CW') {
        if (this.ec11CW_func === 0) return 0xff;
        if (this.ec11CW_func === 1) return this.ec11CW_mediaVal >> 8 & 0xFF;
        if (this.ec11CW_func === 2) return 0xff;
        if (this.ec11CW_func === 3) return 0xff;
        if (this.ec11CW_func === 4) return this.ec11CW_mouseMode;
        if (this.ec11CW_func === 5) return 0xff;
      } else if (dir === 'CCW') {
        if (this.ec11CCW_func === 0) return 0xff;
        if (this.ec11CCW_func === 1) return this.ec11CCW_mediaVal >> 8 & 0xFF;
        if (this.ec11CCW_func === 2) return 0xff;
        if (this.ec11CCW_func === 3) return 0xff;
        if (this.ec11CCW_func === 4) return this.ec11CCW_mouseMode;
        if (this.ec11CCW_func === 5) return 0xff;
      } else if (dir === 'Btn') {
        if (this.ec11Btn_func === 0) return 0xff;
        if (this.ec11Btn_func === 1) return this.ec11Btn_mediaVal >> 8 & 0xFF;
        if (this.ec11Btn_func === 2) return 0xff;
        if (this.ec11Btn_func === 3) return 0xff;
        if (this.ec11Btn_func === 4) return this.ec11Btn_mouseMode;
        if (this.ec11Btn_func === 5) return 0xff;
      }
      return 0xff;
    },
    initEc11UI: function initEc11UI() {
      this.setEc11UI('CW');
      this.setEc11UI('CCW');
      this.setEc11UI('Btn');
    },
    setEc11UI: function setEc11UI(dir) {
      var func, key, keyF;
      if (dir === 'CW') {
        func = this.ec11CW_func;key = this.ec11CW_key;keyF = this.ec11CW_keyF;
      } else if (dir === 'CCW') {
        func = this.ec11CCW_func;key = this.ec11CCW_key;keyF = this.ec11CCW_keyF;
      } else if (dir === 'Btn') {
        func = this.ec11Btn_func;key = this.ec11Btn_key;keyF = this.ec11Btn_keyF;
      }
      if (func === 0) {
        var ch = key >= 0x20 && key <= 0x7e ? String.fromCharCode(key) : '';
        if (dir === 'CW') this.ec11CW_keyChar = ch;else if (dir === 'CCW') this.ec11CCW_keyChar = ch;else if (dir === 'Btn') this.ec11Btn_keyChar = ch;
      } else if (func === 1) {
        var mediaVal = keyF << 8 | key;
        if (dir === 'CW') this.ec11CW_mediaVal = mediaVal;else if (dir === 'CCW') this.ec11CCW_mediaVal = mediaVal;else if (dir === 'Btn') this.ec11Btn_mediaVal = mediaVal;
      } else if (func === 2) {
        if (dir === 'CW') this.ec11CW_fnVal = key;else if (dir === 'CCW') this.ec11CCW_fnVal = key;else if (dir === 'Btn') this.ec11Btn_fnVal = key;
      } else if (func === 3) {
        if (dir === 'CW') this.ec11CW_scrollDir = key;else if (dir === 'CCW') this.ec11CCW_scrollDir = key;else if (dir === 'Btn') this.ec11Btn_scrollDir = key;
      } else if (func === 4) {
        if (dir === 'CW') {
          this.ec11CW_mouseBtn = key;this.ec11CW_mouseMode = keyF;
        } else if (dir === 'CCW') {
          this.ec11CCW_mouseBtn = key;this.ec11CCW_mouseMode = keyF;
        } else if (dir === 'Btn') {
          this.ec11Btn_mouseBtn = key;this.ec11Btn_mouseMode = keyF;
        }
      } else if (func === 5 && dir === 'CW') {
        var tmpCWCount = 0;
        for (var miCW = 0; miCW < 5; miCW++) {
          if (this.ec11CW_keyMix[miCW] !== 0xff) tmpCWCount = miCW + 1;else break;
        }
        this.ec11CW_mixCount = tmpCWCount;
        var fnValCW = this.fnKeyOptions.map(function (f) {
          return f.value;
        });
        for (var mCW = 0; mCW < 5; mCW++) {
          if (mCW < tmpCWCount) {
            var mkCW = this.ec11CW_keyMix[mCW];
            var foundCW = false;
            for (var fvCW = 0; fvCW < fnValCW.length; fvCW++) {
              if (fnValCW[fvCW] === mkCW) {
                this.ec11CW_mixShowArray[mCW] = true;
                this.ec11CW_mixFuncSelectValue[mCW] = mkCW;
                this.ec11CW_mixText[mCW] = '';
                foundCW = true;
                break;
              }
            }
            if (!foundCW) {
              this.ec11CW_mixShowArray[mCW] = false;
              this.ec11CW_mixFuncSelectValue[mCW] = '';
              this.ec11CW_mixText[mCW] = mkCW >= 0x20 && mkCW <= 0x7e ? String.fromCharCode(mkCW) : '';
            }
          } else {
            this.ec11CW_mixShowArray[mCW] = false;
            this.ec11CW_mixFuncSelectValue[mCW] = '';
            this.ec11CW_mixText[mCW] = '';
          }
        }
        this.ec11CWMixCountChange();
      } else if (func === 5 && dir === 'CCW') {
        var tmpCCWCount = 0;
        for (var miCCW = 0; miCCW < 5; miCCW++) {
          if (this.ec11CCW_keyMix[miCCW] !== 0xff) tmpCCWCount = miCCW + 1;else break;
        }
        this.ec11CCW_mixCount = tmpCCWCount;
        var fnValCCW = this.fnKeyOptions.map(function (f) {
          return f.value;
        });
        for (var mCCW = 0; mCCW < 5; mCCW++) {
          if (mCCW < tmpCCWCount) {
            var mkCCW = this.ec11CCW_keyMix[mCCW];
            var foundCCW = false;
            for (var fvCCW = 0; fvCCW < fnValCCW.length; fvCCW++) {
              if (fnValCCW[fvCCW] === mkCCW) {
                this.ec11CCW_mixShowArray[mCCW] = true;
                this.ec11CCW_mixFuncSelectValue[mCCW] = mkCCW;
                this.ec11CCW_mixText[mCCW] = '';
                foundCCW = true;
                break;
              }
            }
            if (!foundCCW) {
              this.ec11CCW_mixShowArray[mCCW] = false;
              this.ec11CCW_mixFuncSelectValue[mCCW] = '';
              this.ec11CCW_mixText[mCCW] = mkCCW >= 0x20 && mkCCW <= 0x7e ? String.fromCharCode(mkCCW) : '';
            }
          } else {
            this.ec11CCW_mixShowArray[mCCW] = false;
            this.ec11CCW_mixFuncSelectValue[mCCW] = '';
            this.ec11CCW_mixText[mCCW] = '';
          }
        }
        this.ec11CCWMixCountChange();
      } else if (func === 5 && dir === 'Btn') {
        var tmpMixCount = 0;
        for (var mi = 0; mi < 5; mi++) {
          if (this.ec11Btn_keyMix[mi] !== 0xff) tmpMixCount = mi + 1;else break;
        }
        this.ec11Btn_mixCount = tmpMixCount;
        var fnValues = this.fnKeyOptions.map(function (f) {
          return f.value;
        });
        for (var m3 = 0; m3 < 5; m3++) {
          if (m3 < tmpMixCount) {
            var mk = this.ec11Btn_keyMix[m3];
            var foundFn = false;
            for (var fv = 0; fv < fnValues.length; fv++) {
              if (fnValues[fv] === mk) {
                this.ec11Btn_mixShowArray[m3] = true;
                this.ec11Btn_mixFuncSelectValue[m3] = mk;
                this.ec11Btn_mixText[m3] = '';
                foundFn = true;
                break;
              }
            }
            if (!foundFn) {
              this.ec11Btn_mixShowArray[m3] = false;
              this.ec11Btn_mixFuncSelectValue[m3] = '';
              this.ec11Btn_mixText[m3] = mk >= 0x20 && mk <= 0x7e ? String.fromCharCode(mk) : '';
            }
          } else {
            this.ec11Btn_mixShowArray[m3] = false;
            this.ec11Btn_mixFuncSelectValue[m3] = '';
            this.ec11Btn_mixText[m3] = '';
          }
        }
        this.ec11BtnMixCountChange();
      }
    },
    ec11BtnMixAdd: function ec11BtnMixAdd(type) {
      if (this.ec11Btn_mixCount >= 5) {
        this.$message.error(this.$t('keyConfig.mixMaxErr'));
        return;
      }
      if (type === 1) {
        this.ec11Btn_mixShowArray[this.ec11Btn_mixCount] = true;
      } else if (type === 2) {
        this.ec11Btn_mixShowArray[this.ec11Btn_mixCount] = false;
      }
      this.ec11Btn_mixCount++;
      this.ec11BtnMixCountChange();
    },
    ec11BtnMixDelete: function ec11BtnMixDelete() {
      if (this.ec11Btn_mixCount <= 0) {
        this.$message.error(this.$t('keyConfig.delErr'));
        return;
      }
      this.ec11Btn_mixCount--;
      this.ec11Btn_mixFuncSelectValue[this.ec11Btn_mixCount] = '';
      this.ec11Btn_mixText[this.ec11Btn_mixCount] = '';
      this.ec11Btn_mixShowArray[this.ec11Btn_mixCount] = false;
      this.ec11Btn_keyMix[this.ec11Btn_mixCount] = 0xff;
      this.ec11BtnMixCountChange();
    },
    ec11BtnMixReset: function ec11BtnMixReset() {
      this.ec11Btn_mixCount = 0;
      for (var i = 0; i < 5; i++) {
        this.ec11Btn_mixCountArray[i] = false;
        this.ec11Btn_mixShowArray[i] = false;
        this.ec11Btn_mixFuncSelectValue[i] = '';
        this.ec11Btn_mixText[i] = '';
        this.ec11Btn_keyMix[i] = 0xff;
      }
      this.ec11BtnMixCountChange();
    },
    ec11BtnMixCountChange: function ec11BtnMixCountChange() {
      switch (this.ec11Btn_mixCount) {
        case 0:
          this.ec11Btn_mixCountArray = [false, false, false, false, false];
          break;
        case 1:
          this.ec11Btn_mixCountArray = [true, false, false, false, false];
          break;
        case 2:
          this.ec11Btn_mixCountArray = [true, true, false, false, false];
          break;
        case 3:
          this.ec11Btn_mixCountArray = [true, true, true, false, false];
          break;
        case 4:
          this.ec11Btn_mixCountArray = [true, true, true, true, false];
          break;
        case 5:
          this.ec11Btn_mixCountArray = [true, true, true, true, true];
          break;
        default:
          this.ec11Btn_mixCountArray = [false, false, false, false, false];
          break;
      }
      var mixShowArray = this.ec11Btn_mixShowArray;
      var mixFuncSelectValue = this.ec11Btn_mixFuncSelectValue;
      var mixText = this.ec11Btn_mixText;
      var mixTips = '';
      for (var i = 0; i < 5; i++) {
        if (this.ec11Btn_mixCountArray[i]) {
          if (mixShowArray[i]) {
            if (mixFuncSelectValue[i] === '') mixTips = mixTips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr2') + ' ';
          } else {
            if (mixText[i].length != 1) mixTips = mixTips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3') + ' ';
          }
        }
      }
      if (this.ec11Btn_mixCount < 2) mixTips = this.$t('keyConfig.mixAdd');
      if (mixTips === '') mixTips = this.$t('keyConfig.mixMax5');
      this.ec11Btn_mixTips = mixTips;
    },
    ec11CWMixAdd: function ec11CWMixAdd(type) {
      if (this.ec11CW_mixCount >= 5) {
        this.$message.error(this.$t('keyConfig.mixMaxErr'));
        return;
      }
      if (type === 1) {
        this.ec11CW_mixShowArray[this.ec11CW_mixCount] = true;
      } else if (type === 2) {
        this.ec11CW_mixShowArray[this.ec11CW_mixCount] = false;
      }
      this.ec11CW_mixCount++;
      this.ec11CWMixCountChange();
    },
    ec11CWMixDelete: function ec11CWMixDelete() {
      if (this.ec11CW_mixCount <= 0) {
        this.$message.error(this.$t('keyConfig.delErr'));
        return;
      }
      this.ec11CW_mixCount--;
      this.ec11CW_mixFuncSelectValue[this.ec11CW_mixCount] = '';
      this.ec11CW_mixText[this.ec11CW_mixCount] = '';
      this.ec11CW_mixShowArray[this.ec11CW_mixCount] = false;
      this.ec11CW_keyMix[this.ec11CW_mixCount] = 0xff;
      this.ec11CWMixCountChange();
    },
    ec11CWMixReset: function ec11CWMixReset() {
      this.ec11CW_mixCount = 0;
      for (var i = 0; i < 5; i++) {
        this.ec11CW_mixCountArray[i] = false;
        this.ec11CW_mixShowArray[i] = false;
        this.ec11CW_mixFuncSelectValue[i] = '';
        this.ec11CW_mixText[i] = '';
        this.ec11CW_keyMix[i] = 0xff;
      }
      this.ec11CWMixCountChange();
    },
    ec11CWMixCountChange: function ec11CWMixCountChange() {
      switch (this.ec11CW_mixCount) {
        case 0:
          this.ec11CW_mixCountArray = [false, false, false, false, false];break;
        case 1:
          this.ec11CW_mixCountArray = [true, false, false, false, false];break;
        case 2:
          this.ec11CW_mixCountArray = [true, true, false, false, false];break;
        case 3:
          this.ec11CW_mixCountArray = [true, true, true, false, false];break;
        case 4:
          this.ec11CW_mixCountArray = [true, true, true, true, false];break;
        case 5:
          this.ec11CW_mixCountArray = [true, true, true, true, true];break;
        default:
          this.ec11CW_mixCountArray = [false, false, false, false, false];break;
      }
      var mixShow = this.ec11CW_mixShowArray,
          mixVal = this.ec11CW_mixFuncSelectValue,
          mixTx = this.ec11CW_mixText;
      var tips = '';
      for (var i = 0; i < 5; i++) {
        if (this.ec11CW_mixCountArray[i]) {
          if (mixShow[i]) {
            if (mixVal[i] === '') tips = tips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr2') + ' ';
          } else {
            if (mixTx[i].length != 1) tips = tips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3') + ' ';
          }
        }
      }
      if (this.ec11CW_mixCount < 2) tips = this.$t('keyConfig.mixAdd');
      if (tips === '') tips = this.$t('keyConfig.mixMax5');
      this.ec11CW_mixTips = tips;
    },
    ec11CCWMixAdd: function ec11CCWMixAdd(type) {
      if (this.ec11CCW_mixCount >= 5) {
        this.$message.error(this.$t('keyConfig.mixMaxErr'));
        return;
      }
      if (type === 1) {
        this.ec11CCW_mixShowArray[this.ec11CCW_mixCount] = true;
      } else if (type === 2) {
        this.ec11CCW_mixShowArray[this.ec11CCW_mixCount] = false;
      }
      this.ec11CCW_mixCount++;
      this.ec11CCWMixCountChange();
    },
    ec11CCWMixDelete: function ec11CCWMixDelete() {
      if (this.ec11CCW_mixCount <= 0) {
        this.$message.error(this.$t('keyConfig.delErr'));
        return;
      }
      this.ec11CCW_mixCount--;
      this.ec11CCW_mixFuncSelectValue[this.ec11CCW_mixCount] = '';
      this.ec11CCW_mixText[this.ec11CCW_mixCount] = '';
      this.ec11CCW_mixShowArray[this.ec11CCW_mixCount] = false;
      this.ec11CCW_keyMix[this.ec11CCW_mixCount] = 0xff;
      this.ec11CCWMixCountChange();
    },
    ec11CCWMixReset: function ec11CCWMixReset() {
      this.ec11CCW_mixCount = 0;
      for (var i = 0; i < 5; i++) {
        this.ec11CCW_mixCountArray[i] = false;
        this.ec11CCW_mixShowArray[i] = false;
        this.ec11CCW_mixFuncSelectValue[i] = '';
        this.ec11CCW_mixText[i] = '';
        this.ec11CCW_keyMix[i] = 0xff;
      }
      this.ec11CCWMixCountChange();
    },
    ec11CCWMixCountChange: function ec11CCWMixCountChange() {
      switch (this.ec11CCW_mixCount) {
        case 0:
          this.ec11CCW_mixCountArray = [false, false, false, false, false];break;
        case 1:
          this.ec11CCW_mixCountArray = [true, false, false, false, false];break;
        case 2:
          this.ec11CCW_mixCountArray = [true, true, false, false, false];break;
        case 3:
          this.ec11CCW_mixCountArray = [true, true, true, false, false];break;
        case 4:
          this.ec11CCW_mixCountArray = [true, true, true, true, false];break;
        case 5:
          this.ec11CCW_mixCountArray = [true, true, true, true, true];break;
        default:
          this.ec11CCW_mixCountArray = [false, false, false, false, false];break;
      }
      var mixShow = this.ec11CCW_mixShowArray,
          mixVal = this.ec11CCW_mixFuncSelectValue,
          mixTx = this.ec11CCW_mixText;
      var tips = '';
      for (var i = 0; i < 5; i++) {
        if (this.ec11CCW_mixCountArray[i]) {
          if (mixShow[i]) {
            if (mixVal[i] === '') tips = tips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr2') + ' ';
          } else {
            if (mixTx[i].length != 1) tips = tips + ' ' + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3') + ' ';
          }
        }
      }
      if (this.ec11CCW_mixCount < 2) tips = this.$t('keyConfig.mixAdd');
      if (tips === '') tips = this.$t('keyConfig.mixMax5');
      this.ec11CCW_mixTips = tips;
    },
    showAbout: function showAbout() {
      this.showMainHelp = false;
      this.showMoreMenu = false;
      var t = this.buildTime || '--';
      this.$alert(this.$t('index.aboutBuildTime') + t, this.$t('index.about'), { type: 'info' });
    },
    openRf24PairFromHelp: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                this.showMainHelp = false;
                this.showMoreMenu = false;
                _context17.next = 4;
                return this.openRf24Pair();

              case 4:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function openRf24PairFromHelp() {
        return _ref17.apply(this, arguments);
      }

      return openRf24PairFromHelp;
    }(),
    openRf24Pair: function () {
      var _ref18 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee18() {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                if (!this.port) {
                  _context18.next = 4;
                  break;
                }

                _context18.next = 4;
                return this.disconnectSerial();

              case 4:
                _context18.next = 8;
                break;

              case 6:
                _context18.prev = 6;
                _context18.t0 = _context18['catch'](0);

              case 8:
                this.showRf24Pair = true;

              case 9:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 6]]);
      }));

      function openRf24Pair() {
        return _ref18.apply(this, arguments);
      }

      return openRf24Pair;
    }(),
    sendFactoryLed: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee19(on) {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (this.writer) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt('return');

              case 2:
                _context19.prev = 2;
                _context19.next = 5;
                return this.writer.write(new Uint8Array([0x02, on ? 0x47 : 0x48]));

              case 5:
                _context19.next = 9;
                break;

              case 7:
                _context19.prev = 7;
                _context19.t0 = _context19['catch'](2);

              case 9:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[2, 7]]);
      }));

      function sendFactoryLed(_x3) {
        return _ref19.apply(this, arguments);
      }

      return sendFactoryLed;
    }(),
    openFactoryTest: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee20() {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                this.factoryData = null;
                this.factoryRaw = '';
                this.factoryError = '';
                this.factoryPressedMask = 0;
                this.factoryAuto = true;
                this.showFactoryTest = true;
                _context20.next = 8;
                return this.sendFactoryLed(true);

              case 8:
                this.factoryAutoChanged(true);

              case 9:
              case 'end':
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function openFactoryTest() {
        return _ref20.apply(this, arguments);
      }

      return openFactoryTest;
    }(),
    closeFactoryTest: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee21() {
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                this.stopFactoryTest();
                this.factoryAuto = false;
                _context21.next = 4;
                return this.sendFactoryLed(false);

              case 4:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function closeFactoryTest() {
        return _ref21.apply(this, arguments);
      }

      return closeFactoryTest;
    }(),
    stopFactoryTest: function stopFactoryTest() {
      if (this.factoryTimer) {
        clearInterval(this.factoryTimer);
        this.factoryTimer = null;
      }
    },
    resetFactoryTest: function resetFactoryTest() {
      this.stopFactoryTest();
      this.factoryData = null;
      this.factoryRaw = '';
      this.factoryError = '';
      this.factoryPressedMask = 0;
      this.factoryAuto = true;
      this.showFactoryTest = false;
    },
    factoryAutoChanged: function factoryAutoChanged(value) {
      var _this8 = this;

      if (this.factoryTimer) {
        clearInterval(this.factoryTimer);
        this.factoryTimer = null;
      }
      if (value) {
        this.readFactoryTest();
        this.factoryTimer = setInterval(function () {
          return _this8.readFactoryTest();
        }, 500);
      }
    },
    parseFactoryLine: function parseFactoryLine(line) {
      var m = /^FT1:KEY=([0-9A-F]{2,3}),PCT=(\d+),BAT=(\d+),USB=([01]),CHG=([01]),LEDR=([01]),LEDG=([01]),BLE=([01]),RF=([01]),RFEN=([01]),PA=([0-9A-F]{4}),PB=([0-9A-F]{8}),MODE=([0-9A-F]{2})$/i.exec(line.trim());
      if (!m) throw Error(this.$t('index.errFactoryFormat') + line);
      var bits = parseInt(m[1], 16);
      var keyCount = this.deviceType === 'D2' ? 2 : this.deviceType === 'D9' ? 9 : 6;
      return {
        keys: __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()({ length: keyCount }, function (_, i) {
          return bits >> i & 1;
        }),
        pct: parseInt(m[2], 10),
        bat: parseInt(m[3], 10),
        usb: parseInt(m[4], 10),
        chg: parseInt(m[5], 10),
        ledr: parseInt(m[6], 10),
        ledg: parseInt(m[7], 10),
        ble: parseInt(m[8], 10),
        rf: parseInt(m[9], 10),
        rfen: parseInt(m[10], 10),
        pa: parseInt(m[11], 16),
        pb: parseInt(m[12], 16),
        mode: parseInt(m[13], 16)
      };
    },
    factoryRowClass: function factoryRowClass(_ref22) {
      var row = _ref22.row;

      if (row.state === 'ok') return 'factory-ok';
      if (row.state === 'bad') return 'factory-bad';
      return '';
    },
    factoryCellStyle: function factoryCellStyle(_ref23) {
      var row = _ref23.row;

      if (row.state === 'ok') return { background: '#f0f9eb', color: '#529b2e', fontWeight: '600' };
      if (row.state === 'bad') return { background: '#fef0f0', color: '#c45656', fontWeight: '600' };
      return {};
    },
    readFactoryTest: function () {
      var _ref24 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee22() {
        var _this9 = this;

        var line, parsed;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!(this.factoryReading || this.savingV62)) {
                  _context22.next = 2;
                  break;
                }

                return _context22.abrupt('return');

              case 2:
                if (!(this.sendLabel || !this.writer || !this.reader)) {
                  _context22.next = 7;
                  break;
                }

                this.factoryError = this.$t('index.factoryConnectFirst');
                this.stopFactoryTest();
                this.factoryAuto = false;
                return _context22.abrupt('return');

              case 7:
                this.factoryReading = true;
                _context22.prev = 8;
                _context22.next = 11;
                return this.writer.write(new Uint8Array([0x02, 0x46]));

              case 11:
                _context22.next = 13;
                return this.readV62Line(2000);

              case 13:
                line = _context22.sent;
                parsed = this.parseFactoryLine(line);

                parsed.keys.forEach(function (pressed, i) {
                  if (pressed) _this9.factoryPressedMask |= 1 << i;
                });
                this.factoryData = parsed;
                this.factoryRaw = line;
                this.factoryError = '';
                _context22.next = 26;
                break;

              case 21:
                _context22.prev = 21;
                _context22.t0 = _context22['catch'](8);

                this.factoryError = _context22.t0.message || String(_context22.t0);
                this.stopFactoryTest();
                this.factoryAuto = false;

              case 26:
                _context22.prev = 26;

                this.factoryReading = false;
                return _context22.finish(26);

              case 29:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this, [[8, 21, 26, 29]]);
      }));

      function readFactoryTest() {
        return _ref24.apply(this, arguments);
      }

      return readFactoryTest;
    }(),
    connectSerial: function () {
      var _ref25 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var _this10 = this;

        var filters, decoder, readableStreamClosed, inputStream, label, newProtocol, isB3, isC4, isB6, isB4, isD2, isE6, isD6, isD9, lineTimer, value, done, result, dl, _dl, c4Ver, _dl2, _dl3, _dl4, _dl5, _dl6, dataLabel;

        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                this.resetFactoryTest();
                this.e6DeviceModeAtLoad = null;
                filters = [{ usbVendorId: 0x1209, usbProductId: 0xC550 }, { usbVendorId: 0x1A86, usbProductId: 0x8041 }, // CH591R 复合设备
                { usbVendorId: 0x1A86, usbProductId: 0x8042 } // 2.4G Rx Head CDC
                ];
                _context23.prev = 3;
                _context23.next = 6;
                return navigator.serial.requestPort({ filters: filters });

              case 6:
                this.port = _context23.sent;
                _context23.next = 9;
                return this.port.open({ baudRate: 115200 });

              case 9:
                this.serialPortSelected = true;
                this.writer = this.port.writable.getWriter();
                decoder = new TextDecoderStream();
                readableStreamClosed = this.port.readable.pipeTo(decoder.writable);
                inputStream = decoder.readable;

                this.reader = decoder.readable.pipeThrough(new TransformStream(new LineBreakTransformer())).getReader();
                this.sendLabel = false;
                this.sendText = this.$t('index.submit');
                this.conButton = this.$t('index.disconnect');
                this.conButtonType = 'warning';
                _context23.next = 21;
                return this.sendQuery();

              case 21:
                label = 0;
                newProtocol = false;
                isB3 = false;
                isC4 = false;
                isB6 = false;
                isB4 = false;
                isD2 = false;
                isE6 = false;
                isD6 = false;
                isD9 = false;

                this.v62Protocol = false;

              case 32:
                if (false) {
                  _context23.next = 202;
                  break;
                }

                lineTimer = null;
                value = '';
                done = false;
                _context23.prev = 36;
                _context23.next = 39;
                return __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a.race([this.reader.read(), new __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  lineTimer = setTimeout(function () {
                    return reject(new Error(_this10.$t('index.errNoResponse')));
                  }, 5000);
                })]);

              case 39:
                result = _context23.sent;

                value = result.value;
                done = result.done;

              case 42:
                _context23.prev = 42;

                if (lineTimer) clearTimeout(lineTimer);
                return _context23.finish(42);

              case 45:
                if (!(label == 0)) {
                  _context23.next = 116;
                  break;
                }

                if (!__WEBPACK_IMPORTED_MODULE_11__stability_legacy_bridge_js__["c" /* isModernReply */](value)) {
                  _context23.next = 52;
                  break;
                }

                _context23.next = 49;
                return this.applyV62Snapshot(__WEBPACK_IMPORTED_MODULE_10__stability_codec_js__["parseQuery"](value));

              case 49:
                return _context23.abrupt('break', 202);

              case 52:
                if (!(value == "1")) {
                  _context23.next = 57;
                  break;
                }

                this.$message({
                  message: this.$t('index.success'),
                  type: "success",
                  duration: 5000,
                  showClose: true,
                  customClass: 'success-message'
                });
                return _context23.abrupt('continue', 32);

              case 57:
                if (!(value == 'A1')) {
                  _context23.next = 62;
                  break;
                }

                this.deviceType = 'A1';
                newProtocol = true;
                _context23.next = 114;
                break;

              case 62:
                if (!(value == 'B3')) {
                  _context23.next = 68;
                  break;
                }

                this.deviceType = 'B3';
                newProtocol = true;
                isB3 = true;
                _context23.next = 114;
                break;

              case 68:
                if (!(value == 'C4')) {
                  _context23.next = 74;
                  break;
                }

                this.deviceType = 'C4';
                newProtocol = true;
                isC4 = true;
                _context23.next = 114;
                break;

              case 74:
                if (!(value == 'B6')) {
                  _context23.next = 80;
                  break;
                }

                this.deviceType = 'B6';
                newProtocol = true;
                isB6 = true;
                _context23.next = 114;
                break;

              case 80:
                if (!(value == 'D2')) {
                  _context23.next = 86;
                  break;
                }

                this.deviceType = 'D2';
                newProtocol = true;
                isD2 = true;
                _context23.next = 114;
                break;

              case 86:
                if (!(value == 'B4')) {
                  _context23.next = 92;
                  break;
                }

                this.deviceType = 'B4';
                newProtocol = true;
                isB4 = true;
                _context23.next = 114;
                break;

              case 92:
                if (!(value == 'E6' || value == 'D6')) {
                  _context23.next = 98;
                  break;
                }

                /* E6 与 D6 指向同一台设备，统一使用新的 D6 协议(时间序号+三模选择+CRC16) */
                this.deviceType = value;
                newProtocol = true;
                isD6 = true;
                _context23.next = 114;
                break;

              case 98:
                if (!(value == 'D9')) {
                  _context23.next = 105;
                  break;
                }

                /* 9 键：D6 协议扩展，增加 key7/8/9 */
                this.deviceType = 'D9';
                newProtocol = true;
                isD6 = true;
                isD9 = true;
                _context23.next = 114;
                break;

              case 105:
                if (!(value && value != 'v3' && value != 'v4' && value != 'v5' && value != 'v6' && value != 'v7')) {
                  _context23.next = 114;
                  break;
                }

                _context23.next = 108;
                return this.disconnectSerial();

              case 108:
                this.sendLabel = true;
                this.sendText = this.$t('index.submit');
                this.conButton = this.$t('index.connButtonText1');
                this.conButtonType = "primary";
                this.$message({
                  type: 'warning',
                  message: this.$t('index.firmwareErr1')
                });
                return _context23.abrupt('return');

              case 114:
                _context23.next = 117;
                break;

              case 116:
                if (newProtocol && label == 1) {
                  this.deviceVersion = value;
                } else if (isB3) {
                  dl = label - 1;

                  if (dl == 1) this.b3key1 = parseInt(value, 16);else if (dl == 2) this.b3key2 = parseInt(value, 16);else if (dl == 3) this.b3key3 = parseInt(value, 16);else if (dl == 4) this.b3key1func = parseInt(value, 16);else if (dl == 5) this.b3key2func = parseInt(value, 16);else if (dl == 6) this.b3key3func = parseInt(value, 16);else if (dl == 7) this.b3key1f = parseInt(value, 16);else if (dl == 8) this.b3key2f = parseInt(value, 16);else if (dl == 9) this.b3key3f = parseInt(value, 16);else if (dl == 10) this.b3custStr1 = value;else if (dl == 11) this.b3custStr2 = value;else if (dl == 12) this.b3custStr3 = value;else if (dl >= 13 && dl <= 17) this.b3key1mix[dl - 13] = parseInt(value, 16);else if (dl >= 18 && dl <= 22) this.b3key2mix[dl - 18] = parseInt(value, 16);else if (dl >= 23 && dl <= 27) this.b3key3mix[dl - 23] = parseInt(value, 16);else if (parseInt(this.deviceVersion, 10) >= 1 && dl == 28) this.backlightMode = parseInt(value, 16);else if (parseInt(this.deviceVersion, 10) >= 1 && dl == 29) this.backlightColor1 = parseInt(value, 16);else if (parseInt(this.deviceVersion, 10) >= 1 && dl == 30) this.backlightColor2 = parseInt(value, 16);else if (parseInt(this.deviceVersion, 10) >= 1 && dl == 31) this.backlightColor3 = parseInt(value, 16);else if (parseInt(this.deviceVersion, 10) >= 1 && dl == 32) this.backlightBrightness = parseInt(value, 16);else if (dl == 28) this.b3keyall = parseInt(value, 16);else if (dl == 29) this.b3keyallfunc = parseInt(value, 16);else if (dl == 30) this.b3keyallf = parseInt(value, 16);else if (dl == 31) {} else if (dl >= 32 && dl <= 36) this.b3keyallmix[dl - 32] = parseInt(value, 16);else if (dl == 37) this.keyallmode = parseInt(value, 16);
                } else if (isC4) {
                  _dl = label - 1;
                  c4Ver = parseInt(this.deviceVersion, 10) || 0;

                  if (_dl == 1) this.c4key1 = parseInt(value, 16);else if (_dl == 2) this.c4key2 = parseInt(value, 16);else if (_dl == 3) this.c4key3 = parseInt(value, 16);else if (_dl == 4) this.c4key4 = parseInt(value, 16);else if (_dl == 5) this.c4key1func = parseInt(value, 16);else if (_dl == 6) this.c4key2func = parseInt(value, 16);else if (_dl == 7) this.c4key3func = parseInt(value, 16);else if (_dl == 8) this.c4key4func = parseInt(value, 16);else if (_dl == 9) this.c4key1f = parseInt(value, 16);else if (_dl == 10) this.c4key2f = parseInt(value, 16);else if (_dl == 11) this.c4key3f = parseInt(value, 16);else if (_dl == 12) this.c4key4f = parseInt(value, 16);else if (_dl == 13) this.c4custStr1 = value;else if (_dl == 14) this.c4custStr2 = value;else if (_dl == 15) this.c4custStr3 = value;else if (_dl == 16) this.c4custStr4 = value;else if (_dl >= 17 && _dl <= 21) this.c4key1mix[_dl - 17] = parseInt(value, 16);else if (_dl >= 22 && _dl <= 26) this.c4key2mix[_dl - 22] = parseInt(value, 16);else if (_dl >= 27 && _dl <= 31) this.c4key3mix[_dl - 27] = parseInt(value, 16);else if (_dl >= 32 && _dl <= 36) this.c4key4mix[_dl - 32] = parseInt(value, 16);else if (_dl == 37) this.backlightModeC4 = parseInt(value, 16);else if (_dl == 38) this.backlightColorC4_1 = parseInt(value, 16);else if (_dl == 39) this.backlightColorC4_2 = parseInt(value, 16);else if (_dl == 40) this.backlightColorC4_3 = parseInt(value, 16);else if (_dl == 41) this.backlightColorC4_4 = parseInt(value, 16);else if (_dl == 42) this.backlightBrightnessC4 = parseInt(value, 16);else if (_dl == 43) this.ec11CW_key = parseInt(value, 16);else if (_dl == 44) this.ec11CW_func = parseInt(value, 16);else if (_dl == 45) this.ec11CW_keyF = parseInt(value, 16);else if (_dl == 46) this.ec11CCW_key = parseInt(value, 16);else if (_dl == 47) this.ec11CCW_func = parseInt(value, 16);else if (_dl == 48) this.ec11CCW_keyF = parseInt(value, 16);else if (_dl == 49) this.ec11Btn_key = parseInt(value, 16);else if (_dl == 50) this.ec11Btn_func = parseInt(value, 16);else if (_dl == 51) this.ec11Btn_keyF = parseInt(value, 16);else if (c4Ver >= 2 && _dl >= 52 && _dl <= 56) this.ec11Btn_keyMix[_dl - 52] = parseInt(value, 16);else if (c4Ver >= 3 && _dl >= 57 && _dl <= 61) this.ec11CW_keyMix[_dl - 57] = parseInt(value, 16);else if (c4Ver >= 3 && _dl >= 62 && _dl <= 66) this.ec11CCW_keyMix[_dl - 62] = parseInt(value, 16);
                } else if (isB6 && parseInt(this.deviceVersion, 10) >= 0) {
                  _dl2 = label - 1;

                  if (_dl2 == 1) this.b6key1 = parseInt(value, 16);else if (_dl2 == 2) this.b6key2 = parseInt(value, 16);else if (_dl2 == 3) this.b6key3 = parseInt(value, 16);else if (_dl2 == 4) this.b6key4 = parseInt(value, 16);else if (_dl2 == 5) this.b6key5 = parseInt(value, 16);else if (_dl2 == 6) this.b6key6 = parseInt(value, 16);else if (_dl2 == 7) this.b6key1func = parseInt(value, 16);else if (_dl2 == 8) this.b6key2func = parseInt(value, 16);else if (_dl2 == 9) this.b6key3func = parseInt(value, 16);else if (_dl2 == 10) this.b6key4func = parseInt(value, 16);else if (_dl2 == 11) this.b6key5func = parseInt(value, 16);else if (_dl2 == 12) this.b6key6func = parseInt(value, 16);else if (_dl2 == 13) this.b6key1f = parseInt(value, 16);else if (_dl2 == 14) this.b6key2f = parseInt(value, 16);else if (_dl2 == 15) this.b6key3f = parseInt(value, 16);else if (_dl2 == 16) this.b6key4f = parseInt(value, 16);else if (_dl2 == 17) this.b6key5f = parseInt(value, 16);else if (_dl2 == 18) this.b6key6f = parseInt(value, 16);else if (_dl2 == 19) this.b6custStr1 = value;else if (_dl2 == 20) this.b6custStr2 = value;else if (_dl2 == 21) this.b6custStr3 = value;else if (_dl2 == 22) this.b6custStr4 = value;else if (_dl2 == 23) this.b6custStr5 = value;else if (_dl2 == 24) this.b6custStr6 = value;else if (_dl2 >= 25 && _dl2 <= 29) this.b6key1mix[_dl2 - 25] = parseInt(value, 16);else if (_dl2 >= 30 && _dl2 <= 34) this.b6key2mix[_dl2 - 30] = parseInt(value, 16);else if (_dl2 >= 35 && _dl2 <= 39) this.b6key3mix[_dl2 - 35] = parseInt(value, 16);else if (_dl2 >= 40 && _dl2 <= 44) this.b6key4mix[_dl2 - 40] = parseInt(value, 16);else if (_dl2 >= 45 && _dl2 <= 49) this.b6key5mix[_dl2 - 45] = parseInt(value, 16);else if (_dl2 >= 50 && _dl2 <= 54) this.b6key6mix[_dl2 - 50] = parseInt(value, 16);else if (_dl2 == 55) this.backlightColorB6_1 = parseInt(value, 16);else if (_dl2 == 56) this.backlightColorB6_2 = parseInt(value, 16);else if (_dl2 == 57) this.backlightColorB6_3 = parseInt(value, 16);else if (_dl2 == 58) this.backlightColorB6_4 = parseInt(value, 16);else if (_dl2 == 59) this.backlightColorB6_5 = parseInt(value, 16);else if (_dl2 == 60) this.backlightColorB6_6 = parseInt(value, 16);else if (_dl2 == 61) this.backlightModeB6 = parseInt(value, 16);else if (_dl2 == 62) this.backlightBrightnessB6 = parseInt(value, 16);
                } else if (isB4) {
                  _dl3 = label - 1;

                  if (_dl3 == 1) this.b4key1 = parseInt(value, 16);else if (_dl3 == 2) this.b4key2 = parseInt(value, 16);else if (_dl3 == 3) this.b4key3 = parseInt(value, 16);else if (_dl3 == 4) this.b4key4 = parseInt(value, 16);else if (_dl3 == 5) this.b4key1func = parseInt(value, 16);else if (_dl3 == 6) this.b4key2func = parseInt(value, 16);else if (_dl3 == 7) this.b4key3func = parseInt(value, 16);else if (_dl3 == 8) this.b4key4func = parseInt(value, 16);else if (_dl3 == 9) this.b4key1f = parseInt(value, 16);else if (_dl3 == 10) this.b4key2f = parseInt(value, 16);else if (_dl3 == 11) this.b4key3f = parseInt(value, 16);else if (_dl3 == 12) this.b4key4f = parseInt(value, 16);else if (_dl3 == 13) this.b4custStr1 = value;else if (_dl3 == 14) this.b4custStr2 = value;else if (_dl3 == 15) this.b4custStr3 = value;else if (_dl3 == 16) this.b4custStr4 = value;else if (_dl3 >= 17 && _dl3 <= 21) this.b4key1mix[_dl3 - 17] = parseInt(value, 16);else if (_dl3 >= 22 && _dl3 <= 26) this.b4key2mix[_dl3 - 22] = parseInt(value, 16);else if (_dl3 >= 27 && _dl3 <= 31) this.b4key3mix[_dl3 - 27] = parseInt(value, 16);else if (_dl3 >= 32 && _dl3 <= 36) this.b4key4mix[_dl3 - 32] = parseInt(value, 16);else if (_dl3 == 37) this.backlightModeB4 = parseInt(value, 16);else if (_dl3 == 38) this.backlightColorB4_1 = parseInt(value, 16);else if (_dl3 == 39) this.backlightColorB4_2 = parseInt(value, 16);else if (_dl3 == 40) this.backlightColorB4_3 = parseInt(value, 16);else if (_dl3 == 41) this.backlightColorB4_4 = parseInt(value, 16);else if (_dl3 == 42) this.backlightBrightnessB4 = parseInt(value, 16);
                } else if (isD2) {
                  _dl4 = label - 1;

                  if (_dl4 == 1) this.d2key1 = parseInt(value, 16);else if (_dl4 == 2) this.d2key2 = parseInt(value, 16);else if (_dl4 == 3) this.d2key1func = parseInt(value, 16);else if (_dl4 == 4) this.d2key2func = parseInt(value, 16);else if (_dl4 == 5) this.d2key1f = parseInt(value, 16);else if (_dl4 == 6) this.d2key2f = parseInt(value, 16);else if (_dl4 == 7) this.d2custStr1 = value;else if (_dl4 == 8) this.d2custStr2 = value;else if (_dl4 >= 9 && _dl4 <= 13) this.d2key1mix[_dl4 - 9] = parseInt(value, 16);else if (_dl4 >= 14 && _dl4 <= 18) this.d2key2mix[_dl4 - 14] = parseInt(value, 16);else if (_dl4 == 19) this.d2RunMode = parseInt(value, 16);else if (_dl4 == 20) this.d2PageAction = parseInt(value, 16);
                } else if (isE6) {
                  _dl5 = label - 1;

                  if (_dl5 == 1) this.e6key1 = parseInt(value, 16);else if (_dl5 == 2) this.e6key2 = parseInt(value, 16);else if (_dl5 == 3) this.e6key1func = parseInt(value, 16);else if (_dl5 == 4) this.e6key2func = parseInt(value, 16);else if (_dl5 == 5) this.e6key1f = parseInt(value, 16);else if (_dl5 == 6) this.e6key2f = parseInt(value, 16);else if (_dl5 == 7) this.e6custStr1 = value;else if (_dl5 == 8) this.e6custStr2 = value;else if (_dl5 >= 9 && _dl5 <= 13) this.e6key1mix[_dl5 - 9] = parseInt(value, 16);else if (_dl5 >= 14 && _dl5 <= 18) this.e6key2mix[_dl5 - 14] = parseInt(value, 16);else if (_dl5 == 19) this.e6RunMode = parseInt(value, 16);else if (_dl5 == 20) this.e6PageAction = parseInt(value, 16);else if (_dl5 == 21) this.e6key3 = parseInt(value, 16);else if (_dl5 == 22) this.e6key4 = parseInt(value, 16);else if (_dl5 == 23) this.e6key5 = parseInt(value, 16);else if (_dl5 == 24) this.e6key6 = parseInt(value, 16);else if (_dl5 == 25) this.e6key3func = parseInt(value, 16);else if (_dl5 == 26) this.e6key4func = parseInt(value, 16);else if (_dl5 == 27) this.e6key5func = parseInt(value, 16);else if (_dl5 == 28) this.e6key6func = parseInt(value, 16);else if (_dl5 == 29) this.e6key3f = parseInt(value, 16);else if (_dl5 == 30) this.e6key4f = parseInt(value, 16);else if (_dl5 == 31) this.e6key5f = parseInt(value, 16);else if (_dl5 == 32) this.e6key6f = parseInt(value, 16);else if (_dl5 >= 33 && _dl5 <= 37) this.e6key3mix[_dl5 - 33] = parseInt(value, 16);else if (_dl5 >= 38 && _dl5 <= 42) this.e6key4mix[_dl5 - 38] = parseInt(value, 16);else if (_dl5 >= 43 && _dl5 <= 47) this.e6key5mix[_dl5 - 43] = parseInt(value, 16);else if (_dl5 >= 48 && _dl5 <= 52) this.e6key6mix[_dl5 - 48] = parseInt(value, 16);else if (_dl5 == 53) {
                    this.e6DeviceMode = parseInt(value, 16);this.e6DeviceModeAtLoad = this.e6DeviceMode;
                  }
                } else if (isD6) {
                  /* D6: [1]类型 [2]版本(由newProtocol分支接收) [3]时间序号 [4]三模选择 [5..]字段 */
                  _dl6 = label - 1;

                  if (_dl6 == 1) this.e6TimeSeq = parseInt(value, 16);else if (_dl6 == 2) {
                    this.e6DeviceMode = parseInt(value, 16);this.e6DeviceModeAtLoad = this.e6DeviceMode;
                  } else if (_dl6 == 3) this.e6key1 = parseInt(value, 16);else if (_dl6 == 4) this.e6key2 = parseInt(value, 16);else if (_dl6 == 5) this.e6key1func = parseInt(value, 16);else if (_dl6 == 6) this.e6key2func = parseInt(value, 16);else if (_dl6 == 7) this.e6key1f = parseInt(value, 16);else if (_dl6 == 8) this.e6key2f = parseInt(value, 16);else if (_dl6 == 9) this.e6custStr1 = value;else if (_dl6 == 10) this.e6custStr2 = value;else if (_dl6 >= 11 && _dl6 <= 15) this.e6key1mix[_dl6 - 11] = parseInt(value, 16);else if (_dl6 >= 16 && _dl6 <= 20) this.e6key2mix[_dl6 - 16] = parseInt(value, 16);else if (_dl6 == 21) this.e6RunMode = parseInt(value, 16);else if (_dl6 == 22) this.e6PageAction = parseInt(value, 16);else if (_dl6 == 23) this.e6key3 = parseInt(value, 16);else if (_dl6 == 24) this.e6key4 = parseInt(value, 16);else if (_dl6 == 25) this.e6key5 = parseInt(value, 16);else if (_dl6 == 26) this.e6key6 = parseInt(value, 16);else if (_dl6 == 27) this.e6key3func = parseInt(value, 16);else if (_dl6 == 28) this.e6key4func = parseInt(value, 16);else if (_dl6 == 29) this.e6key5func = parseInt(value, 16);else if (_dl6 == 30) this.e6key6func = parseInt(value, 16);else if (_dl6 == 31) this.e6key3f = parseInt(value, 16);else if (_dl6 == 32) this.e6key4f = parseInt(value, 16);else if (_dl6 == 33) this.e6key5f = parseInt(value, 16);else if (_dl6 == 34) this.e6key6f = parseInt(value, 16);else if (_dl6 >= 35 && _dl6 <= 39) this.e6key3mix[_dl6 - 35] = parseInt(value, 16);else if (_dl6 >= 40 && _dl6 <= 44) this.e6key4mix[_dl6 - 40] = parseInt(value, 16);else if (_dl6 >= 45 && _dl6 <= 49) this.e6key5mix[_dl6 - 45] = parseInt(value, 16);else if (_dl6 >= 50 && _dl6 <= 54) this.e6key6mix[_dl6 - 50] = parseInt(value, 16);else if (_dl6 == 55) this.e6custStr3 = value;else if (_dl6 == 56) this.e6custStr4 = value;else if (_dl6 == 57) this.e6custStr5 = value;else if (_dl6 == 58) this.e6custStr6 = value;else if (_dl6 == 59) this.e6key7 = parseInt(value, 16);else if (_dl6 == 60) this.e6key8 = parseInt(value, 16);else if (_dl6 == 61) this.e6key9 = parseInt(value, 16);else if (_dl6 == 62) this.e6key7func = parseInt(value, 16);else if (_dl6 == 63) this.e6key8func = parseInt(value, 16);else if (_dl6 == 64) this.e6key9func = parseInt(value, 16);else if (_dl6 == 65) this.e6key7f = parseInt(value, 16);else if (_dl6 == 66) this.e6key8f = parseInt(value, 16);else if (_dl6 == 67) this.e6key9f = parseInt(value, 16);else if (_dl6 >= 68 && _dl6 <= 72) this.e6key7mix[_dl6 - 68] = parseInt(value, 16);else if (_dl6 >= 73 && _dl6 <= 77) this.e6key8mix[_dl6 - 73] = parseInt(value, 16);else if (_dl6 >= 78 && _dl6 <= 82) this.e6key9mix[_dl6 - 78] = parseInt(value, 16);else if (_dl6 == 83) this.e6custStr7 = value;else if (_dl6 == 84) this.e6custStr8 = value;else if (_dl6 == 85) this.e6custStr9 = value;
                } else {
                  dataLabel = newProtocol ? label - 1 : label;

                  if (dataLabel == 1) {
                    this.key = parseInt(value, 16);
                  } else if (dataLabel == 2) {
                    this.keyfunc = parseInt(value, 16);
                  } else if (dataLabel == 3) {
                    this.keyf = parseInt(value, 16);
                  } else if (dataLabel == 4) {
                    this.keystr = value;
                  } else if (dataLabel == 5) {
                    this.keymix[0] = parseInt(value, 16);
                  } else if (dataLabel == 6) {
                    this.keymix[1] = parseInt(value, 16);
                  } else if (dataLabel == 7) {
                    this.keymix[2] = parseInt(value, 16);
                  } else if (dataLabel == 8) {
                    this.keymix[3] = parseInt(value, 16);
                  } else if (dataLabel == 9) {
                    this.keymix[4] = parseInt(value, 16);
                  } else if (dataLabel == 10) {
                    this.triggerMode = parseInt(value, 16);
                  } else if (dataLabel == 11) {
                    this.timerHour = parseInt(value, 16);
                  } else if (dataLabel == 12) {
                    this.timerMinute = parseInt(value, 16);
                  } else if (dataLabel == 13) {
                    this.timerSecond = parseInt(value, 16);
                  }
                }

              case 117:
                label++;

                if (!(isB3 && (parseInt(this.deviceVersion, 10) >= 1 ? label >= 34 : label >= 39))) {
                  _context23.next = 127;
                  break;
                }

                label = 0;
                this.$refs.b3key1config.setKey(this.b3key1, this.b3key1func, this.b3key1f, this.b3custStr1, this.b3key1mix);
                this.$refs.b3key2config.setKey(this.b3key2, this.b3key2func, this.b3key2f, this.b3custStr2, this.b3key2mix);
                this.$refs.b3key3config.setKey(this.b3key3, this.b3key3func, this.b3key3f, this.b3custStr3, this.b3key3mix);
                this.updateB3KeyDescs();
                return _context23.abrupt('break', 202);

              case 127:
                if (!(isC4 && (parseInt(this.deviceVersion, 10) >= 3 ? label >= 68 : parseInt(this.deviceVersion, 10) >= 2 ? label >= 58 : label >= 53))) {
                  _context23.next = 138;
                  break;
                }

                label = 0;
                this.$refs.c4key1config.setKey(this.c4key1, this.c4key1func, this.c4key1f, this.c4custStr1, this.c4key1mix);
                this.$refs.c4key2config.setKey(this.c4key2, this.c4key2func, this.c4key2f, this.c4custStr2, this.c4key2mix);
                this.$refs.c4key3config.setKey(this.c4key3, this.c4key3func, this.c4key3f, this.c4custStr3, this.c4key3mix);
                this.$refs.c4key4config.setKey(this.c4key4, this.c4key4func, this.c4key4f, this.c4custStr4, this.c4key4mix);
                this.initEc11UI();
                this.updateC4KeyDescs();
                return _context23.abrupt('break', 202);

              case 138:
                if (!(isB6 && label >= 64)) {
                  _context23.next = 150;
                  break;
                }

                label = 0;
                this.$refs.b6key1config.setKey(this.b6key1, this.b6key1func, this.b6key1f, this.b6custStr1, this.b6key1mix);
                this.$refs.b6key2config.setKey(this.b6key2, this.b6key2func, this.b6key2f, this.b6custStr2, this.b6key2mix);
                this.$refs.b6key3config.setKey(this.b6key3, this.b6key3func, this.b6key3f, this.b6custStr3, this.b6key3mix);
                this.$refs.b6key4config.setKey(this.b6key4, this.b6key4func, this.b6key4f, this.b6custStr4, this.b6key4mix);
                this.$refs.b6key5config.setKey(this.b6key5, this.b6key5func, this.b6key5f, this.b6custStr5, this.b6key5mix);
                this.$refs.b6key6config.setKey(this.b6key6, this.b6key6func, this.b6key6f, this.b6custStr6, this.b6key6mix);
                this.updateB6KeyDescs();
                return _context23.abrupt('break', 202);

              case 150:
                if (!(isD2 && label >= 22)) {
                  _context23.next = 157;
                  break;
                }

                label = 0;
                this.$refs.d2key1config.setKey(this.d2key1, this.d2key1func, this.d2key1f, this.d2custStr1, this.d2key1mix);
                this.$refs.d2key2config.setKey(this.d2key2, this.d2key2func, this.d2key2f, this.d2custStr2, this.d2key2mix);
                return _context23.abrupt('break', 202);

              case 157:
                if (!(isB4 && label >= 44)) {
                  _context23.next = 167;
                  break;
                }

                label = 0;
                this.$refs.b4key1config.setKey(this.b4key1, this.b4key1func, this.b4key1f, this.b4custStr1, this.b4key1mix);
                this.$refs.b4key2config.setKey(this.b4key2, this.b4key2func, this.b4key2f, this.b4custStr2, this.b4key2mix);
                this.$refs.b4key3config.setKey(this.b4key3, this.b4key3func, this.b4key3f, this.b4custStr3, this.b4key3mix);
                this.$refs.b4key4config.setKey(this.b4key4, this.b4key4func, this.b4key4f, this.b4custStr4, this.b4key4mix);
                this.updateB4KeyDescs();
                return _context23.abrupt('break', 202);

              case 167:
                if (!(isE6 && label >= 55)) {
                  _context23.next = 179;
                  break;
                }

                label = 0;
                this.$refs.e6key1config.setKey(this.e6key1, this.e6key1func, this.e6key1f, this.e6custStr1, this.e6key1mix);
                this.$refs.e6key2config.setKey(this.e6key2, this.e6key2func, this.e6key2f, this.e6custStr2, this.e6key2mix);
                this.$refs.e6key3config.setKey(this.e6key3, this.e6key3func, this.e6key3f, '', this.e6key3mix);
                this.$refs.e6key4config.setKey(this.e6key4, this.e6key4func, this.e6key4f, '', this.e6key4mix);
                this.$refs.e6key5config.setKey(this.e6key5, this.e6key5func, this.e6key5f, '', this.e6key5mix);
                this.$refs.e6key6config.setKey(this.e6key6, this.e6key6func, this.e6key6f, '', this.e6key6mix);
                this.updateE6KeyDescs();
                return _context23.abrupt('break', 202);

              case 179:
                if (!(isD6 && label >= (isD9 ? 87 : 60))) {
                  _context23.next = 192;
                  break;
                }

                label = 0;
                this.$refs.e6key1config.setKey(this.e6key1, this.e6key1func, this.e6key1f, this.e6custStr1, this.e6key1mix);
                this.$refs.e6key2config.setKey(this.e6key2, this.e6key2func, this.e6key2f, this.e6custStr2, this.e6key2mix);
                this.$refs.e6key3config.setKey(this.e6key3, this.e6key3func, this.e6key3f, this.e6custStr3, this.e6key3mix);
                this.$refs.e6key4config.setKey(this.e6key4, this.e6key4func, this.e6key4f, this.e6custStr4, this.e6key4mix);
                this.$refs.e6key5config.setKey(this.e6key5, this.e6key5func, this.e6key5f, this.e6custStr5, this.e6key5mix);
                this.$refs.e6key6config.setKey(this.e6key6, this.e6key6func, this.e6key6f, this.e6custStr6, this.e6key6mix);
                if (isD9 && this.$refs.e6key7config) {
                  this.$refs.e6key7config.setKey(this.e6key7, this.e6key7func, this.e6key7f, this.e6custStr7, this.e6key7mix);
                  this.$refs.e6key8config.setKey(this.e6key8, this.e6key8func, this.e6key8f, this.e6custStr8, this.e6key8mix);
                  this.$refs.e6key9config.setKey(this.e6key9, this.e6key9func, this.e6key9f, this.e6custStr9, this.e6key9mix);
                }
                this.updateE6KeyDescs();
                return _context23.abrupt('break', 202);

              case 192:
                if (!(!isB3 && !isC4 && !isB6 && !isD2 && !isB4 && !isE6 && !isD6 && (newProtocol && label >= 15 || !newProtocol && label >= 14))) {
                  _context23.next = 196;
                  break;
                }

                label = 0;
                this.$refs.key1config.setKey(this.key, this.keyfunc, this.keyf, this.keystr, this.keymix);
                return _context23.abrupt('break', 202);

              case 196:
                if (!done) {
                  _context23.next = 200;
                  break;
                }

                _context23.next = 199;
                return readableStreamClosed.catch(function () {});

              case 199:
                return _context23.abrupt('break', 202);

              case 200:
                _context23.next = 32;
                break;

              case 202:
                _context23.next = 218;
                break;

              case 204:
                _context23.prev = 204;
                _context23.t0 = _context23['catch'](3);

                if (!(_context23.t0.name == 'NotFoundError')) {
                  _context23.next = 210;
                  break;
                }

                return _context23.abrupt('return');

              case 210:
                if (_context23.t0.name == 'InvalidStateError' || _context23.t0.name == 'NetworkError') {
                  this.$message.error(this.$t('index.conError1'));
                } else {
                  this.$message.error(this.$t('index.conError2') + _context23.t0);
                }

              case 211:
                _context23.prev = 211;
                _context23.next = 214;
                return this.disconnectSerial();

              case 214:
                _context23.next = 218;
                break;

              case 216:
                _context23.prev = 216;
                _context23.t1 = _context23['catch'](211);

              case 218:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this, [[3, 204], [36,, 42, 45], [211, 216]]);
      }));

      function connectSerial() {
        return _ref25.apply(this, arguments);
      }

      return connectSerial;
    }(),
    disconnectSerial: function () {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_5_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee24() {
        var wasFactoryTest;
        return __WEBPACK_IMPORTED_MODULE_4_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                wasFactoryTest = this.showFactoryTest;

                this.stopFactoryTest();

                if (!wasFactoryTest) {
                  _context24.next = 5;
                  break;
                }

                _context24.next = 5;
                return this.sendFactoryLed(false);

              case 5:
                this.showFactoryTest = false;
                _context24.prev = 6;

                if (!this.reader) {
                  _context24.next = 12;
                  break;
                }

                _context24.next = 10;
                return this.reader.cancel();

              case 10:
                _context24.next = 12;
                return this.reader.releaseLock();

              case 12:
                _context24.next = 16;
                break;

              case 14:
                _context24.prev = 14;
                _context24.t0 = _context24['catch'](6);

              case 16:
                _context24.prev = 16;

                if (!this.writer) {
                  _context24.next = 22;
                  break;
                }

                _context24.next = 20;
                return this.writer.close();

              case 20:
                _context24.next = 22;
                return this.writer.releaseLock();

              case 22:
                _context24.next = 26;
                break;

              case 24:
                _context24.prev = 24;
                _context24.t1 = _context24['catch'](16);

              case 26:
                _context24.prev = 26;

                if (!this.port) {
                  _context24.next = 30;
                  break;
                }

                _context24.next = 30;
                return this.port.close();

              case 30:
                _context24.next = 34;
                break;

              case 32:
                _context24.prev = 32;
                _context24.t2 = _context24['catch'](26);

              case 34:
                this.reader = null;
                this.writer = null;
                this.port = null;
                this.sendLabel = true;
                this.deviceType = '';
                this.v62Protocol = false;
                this.sendText = this.$t('index.connFirst');
                this.conButton = this.$t('index.connButtonText1');
                this.conButtonType = 'primary';

              case 43:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this, [[6, 14], [16, 24], [26, 32]]);
      }));

      function disconnectSerial() {
        return _ref26.apply(this, arguments);
      }

      return disconnectSerial;
    }(),
    getCommonData: function getCommonData() {
      var this_app = this;
      __WEBPACK_IMPORTED_MODULE_12_axios___default.a.get('common.json').then(function (response) {
        var commonkeys = [];
        for (var i = 0; i < response.data.length; i++) {
          var tmp = {};
          if (!tmp.mixkeys) {
            tmp.mixkeys = [];
          }
          for (var j = 0; j < response.data[i].mixkeys.length; j++) {
            tmp.mixkeys[j] = parseInt(response.data[i].mixkeys[j]);
          }
          if (this_app.$i18n.locale == 'zh') {
            tmp.description = response.data[i].description_zh;
          } else if (this_app.$i18n.locale == 'en') {
            tmp.description = response.data[i].description_en;
          }
          commonkeys.push(tmp);
        }
        if (this_app.deviceType === 'B3') {
          if (this_app.$refs.b3key1config) this_app.$refs.b3key1config.setCommon(commonkeys);
          if (this_app.$refs.b3key2config) this_app.$refs.b3key2config.setCommon(commonkeys);
          if (this_app.$refs.b3key3config) this_app.$refs.b3key3config.setCommon(commonkeys);
        } else if (this_app.deviceType === 'C4') {
          if (this_app.$refs.c4key1config) this_app.$refs.c4key1config.setCommon(commonkeys);
          if (this_app.$refs.c4key2config) this_app.$refs.c4key2config.setCommon(commonkeys);
          if (this_app.$refs.c4key3config) this_app.$refs.c4key3config.setCommon(commonkeys);
          if (this_app.$refs.c4key4config) this_app.$refs.c4key4config.setCommon(commonkeys);
        } else if (this_app.deviceType === 'B6') {
          if (this_app.$refs.b6key1config) this_app.$refs.b6key1config.setCommon(commonkeys);
          if (this_app.$refs.b6key2config) this_app.$refs.b6key2config.setCommon(commonkeys);
          if (this_app.$refs.b6key3config) this_app.$refs.b6key3config.setCommon(commonkeys);
          if (this_app.$refs.b6key4config) this_app.$refs.b6key4config.setCommon(commonkeys);
          if (this_app.$refs.b6key5config) this_app.$refs.b6key5config.setCommon(commonkeys);
          if (this_app.$refs.b6key6config) this_app.$refs.b6key6config.setCommon(commonkeys);
        } else if (this_app.deviceType === 'D2') {
          if (this_app.$refs.d2key1config) this_app.$refs.d2key1config.setCommon(commonkeys);
          if (this_app.$refs.d2key2config) this_app.$refs.d2key2config.setCommon(commonkeys);
        } else if (this_app.deviceType === 'B4') {
          if (this_app.$refs.b4key1config) this_app.$refs.b4key1config.setCommon(commonkeys);
          if (this_app.$refs.b4key2config) this_app.$refs.b4key2config.setCommon(commonkeys);
          if (this_app.$refs.b4key3config) this_app.$refs.b4key3config.setCommon(commonkeys);
          if (this_app.$refs.b4key4config) this_app.$refs.b4key4config.setCommon(commonkeys);
        } else if (this_app.deviceType === 'E6' || this_app.deviceType === 'D6' || this_app.deviceType === 'D9') {
          if (this_app.$refs.e6key1config) this_app.$refs.e6key1config.setCommon(commonkeys);
          if (this_app.$refs.e6key2config) this_app.$refs.e6key2config.setCommon(commonkeys);
          if (this_app.$refs.e6key3config) this_app.$refs.e6key3config.setCommon(commonkeys);
          if (this_app.$refs.e6key4config) this_app.$refs.e6key4config.setCommon(commonkeys);
          if (this_app.$refs.e6key5config) this_app.$refs.e6key5config.setCommon(commonkeys);
          if (this_app.$refs.e6key6config) this_app.$refs.e6key6config.setCommon(commonkeys);
          if (this_app.deviceType === 'D9') {
            if (this_app.$refs.e6key7config) this_app.$refs.e6key7config.setCommon(commonkeys);
            if (this_app.$refs.e6key8config) this_app.$refs.e6key8config.setCommon(commonkeys);
            if (this_app.$refs.e6key9config) this_app.$refs.e6key9config.setCommon(commonkeys);
          }
        } else {
          if (this_app.$refs.key1config) this_app.$refs.key1config.setCommon(commonkeys);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    changeLang: function changeLang(lang) {
      this.$i18n.locale = lang;
      document.title = this.$t('index.pageTitle');
      document.documentElement.lang = lang === 'en' ? 'en' : 'zh-CN';
      localStorage.setItem('lang', lang);
      if (this.deviceType === 'B3') {
        if (this.$refs.b3key1config) this.$refs.b3key1config.refreshText();
        if (this.$refs.b3key2config) this.$refs.b3key2config.refreshText();
        if (this.$refs.b3key3config) this.$refs.b3key3config.refreshText();
      } else if (this.deviceType === 'C4') {
        if (this.$refs.c4key1config) this.$refs.c4key1config.refreshText();
        if (this.$refs.c4key2config) this.$refs.c4key2config.refreshText();
        if (this.$refs.c4key3config) this.$refs.c4key3config.refreshText();
        if (this.$refs.c4key4config) this.$refs.c4key4config.refreshText();
      } else if (this.deviceType === 'B6') {
        if (this.$refs.b6key1config) this.$refs.b6key1config.refreshText();
        if (this.$refs.b6key2config) this.$refs.b6key2config.refreshText();
        if (this.$refs.b6key3config) this.$refs.b6key3config.refreshText();
        if (this.$refs.b6key4config) this.$refs.b6key4config.refreshText();
        if (this.$refs.b6key5config) this.$refs.b6key5config.refreshText();
        if (this.$refs.b6key6config) this.$refs.b6key6config.refreshText();
      } else if (this.deviceType === 'D2') {
        if (this.$refs.d2key1config) this.$refs.d2key1config.refreshText();
        if (this.$refs.d2key2config) this.$refs.d2key2config.refreshText();
      } else if (this.deviceType === 'E6' || this.deviceType === 'D6' || this.deviceType === 'D9') {
        if (this.$refs.e6key1config) this.$refs.e6key1config.refreshText();
        if (this.$refs.e6key2config) this.$refs.e6key2config.refreshText();
        if (this.$refs.e6key3config) this.$refs.e6key3config.refreshText();
        if (this.$refs.e6key4config) this.$refs.e6key4config.refreshText();
        if (this.$refs.e6key5config) this.$refs.e6key5config.refreshText();
        if (this.$refs.e6key6config) this.$refs.e6key6config.refreshText();
        if (this.deviceType === 'D9') {
          if (this.$refs.e6key7config) this.$refs.e6key7config.refreshText();
          if (this.$refs.e6key8config) this.$refs.e6key8config.refreshText();
          if (this.$refs.e6key9config) this.$refs.e6key9config.refreshText();
        }
      } else {
        if (this.$refs.key1config) this.$refs.key1config.refreshText();
      }
      this.getCommonData();
      if (this.sendLabel == true) {
        this.sendText = this.$t('index.connFirst');
        this.conButton = this.$t('index.connButtonText1');
      } else {
        this.sendText = this.$t('index.submit');
        this.conButton = this.$t('index.disconnect');
      }
    },
    selectB3Key: function selectB3Key(key) {
      this.selectedB3Key = key;
    },
    updateB3KeyDescs: function updateB3KeyDescs() {
      if (this.$refs.b3key1config) {
        this.b3KeyDesc1 = this.$refs.b3key1config.getKeyDescription();
      }
      if (this.$refs.b3key2config) {
        this.b3KeyDesc2 = this.$refs.b3key2config.getKeyDescription();
      }
      if (this.$refs.b3key3config) {
        this.b3KeyDesc3 = this.$refs.b3key3config.getKeyDescription();
      }
    },
    selectC4Key: function selectC4Key(key) {
      this.selectedC4Key = key;
    },
    updateC4KeyDescs: function updateC4KeyDescs() {
      if (this.$refs.c4key1config) this.c4KeyDesc1 = this.$refs.c4key1config.getKeyDescription();
      if (this.$refs.c4key2config) this.c4KeyDesc2 = this.$refs.c4key2config.getKeyDescription();
      if (this.$refs.c4key3config) this.c4KeyDesc3 = this.$refs.c4key3config.getKeyDescription();
      if (this.$refs.c4key4config) this.c4KeyDesc4 = this.$refs.c4key4config.getKeyDescription();
    },
    getEc11Description: function getEc11Description(type) {
      var funcKeyOptions = this.fnKeyOptions;
      var mediaKeyOptions = this.mediaKeyOptions;
      var func = void 0,
          keyChar = void 0,
          mediaVal = void 0,
          fnVal = void 0,
          scrollDir = void 0,
          mouseBtn = void 0,
          mouseMode = void 0;
      var mixCount = void 0,
          mixShowArray = void 0,
          mixFuncSelectValue = void 0,
          mixText = void 0;
      if (type === 'CW') {
        func = this.ec11CW_func;keyChar = this.ec11CW_keyChar;mediaVal = this.ec11CW_mediaVal;fnVal = this.ec11CW_fnVal;scrollDir = this.ec11CW_scrollDir;mouseBtn = this.ec11CW_mouseBtn;mouseMode = this.ec11CW_mouseMode;
        mixCount = this.ec11CW_mixCount;mixShowArray = this.ec11CW_mixShowArray;mixFuncSelectValue = this.ec11CW_mixFuncSelectValue;mixText = this.ec11CW_mixText;
      } else if (type === 'CCW') {
        func = this.ec11CCW_func;keyChar = this.ec11CCW_keyChar;mediaVal = this.ec11CCW_mediaVal;fnVal = this.ec11CCW_fnVal;scrollDir = this.ec11CCW_scrollDir;mouseBtn = this.ec11CCW_mouseBtn;mouseMode = this.ec11CCW_mouseMode;
        mixCount = this.ec11CCW_mixCount;mixShowArray = this.ec11CCW_mixShowArray;mixFuncSelectValue = this.ec11CCW_mixFuncSelectValue;mixText = this.ec11CCW_mixText;
      } else {
        func = this.ec11Btn_func;keyChar = this.ec11Btn_keyChar;mediaVal = this.ec11Btn_mediaVal;fnVal = this.ec11Btn_fnVal;mouseBtn = this.ec11Btn_mouseBtn;mouseMode = this.ec11Btn_mouseMode;
        mixCount = this.ec11Btn_mixCount;mixShowArray = this.ec11Btn_mixShowArray;mixFuncSelectValue = this.ec11Btn_mixFuncSelectValue;mixText = this.ec11Btn_mixText;
      }
      if (func === 0) return keyChar || this.$t('keyConfig.notSet');
      if (func === 1) {
        var m = mediaKeyOptions.find(function (m) {
          return m.value === mediaVal;
        });
        return m ? m.label : this.$t('keyConfig.notSet');
      }
      if (func === 2) {
        var f = funcKeyOptions.find(function (f) {
          return f.value === fnVal;
        });
        return f ? f.label : this.$t('keyConfig.notSet');
      }
      if (func === 3) return scrollDir === 0 ? this.$t('index.ec11ScrollUp') : this.$t('index.ec11ScrollDown');
      if (func === 4) {
        var btnLabel = mouseBtn === 1 ? this.$t('index.ec11MouseLeft') : mouseBtn === 4 ? this.$t('index.ec11MouseMiddle') : this.$t('index.ec11MouseRight');
        var modeLabel = mouseMode === 0 ? this.$t('index.ec11ClickSingle') : mouseMode === 1 ? this.$t('index.ec11ClickContinuous') : this.$t('index.ec11ClickPress');
        return btnLabel + ' ' + modeLabel;
      }
      if (func === 5) {
        var mixDesc = '';
        for (var i = 0; i < mixCount; i++) {
          if (i > 0) mixDesc += '+';
          if (mixShowArray[i]) {
            var mf = funcKeyOptions.find(function (f) {
              return f.value === mixFuncSelectValue[i];
            });
            mixDesc += mf ? mf.label : this.$t('keyConfig.notSet');
          } else {
            mixDesc += mixText[i] || this.$t('keyConfig.notSet');
          }
        }
        return mixDesc || this.$t('keyConfig.notSet');
      }
      return this.$t('keyConfig.notSet');
    },
    selectB6Key: function selectB6Key(key) {
      this.selectedB6Key = key;
    },
    updateB6KeyDescs: function updateB6KeyDescs() {
      if (this.$refs.b6key1config) this.b6KeyDesc1 = this.$refs.b6key1config.getKeyDescription();
      if (this.$refs.b6key2config) this.b6KeyDesc2 = this.$refs.b6key2config.getKeyDescription();
      if (this.$refs.b6key3config) this.b6KeyDesc3 = this.$refs.b6key3config.getKeyDescription();
      if (this.$refs.b6key4config) this.b6KeyDesc4 = this.$refs.b6key4config.getKeyDescription();
      if (this.$refs.b6key5config) this.b6KeyDesc5 = this.$refs.b6key5config.getKeyDescription();
      if (this.$refs.b6key6config) this.b6KeyDesc6 = this.$refs.b6key6config.getKeyDescription();
    },
    selectB4Key: function selectB4Key(key) {
      this.selectedB4Key = key;
    },
    updateB4KeyDescs: function updateB4KeyDescs() {
      if (this.$refs.b4key1config) this.b4KeyDesc1 = this.$refs.b4key1config.getKeyDescription();
      if (this.$refs.b4key2config) this.b4KeyDesc2 = this.$refs.b4key2config.getKeyDescription();
      if (this.$refs.b4key3config) this.b4KeyDesc3 = this.$refs.b4key3config.getKeyDescription();
      if (this.$refs.b4key4config) this.b4KeyDesc4 = this.$refs.b4key4config.getKeyDescription();
    },
    selectE6Key: function selectE6Key(key) {
      this.selectedE6Key = key;
      this.updateE6KeyDescs();
      this.$set(this.e6KeyOpen, key - 1, true);
      this.$nextTick(function () {
        var el = document.getElementById('e6keycard' + key);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    },
    toggleE6Key: function toggleE6Key(index) {
      this.updateE6KeyDescs();
      this.$set(this.e6KeyOpen, index, !this.e6KeyOpen[index]);
    },
    updateE6KeyDescs: function updateE6KeyDescs() {
      if (this.$refs.e6key1config) this.e6KeyDesc1 = this.$refs.e6key1config.getKeyDescription();
      if (this.$refs.e6key2config) this.e6KeyDesc2 = this.$refs.e6key2config.getKeyDescription();
      if (this.$refs.e6key3config) this.e6KeyDesc3 = this.$refs.e6key3config.getKeyDescription();
      if (this.$refs.e6key4config) this.e6KeyDesc4 = this.$refs.e6key4config.getKeyDescription();
      if (this.$refs.e6key5config) this.e6KeyDesc5 = this.$refs.e6key5config.getKeyDescription();
      if (this.$refs.e6key6config) this.e6KeyDesc6 = this.$refs.e6key6config.getKeyDescription();
      if (this.deviceType === 'D9') {
        if (this.$refs.e6key7config) this.e6KeyDesc7 = this.$refs.e6key7config.getKeyDescription();
        if (this.$refs.e6key8config) this.e6KeyDesc8 = this.$refs.e6key8config.getKeyDescription();
        if (this.$refs.e6key9config) this.e6KeyDesc9 = this.$refs.e6key9config.getKeyDescription();
      }
    },
    getBacklightColor: function getBacklightColor(colorIndex) {
      var colors = { 1: '#409EFF', 2: '#67C23A', 3: '#F56C6C', 4: '#E6A23C', 5: '#4ECDC4', 6: '#B37FEB', 7: '#C0C4CC' };
      return colors[colorIndex] || '#C0C4CC';
    }
  },
  computed: {
    factoryKeyCount: function factoryKeyCount() {
      return this.deviceType === 'D2' ? 2 : this.deviceType === 'D9' ? 9 : 6;
    },
    factoryRows: function factoryRows() {
      var d = this.factoryData;
      if (!d) return [];
      var hex = function hex(v, n) {
        return '0x' + v.toString(16).toUpperCase().padStart(n, '0');
      };
      var rows = [];
      for (var i = 0; i < this.factoryKeyCount; i++) {
        var pressed = !!d.keys[i];
        var latched = !!(this.factoryPressedMask & 1 << i);
        rows.push({
          name: this.$t('index.factoryKey') + (i + 1),
          value: pressed ? this.$t('index.factoryPressed') : latched ? this.$t('index.factoryReleasedDetected') : this.$t('index.factoryReleased'),
          state: pressed || latched ? 'ok' : '',
          result: latched ? 'pass' : 'wait'
        });
      }
      rows.push({ name: this.$t('index.factoryBatteryAdc'), value: d.bat + ' mV / ' + d.pct + '%', state: d.bat >= 2000 ? 'ok' : 'bad', result: d.bat >= 2000 ? 'pass' : 'fail' });
      rows.push({ name: this.$t('index.factoryUsbVcc'), value: d.usb ? this.$t('index.factoryUsbHigh') : this.$t('index.factoryUsbLow'), state: d.usb ? 'ok' : '', result: d.usb ? 'pass' : 'wait' });
      rows.push({ name: 'CHRG', value: d.chg ? this.$t('index.factoryCharging') : this.$t('index.factoryNotCharging'), state: d.chg ? 'ok' : '', result: d.chg ? 'pass' : 'wait' });
      rows.push({ name: this.$t('index.factoryLedRed'), value: d.ledr ? this.$t('index.factoryOn') : this.$t('index.factoryOff'), state: d.ledr ? 'ok' : '', result: d.ledr ? 'pass' : 'wait' });
      rows.push({ name: this.$t('index.factoryLedGreen'), value: d.ledg ? this.$t('index.factoryOn') : this.$t('index.factoryOff'), state: d.ledg ? 'ok' : '', result: d.ledg ? 'pass' : 'wait' });
      rows.push({ name: this.$t('index.factoryBle'), value: d.ble ? this.$t('index.factoryConnected') : this.$t('index.factoryDisconnected'), state: d.ble ? 'ok' : '', result: d.ble ? 'pass' : 'wait' });
      if (this.deviceType === 'D6' || this.deviceType === 'D9') {
        rows.push({ name: this.$t('index.factoryRf24'), value: d.rfen ? d.rf ? this.$t('index.factoryConnected') : this.$t('index.factoryDisconnected') : this.$t('index.factoryNotEnabled'), state: d.rfen ? d.rf ? 'ok' : '' : '', result: d.rfen ? d.rf ? 'pass' : 'wait' : 'info' });
      }
      rows.push({ name: this.$t('index.factoryPaRaw'), value: hex(d.pa, 4), result: 'info' });
      rows.push({ name: this.$t('index.factoryPbRaw'), value: hex(d.pb, 8), result: 'info' });
      if (this.deviceType === 'D6' || this.deviceType === 'D9') {
        rows.push({ name: this.$t('index.factoryMode'), value: hex(d.mode, 2), result: 'info' });
      }
      return rows;
    },
    factoryAbnormal: function factoryAbnormal() {
      var d = this.factoryData;
      if (!d) return false;
      return !d.keys.some(Boolean) && !d.usb && !d.chg && d.bat < 2000;
    },
    factoryPass: function factoryPass() {
      var d = this.factoryData;
      var mask = (1 << this.factoryKeyCount) - 1;
      return !!d && (this.factoryPressedMask & mask) === mask && d.bat >= 2000;
    },
    mediaKeyOptions: function mediaKeyOptions() {
      var keys = this.$t('keyConfig.mediakeys');
      var values = [0xB5, 0xB6, 0xB7, 0xCD, 0xB0, 0xE2, 0xE9, 0xEA, 0x6F, 0x70, 0x183, 0x18A, 0x192, 0x194, 0x223, 0x224, 0x225, 0x227, 0x22A, 0x30, 0x32, 0xB2, 0xB3, 0xB4, 0x19E];
      return keys.map(function (k, i) {
        return { value: values[i], label: k };
      });
    },
    fnKeyOptions: function fnKeyOptions() {
      var keys = this.$t('keyConfig.functionkeys');
      var values = [0x80, 0x81, 0x82, 0x83, 0x84, 0x85, 0x86, 0x87, 0xDA, 0xD9, 0xD8, 0xD7, 0xB2, 0xB3, 0xB0, 0xB1, 0xD1, 0xD4, 0xD3, 0xD6, 0xD2, 0xD5, 0xC1, 0xCE, 0xCF, 0xD0, 0xDB, 0xC2, 0xC3, 0xC4, 0xC5, 0xC6, 0xC7, 0xC8, 0xC9, 0xCA, 0xCB, 0xCC, 0xCD, 0xF0, 0xF1, 0xF2, 0xF3, 0xF4, 0xF5, 0xF6, 0xF7, 0xF8, 0xF9, 0xFA, 0xFB, 0xED, 0xDC, 0xDD, 0xDE, 0xDF, 0xE0, 0xE1, 0xE2, 0xE3, 0xE4, 0xE5, 0xE6, 0xE7, 0xE8, 0xE9, 0xEA, 0xEB];
      return keys.map(function (k, i) {
        return { value: values[i], label: k };
      });
    },
    colorOptions: function colorOptions() {
      return [{ value: 1, label: this.$t('index.colorBlue') }, { value: 2, label: this.$t('index.colorGreen') }, { value: 3, label: this.$t('index.colorRed') }, { value: 4, label: this.$t('index.colorYellow') }, { value: 5, label: this.$t('index.colorCyan') }, { value: 6, label: this.$t('index.colorPurple') }, { value: 7, label: this.$t('index.colorWhite') }];
    },
    c4Ec11CWDesc: function c4Ec11CWDesc() {
      return this.getEc11Description('CW');
    },
    c4Ec11CCWDesc: function c4Ec11CCWDesc() {
      return this.getEc11Description('CCW');
    },
    c4Ec11BtnDesc: function c4Ec11BtnDesc() {
      return this.getEc11Description('Btn');
    },
    shortcutGroups: function shortcutGroups() {
      return [{ name: this.$t('index.scGroupEdit'), items: [{ key: 'Ctrl+C', desc: this.$t('index.scCopy') }, { key: 'Ctrl+V', desc: this.$t('index.scPaste') }, { key: 'Ctrl+X', desc: this.$t('index.scCut') }, { key: 'Ctrl+Z', desc: this.$t('index.scUndo') }, { key: 'Ctrl+Y', desc: this.$t('index.scRedo') }, { key: 'Ctrl+A', desc: this.$t('index.scSelectAll') }, { key: 'Ctrl+S', desc: this.$t('index.scSave') }, { key: 'Ctrl+F', desc: this.$t('index.scFind') }, { key: 'Ctrl+H', desc: this.$t('index.scReplace') }, { key: 'Ctrl+P', desc: this.$t('index.scPrint') }] }, { name: this.$t('index.scGroupWin'), items: [{ key: 'Alt+Tab', desc: this.$t('index.scSwitchWin') }, { key: 'Win+D', desc: this.$t('index.scDesktop') }, { key: 'Win+E', desc: this.$t('index.scExplorer') }, { key: 'Win+L', desc: this.$t('index.scLock') }, { key: 'Win+I', desc: this.$t('index.scSettings') }, { key: 'Win+S', desc: this.$t('index.scSearch') }, { key: 'Alt+F4', desc: this.$t('index.scCloseWin') }, { key: 'F11', desc: this.$t('index.scFullscreen') }, { key: 'PrtSc', desc: this.$t('index.scScreenshot') }, { key: 'Win+Shift+S', desc: this.$t('index.scSnipping') }] }, { name: this.$t('index.scGroupText'), items: [{ key: 'Ctrl+B', desc: this.$t('index.scBold') }, { key: 'Ctrl+I', desc: this.$t('index.scItalic') }, { key: 'Ctrl+U', desc: this.$t('index.scUnderline') }, { key: 'Ctrl+Shift+→', desc: this.$t('index.scSelectWord') }, { key: 'Ctrl+Home', desc: this.$t('index.scHome') }, { key: 'Ctrl+End', desc: this.$t('index.scEnd') }, { key: 'Delete', desc: this.$t('index.scDelete') }] }, { name: this.$t('index.scGroupBrowser'), items: [{ key: 'Ctrl+T', desc: this.$t('index.scNewTab') }, { key: 'Ctrl+W', desc: this.$t('index.scCloseTab') }, { key: 'Ctrl+Tab', desc: this.$t('index.scSwitchTab') }, { key: 'Ctrl+Shift+T', desc: this.$t('index.scReopenTab') }, { key: 'Ctrl+D', desc: this.$t('index.scBookmark') }, { key: 'F5', desc: this.$t('index.scRefresh') }, { key: 'Ctrl+F5', desc: this.$t('index.scHardRefresh') }] }, { name: this.$t('index.scGroupDev'), items: [{ key: 'F12', desc: this.$t('index.scDevTools') }, { key: 'Ctrl+Shift+I', desc: this.$t('index.scDevTools2') }, { key: 'F5', desc: this.$t('index.scDebug') }, { key: 'Ctrl+`', desc: this.$t('index.scTerminal') }, { key: 'Ctrl+Shift+P', desc: this.$t('index.scCommandPalette') }, { key: 'Ctrl+Shift+N', desc: this.$t('index.scNewWin') }] }, { name: this.$t('index.scGroupIDE'), items: [{ key: 'Ctrl+Shift+K', desc: this.$t('index.scDeleteLine') }, { key: 'Ctrl+D', desc: this.$t('index.scSelectNext') }, { key: 'Ctrl+Shift+L', desc: this.$t('index.scSelectAll') }, { key: 'Alt+↑/↓', desc: this.$t('index.scMoveLine') }, { key: 'Ctrl+/', desc: this.$t('index.scComment') }, { key: 'F2', desc: this.$t('index.scRename') }, { key: 'Ctrl+Shift+F', desc: this.$t('index.scGlobalSearch') }, { key: 'Ctrl+Shift+E', desc: this.$t('index.scExplorer') }, { key: 'Ctrl+G', desc: this.$t('index.scGoToLine') }, { key: 'Alt+Shift+F', desc: this.$t('index.scFormat') }, { key: 'Ctrl+Space', desc: this.$t('index.scSuggest') }, { key: 'Ctrl+.', desc: this.$t('index.scQuickFix') }, { key: 'Ctrl+B', desc: this.$t('index.scToggleSidebar') }, { key: 'Ctrl+Shift+O', desc: this.$t('index.scGoToSymbol') }] },
      // Cursor AI 快捷键
      { name: this.$t('index.scGroupAIChat'), items: [{ key: 'Ctrl+Enter', desc: this.$t('index.scAIChatSubmit') }, { key: 'Shift+Enter', desc: this.$t('index.scAIChatNewline') }, { key: 'Ctrl+L', desc: this.$t('index.scAIChatClear') }, { key: 'Ctrl+Shift+Z', desc: this.$t('index.scAIChatUndo') }, { key: 'Ctrl+Shift+U', desc: this.$t('index.scAIChatRetry') }, { key: 'Esc', desc: this.$t('index.scAIChatStop') }] }, { name: this.$t('index.scGroupAICode'), items: [{ key: 'Ctrl+K', desc: this.$t('index.scAICodeSidebar') }, { key: 'Ctrl+I', desc: this.$t('index.scAICodeInline') }, { key: 'Ctrl+Shift+L', desc: this.$t('index.scAICodeSelectBlock') }, { key: 'Tab', desc: this.$t('index.scAICodeAccept') }, { key: 'Shift+Tab', desc: this.$t('index.scAICodeReject') }, { key: 'Ctrl+Shift+R', desc: this.$t('index.scAICodeRefactor') }] }, { name: this.$t('index.scGroupAIFile'), items: [{ key: 'Ctrl+Shift+P', desc: this.$t('index.scAIFileCmdPalette') }, { key: 'Ctrl+O', desc: this.$t('index.scAIFileOpen') }, { key: 'Ctrl+Shift+F', desc: this.$t('index.scAIFileSearch') }, { key: 'Ctrl+B', desc: this.$t('index.scAIFileExplorer') }, { key: 'Ctrl+`', desc: this.$t('index.scAIFileTerminal') }] }, { name: this.$t('index.scGroupAIWin'), items: [{ key: 'Ctrl+N', desc: this.$t('index.scAIWinNew') }, { key: 'Ctrl+Tab', desc: this.$t('index.scAIWinSwitch') }, { key: 'Ctrl+W', desc: this.$t('index.scAIWinClose') }, { key: 'Alt+←/→', desc: this.$t('index.scAIWinHistory') }] }, { name: this.$t('index.scGroupZoomShort'), items: [{ key: 'Ctrl + +', desc: this.$t('index.scZoomIn') }, { key: 'Ctrl + -', desc: this.$t('index.scZoomOut') }, { key: 'Ctrl + 0', desc: this.$t('index.scZoomReset') }] }, { name: this.$t('index.scGroupOfficeCommon'), items: [{ key: 'Ctrl+N', desc: this.$t('index.scOfficeNewFile') }, { key: 'Ctrl+O', desc: this.$t('index.scOfficeOpenFile') }, { key: 'Ctrl+S', desc: this.$t('index.scOfficeSave') }, { key: 'Ctrl+Shift+S', desc: this.$t('index.scOfficeSaveAs') }, { key: 'Ctrl+P', desc: this.$t('index.scOfficePrint') }, { key: 'Ctrl+W', desc: this.$t('index.scOfficeCloseFile') }, { key: 'Ctrl+Z', desc: this.$t('index.scOfficeUndo') }, { key: 'Ctrl+Y', desc: this.$t('index.scOfficeRedo') }, { key: 'Ctrl+F', desc: this.$t('index.scOfficeFind') }, { key: 'Ctrl+H', desc: this.$t('index.scOfficeReplace') }] }, { name: this.$t('index.scGroupOfficeWord'), items: [{ key: 'Ctrl+N', desc: this.$t('index.scWordNewDoc') }, { key: 'Ctrl+O', desc: this.$t('index.scWordOpenDoc') }, { key: 'F12', desc: this.$t('index.scWordSaveAs') }, { key: 'Shift+F4', desc: this.$t('index.scWordFindNext') }, { key: 'Ctrl+G', desc: this.$t('index.scWordGoToPage') }, { key: 'Ctrl+K', desc: this.$t('index.scWordInsertLink') }, { key: 'Ctrl+Enter', desc: this.$t('index.scWordInsertPageBreak') }, { key: 'Ctrl+E', desc: this.$t('index.scWordCenterAlign') }, { key: 'Ctrl+L', desc: this.$t('index.scWordLeftAlign') }, { key: 'Ctrl+R', desc: this.$t('index.scWordRightAlign') }, { key: 'Ctrl+J', desc: this.$t('index.scWordJustifyAlign') }, { key: 'Ctrl+5', desc: this.$t('index.scWord1_5Line') }, { key: 'Ctrl+B', desc: this.$t('index.scWordBold') }, { key: 'Ctrl+U', desc: this.$t('index.scWordUnderline') }, { key: 'Ctrl+I', desc: this.$t('index.scWordItalic') }] }, { name: this.$t('index.scGroupOfficeExcel'), items: [{ key: 'Alt + =', desc: this.$t('index.scExcelSumAuto') }, { key: 'Ctrl + R', desc: this.$t('index.scExcelFillRight') }, { key: 'Ctrl + D', desc: this.$t('index.scExcelFillDown') }, { key: 'Ctrl+Shift+V', desc: this.$t('index.scExcelPasteValue') }, { key: 'Ctrl+Shift+C', desc: this.$t('index.scExcelPasteFormat') }, { key: 'Ctrl+Shift++', desc: this.$t('index.scExcelInsertRow') }, { key: 'Ctrl + -', desc: this.$t('index.scExcelDeleteRow') }, { key: 'Ctrl+Shift+L', desc: this.$t('index.scExcelToggleFilter') }, { key: 'F5', desc: this.$t('index.scExcelGoToCell') }, { key: 'Ctrl+F3', desc: this.$t('index.scExcelNameBox') }, { key: 'Ctrl + ;', desc: this.$t('index.scExcelTodayDate') }, { key: 'Ctrl+Shift+: ', desc: this.$t('index.scExcelNowTime') }, { key: 'Ctrl + A / Ctrl+*', desc: this.$t('index.scExcelSelectAllRegion') }, { key: 'F2', desc: this.$t('index.scExcelEditCell') }, { key: 'Ctrl+PageDown', desc: this.$t('index.scExcelSwitchSheet') }] }];
    }
  },
  mounted: function mounted() {
    this.getCommonData();
    this.videoUrl = __WEBPACK_IMPORTED_MODULE_13__assets_video_tutorial_mp4___default.a;
    document.title = this.$t('index.pageTitle');
    document.documentElement.lang = this.$i18n.locale === 'en' ? 'en' : 'zh-CN';
  },
  data: function data() {
    return {
      v5version: false,
      v7version: false,
      oldversion: false,
      v62Protocol: false,
      v62Status: 0,
      savingV62: false,
      commitSent: false,
      deviceType: '',
      deviceVersion: '',
      writer: {},
      port: {},
      reader: {},
      sendLabel: true,
      sendText: this.$t('index.connFirst'),
      conButton: this.$t('index.connButtonText1'),
      conButtonType: "primary",
      key: 0xff,
      keyfunc: 0xff,
      keyf: 0xff,
      keystr: '',
      keymix: [0xff, 0xff, 0xff, 0xff, 0xff],
      triggerMode: 0,
      timerHour: 0,
      timerMinute: 0,
      timerSecond: 0,
      b3key1: 0xff,
      b3key2: 0xff,
      b3key3: 0xff,
      b3keyall: 0xff,
      b3key1func: 0xff,
      b3key2func: 0xff,
      b3key3func: 0xff,
      b3keyallfunc: 0xff,
      b3key1f: 0xff,
      b3key2f: 0xff,
      b3key3f: 0xff,
      b3keyallf: 0xff,
      b3key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b3key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b3key3mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b3keyallmix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b3custStr1: '',
      b3custStr2: '',
      b3custStr3: '',
      keyallmode: 0,
      backlightMode: 0,
      backlightColor1: 1,
      backlightColor2: 1,
      backlightColor3: 1,
      backlightBrightness: 128,
      selectedB3Key: 0,
      compactKeyboardHiddenMediaValues: [0x18A, 0x223, 0x224, 0x225, 0x227, 0x22A, 0x30, 0x32, 0x19E],
      b3KeyDesc1: '', b3KeyDesc2: '', b3KeyDesc3: '',
      showVideoModal: false,
      showKeyTester: false,
      showMainHelp: false,
      showMoreMenu: false,
      rightTipClosed: false,
      deviceConnecting: false,
      serialPortSelected: false,
      e6KeyOpen: [false, false, false, false, false, false, false, false, false],
      buildTime:  true ? "2026-11-02 22:45:09" : '',
      showRf24Pair: false,
      showFactoryTest: false,
      factoryData: null,
      factoryRaw: '',
      factoryError: '',
      factoryPressedMask: 0,
      factoryAuto: true,
      factoryTimer: null,
      factoryReading: false,
      videoUrl: '',
      // C4
      c4key1: 0xff, c4key2: 0xff, c4key3: 0xff, c4key4: 0xff,
      c4key1func: 0xff, c4key2func: 0xff, c4key3func: 0xff, c4key4func: 0xff,
      c4key1f: 0xff, c4key2f: 0xff, c4key3f: 0xff, c4key4f: 0xff,
      c4key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      c4key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      c4key3mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      c4key4mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      c4custStr1: '', c4custStr2: '', c4custStr3: '', c4custStr4: '',
      ec11CW_func: 0, ec11CW_key: 0xff, ec11CW_keyChar: '', ec11CW_keyF: 0xff,
      ec11CW_mediaVal: 0xE2, ec11CW_mouseBtn: 1, ec11CW_mouseMode: 0, ec11CW_fnVal: 0xC2, ec11CW_scrollDir: 0,
      ec11CW_keyMix: [0xff, 0xff, 0xff, 0xff, 0xff],
      ec11CW_mixCount: 0,
      ec11CW_mixCountArray: [false, false, false, false, false],
      ec11CW_mixShowArray: [false, false, false, false, false],
      ec11CW_mixFuncSelectValue: ['', '', '', '', ''],
      ec11CW_mixText: ['', '', '', '', ''],
      ec11CW_mixTips: '',
      ec11CCW_func: 0, ec11CCW_key: 0xff, ec11CCW_keyChar: '', ec11CCW_keyF: 0xff,
      ec11CCW_mediaVal: 0xE9, ec11CCW_mouseBtn: 1, ec11CCW_mouseMode: 0, ec11CCW_fnVal: 0xC2, ec11CCW_scrollDir: 1,
      ec11CCW_keyMix: [0xff, 0xff, 0xff, 0xff, 0xff],
      ec11CCW_mixCount: 0,
      ec11CCW_mixCountArray: [false, false, false, false, false],
      ec11CCW_mixShowArray: [false, false, false, false, false],
      ec11CCW_mixFuncSelectValue: ['', '', '', '', ''],
      ec11CCW_mixText: ['', '', '', '', ''],
      ec11CCW_mixTips: '',
      ec11Btn_func: 0, ec11Btn_key: 0xff, ec11Btn_keyChar: '', ec11Btn_keyF: 0xff,
      ec11Btn_mediaVal: 0xCD, ec11Btn_mouseBtn: 1, ec11Btn_mouseMode: 0, ec11Btn_fnVal: 0xC2, ec11Btn_scrollDir: 0,
      ec11Btn_keyMix: [0xff, 0xff, 0xff, 0xff, 0xff],
      ec11Btn_mixCount: 0,
      ec11Btn_mixCountArray: [false, false, false, false, false],
      ec11Btn_mixShowArray: [false, false, false, false, false],
      ec11Btn_mixFuncSelectValue: ['', '', '', '', ''],
      ec11Btn_mixText: ['', '', '', '', ''],
      ec11Btn_mixTips: '',
      backlightModeC4: 0,
      backlightColorC4_1: 1, backlightColorC4_2: 1,
      backlightColorC4_3: 1, backlightColorC4_4: 1,
      backlightBrightnessC4: 128,
      // C4 Key Descriptions
      c4KeyDesc1: '', c4KeyDesc2: '', c4KeyDesc3: '', c4KeyDesc4: '',
      selectedC4Key: 0,
      // B6 Key Descriptions
      b6KeyDesc1: '', b6KeyDesc2: '', b6KeyDesc3: '', b6KeyDesc4: '', b6KeyDesc5: '', b6KeyDesc6: '',
      selectedB6Key: 0,
      b6key1: 0xff, b6key2: 0xff, b6key3: 0xff, b6key4: 0xff, b6key5: 0xff, b6key6: 0xff,
      b6key1func: 0xff, b6key2func: 0xff, b6key3func: 0xff, b6key4func: 0xff, b6key5func: 0xff, b6key6func: 0xff,
      b6key1f: 0xff, b6key2f: 0xff, b6key3f: 0xff, b6key4f: 0xff, b6key5f: 0xff, b6key6f: 0xff,
      b6key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6key3mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6key4mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6key5mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6key6mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b6custStr1: '', b6custStr2: '', b6custStr3: '', b6custStr4: '', b6custStr5: '', b6custStr6: '',
      backlightModeB6: 0,
      backlightColorB6_1: 1, backlightColorB6_2: 1, backlightColorB6_3: 1,
      backlightColorB6_4: 1, backlightColorB6_5: 1, backlightColorB6_6: 1,
      backlightBrightnessB6: 128,
      // D2
      d2key1: 0xff, d2key2: 0xff,
      d2key1func: 0xff, d2key2func: 0xff,
      d2key1f: 0xff, d2key2f: 0xff,
      d2key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      d2key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      d2custStr1: '', d2custStr2: '',
      d2RunMode: 0,
      d2PageAction: 0,
      // B4
      b4key1: 0xff, b4key2: 0xff, b4key3: 0xff, b4key4: 0xff,
      b4key1func: 0xff, b4key2func: 0xff, b4key3func: 0xff, b4key4func: 0xff,
      b4key1f: 0xff, b4key2f: 0xff, b4key3f: 0xff, b4key4f: 0xff,
      b4key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b4key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b4key3mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b4key4mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      b4custStr1: '', b4custStr2: '', b4custStr3: '', b4custStr4: '',
      backlightModeB4: 0,
      backlightColorB4_1: 1, backlightColorB4_2: 1,
      backlightColorB4_3: 1, backlightColorB4_4: 1,
      backlightBrightnessB4: 128,
      selectedB4Key: 0,
      b4KeyDesc1: '', b4KeyDesc2: '', b4KeyDesc3: '', b4KeyDesc4: '',
      // E6 (三模键盘 6键)
      e6key1: 0xff, e6key2: 0xff, e6key3: 0xff, e6key4: 0xff, e6key5: 0xff, e6key6: 0xff,
      e6key7: 0xff, e6key8: 0xff, e6key9: 0xff,
      e6key1func: 0xff, e6key2func: 0xff, e6key3func: 0xff, e6key4func: 0xff, e6key5func: 0xff, e6key6func: 0xff,
      e6key7func: 0xff, e6key8func: 0xff, e6key9func: 0xff,
      e6key1f: 0xff, e6key2f: 0xff, e6key3f: 0xff, e6key4f: 0xff, e6key5f: 0xff, e6key6f: 0xff,
      e6key7f: 0xff, e6key8f: 0xff, e6key9f: 0xff,
      e6key1mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key2mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key3mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key4mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key5mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key6mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key7mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key8mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6key9mix: [0xff, 0xff, 0xff, 0xff, 0xff],
      e6custStr1: '', e6custStr2: '', e6custStr3: '', e6custStr4: '', e6custStr5: '', e6custStr6: '',
      e6custStr7: '', e6custStr8: '', e6custStr9: '',
      e6RunMode: 0,
      e6PageAction: 0,
      e6DeviceMode: 0x24,
      e6DeviceModeAtLoad: null,
      e6TimeSeq: 0,
      selectedE6Key: 0,
      e6KeyDesc1: '', e6KeyDesc2: '', e6KeyDesc3: '', e6KeyDesc4: '', e6KeyDesc5: '', e6KeyDesc6: '',
      e6KeyDesc7: '', e6KeyDesc8: '', e6KeyDesc9: ''
    };
  }
});

var LineBreakTransformer = function () {
  function LineBreakTransformer() {
    __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_classCallCheck___default()(this, LineBreakTransformer);

    // 保存流数据直到新行出现的容器
    this.container = "";
  }

  __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_createClass___default()(LineBreakTransformer, [{
    key: 'transform',
    value: function transform(chunk, controller) {
      // 将新块追加到现有块。
      this.container += chunk;
      // console.log(this.container);
      // ACK 也是一行文本；必须等 CRLF 完整到达，不能提前消费单独的 "1"，
      // 否则后续 CRLF 会作为空行留给下一次保存。
      var lines = this.container.split("\r\n");
      this.container = lines.pop();
      lines.forEach(function (line) {
        return controller.enqueue(line);
      });
    }
  }, {
    key: 'flush',
    value: function flush(controller) {
      // 当流关闭时，清除所有剩余的块。
      controller.enqueue(this.container);
    }
  }]);

  return LineBreakTransformer;
}();

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    labelstr: '',
    stringshow: true,
    mouseoptshow: {
      type: Boolean,
      default: true
    },
    mouseclickonly: {
      type: Boolean,
      default: false
    },
    scrolloptshow: {
      type: Boolean,
      default: false
    },
    mousedoubleEnable: {
      type: Boolean,
      default: false
    },
    stringsize: {
      type: Number,
      default: 30
    },
    hidNormalKey: { type: Boolean, default: false },
    normalOnly: { type: Boolean, default: false },
    hiddenMediaValues: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      keyname: '',
      keyradio: 0,
      funcselectshow: false,
      mediaselectshow: false,
      input1show: false,
      input2show: false,
      scrollshow: false,
      scrollvalue: 0,
      mouseselectshow: false,
      mouseselectvalue: '',
      mouseoptions: [],
      mixshow: false,
      mediaselectvalue: '',
      funcoptions: [],
      funcselectvalue: '',
      mediaoptions: [],
      text1: '',
      text2: '',
      mixcount: 0,
      mousescroolshow: false,
      mousescrool: 0,
      mouseinputtxt: '',
      mouseshow: false,
      mousechecktxt: '',
      mousepresschecktxt: '',
      stringchecktxt: '',
      mouseinputshow: false,
      mousecheckshow: false,
      mousepresscheckshow: false,
      mousecheck: false,
      mousepresscheck: false,
      mousedouble: false,
      mousedoubleshow: false,
      mousedoubletxt: '',
      stringcheck: false,
      mouseinput: 10,
      mixfuncoptions: [],
      mixfuncselectvalue: ['', '', '', '', ''],
      mixtext: ['', '', '', '', ''],
      mixtips: '',
      mixcountarray: [false, false, false, false, false],
      mixshowarray: [false, false, false, false, false],
      mouses: this.$t('keyConfig.mouses'),
      functionkeys: this.$t('keyConfig.functionkeys'),
      functionkeyvalues: [0x80, 0x81, 0x82, 0x83, 0x84, 0x85, 0x86, 0x87, 0xDA, 0xD9, 0xD8, 0xD7, 0xB2, 0xB3, 0xB0, 0xB1, 0xD1, 0xD4, 0xD3, 0xD6, 0xD2, 0xD5, 0xC1, 0xCE, 0xCF, 0xD0, 0xDB, 0xC2, 0xC3, 0xC4, 0xC5, 0xC6, 0xC7, 0xC8, 0xC9, 0xCA, 0xCB, 0xCC, 0xCD, 0xF0, 0xF1, 0xF2, 0xF3, 0xF4, 0xF5, 0xF6, 0xF7, 0xF8, 0xF9, 0xFA, 0xFB, 0xED, 0xDC, 0xDD, 0xDE, 0xDF, 0xE0, 0xE1, 0xE2, 0xE3, 0xE4, 0xE5, 0xE6, 0xE7, 0xE8, 0xE9, 0xEA, 0xEB],
      mediakeys: this.$t('keyConfig.mediakeys'),
      mediakeyvalues: [0xB5, 0xB6, 0xB7, 0xCD, 0xB0, 0xE2, 0xE9, 0xEA, 0x6F, 0x70, 0x183, 0x18A, 0x192, 0x194, 0x223, 0x224, 0x225, 0x227, 0x22A, 0x30, 0x32, 0xB2, 0xB3, 0xB4, 0x19e],
      tableData: [],
      commonshow: false,
      quickPanelOpen: false,
      quickSearch: '',
      quickCategory: 'all',
      quickList: [],
      quickActiveId: null
    };
  },

  computed: {
    isText1Valid: function isText1Valid() {
      if (!this.text1 || this.text1.length !== 1) return false;
      if (this.hidNormalKey) return this.textToHidKey(this.text1) !== null;
      var code = this.text1.charCodeAt(0);
      return code >= 0x20 && code <= 0x7E;
    },
    quickCategories: function quickCategories() {
      var t = this.$t('keyConfig');
      var it = this.$i18n.messages[this.$i18n.locale].index;
      return [{ value: 'all', label: t.quickCategoryAll }, { value: 'edit', label: t.quickCategoryEdit }, { value: 'system', label: t.quickCategorySystem }, { value: 'browser', label: t.quickCategoryBrowser }, { value: 'office', label: t.quickCategoryOffice }, { value: 'word', label: it.scGroupOfficeWord }, { value: 'excel', label: it.scGroupOfficeExcel }, { value: 'ide', label: t.quickCategoryIDE }, { value: 'ai-chat', label: it.scGroupAIChat }, { value: 'ai-code', label: it.scGroupAICode }, { value: 'zoom', label: t.quickCategoryZoom }, { value: 'media', label: t.quickCategoryMedia }];
    },
    filteredQuickList: function filteredQuickList() {
      var _this = this;

      var kw = (this.quickSearch || '').trim().toLowerCase();
      return this.quickList.filter(function (it) {
        var catOk = _this.quickCategory === 'all' || it.category === _this.quickCategory;
        if (!catOk) return false;
        if (!kw) return true;
        return (it.name || '').toLowerCase().indexOf(kw) >= 0 || (it.hotkey || '').toLowerCase().indexOf(kw) >= 0 || (it.searchText || '').toLowerCase().indexOf(kw) >= 0;
      });
    }
  },
  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.refreshText();this.buildQuickList();
    }
  },
  mounted: function mounted() {
    this.keyname = this.labelstr + ':';
    this.buildQuickList();
    if (this.normalOnly) {
      this.keyradio = 1;
      this.fucChange();
    }
  },

  methods: {
    buildQuickList: function buildQuickList() {
      var LCTRL = 0x80;
      var LSHIFT = 0x81;
      var LALT = 0x82;
      var LWIN = 0x83;
      var RCTRL = 0x84;
      var RSHIFT = 0x85;
      var RALT = 0x86;
      var RWIN = 0x87;
      var ENTER = 0xB0;
      var INSERT = 0xD1;
      var DEL = 0xD4;
      var HOME = 0xD2;
      var END = 0xD5;
      var ESC = 0xB1;
      var TAB = 0xB3;
      var CAPS = 0xC1;
      var F1 = 0xC2;
      var F2 = 0xC3;
      var F3 = 0xC4;
      var F4 = 0xC5;
      var F5 = 0xC6;
      var F6 = 0xC7;
      var F7 = 0xC8;
      var F8 = 0xC9;
      var F9 = 0xCA;
      var F10 = 0xCB;
      var F11 = 0xCC;
      var F12 = 0xCD;
      var PRINTSCREEN = 0xCE;
      var PAGEUP = 0xD3;
      var PAGEDOWN = 0xD6;
      var UARROW = 0xDA;
      var DARROW = 0xD9;
      var LARROW = 0xD8;
      var RARROW = 0xD7;
      var BS = 0xB2;
      var c_a = 0x61,
          c_b = 0x62,
          c_c = 0x63,
          c_d = 0x64,
          c_e = 0x65,
          c_f = 0x66,
          c_g = 0x67;
      var c_h = 0x68,
          c_i = 0x69,
          c_j = 0x6A,
          c_k = 0x6B,
          c_l = 0x6C,
          c_m = 0x6D,
          c_n = 0x6E;
      var c_o = 0x6F,
          c_p = 0x70,
          c_q = 0x71,
          c_r = 0x72,
          c_s = 0x73,
          c_t = 0x74,
          c_u = 0x75;
      var c_v = 0x76,
          c_w = 0x77,
          c_x = 0x78,
          c_y = 0x79,
          c_z = 0x7A;
      var c_0 = 0x30,
          c_1 = 0x31,
          c_2 = 0x32,
          c_3 = 0x33,
          c_4 = 0x34,
          c_5 = 0x35,
          c_6 = 0x36,
          c_7 = 0x37,
          c_8 = 0x38,
          c_9 = 0x39;
      var c_eq = 0x3D,
          c_sub = 0x2D,
          c_space = 0x20,
          c_dot = 0x2E,
          c_slash = 0x2F;
      var c_semi = 0x3B,
          c_tick = 0x60;
      var t = this.$i18n.messages[this.$i18n.locale].index;
      var mk = function mk(id, cat, name, hotkey, mixArr) {
        var extraSearch = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

        var mix = [0xFF, 0xFF, 0xFF, 0xFF, 0xFF];
        var keyCount = 0;
        for (var i = 0; i < Math.min(mixArr.length, 5); i++) {
          mix[i] = mixArr[i];keyCount++;
        }
        return { id: id, category: cat, name: name, hotkey: hotkey, mix: mix, keyCount: keyCount, searchText: extraSearch };
      };
      var list = [];
      var idSeq = 0;
      // ===== 高频编辑 10 条（复制/粘贴/剪切... 优先展示） =====
      list.push(mk(idSeq++, 'edit', t.scCopy, 'Ctrl + C', [LCTRL, c_c], 'copy 复制'));
      list.push(mk(idSeq++, 'edit', t.scPaste, 'Ctrl + V', [LCTRL, c_v], 'paste 粘贴'));
      list.push(mk(idSeq++, 'edit', t.scCut, 'Ctrl + X', [LCTRL, c_x], 'cut 剪切'));
      list.push(mk(idSeq++, 'edit', t.scUndo, 'Ctrl + Z', [LCTRL, c_z], 'undo 撤销'));
      list.push(mk(idSeq++, 'edit', t.scRedo, 'Ctrl + Y', [LCTRL, c_y], 'redo 重做 恢复'));
      list.push(mk(idSeq++, 'edit', t.scSelectAll, 'Ctrl + A', [LCTRL, c_a], 'select all 全选'));
      list.push(mk(idSeq++, 'edit', t.scSave, 'Ctrl + S', [LCTRL, c_s], 'save 保存'));
      list.push(mk(idSeq++, 'edit', t.scFind, 'Ctrl + F', [LCTRL, c_f], 'find 查找'));
      list.push(mk(idSeq++, 'edit', t.scReplace, 'Ctrl + H', [LCTRL, c_h], 'replace 替换'));
      list.push(mk(idSeq++, 'edit', t.scPrint, 'Ctrl + P', [LCTRL, c_p], 'print 打印'));
      // ===== 视图缩放 3 条 =====
      list.push(mk(idSeq++, 'zoom', t.scZoomIn, 'Ctrl + +', [LCTRL, c_eq], 'zoom in 放大 enlarge bigger font 字体'));
      list.push(mk(idSeq++, 'zoom', t.scZoomOut, 'Ctrl + -', [LCTRL, c_sub], 'zoom out 缩小 reduce smaller'));
      list.push(mk(idSeq++, 'zoom', t.scZoomReset, 'Ctrl + 0', [LCTRL, c_0], 'zoom reset 重置缩放 reset 100% 恢复'));
      // ===== 粘贴为数值 / 格式 / 填充等办公常用 =====
      list.push(mk(idSeq++, 'office', t.scPasteValue, 'Ctrl + Shift + V', [LCTRL, LSHIFT, c_v], 'paste value 粘贴成数值 special paste 选择性粘贴 excel wps office'));
      list.push(mk(idSeq++, 'office', t.scPasteFormat, 'Ctrl + Shift + C', [LCTRL, LSHIFT, c_c], 'paste format 粘贴格式 format painter 格式刷 复制格式'));
      list.push(mk(idSeq++, 'office', t.scPasteLink, 'Ctrl + Alt + V', [LCTRL, LALT, c_v], 'paste link 粘贴为链接 hyperlink 超链接'));
      list.push(mk(idSeq++, 'office', t.scFillDown, 'Ctrl + D', [LCTRL, c_d], 'fill down 向下填充 duplicate 复制上一行'));
      list.push(mk(idSeq++, 'office', t.scQuickSave, 'Ctrl + Shift + S', [LCTRL, LSHIFT, c_s], 'save as 另存为 export 导出'));
      list.push(mk(idSeq++, 'office', t.scFormulaBar, 'Ctrl + `', [LCTRL, c_tick], 'formula bar 编辑栏 显示隐藏 excel wps'));
      list.push(mk(idSeq++, 'office', t.scPivotTable, 'Alt + N', [LALT, c_n], 'pivot table 创建数据透视表 pivot excel alt n'));
      // ===== 系统窗口 12 条（快捷键参考 scGroupWin 全量） =====
      list.push(mk(idSeq++, 'system', t.scSwitchWin, 'Alt + Tab', [LALT, TAB], 'switch window 切换窗口 app'));
      list.push(mk(idSeq++, 'system', t.scCycleApps, 'Alt + Esc', [LALT, ESC], 'cycle apps 循环切换应用程序 alt escape'));
      list.push(mk(idSeq++, 'system', t.scDesktop, 'Win + D', [LWIN, c_d], 'desktop 显示桌面 最小化所有窗口'));
      list.push(mk(idSeq++, 'system', t.scExplorer, 'Win + E', [LWIN, c_e], 'explorer 打开文件管理器 我的电脑'));
      list.push(mk(idSeq++, 'system', t.scSearch, 'Win + S', [LWIN, c_s], 'search 搜索 cortana'));
      list.push(mk(idSeq++, 'system', t.scLock, 'Win + L', [LWIN, c_l], 'lock 锁定电脑 screen'));
      list.push(mk(idSeq++, 'system', t.scSettings, 'Win + I', [LWIN, c_i], 'settings 打开设置 panel'));
      list.push(mk(idSeq++, 'system', t.scRun, 'Win + R', [LWIN, c_r], 'run 运行 命令行 cmd 执行程序'));
      list.push(mk(idSeq++, 'system', t.scNewWin, 'Ctrl + N', [LCTRL, c_n], 'new window 新建窗口 新窗口'));
      list.push(mk(idSeq++, 'system', t.scCloseWin, 'Alt + F4', [LALT, F4], 'close window 关闭窗口 exit 退出'));
      list.push(mk(idSeq++, 'system', t.scFullscreen, 'F11', [F11], 'fullscreen 全屏 退出全屏'));
      list.push(mk(idSeq++, 'system', t.scScreenshot, 'PrtSc', [PRINTSCREEN], 'screenshot full 截图 全屏 printscreen'));
      list.push(mk(idSeq++, 'system', t.scSnipping, 'Win + Shift + S', [LWIN, LSHIFT, c_s], 'screenshot region 截图 区域 截取 snip & sketch'));
      list.push(mk(idSeq++, 'system', t.scTaskManager, 'Ctrl + Shift + Esc', [LCTRL, LSHIFT, ESC], 'task manager 任务管理器 kill task 杀进程'));
      // ===== 文本富文本（scGroupText 全量） =====
      list.push(mk(idSeq++, 'edit', t.scBold, 'Ctrl + B', [LCTRL, c_b], 'bold 加粗 font'));
      list.push(mk(idSeq++, 'edit', t.scItalic, 'Ctrl + I', [LCTRL, c_i], 'italic 斜体'));
      list.push(mk(idSeq++, 'edit', t.scUnderline, 'Ctrl + U', [LCTRL, c_u], 'underline 下划线'));
      list.push(mk(idSeq++, 'edit', t.scSelectWord, 'Ctrl + Shift + →', [LCTRL, LSHIFT, RARROW], 'select word 选中单词 扩选 right arrow 扩展选择'));
      list.push(mk(idSeq++, 'edit', t.scHome, 'Ctrl + Home', [LCTRL, HOME], 'jump to home 文档开头 文件开始'));
      list.push(mk(idSeq++, 'edit', t.scEnd, 'Ctrl + End', [LCTRL, END], 'jump to end 文档结尾 文件结束'));
      list.push(mk(idSeq++, 'edit', t.scDelete, 'Delete', [DEL], 'delete 删除 后删'));
      // ===== 浏览器（scGroupBrowser 全量） =====
      list.push(mk(idSeq++, 'browser', t.scNewTab, 'Ctrl + T', [LCTRL, c_t], 'new tab 新建标签页 tab'));
      list.push(mk(idSeq++, 'browser', t.scCloseTab, 'Ctrl + W', [LCTRL, c_w], 'close tab 关闭标签页 close window'));
      list.push(mk(idSeq++, 'browser', t.scSwitchTab, 'Ctrl + Tab', [LCTRL, TAB], 'switch tab 切换标签页 下一个 tab'));
      list.push(mk(idSeq++, 'browser', t.scReopenTab, 'Ctrl + Shift + T', [LCTRL, LSHIFT, c_t], 'reopen tab 恢复关闭标签页 undo close tab'));
      list.push(mk(idSeq++, 'browser', t.scBookmark, 'Ctrl + D', [LCTRL, c_d], 'bookmark 添加书签 收藏 favorite'));
      list.push(mk(idSeq++, 'browser', t.scRefresh, 'F5', [F5], 'refresh 刷新 reload 重新加载'));
      list.push(mk(idSeq++, 'browser', t.scHardRefresh, 'Ctrl + F5', [LCTRL, F5], 'hard refresh 强制刷新 清除缓存 clear cache'));
      list.push(mk(idSeq++, 'browser', t.scGoBack, 'Alt + ←', [LALT, LARROW], 'back 后退 返回上一页 history back'));
      list.push(mk(idSeq++, 'browser', t.scGoForward, 'Alt + →', [LALT, RARROW], 'forward 前进 下一页 history forward'));
      list.push(mk(idSeq++, 'browser', t.scDevTools, 'F12', [F12], 'developer tools 开发者工具 inspector console debug'));
      list.push(mk(idSeq++, 'browser', t.scDevTools2, 'Ctrl + Shift + I', [LCTRL, LSHIFT, c_i], 'devtools 开发者工具 备选 chrome edge inspector element'));
      // ===== IDE / 编辑器（scGroupIDE 全量 + scGroupDev 补充） =====
      list.push(mk(idSeq++, 'ide', t.scDeleteLine, 'Ctrl + Shift + K', [LCTRL, LSHIFT, c_k], 'delete line 删除行 remove line'));
      list.push(mk(idSeq++, 'ide', t.scSelectNext, 'Ctrl + D', [LCTRL, c_d], 'select next 选中下一个相同 多选相同 word'));
      list.push(mk(idSeq++, 'ide', t.scSelectAll, 'Ctrl + Shift + L', [LCTRL, LSHIFT, c_l], 'select all occurrences 选中所有相同 全部相同词 cursor vscode'));
      list.push(mk(idSeq++, 'ide', t.scMoveLine, 'Alt + ↑ / ↓', [LALT, UARROW], 'move line 移动行上下 alt up down 整行移动'));
      list.push(mk(idSeq++, 'ide', t.scComment, 'Ctrl + /', [LCTRL, c_slash], 'comment toggle 注释 取消注释 line comment block'));
      list.push(mk(idSeq++, 'ide', t.scRename, 'F2', [F2], 'rename symbol 重命名 重命名变量 refactor'));
      list.push(mk(idSeq++, 'ide', t.scGlobalSearch, 'Ctrl + Shift + F', [LCTRL, LSHIFT, c_f], 'global search 全局搜索 find in files project'));
      list.push(mk(idSeq++, 'ide', t.scExplorer, 'Ctrl + Shift + E', [LCTRL, LSHIFT, c_e], 'file explorer 文件资源管理器 左侧 文件树'));
      list.push(mk(idSeq++, 'ide', t.scGoToLine, 'Ctrl + G', [LCTRL, c_g], 'go to line 跳转到行 number line'));
      list.push(mk(idSeq++, 'ide', t.scGoToSymbol, 'Ctrl + Shift + O', [LCTRL, LSHIFT, c_o], 'go to symbol 跳转到符号 function variable outline'));
      list.push(mk(idSeq++, 'ide', t.scFormat, 'Shift + Alt + F', [LSHIFT, LALT, c_f], 'format code 格式化代码 format document prettier indent'));
      list.push(mk(idSeq++, 'ide', t.scCommandPalette, 'Ctrl + Shift + P', [LCTRL, LSHIFT, c_p], 'command palette 命令面板 vs code all commands'));
      list.push(mk(idSeq++, 'ide', t.scSuggest, 'Ctrl + Space', [LCTRL, c_space], 'suggest trigger 触发建议 代码补全 intellisense autocomplete'));
      list.push(mk(idSeq++, 'ide', t.scQuickFix, 'Ctrl + .', [LCTRL, c_dot], 'quick fix 快速修复 灯泡修复 bulb code action'));
      list.push(mk(idSeq++, 'ide', t.scToggleSidebar, 'Ctrl + B', [LCTRL, c_b], 'toggle sidebar 切换侧边栏 activity bar 显示隐藏 左栏'));
      list.push(mk(idSeq++, 'ide', t.scDebug, 'F5', [F5], 'start debugging 开始调试 debug run 运行'));
      list.push(mk(idSeq++, 'ide', t.scTerminal, 'Ctrl + `', [LCTRL, c_tick], 'terminal 终端 命令行 terminal panel shell'));
      // ===== AI 对话聊天（scGroupAIChat 全量） =====
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatSubmit, 'Ctrl + Enter', [LCTRL, ENTER], 'submit prompt 提交 发送 AI 生成 send message'));
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatNewline, 'Shift + Enter', [LSHIFT, ENTER], 'new line 换行 不发送 多行输入 enter 不发送'));
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatClear, 'Ctrl + L', [LCTRL, c_l], 'clear chat 清空对话 context 上下文 清空 chatgpt cursor'));
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatUndo, 'Ctrl + Shift + Z', [LCTRL, LSHIFT, c_z], 'undo ai 撤销上一轮 ai 生成 code 回滚'));
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatRetry, 'Ctrl + Shift + U', [LCTRL, LSHIFT, c_u], 'retry regenerate 重新生成 重试 ai 再次生成'));
      list.push(mk(idSeq++, 'ai-chat', t.scAIChatStop, 'Esc', [ESC], 'stop ai 停止生成 中断 AI 生成 cancel abort'));
      // ===== 选中代码后 AI 操作（scGroupAICode 全量） =====
      list.push(mk(idSeq++, 'ai-code', t.scAICodeSidebar, 'Ctrl + K', [LCTRL, c_k], 'ai sidebar 唤起 AI 侧边栏 解释修改选中代码 cursor chat'));
      list.push(mk(idSeq++, 'ai-code', t.scAICodeInline, 'Ctrl + I', [LCTRL, c_i], 'inline ai 行内 AI 编辑 补全 重构 cursor edit code inline'));
      list.push(mk(idSeq++, 'ai-code', t.scAICodeSelectBlock, 'Ctrl + Shift + L', [LCTRL, LSHIFT, c_l], 'select block 选中整段函数 代码块 select function cursor'));
      list.push(mk(idSeq++, 'ai-code', t.scAICodeAccept, 'Tab', [TAB], 'accept ai 接受 AI 补全 tab 采用 suggestion 单行'));
      list.push(mk(idSeq++, 'ai-code', t.scAICodeReject, 'Shift + Tab', [LSHIFT, TAB], 'reject ai 拒绝补全 回退 shift tab 取消 completion'));
      list.push(mk(idSeq++, 'ai-code', t.scAICodeRefactor, 'Ctrl + Shift + R', [LCTRL, LSHIFT, c_r], 'refactor ai 重构选中代码 优化逻辑 修复 bug refactor'));
      // ===== Office 通用（scGroupOfficeCommon 全量 + 缩放相关） =====
      var tw = this.$i18n.messages[this.$i18n.locale].index;
      list.push(mk(idSeq++, 'office', tw.scOfficeNewFile, 'Ctrl + N', [LCTRL, c_n], 'office new 新建文件 wps word excel ppt'));
      list.push(mk(idSeq++, 'office', tw.scOfficeOpenFile, 'Ctrl + O', [LCTRL, c_o], 'office open 打开文件 open document browse'));
      list.push(mk(idSeq++, 'office', tw.scOfficeSave, 'Ctrl + S', [LCTRL, c_s], 'office save 保存 wps 保存文档'));
      list.push(mk(idSeq++, 'office', tw.scOfficeSaveAs, 'Ctrl + Shift + S', [LCTRL, LSHIFT, c_s], 'office save as 另存为 save a copy 导出'));
      list.push(mk(idSeq++, 'office', tw.scOfficePrint, 'Ctrl + P', [LCTRL, c_p], 'office print 打印'));
      list.push(mk(idSeq++, 'office', tw.scOfficeCloseFile, 'Ctrl + W', [LCTRL, c_w], 'office close 关闭当前文件 close document tab'));
      list.push(mk(idSeq++, 'office', tw.scOfficeUndo, 'Ctrl + Z', [LCTRL, c_z], 'office undo 撤销'));
      list.push(mk(idSeq++, 'office', tw.scOfficeRedo, 'Ctrl + Y', [LCTRL, c_y], 'office redo 重做 恢复'));
      list.push(mk(idSeq++, 'office', tw.scOfficeFind, 'Ctrl + F', [LCTRL, c_f], 'office find 查找'));
      list.push(mk(idSeq++, 'office', tw.scOfficeReplace, 'Ctrl + H', [LCTRL, c_h], 'office replace 替换 find & replace'));
      list.push(mk(idSeq++, 'office', tw.scOfficeFullScreen, 'F11 / Ctrl + F1', [F11], 'office full screen 全屏显示 reading 阅读模式 alt w u'));
      list.push(mk(idSeq++, 'office', tw.scOfficeZoomPlus, 'Ctrl + 1', [LCTRL, c_eq], 'office zoom in 放大视图 文档放大 bigger'));
      list.push(mk(idSeq++, 'office', tw.scOfficeZoomMinus, 'Ctrl + 2', [LCTRL, c_sub], 'office zoom out 缩小视图 smaller reduce'));
      list.push(mk(idSeq++, 'office', tw.scOfficeZoom100, 'Ctrl + Alt + 0', [LCTRL, RALT, c_0], 'office zoom 100% 缩放到100% 实际大小 actual size'));
      // ===== Word / WPS 文字（scGroupOfficeWord 全量） =====
      list.push(mk(idSeq++, 'word', tw.scWordNewDoc, 'Ctrl + N', [LCTRL, c_n], 'word 新建文档 new document wps'));
      list.push(mk(idSeq++, 'word', tw.scWordOpenDoc, 'Ctrl + O', [LCTRL, c_o], 'word 打开文档 open file docx doc'));
      list.push(mk(idSeq++, 'word', tw.scWordSaveAs, 'F12', [F12], 'word 另存为 save as f12 export'));
      list.push(mk(idSeq++, 'word', tw.scWordFindNext, 'Shift + F4', [LSHIFT, F4], 'word 查找下一处 find next repeat last search'));
      list.push(mk(idSeq++, 'word', tw.scWordGoToPage, 'Ctrl + G', [LCTRL, c_g], 'word 定位 页码 goto page section bookmark'));
      list.push(mk(idSeq++, 'word', tw.scWordInsertLink, 'Ctrl + K', [LCTRL, c_k], 'word 插入超链接 hyperlink 链接 url'));
      list.push(mk(idSeq++, 'word', tw.scWordInsertPageBreak, 'Ctrl + Enter', [LCTRL, ENTER], 'word 插入分页符 page break 分页'));
      list.push(mk(idSeq++, 'word', tw.scWordSelectPara, 'Ctrl + E', [LCTRL, c_e], 'word 选中整个段落 select paragraph 段落 selection'));
      list.push(mk(idSeq++, 'word', tw.scWordCenterAlign, 'Ctrl + E', [LCTRL, c_e], 'word 居中 center align paragraph 居中对齐'));
      list.push(mk(idSeq++, 'word', tw.scWordLeftAlign, 'Ctrl + L', [LCTRL, c_l], 'word 左对齐 left align 左对齐段落'));
      list.push(mk(idSeq++, 'word', tw.scWordRightAlign, 'Ctrl + R', [LCTRL, c_r], 'word 右对齐 right align 右对齐段落'));
      list.push(mk(idSeq++, 'word', tw.scWordJustifyAlign, 'Ctrl + J', [LCTRL, c_j], 'word 两端对齐 justify 两端 分散对齐'));
      list.push(mk(idSeq++, 'word', tw.scWord1_5Line, 'Ctrl + 5', [LCTRL, c_5], 'word 1.5倍行距 line spacing 1.5 lines 行间距'));
      list.push(mk(idSeq++, 'word', tw.scWordBold, 'Ctrl + B', [LCTRL, c_b], 'word 加粗 bold'));
      list.push(mk(idSeq++, 'word', tw.scWordUnderline, 'Ctrl + U', [LCTRL, c_u], 'word 下划线 underline'));
      list.push(mk(idSeq++, 'word', tw.scWordItalic, 'Ctrl + I', [LCTRL, c_i], 'word 斜体 italic'));
      // ===== Excel / WPS 表格（scGroupOfficeExcel 全量） =====
      list.push(mk(idSeq++, 'excel', tw.scExcelSumAuto, 'Alt + =', [LALT, c_eq], 'excel 自动求和 auto sum alt equal sigma 总计'));
      list.push(mk(idSeq++, 'excel', tw.scExcelFillRight, 'Ctrl + R', [LCTRL, c_r], 'excel 向右填充 fill right 左格右填'));
      list.push(mk(idSeq++, 'excel', tw.scExcelFillDown, 'Ctrl + D', [LCTRL, c_d], 'excel 向下填充 fill down 上方下填'));
      list.push(mk(idSeq++, 'excel', tw.scExcelPasteValue, 'Ctrl + Shift + V', [LCTRL, LSHIFT, c_v], 'excel 粘贴成数值 paste value 仅值 不带格式'));
      list.push(mk(idSeq++, 'excel', tw.scExcelPasteFormat, 'Ctrl + Shift + C', [LCTRL, LSHIFT, c_c], 'excel 粘贴格式 format painter 复制格式 格式刷'));
      list.push(mk(idSeq++, 'excel', tw.scExcelInsertRow, 'Ctrl + Shift + +', [LCTRL, LSHIFT, c_eq], 'excel 插入行 insert row column 插行 插列'));
      list.push(mk(idSeq++, 'excel', tw.scExcelDeleteRow, 'Ctrl + -', [LCTRL, c_sub], 'excel 删除行 delete row column 删行 删列'));
      list.push(mk(idSeq++, 'excel', tw.scExcelToggleFilter, 'Ctrl + Shift + L', [LCTRL, LSHIFT, c_l], 'excel 开启筛选 filter 开关 自动筛选'));
      list.push(mk(idSeq++, 'excel', tw.scExcelGoToCell, 'F5', [F5], 'excel goto 定位 单元格 goto special 定位条件'));
      list.push(mk(idSeq++, 'excel', tw.scExcelNameBox, 'Ctrl + F3', [LCTRL, F3], 'excel 跳转到名称框 name manager 名称管理器 define name'));
      list.push(mk(idSeq++, 'excel', tw.scExcelSelectAllRegion, 'Ctrl + A / Ctrl + *', [LCTRL, c_a], 'excel 选中当前数据区域 select all data range 数据区域 全选'));
      list.push(mk(idSeq++, 'excel', tw.scExcelTodayDate, 'Ctrl + ;', [LCTRL, c_semi], 'excel 插入当前日期 date today 今天 分号'));
      list.push(mk(idSeq++, 'excel', tw.scExcelNowTime, 'Ctrl + Shift + :', [LCTRL, LSHIFT, c_semi], 'excel 插入当前时间 time now 冒号 现在'));
      list.push(mk(idSeq++, 'excel', tw.scExcelEditCell, 'F2', [F2], 'excel 编辑单元格 edit cell 进入编辑 单元格编辑'));
      list.push(mk(idSeq++, 'excel', tw.scExcelSwitchSheet, 'Ctrl + PageDown', [LCTRL, PAGEDOWN], 'excel 切换工作表 switch sheet 下一个 sheet tab 切表'));
      list.push(mk(idSeq++, 'excel', tw.scExcelFreezePane, 'Alt + W', [LALT, c_w], 'excel 冻结窗格 freeze pane 冻结首行 alt w f f'));
      this.quickList = list;
    },
    applyQuickSetting: function applyQuickSetting(item) {
      if (!item || !item.mix || !item.mix.length) return;
      this.quickActiveId = item.id;
      if (item.keyCount === 1) {
        // 单键项（F1、Delete、Esc 等）设为功能键模式
        this.setKey(item.mix[0], 0, 0xFF, '', []);
      } else {
        // 多键项设为组合键模式
        this.setKey(0xFF, 2, 0xFF, '', item.mix);
      }
    },
    setCommon: function setCommon(commonkeys) {
      this.tableData.splice(0, this.tableData.length);
      for (var i = 0; i < commonkeys.length; i++) {
        var item = {};
        var keys = '';
        for (var j = 0; j < commonkeys[i].mixkeys.length; j++) {
          var keylabel = false;
          for (var k = 0; k < this.functionkeyvalues.length; k++) {
            if (this.functionkeyvalues[k] == commonkeys[i].mixkeys[j]) {
              if (j != 0) {
                keys += '+ ';
              }
              keys += this.functionkeys[k] + ' ';
              keylabel = true;
            }
          }
          if (!keylabel) {
            if (j != 0) {
              keys += '+ ';
            }
            keys += String.fromCharCode(commonkeys[i].mixkeys[j]) + ' ';
          }
        }
        item.keys = keys;
        item.description = commonkeys[i].description;
        item.mixkeys = commonkeys[i].mixkeys;
        this.tableData.push(item);
      }
      if (commonkeys.length) {
        this.commonshow = true;
      }
    },
    handleCommonClick: function handleCommonClick(row) {
      this.mixcount = row.mixkeys.length;
      this.mixcountchange();
      for (var i = 0; i < row.mixkeys.length; i++) {
        var keylabel = false;
        for (var k = 0; k < this.functionkeyvalues.length; k++) {
          if (this.functionkeyvalues[k] == row.mixkeys[i]) {
            this.mixfuncselectvalue[i] = row.mixkeys[i];
            keylabel = true;
            this.mixshowarray[i] = true;
          }
        }
        if (!keylabel) {
          this.mixtext[i] = String.fromCharCode(row.mixkeys[i]);
          this.mixshowarray[i] = false;
        }
      }
      this.$refs.popover.doClose();
    },
    keyReset: function keyReset() {
      this.mousedouble = false;
      this.keyradio = 0;
      this.funcselectshow = false;
      this.mediaselectshow = false;
      this.input1show = false;
      this.input2show = false;
      this.scrollshow = false;
      this.scrollvalue = 0;
      this.mixshow = false;
      this.mouseselectshow = false, this.mouseselectvalue = '', this.mouseoptions = [], this.mediaselectvalue = '';
      this.funcoptions = [];
      this.funcselectvalue = '';
      this.mediaoptions = [];
      this.text1 = '';
      this.text2 = '';
      this.mousescroolshow = false, this.mousescrool = 0, this.mouseinputtxt = '', this.mouseshow = false, this.mousechecktxt = '', this.mousepresschecktxt = '', this.mouseinputshow = false, this.mousecheckshow = false, this.mousepresscheckshow = false, this.mousecheck = false, this.mousepresscheck = false, this.stringcheck = false, this.mouseinput = 10, this.mixcount = 0;
      this.mixfuncoptions = [];
      this.mixfuncselectvalue = ['', '', '', '', ''];
      this.mixtext = ['', '', '', '', ''];
      this.mixtips = '';
      this.mixcountarray = [false, false, false, false, false];
      this.mixshowarray = [false, false, false, false, false];
    },

    // D6 stores normal keys as USB HID usages. Keep other models' ASCII protocol unchanged.
    hidKeyToText: function hidKeyToText(key) {
      if (key >= 0x04 && key <= 0x1d) return String.fromCharCode(97 + key - 0x04);
      if (key >= 0x1e && key <= 0x26) return String.fromCharCode(49 + key - 0x1e);
      if (key === 0x27) return '0';
      var chars = { 0x2c: ' ', 0x2d: '-', 0x2e: '=', 0x2f: '[', 0x30: ']',
        0x31: '\\', 0x33: ';', 0x34: "'", 0x35: '`', 0x36: ',', 0x37: '.', 0x38: '/' };
      return Object.prototype.hasOwnProperty.call(chars, key) ? chars[key] : '';
    },
    textToHidKey: function textToHidKey(text) {
      var code = text.charCodeAt(0);
      if (code >= 97 && code <= 122) return code - 97 + 0x04;
      if (code >= 49 && code <= 57) return code - 49 + 0x1e;
      if (code === 48) return 0x27;
      var chars = { ' ': 0x2c, '-': 0x2d, '=': 0x2e, '[': 0x2f, ']': 0x30,
        '\\': 0x31, ';': 0x33, "'": 0x34, '`': 0x35, ',': 0x36, '.': 0x37, '/': 0x38 };
      return Object.prototype.hasOwnProperty.call(chars, text) ? chars[text] : null;
    },
    setKey: function setKey(key, keyfunc, keyf, customstr, keymix) {
      if (this.normalOnly) {
        this.keyradio = 1;
        this.fucChange();
        this.text1 = this.hidNormalKey ? this.hidKeyToText(key) : String.fromCharCode(key);
        return;
      }
      switch (keyfunc) {
        case 1:
          //media
          this.keyradio = 3;
          this.fucChange();
          if (keyf == 0xff) {
            this.mediaselectvalue = key;
          } else {
            var tmp = Number(keyf << 8) + Number(key);
            this.mediaselectvalue = tmp;
          }
          break;
        case 2:
          //mix
          this.mixcount = 0;
          this.keyradio = 4;
          this.fucChange();
          for (var i = 0; i < keymix.length; i++) {
            if (keymix[i] != 0xff) {
              this.mixcount++;
              var tmplabel = true;
              for (var j = 0; j < this.functionkeyvalues.length; j++) {
                if (this.functionkeyvalues[j] == keymix[i]) {
                  this.mixfuncselectvalue[i] = keymix[i];
                  this.mixshowarray[i] = true;
                  tmplabel = false;
                  break;
                }
              }
              if (tmplabel) {
                this.mixshowarray[i] = false;
                this.mixtext[i] = String.fromCharCode(keymix[i]);
              }
            }
          }
          this.mixcountchange();
          break;
        case 3:
          //string
          this.keyradio = 5;
          this.fucChange();
          this.text2 = customstr;
          if (keyf == 0x00) {
            this.stringcheck = false;
          } else if (keyf == 0x01) {
            this.stringcheck = true;
          }
          break;
        case 4:
          //mouse click
          this.keyradio = 6;
          if (keyf == 0x00) {
            this.mousecheck = false;
          } else if (keyf == 0x01) {
            this.mousecheck = true;
          } else if (keyf == 0x02) {
            this.mousepresscheck = true;
          } else if (keyf == 0x03) {
            this.mousedouble = true;
          }
          if (key == 0x01) {
            this.mouseselectvalue = 1;
          } else if (key == 0x02) {
            this.mouseselectvalue = 3;
          } else if (key == 0x04) {
            this.mouseselectvalue = 2;
          }
          this.fucChange();
          break;
        case 5:
          //mouse move random
          this.keyradio = 6;
          this.mouseselectvalue = 4;
          this.fucChange();
          break;
        case 6:
          //mouse move
          this.keyradio = 6;
          if (keyf == 0x01) {
            //up
            this.mouseselectvalue = 5;
          } else if (keyf == 0x02) {
            //down
            this.mouseselectvalue = 6;
          } else if (keyf == 0x03) {
            //left
            this.mouseselectvalue = 7;
          } else if (keyf == 0x04) {
            //right
            this.mouseselectvalue = 8;
          }
          this.mouseinput = key - 31;
          this.mousecheck = false;
          this.fucChange();
          break;
        case 7:
          //mouse move hold
          this.keyradio = 6;
          if (keyf == 0x01) {
            //up
            this.mouseselectvalue = 5;
          } else if (keyf == 0x02) {
            //down
            this.mouseselectvalue = 6;
          } else if (keyf == 0x03) {
            //left
            this.mouseselectvalue = 7;
          } else if (keyf == 0x04) {
            //right
            this.mouseselectvalue = 8;
          }
          this.mouseinput = key - 31;
          this.mousecheck = true;
          this.fucChange();
          break;
        case 8:
          //mouse scrool
          this.keyradio = 6;
          if (keyf == 0x01) {
            //up
            this.mouseselectvalue = 9;
          } else if (keyf == 0x02) {
            //down
            this.mouseselectvalue = 10;
          }
          if (key == 1) {
            this.mousescrool = 1;
          } else if (key == 5) {
            this.mousescrool = 2;
          } else if (key == 20) {
            this.mousescrool = 3;
          } else if (key == 60) {
            this.mousescrool = 4;
          } else if (key == 100) {
            this.mousescrool = 5;
          }
          this.fucChange();
          break;
        case 9:
          //mouse scrool hold
          this.keyradio = 6;
          if (keyf == 0x01) {
            //up
            this.mouseselectvalue = 9;
          } else if (keyf == 0x02) {
            //down
            this.mouseselectvalue = 10;
          }
          if (key == 1) {
            this.mousescrool = 1;
          } else if (key == 5) {
            this.mousescrool = 2;
          } else if (key == 20) {
            this.mousescrool = 3;
          } else if (key == 60) {
            this.mousescrool = 4;
          } else if (key == 100) {
            this.mousescrool = 5;
          }
          this.mousecheck = true;
          this.fucChange();
          break;
        case 10:
          // EC11 one-step wheel
          this.keyradio = 7;
          this.scrollvalue = key;
          this.fucChange();
          break;
        default:
          //normal
          var keylabel = false;
          //function
          for (var i = 0; i < this.functionkeyvalues.length; i++) {
            if (this.functionkeyvalues[i] == key) {
              this.keyradio = 2;
              this.fucChange();
              this.funcselectvalue = key;
              keylabel = true;
            }
          }
          if (!keylabel) {
            //normal
            this.keyradio = 1;
            this.fucChange();
            this.text1 = this.hidNormalKey ? this.hidKeyToText(key) : String.fromCharCode(key);
          }
          break;
      }
    },
    getResult: function getResult() {
      if (this.normalOnly) this.keyradio = 1;
      var result = {
        funcCode: 0xff,
        keyCode: 0xff,
        mediaExtraCode: 0xff,
        mixCode: [0xff, 0xff, 0xff, 0xff, 0xff],
        stringCode: new Array(this.stringsize).fill(0xff)
      };
      switch (this.keyradio) {
        case 1:
          //normal
          if (this.text1.length != 1) {
            this.$message.error(this.labelstr + this.$t('keyConfig.inputErr'));
            return;
          }
          var tmp = this.text1.charCodeAt(0);
          if (tmp < 0 || tmp > 255) {
            this.$message.error(this.labelstr + this.$t('keyConfig.inputErr'));
            return;
          }
          if (this.hidNormalKey) {
            tmp = this.textToHidKey(this.text1);
            if (tmp === null) {
              this.$message.error(this.labelstr + this.$t('keyConfig.inputErr'));
              return;
            }
          }
          result.keyCode = tmp;
          result.funcCode = 0x00;
          break;
        case 2:
          //function
          if (this.funcselectvalue == "") {
            this.$message.error(this.labelstr + this.$t('keyConfig.selectErr'));
            return;
          }
          result.keyCode = this.funcselectvalue;
          result.funcCode = 0x00;
          break;
        case 3:
          //media
          if (this.mediaselectvalue == "") {
            this.$message.error(this.labelstr + this.$t('keyConfig.selectErr'));
            return;
          }
          result.keyCode = this.mediaselectvalue & 0xff;
          if ((this.mediaselectvalue >> 8 & 0xff) != 0) {
            result.mediaExtraCode = this.mediaselectvalue >> 8 & 0xff;
          }
          result.funcCode = 0x01;
          break;
        case 4:
          //mix
          if (this.mixcount < 2) {
            this.$message.error(this.labelstr + this.$t('keyConfig.mixErr'));
            return;
          }
          for (var i = 0; i < this.mixcount; i++) {
            if (this.mixshowarray[i]) {
              if (this.mixfuncselectvalue[i] == "") {
                this.$message.error(this.labelstr + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr2'));
                return;
              }
              result.mixCode[i] = this.mixfuncselectvalue[i];
            } else {
              if (this.mixtext[i].length != 1) {
                this.$message.error(this.labelstr + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3'));
                return;
              }
              var _tmp = this.mixtext[i].charCodeAt(0);
              if (_tmp < 0 || _tmp > 255) {
                this.$message.error(this.labelstr + this.$t('keyConfig.mixErr1') + (i + 1) + this.$t('keyConfig.mixErr3'));
                return;
              }
              result.mixCode[i] = _tmp;
            }
          }
          result.funcCode = 0x02;
          break;
        case 5:
          //string
          if (this.text2.length == 0) {
            this.$message.error(this.labelstr + this.$t('keyConfig.textErr'));
            return;
          }
          for (var i = 0; i < this.text2.length; i++) {
            var chr = this.text2.charCodeAt(i);
            if (chr < 0x20 || chr > 0x7E) {
              this.$message.error(this.labelstr + this.$t('keyConfig.textErr1'));
              return;
            }
            result.stringCode[i] = chr;
          }
          result.funcCode = 0x03;
          result.mediaExtraCode = this.stringcheck ? 0x01 : 0x00;
          break;
        case 6:
          //mouse
          if (this.mouseselectvalue == "") {
            this.$message.error(this.labelstr + this.$t('keyConfig.selectErr'));
            return;
          }
          if (this.mouseselectvalue == 1 || this.mouseselectvalue == 2 || this.mouseselectvalue == 3) {
            //click
            if (this.mousedouble) {
              result.funcCode = 0x04;
              result.mediaExtraCode = 0x03;
            } else {
              result.mediaExtraCode = this.mousecheck ? 0x01 : 0x00;
              if (this.mousepresscheck) {
                result.mediaExtraCode = 0x02;
              }
              result.funcCode = 0x04;
            }
            if (this.mouseselectvalue == 1) {
              //left
              result.keyCode = 0x01;
            } else if (this.mouseselectvalue == 2) {
              //middle
              result.keyCode = 0x04;
            } else if (this.mouseselectvalue == 3) {
              //right
              result.keyCode = 0x02;
            }
          } else if (this.mouseselectvalue == 4) {
            //move random
            result.funcCode = 0x05;
          } else if (this.mouseselectvalue == 5 || this.mouseselectvalue == 6 || this.mouseselectvalue == 7 || this.mouseselectvalue == 8) {
            //move move 
            result.funcCode = this.mousecheck ? 0x07 : 0x06;
            if (this.mouseselectvalue == 5) {
              //up
              result.mediaExtraCode = 0x01;
            } else if (this.mouseselectvalue == 6) {
              //down
              result.mediaExtraCode = 0x02;
            } else if (this.mouseselectvalue == 7) {
              //left
              result.mediaExtraCode = 0x03;
            } else if (this.mouseselectvalue == 8) {
              //right
              result.mediaExtraCode = 0x04;
            }
            result.keyCode = this.mouseinput + 31;
          } else if (this.mouseselectvalue == 9 || this.mouseselectvalue == 10) {
            //move scrool
            result.funcCode = this.mousecheck ? 0x09 : 0x08;
            if (this.mouseselectvalue == 9) {
              //up
              result.mediaExtraCode = 0x01;
            } else if (this.mouseselectvalue == 10) {
              //down
              result.mediaExtraCode = 0x02;
            }
            if (this.mousescrool == 1) {
              result.keyCode = 1;
            } else if (this.mousescrool == 2) {
              result.keyCode = 5;
            } else if (this.mousescrool == 3) {
              result.keyCode = 20;
            } else if (this.mousescrool == 4) {
              result.keyCode = 60;
            } else if (this.mousescrool == 5) {
              result.keyCode = 100;
            }
          }
          break;
        case 7:
          //EC11 wheel
          result.funcCode = 0x0A;
          result.keyCode = this.scrollvalue;
          result.mediaExtraCode = 0xFF;
          break;
        default:
          //none
          this.$message.error(this.labelstr + this.$t('keyConfig.setErr'));
          return;
      }
      return result;
    },
    fucChange: function fucChange() {
      switch (this.keyradio) {
        case 1:
          //normal
          this.input1show = true;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          break;
        case 2:
          //function
          this.input1show = false;
          this.funcselectshow = true;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          this.funcoptions.splice(0, this.funcoptions.length);
          for (var i = 0; i < this.functionkeys.length; i++) {
            if (this.hidNormalKey && this.functionkeyvalues[i] >= 0xF0 && this.functionkeyvalues[i] <= 0xFB) continue;
            this.funcoptions.push({ value: this.functionkeyvalues[i], label: this.functionkeys[i] });
          }
          break;
        case 3:
          //media
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = true;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          this.mediaoptions.splice(0, this.mediaoptions.length);
          for (var i = 0; i < this.mediakeys.length; i++) {
            if (this.hiddenMediaValues.indexOf(this.mediakeyvalues[i]) < 0) {
              this.mediaoptions.push({ value: this.mediakeyvalues[i], label: this.mediakeys[i] });
            }
          }
          break;
        case 4:
          //mix
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = true;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          this.mixfuncoptions.splice(0, this.mixfuncoptions.length);
          for (var i = 0; i < this.functionkeys.length; i++) {
            if (this.hidNormalKey && this.functionkeyvalues[i] >= 0xF0 && this.functionkeyvalues[i] <= 0xFB) continue;
            this.mixfuncoptions.push({ value: this.functionkeyvalues[i], label: this.functionkeys[i] });
          }
          this.mixcountchange();
          break;
        case 5:
          //string
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = true;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          this.stringchecktxt = this.$t('keyConfig.stringEnter');
          break;
        case 6:
          //mouse
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = true;
          this.mouseshow = true;
          this.scrollshow = false;
          this.mouseoptions.splice(0, this.mouseoptions.length);
          var maxMouseOpt = this.mouseclickonly ? 3 : this.mouses.length;
          for (var i = 0; i < maxMouseOpt; i++) {
            this.mouseoptions.push({ value: i + 1, label: this.mouses[i] });
          }
          this.mousecheckchange();
          break;
        case 7:
          //EC11 wheel
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = true;
          break;
        default:
          //none
          this.input1show = false;
          this.funcselectshow = false;
          this.mediaselectshow = false;
          this.input2show = false;
          this.mixshow = false;
          this.mouseselectshow = false;
          this.mouseshow = false;
          this.scrollshow = false;
          break;
      }
    },
    mixdelete: function mixdelete() {
      if (this.mixcount <= 0) {
        this.$message.error(this.$t('keyConfig.delErr'));
        return;
      }
      this.mixcount--;
      this.mixfuncselectvalue[this.mixcount] = '';
      this.mixtext[this.mixcount] = '';
      this.mixcountchange();
    },
    mixadd: function mixadd(type) {
      if (this.mixcount >= 5) {
        this.$message.error(this.$t('keyConfig.mixMaxErr'));
        return;
      }
      if (type == 1) {
        this.mixshowarray[this.mixcount] = true;
      } else if (type == 2) {
        this.mixshowarray[this.mixcount] = false;
      }
      this.mixcount++;
      this.mixcountchange();
    },
    mixreset: function mixreset() {
      this.mixcount = 0;
      this.mixfuncselectvalue = ['', '', '', '', ''];
      this.mixtext = ['', '', '', '', ''];
      this.mixshowarray = [false, false, false, false, false];
      this.mixcountchange();
    },
    mixcountchange: function mixcountchange() {
      switch (this.mixcount) {
        case 0:
          this.mixcountarray = [false, false, false, false, false];
          this.mixtips = this.$t('keyConfig.mixAdd');
          break;
        case 1:
          this.mixcountarray = [true, false, false, false, false];
          this.mixtips = this.$t('keyConfig.mixAdd');
          break;
        case 2:
          this.mixcountarray = [true, true, false, false, false];
          this.mixtips = this.$t('keyConfig.mixMax5');
          break;
        case 3:
          this.mixcountarray = [true, true, true, false, false];
          this.mixtips = this.$t('keyConfig.mixMax5');
          break;
        case 4:
          this.mixcountarray = [true, true, true, true, false];
          this.mixtips = this.$t('keyConfig.mixMax5');
          break;
        case 5:
          this.mixcountarray = [true, true, true, true, true];
          this.mixtips = this.$t('keyConfig.mixMax5');
          break;
        default:
          this.mixcountarray = [false, false, false, false, false];
          this.mixtips = this.$t('keyConfig.mixAdd');
          break;
      }
    },
    mousecheckchange: function mousecheckchange() {
      this.mousecheckshow = false;
      this.mousepresscheckshow = false;
      this.mousedoubleshow = false;
      this.mouseinputshow = false;
      this.mousescroolshow = false;
      this.mousechecktxt = "";
      this.mousepresschecktxt = "";
      this.mousedoubletxt = "";
      this.mouseinputtxt = "";
      if (this.mouseselectvalue == 1 || this.mouseselectvalue == 2 || this.mouseselectvalue == 3) {
        //click
        this.mousedoubleshow = this.mousedoubleEnable;
        this.mousedoubletxt = this.$t('keyConfig.doubleClick');
        this.mousecheckshow = true;
        this.mousechecktxt = this.$t('keyConfig.holdTip');
        this.mousepresscheckshow = true;
        this.mousepresschecktxt = this.$t('keyConfig.holdPressTip');
      } else if (this.mouseselectvalue == 5 || this.mouseselectvalue == 6 || this.mouseselectvalue == 7 || this.mouseselectvalue == 8) {
        //move
        this.mousecheckshow = true;
        this.mouseinputshow = true;
        this.mousechecktxt = this.$t('keyConfig.holdTip');
        this.mouseinputtxt = this.$t('keyConfig.move');
      } else if (this.mouseselectvalue == 9 || this.mouseselectvalue == 10) {
        //scrool
        this.mousecheckshow = true;
        this.mousescroolshow = true;
        this.mousechecktxt = this.$t('keyConfig.holdTip');
        this.mouseinputtxt = this.$t('keyConfig.strong');
      }
    },
    mousecheckpress1: function mousecheckpress1() {
      if (this.mousecheck) {
        this.mousepresscheck = false;
        this.mousedouble = false;
      }
    },
    mousecheckpress2: function mousecheckpress2() {
      if (this.mousepresscheck) {
        this.mousecheck = false;
        this.mousedouble = false;
      }
    },
    mousedoublechange: function mousedoublechange() {
      if (this.mousedouble) {
        this.mousecheck = false;
        this.mousepresscheck = false;
      }
    },
    getKeyDescription: function getKeyDescription() {
      var desc = '';
      switch (this.keyradio) {
        case 1:
          desc = this.text1 === ' ' ? this.$t('workspace.tester.space') : this.text1 === '\xFF' ? '' : this.text1 || '';
          break;
        case 2:
          if (this.funcselectvalue) {
            var idx = this.functionkeyvalues.indexOf(this.funcselectvalue);
            desc = idx >= 0 ? this.functionkeys[idx] : '';
          }
          break;
        case 3:
          if (this.mediaselectvalue) {
            var _idx = this.mediakeyvalues.indexOf(this.mediaselectvalue);
            desc = _idx >= 0 ? this.mediakeys[_idx] : '';
          }
          break;
        case 4:
          var mixParts = [];
          for (var i = 0; i < this.mixcount; i++) {
            if (this.mixshowarray[i]) {
              var _idx2 = this.functionkeyvalues.indexOf(this.mixfuncselectvalue[i]);
              mixParts.push(_idx2 >= 0 ? this.functionkeys[_idx2] : this.mixfuncselectvalue[i]);
            } else {
              mixParts.push(this.mixtext[i]);
            }
          }
          desc = mixParts.join('+');
          break;
        case 5:
          desc = this.text2.length > 20 ? this.text2.substring(0, 20) + '...' : this.text2;
          break;
        case 6:
          if (this.mouseselectvalue >= 1 && this.mouseselectvalue <= this.mouses.length) {
            desc = this.mouses[this.mouseselectvalue - 1];
          }
          break;
        case 7:
          desc = this.$t('workspace.tester.wheel') + ' ' + this.$t('workspace.tester.' + (this.scrollvalue === 0 ? 'upWheel' : 'downWheel'));
          break;
        default:
          desc = '';
      }
      return desc || this.$t('keyConfig.notSet');
    },
    refreshText: function refreshText() {
      this.mouses = this.$t('keyConfig.mouses');
      this.functionkeys = this.$t('keyConfig.functionkeys');
      this.mediakeys = this.$t('keyConfig.mediakeys');
      this.fucChange();
    }
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stability_input_test__ = __webpack_require__(163);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: { dirty: Boolean, disabled: Boolean }, data: function data() {
    return { active: false, started: false, state: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stability_input_test__["a" /* createState */])() };
  },

  watch: {
    disabled: function disabled(value) {
      if (value) this.stop();
    }
  },
  mounted: function mounted() {
    window.addEventListener('blur', this.pause);document.addEventListener('visibilitychange', this.onVisibility);window.addEventListener('mouseup', this.releaseMouse);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('blur', this.pause);document.removeEventListener('visibilitychange', this.onVisibility);window.removeEventListener('mouseup', this.releaseMouse);
  },

  methods: {
    t: function t(key) {
      return this.$t('workspace.tester.' + key);
    },
    start: function start() {
      if (this.disabled) return;this.$refs.pad.focus();this.activate();
    },
    activate: function activate() {
      if (!this.disabled) {
        this.active = true;this.started = true;
      }
    },
    pause: function pause() {
      this.active = false;this.state.held = {};
    },
    stop: function stop() {
      this.pause();if (document.activeElement === this.$refs.pad) this.$refs.pad.blur();
    },
    onVisibility: function onVisibility() {
      if (document.hidden) this.pause();
    },
    clear: function clear() {
      this.stop();this.state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stability_input_test__["a" /* createState */])();this.started = false;
    },
    onKey: function onKey(event) {
      if (!this.active || this.disabled) return;event.preventDefault();event.stopPropagation();__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stability_input_test__["b" /* recordKey */])(this.state, event);if (event.key === 'Escape') this.stop();
    },
    onMouse: function onMouse(event) {
      if (!this.active || this.disabled) return;event.preventDefault();event.stopPropagation();if (event.type === 'mouseup' && !Object.prototype.hasOwnProperty.call(this.state.held, 'Mouse' + event.button)) return;__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stability_input_test__["c" /* recordMouse */])(this.state, event);
    },
    releaseMouse: function releaseMouse(event) {
      if (this.active && Object.prototype.hasOwnProperty.call(this.state.held, 'Mouse' + event.button)) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stability_input_test__["c" /* recordMouse */])(this.state, event);
    },
    onContext: function onContext(event) {
      if (this.active) {
        event.preventDefault();event.stopPropagation();
      }
    },
    heldName: function heldName(id, value) {
      return id.indexOf('Mouse') === 0 ? this.t('mouseNames')[Number(id.slice(5))] || id : value;
    },
    eventLabel: function eventLabel(event) {
      return event.mouse ? event.direction ? this.t(event.direction) : this.t('mouseNames')[event.button] || event.code : event.label;
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var CMD = {
  GET_INFO: 0x01,
  START_SCAN: 0x02,
  GET_RESULTS: 0x03,
  PAIR: 0x04,
  GET_STATUS: 0x05,
  CANCEL: 0x06,
  UNPAIR: 0x07
};
var PROTO_VER = 0x01;
var STATE = {
  IDLE: 0,
  SCANNING: 1,
  PAIRING: 2,
  SUCCESS: 3,
  FAILED: 4
};
var STATE_KEYS = ['stateIdle', 'stateScanning', 'statePairing', 'stateSuccess', 'stateFailed'];

function crc16Ccitt(bytes, start, endExclusive) {
  var crc = 0xffff;
  for (var i = start; i < endExclusive; i++) {
    crc ^= bytes[i] << 8 & 0xffff;
    for (var b = 0; b < 8; b++) {
      crc = crc & 0x8000 ? (crc << 1 ^ 0x1021) & 0xffff : crc << 1 & 0xffff;
    }
  }
  return crc & 0xffff;
}

function bytesToHex(arr) {
  return __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(arr).map(function (v) {
    return v.toString(16).toUpperCase().padStart(2, '0');
  }).join('');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Rf24Pair',
  data: function data() {
    return {
      serialSupported: typeof navigator !== 'undefined' && !!navigator.serial,
      port: null,
      writer: null,
      reader: null,
      readLoopPromise: null,
      connected: false,
      connecting: false,
      rxbuf: new Uint8Array(0),
      pending: {},
      seq: 0,
      localIdHex: '',
      addrHex: '',
      pairFlag: false,
      protoVer: PROTO_VER,
      state: STATE.IDLE,
      progress: 0,
      scanning: false,
      countdown: 0,
      devices: [],
      selectedId: '',
      pairState: 0,
      message: '',
      messageType: 'info',
      pollTimer: null,
      countdownTimer: null
    };
  },

  computed: {
    stateText: function stateText() {
      return this.$t('rf24Pair.' + (STATE_KEYS[this.state] || 'stateUnknown'));
    },
    pairActive: function pairActive() {
      if (this.pairState === STATE.SUCCESS) return 3;
      if (this.pairState === STATE.PAIRING) return Math.max(1, this.progress);
      if (this.pairState === STATE.FAILED) return 0;
      return 0;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopTimers();
    this.disconnect();
  },

  methods: {
    info: function info(msg, type) {
      this.message = msg;
      this.messageType = type || 'info';
    },
    buildFrame: function buildFrame(cmd, seq, payload) {
      var p = payload || [];
      var buf = [0xC5, 0x3A, PROTO_VER, cmd, seq & 0xff, p.length].concat(p);
      var crc = crc16Ccitt(buf, 2, buf.length);
      buf.push(crc & 0xff, crc >> 8 & 0xff);
      return new Uint8Array(buf);
    },
    request: function request(cmd, payload, timeoutMs) {
      var _this = this;

      return new __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var seq = _this.seq = _this.seq + 1 & 0xff;
        var timer = setTimeout(function () {
          if (_this.pending[seq]) {
            delete _this.pending[seq];
            reject(new Error(_this.$t('rf24Pair.timeout')));
          }
        }, timeoutMs || 2000);
        _this.pending[seq] = { resolve: resolve, reject: reject, timer: timer };
        _this.writer.write(_this.buildFrame(cmd, seq, payload || [])).catch(function (err) {
          clearTimeout(timer);
          delete _this.pending[seq];
          reject(err);
        });
      });
    },
    feed: function feed(chunk) {
      var merged = new Uint8Array(this.rxbuf.length + chunk.length);
      merged.set(this.rxbuf, 0);
      merged.set(chunk, this.rxbuf.length);
      var buf = merged;

      while (buf.length >= 9) {
        var i = 0;
        while (i + 1 < buf.length && !(buf[i] === 0x3A && buf[i + 1] === 0xC5)) {
          i++;
        }if (i > 0) buf = buf.slice(i);
        if (buf.length < 9) break;
        if (!(buf[0] === 0x3A && buf[1] === 0xC5)) break;

        var cmd = buf[3];
        var seq = buf[4];
        var status = buf[5];
        var len = buf[6];
        var total = 7 + len + 2;
        if (buf.length < total) break;

        var crcCalc = crc16Ccitt(buf, 2, 7 + len);
        var crcRecv = buf[7 + len] | buf[8 + len] << 8;
        if (crcCalc === crcRecv) {
          var payload = buf.slice(7, 7 + len);
          var p = this.pending[seq];
          if (p) {
            clearTimeout(p.timer);
            delete this.pending[seq];
            p.resolve({ cmd: cmd, status: status, payload: payload });
          }
        }
        buf = buf.slice(total);
      }
      this.rxbuf = buf;
    },
    connect: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.serialSupported) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                this.connecting = true;
                this.rxbuf = new Uint8Array(0);
                _context.prev = 4;
                _context.next = 7;
                return navigator.serial.requestPort();

              case 7:
                this.port = _context.sent;
                _context.next = 10;
                return this.port.open({ baudRate: 115200 });

              case 10:
                this.writer = this.port.writable.getWriter();
                this.reader = this.port.readable.getReader();
                this.connected = true;
                this.readLoopPromise = this.readLoop();
                _context.next = 16;
                return this.refreshInfo();

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](4);

                this.info(this.$t('rf24Pair.connectFailed') + (_context.t0 && _context.t0.message ? _context.t0.message : _context.t0), 'error');

              case 21:
                _context.prev = 21;

                this.connecting = false;
                return _context.finish(21);

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 18, 21, 24]]);
      }));

      function connect() {
        return _ref.apply(this, arguments);
      }

      return connect;
    }(),
    readLoop: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref3, value, done;

        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

              case 1:
                if (false) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 4;
                return this.reader.read();

              case 4:
                _ref3 = _context2.sent;
                value = _ref3.value;
                done = _ref3.done;

                if (!done) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt('break', 12);

              case 9:
                if (value && value.length) this.feed(value);
                _context2.next = 1;
                break;

              case 12:
                _context2.next = 16;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](0);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14]]);
      }));

      function readLoop() {
        return _ref2.apply(this, arguments);
      }

      return readLoop;
    }(),
    disconnect: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.stopTimers();
                _context3.prev = 1;

                if (!this.reader) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.reader.cancel();

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3['catch'](1);

              case 9:
                try {
                  if (this.reader) this.reader.releaseLock();
                } catch (e) {}
                try {
                  if (this.writer) this.writer.releaseLock();
                } catch (e) {}
                _context3.prev = 11;

                if (!this.port) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 15;
                return this.port.close();

              case 15:
                _context3.next = 19;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t1 = _context3['catch'](11);

              case 19:
                this.reader = null;
                this.writer = null;
                this.port = null;
                this.connected = false;
                this.scanning = false;
                this.devices = [];
                this.pairState = 0;
                this.rxbuf = new Uint8Array(0);
                this.pending = {};

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 7], [11, 17]]);
      }));

      function disconnect() {
        return _ref4.apply(this, arguments);
      }

      return disconnect;
    }(),
    applyInfo: function applyInfo(payload) {
      if (!payload || payload.length < 15) return;
      this.state = payload[2];
      this.pairFlag = !!payload[3];
      var addr = (payload[4] | payload[5] << 8 | payload[6] << 16 | payload[7] << 24) >>> 0;
      this.addrHex = '0x' + addr.toString(16).toUpperCase().padStart(8, '0');
      this.localIdHex = bytesToHex(payload.slice(8, 14));
      this.protoVer = payload[14];
    },
    applyStatus: function applyStatus(payload) {
      if (!payload || payload.length < 8) return;
      this.state = payload[0];
      this.progress = payload[1];
      this.pairFlag = !!payload[3];
      var addr = (payload[4] | payload[5] << 8 | payload[6] << 16 | payload[7] << 24) >>> 0;
      this.addrHex = '0x' + addr.toString(16).toUpperCase().padStart(8, '0');
    },
    refreshInfo: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.request(CMD.GET_INFO, []);

              case 3:
                r = _context4.sent;

                this.applyInfo(r.payload);
                _context4.next = 10;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4['catch'](0);

                this.info(_context4.t0.message, 'error');

              case 10:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7]]);
      }));

      function refreshInfo() {
        return _ref5.apply(this, arguments);
      }

      return refreshInfo;
    }(),
    startScan: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return this.request(CMD.START_SCAN, [20]);

              case 3:
                r = _context5.sent;

                this.state = r.payload && r.payload[0] || STATE.SCANNING;
                this.scanning = true;
                this.devices = [];
                this.selectedId = '';
                this.pairState = 0;
                this.countdown = 20;
                this.info(this.$t('rf24Pair.scanStarted'), 'info');
                this.startCountdown(20);
                this.startPolling();
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](0);

                this.info(this.$t('rf24Pair.scanFailed') + _context5.t0.message, 'error');

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 15]]);
      }));

      function startScan() {
        return _ref6.apply(this, arguments);
      }

      return startScan;
    }(),
    startCountdown: function startCountdown(seconds) {
      var _this2 = this;

      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdown = seconds;
      this.countdownTimer = setInterval(function () {
        if (_this2.countdown > 0) _this2.countdown--;
        if (_this2.countdown <= 0) {
          clearInterval(_this2.countdownTimer);
          _this2.countdownTimer = null;
          _this2.scanning = false;
        }
      }, 1000);
    },
    startPolling: function startPolling() {
      var _this3 = this;

      if (this.pollTimer) clearInterval(this.pollTimer);
      this.loadResults();
      this.pollTimer = setInterval(function () {
        if (_this3.pairState === STATE.PAIRING) _this3.pollPairStatus();else _this3.loadResults();
      }, 1000);
    },
    stopTimers: function stopTimers() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);this.pollTimer = null;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);this.countdownTimer = null;
      }
    },
    loadResults: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var r, p, count, list, o, i, id, model;
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.request(CMD.GET_RESULTS, []);

              case 3:
                r = _context6.sent;
                p = r.payload;

                if (!(!p || p.length < 1)) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt('return');

              case 7:
                count = p[0];
                list = [];
                o = 1;

                for (i = 0; i < count && o + 10 <= p.length; i++, o += 10) {
                  id = p.slice(o, o + 6);
                  model = p[o + 6] | p[o + 7] << 8;

                  list.push({
                    idHex: bytesToHex(id),
                    idBytes: __WEBPACK_IMPORTED_MODULE_3_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(id),
                    model: model,
                    modelText: '0x' + model.toString(16).toUpperCase().padStart(4, '0')
                  });
                }
                this.devices = list;
                if (count > 0) this.scanning = true;
                _context6.next = 17;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6['catch'](0);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 15]]);
      }));

      function loadResults() {
        return _ref7.apply(this, arguments);
      }

      return loadResults;
    }(),
    onRowSelect: function onRowSelect(row) {
      if (row) this.selectedId = row.idHex;
    },
    doPair: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee7(row) {
        var r;
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (row) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return');

              case 2:
                this.pendingPairId = row.idHex;
                _context7.prev = 3;
                _context7.next = 6;
                return this.request(CMD.PAIR, row.idBytes);

              case 6:
                r = _context7.sent;

                if (!(r.status !== 0)) {
                  _context7.next = 10;
                  break;
                }

                this.info(this.$t('rf24Pair.pairRequestFailed'), 'error');
                return _context7.abrupt('return');

              case 10:
                this.pairState = STATE.PAIRING;
                this.progress = 1;
                this.info(this.$t('rf24Pair.selected') + row.idHex + this.$t('rf24Pair.selectedSuffix'), 'info');
                this.scanning = false;
                if (this.countdownTimer) {
                  clearInterval(this.countdownTimer);this.countdownTimer = null;
                }
                _context7.next = 20;
                break;

              case 17:
                _context7.prev = 17;
                _context7.t0 = _context7['catch'](3);

                this.info(this.$t('rf24Pair.pairFailed') + _context7.t0.message, 'error');

              case 20:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 17]]);
      }));

      function doPair(_x) {
        return _ref8.apply(this, arguments);
      }

      return doPair;
    }(),
    pollPairStatus: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var r;
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.request(CMD.GET_STATUS, []);

              case 3:
                r = _context8.sent;

                this.applyStatus(r.payload);
                this.pairState = this.state;

                if (!(this.state === STATE.SUCCESS)) {
                  _context8.next = 14;
                  break;
                }

                this.progress = 3;
                this.stopTimers();
                this.info(this.$t('rf24Pair.pairSuccess'), 'success');
                _context8.next = 12;
                return this.refreshInfo();

              case 12:
                _context8.next = 15;
                break;

              case 14:
                if (this.state === STATE.FAILED) {
                  this.stopTimers();
                  this.info(this.$t('rf24Pair.pairRestore'), 'error');
                }

              case 15:
                _context8.next = 19;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](0);

              case 19:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 17]]);
      }));

      function pollPairStatus() {
        return _ref9.apply(this, arguments);
      }

      return pollPairStatus;
    }(),
    cancelScan: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _context9.next = 3;
                return this.request(CMD.CANCEL, []);

              case 3:
                _context9.next = 7;
                break;

              case 5:
                _context9.prev = 5;
                _context9.t0 = _context9['catch'](0);

              case 7:
                this.scanning = false;
                this.pairState = 0;
                this.stopTimers();
                this.info(this.$t('rf24Pair.cancelled'), 'info');
                _context9.next = 13;
                return this.refreshInfo();

              case 13:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 5]]);
      }));

      function cancelScan() {
        return _ref10.apply(this, arguments);
      }

      return cancelScan;
    }(),
    unpair: function () {
      var _ref11 = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.mark(function _callee10() {
        return __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                _context10.next = 3;
                return this.$confirm(this.$t('rf24Pair.unpairWarning'), this.$t('rf24Pair.unpairTitle'), {
                  type: 'warning',
                  confirmButtonText: this.$t('rf24Pair.unpairConfirm'),
                  cancelButtonText: this.$t('rf24Pair.unpairCancel'),
                  confirmButtonClass: 'el-button--danger',
                  closeOnClickModal: false,
                  closeOnPressEscape: false
                });

              case 3:
                _context10.next = 9;
                break;

              case 5:
                _context10.prev = 5;
                _context10.t0 = _context10['catch'](0);

                this.info(this.$t('rf24Pair.unpairCancelled'), 'info');
                return _context10.abrupt('return');

              case 9:
                _context10.prev = 9;
                _context10.next = 12;
                return this.request(CMD.UNPAIR, []);

              case 12:
                this.pairFlag = false;
                this.info(this.$t('rf24Pair.unpairDone'), 'info');
                _context10.next = 16;
                return this.refreshInfo();

              case 16:
                _context10.next = 21;
                break;

              case 18:
                _context10.prev = 18;
                _context10.t1 = _context10['catch'](9);

                this.info(this.$t('rf24Pair.unpairFailed') + _context10.t1.message, 'error');

              case 21:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 5], [9, 18]]);
      }));

      function unpair() {
        return _ref11.apply(this, arguments);
      }

      return unpair;
    }()
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_en__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_zh__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stability_messages__ = __webpack_require__(113);












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);

var messages = {
  en: __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__i18n_en__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a, {
    workspace: __WEBPACK_IMPORTED_MODULE_10__stability_messages__["a" /* en */]
  }),
  zh: __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__i18n_zh__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale_lang_zh_CN___default.a, {
    workspace: __WEBPACK_IMPORTED_MODULE_10__stability_messages__["b" /* zh */]
  })
};

var language = 'zh';
try {
  if (localStorage.getItem('lang') === 'en') language = 'en';
} catch (e) {}
var _i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
  locale: language,
  messages: messages
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  i18n: _i18n,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_4__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return recordKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return recordMouse; });



// Pure, bounded in-memory input recorder. No device or storage access.
function createState() {
  return { held: {}, events: [], text: '', downs: 0, repeats: 0, mouse: 0, sequence: 0 };
}
function add(state, event) {
  state.events.unshift(__WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, event, { id: ++state.sequence }));if (state.events.length > 80) state.events.pop();
}
function keyLabel(event) {
  var mods = [];if (event.ctrlKey) mods.push('Ctrl');if (event.altKey) mods.push('Alt');if (event.shiftKey) mods.push('Shift');if (event.metaKey) mods.push('Win/Command');var names = { Control: 'Ctrl', Meta: 'Win/Command', ' ': 'Space' };var k = names[event.key] || event.key || event.code || 'Unidentified';if (!mods.includes(k)) mods.push(k);return mods.join(' + ');
}
function recordKey(state, event) {
  var id = event.code || event.key,
      label = keyLabel(event),
      down = event.type === 'keydown';
  var repeated = down && (event.repeat || Object.prototype.hasOwnProperty.call(state.held, id));
  if (down) {
    state.held = __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, state.held, __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_defineProperty___default()({}, id, label));if (repeated) state.repeats++;else state.downs++;
  } else {
    var held = __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, state.held);delete held[id];state.held = held;
  }
  add(state, { kind: down ? repeated ? 'repeat' : 'down' : 'up', label: label, code: id, time: new Date().toLocaleTimeString(), location: event.location || 0 });
  if (down && !event.ctrlKey && !event.altKey && !event.metaKey && !event.isComposing) {
    if (event.key === 'Backspace') state.text = __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(state.text).slice(0, -1).join('');else if (event.key === 'Enter') state.text += '\n';else if (event.key === 'Tab') state.text += '\t';else if (event.key && __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(event.key).length === 1) state.text += event.key;
    state.text = state.text.slice(-500);
  }
}
function recordMouse(state, event) {
  var wheel = event.type === 'wheel',
      id = 'Mouse' + event.button;
  if (!wheel) {
    var held = __WEBPACK_IMPORTED_MODULE_2_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_helpers_extends___default()({}, state.held);if (event.type === 'mousedown') held[id] = id;else delete held[id];state.held = held;
  }
  state.mouse++;
  add(state, { kind: wheel ? 'wheel' : event.type === 'mousedown' ? 'down' : 'up', mouse: true, button: event.button,
    direction: wheel ? Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY < 0 ? 'upWheel' : 'downWheel' : event.deltaX < 0 ? 'leftWheel' : 'rightWheel' : '',
    code: wheel ? 'ΔY ' + event.deltaY + ' / ΔX ' + event.deltaX + ' (mode ' + event.deltaMode + ')' : id, time: new Date().toLocaleTimeString() });
}


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__codec_js__ = __webpack_require__(83);
/* unused harmony export bytesToText */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decodePayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buildPayload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isModernReply; });




function bytesToText(bytes) {
  var text = '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_get_iterator___default()(bytes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var value = _step.value;

      if (value === 255) break;
      text += String.fromCharCode(value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return text;
}

function decodePayload(type, payload) {
  var model = __WEBPACK_IMPORTED_MODULE_2__codec_js__["models"][type];
  __WEBPACK_IMPORTED_MODULE_2__codec_js__["validate"](type, payload);
  var keys = [];
  for (var i = 0; i < model.keys; i++) {
    keys.push({
      key: payload[i],
      func: payload[model.keys + i],
      extra: payload[model.keys * 2 + i],
      text: bytesToText(payload.slice(model.textOff + i * model.text, model.textOff + (i + 1) * model.text)),
      mix: __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(payload.slice(model.mixOff + i * 5, model.mixOff + (i + 1) * 5))
    });
  }
  var result = {
    type: type,
    keys: keys,
    lighting: {
      mode: payload[model.lightOff],
      colors: __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(payload.slice(model.lightOff + 1, model.lightOff + 1 + model.keys)),
      brightness: payload[model.brightnessOff]
    }
  };
  if (model.knob) {
    var mixOffsets = [5, 10, 0];
    result.knobs = [];
    for (var _i = 0; _i < 3; _i++) {
      var off = model.knobOff + _i * 3;
      result.knobs.push({
        key: payload[off], func: payload[off + 1], extra: payload[off + 2],
        mix: __WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(payload.slice(model.knobMixOff + mixOffsets[_i], model.knobMixOff + mixOffsets[_i] + 5))
      });
    }
  }
  return result;
}

function buildPayload(type, keyResults, lighting, knobs) {
  var model = __WEBPACK_IMPORTED_MODULE_2__codec_js__["models"][type];
  if (!model || !Array.isArray(keyResults) || keyResults.length !== model.keys) throw Error('配置型号或按键数量不匹配');
  var payload = new Uint8Array(model.length).fill(255);
  keyResults.forEach(function (item, i) {
    if (!item) throw Error('按键 ' + (i + 1) + ' 的配置不完整');
    payload[i] = item.keyCode;
    payload[model.keys + i] = item.funcCode;
    payload[model.keys * 2 + i] = item.mediaExtraCode;
    if (item.funcCode === 3 && item.stringCode) payload.set(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(item.stringCode).slice(0, model.text), model.textOff + i * model.text);
    if (item.funcCode === 2 && item.mixCode) payload.set(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(item.mixCode).slice(0, 5), model.mixOff + i * 5);
  });
  payload[model.lightOff] = lighting.mode;
  for (var i = 0; i < model.keys; i++) {
    payload[model.lightOff + 1 + i] = lighting.colors[i];
  }payload[model.brightnessOff] = lighting.brightness;
  if (model.knob) {
    if (!Array.isArray(knobs) || knobs.length !== 3) throw Error('旋钮配置不完整');
    var mixOffsets = [5, 10, 0];
    knobs.forEach(function (item, i) {
      var off = model.knobOff + i * 3;
      payload[off] = item.key;payload[off + 1] = item.func;payload[off + 2] = item.extra;
      if (item.func === 5 && item.mix) payload.set(__WEBPACK_IMPORTED_MODULE_0_F_01_Keyboard_Series_01_Web_20261101_node_modules_babel_runtime_core_js_array_from___default()(item.mix).slice(0, 5), model.knobMixOff + mixOffsets[i]);
    });
  }
  __WEBPACK_IMPORTED_MODULE_2__codec_js__["validate"](type, payload);
  return payload;
}

function isModernReply(line) {
  return typeof line === 'string' && line.indexOf('Q62:') === 0;
}



/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(180), __esModule: true };

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(181), __esModule: true };

/***/ }),
/* 168 */,
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(184), __esModule: true };

/***/ }),
/* 170 */,
/* 171 */,
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(84);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(166);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(45);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(18);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(176)
var ieee754 = __webpack_require__(251)
var isArray = __webpack_require__(252)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(26);
__webpack_require__(215);
module.exports = __webpack_require__(2).Array.from;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
__webpack_require__(26);
module.exports = __webpack_require__(213);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(37);
__webpack_require__(26);
module.exports = __webpack_require__(214);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(217);
module.exports = __webpack_require__(2).Number.isInteger;

/***/ }),
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(219);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(220);
module.exports = __webpack_require__(2).Object.keys;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
__webpack_require__(26);
__webpack_require__(37);
__webpack_require__(221);
module.exports = __webpack_require__(2).Promise;

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(8)
  , createDesc      = __webpack_require__(25);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 192 */,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(24)
  , call        = __webpack_require__(91)
  , isArrayIter = __webpack_require__(90)
  , anObject    = __webpack_require__(10)
  , toLength    = __webpack_require__(57)
  , getIterFn   = __webpack_require__(61)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(20)
  , floor    = Math.floor;
module.exports = function isInteger(it){
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(6)
  , macrotask = __webpack_require__(98).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(23)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(12)
  , core    = __webpack_require__(2)
  , fails   = __webpack_require__(19);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(14);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(6)
  , core        = __webpack_require__(2)
  , dP          = __webpack_require__(8)
  , DESCRIPTORS = __webpack_require__(11)
  , SPECIES     = __webpack_require__(4)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(10)
  , aFunction = __webpack_require__(48)
  , SPECIES   = __webpack_require__(4)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(10)
  , get      = __webpack_require__(61);
module.exports = __webpack_require__(2).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(49)
  , ITERATOR  = __webpack_require__(4)('iterator')
  , Iterators = __webpack_require__(21);
module.exports = __webpack_require__(2).isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(24)
  , $export        = __webpack_require__(12)
  , toObject       = __webpack_require__(35)
  , call           = __webpack_require__(91)
  , isArrayIter    = __webpack_require__(90)
  , toLength       = __webpack_require__(57)
  , createProperty = __webpack_require__(191)
  , getIterFn      = __webpack_require__(61);

$export($export.S + $export.F * !__webpack_require__(93)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(12);

$export($export.S, 'Number', {isInteger: __webpack_require__(196)});

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(12);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(11), 'Object', {defineProperty: __webpack_require__(8).f});

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(35)
  , $keys    = __webpack_require__(22);

__webpack_require__(207)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(32)
  , global             = __webpack_require__(6)
  , ctx                = __webpack_require__(24)
  , classof            = __webpack_require__(49)
  , $export            = __webpack_require__(12)
  , isObject           = __webpack_require__(20)
  , aFunction          = __webpack_require__(48)
  , anInstance         = __webpack_require__(189)
  , forOf              = __webpack_require__(193)
  , speciesConstructor = __webpack_require__(210)
  , task               = __webpack_require__(98).set
  , microtask          = __webpack_require__(201)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(4)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(208)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(34)($Promise, PROMISE);
__webpack_require__(209)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(93)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "@font-face{font-family:element-icons;src:url(" + __webpack_require__(265) + ") format(\"woff\"),url(" + __webpack_require__(264) + ") format(\"truetype\");font-weight:400;font-display:\"auto\";font-style:normal}[class*=\" el-icon-\"],[class^=el-icon-]{font-family:element-icons!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;vertical-align:baseline;display:inline-block;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.el-icon-ice-cream-round:before{content:\"\\E6A0\"}.el-icon-ice-cream-square:before{content:\"\\E6A3\"}.el-icon-lollipop:before{content:\"\\E6A4\"}.el-icon-potato-strips:before{content:\"\\E6A5\"}.el-icon-milk-tea:before{content:\"\\E6A6\"}.el-icon-ice-drink:before{content:\"\\E6A7\"}.el-icon-ice-tea:before{content:\"\\E6A9\"}.el-icon-coffee:before{content:\"\\E6AA\"}.el-icon-orange:before{content:\"\\E6AB\"}.el-icon-pear:before{content:\"\\E6AC\"}.el-icon-apple:before{content:\"\\E6AD\"}.el-icon-cherry:before{content:\"\\E6AE\"}.el-icon-watermelon:before{content:\"\\E6AF\"}.el-icon-grape:before{content:\"\\E6B0\"}.el-icon-refrigerator:before{content:\"\\E6B1\"}.el-icon-goblet-square-full:before{content:\"\\E6B2\"}.el-icon-goblet-square:before{content:\"\\E6B3\"}.el-icon-goblet-full:before{content:\"\\E6B4\"}.el-icon-goblet:before{content:\"\\E6B5\"}.el-icon-cold-drink:before{content:\"\\E6B6\"}.el-icon-coffee-cup:before{content:\"\\E6B8\"}.el-icon-water-cup:before{content:\"\\E6B9\"}.el-icon-hot-water:before{content:\"\\E6BA\"}.el-icon-ice-cream:before{content:\"\\E6BB\"}.el-icon-dessert:before{content:\"\\E6BC\"}.el-icon-sugar:before{content:\"\\E6BD\"}.el-icon-tableware:before{content:\"\\E6BE\"}.el-icon-burger:before{content:\"\\E6BF\"}.el-icon-knife-fork:before{content:\"\\E6C1\"}.el-icon-fork-spoon:before{content:\"\\E6C2\"}.el-icon-chicken:before{content:\"\\E6C3\"}.el-icon-food:before{content:\"\\E6C4\"}.el-icon-dish-1:before{content:\"\\E6C5\"}.el-icon-dish:before{content:\"\\E6C6\"}.el-icon-moon-night:before{content:\"\\E6EE\"}.el-icon-moon:before{content:\"\\E6F0\"}.el-icon-cloudy-and-sunny:before{content:\"\\E6F1\"}.el-icon-partly-cloudy:before{content:\"\\E6F2\"}.el-icon-cloudy:before{content:\"\\E6F3\"}.el-icon-sunny:before{content:\"\\E6F6\"}.el-icon-sunset:before{content:\"\\E6F7\"}.el-icon-sunrise-1:before{content:\"\\E6F8\"}.el-icon-sunrise:before{content:\"\\E6F9\"}.el-icon-heavy-rain:before{content:\"\\E6FA\"}.el-icon-lightning:before{content:\"\\E6FB\"}.el-icon-light-rain:before{content:\"\\E6FC\"}.el-icon-wind-power:before{content:\"\\E6FD\"}.el-icon-baseball:before{content:\"\\E712\"}.el-icon-soccer:before{content:\"\\E713\"}.el-icon-football:before{content:\"\\E715\"}.el-icon-basketball:before{content:\"\\E716\"}.el-icon-ship:before{content:\"\\E73F\"}.el-icon-truck:before{content:\"\\E740\"}.el-icon-bicycle:before{content:\"\\E741\"}.el-icon-mobile-phone:before{content:\"\\E6D3\"}.el-icon-service:before{content:\"\\E6D4\"}.el-icon-key:before{content:\"\\E6E2\"}.el-icon-unlock:before{content:\"\\E6E4\"}.el-icon-lock:before{content:\"\\E6E5\"}.el-icon-watch:before{content:\"\\E6FE\"}.el-icon-watch-1:before{content:\"\\E6FF\"}.el-icon-timer:before{content:\"\\E702\"}.el-icon-alarm-clock:before{content:\"\\E703\"}.el-icon-map-location:before{content:\"\\E704\"}.el-icon-delete-location:before{content:\"\\E705\"}.el-icon-add-location:before{content:\"\\E706\"}.el-icon-location-information:before{content:\"\\E707\"}.el-icon-location-outline:before{content:\"\\E708\"}.el-icon-location:before{content:\"\\E79E\"}.el-icon-place:before{content:\"\\E709\"}.el-icon-discover:before{content:\"\\E70A\"}.el-icon-first-aid-kit:before{content:\"\\E70B\"}.el-icon-trophy-1:before{content:\"\\E70C\"}.el-icon-trophy:before{content:\"\\E70D\"}.el-icon-medal:before{content:\"\\E70E\"}.el-icon-medal-1:before{content:\"\\E70F\"}.el-icon-stopwatch:before{content:\"\\E710\"}.el-icon-mic:before{content:\"\\E711\"}.el-icon-copy-document:before{content:\"\\E718\"}.el-icon-full-screen:before{content:\"\\E719\"}.el-icon-switch-button:before{content:\"\\E71B\"}.el-icon-aim:before{content:\"\\E71C\"}.el-icon-crop:before{content:\"\\E71D\"}.el-icon-odometer:before{content:\"\\E71E\"}.el-icon-time:before{content:\"\\E71F\"}.el-icon-bangzhu:before{content:\"\\E724\"}.el-icon-close-notification:before{content:\"\\E726\"}.el-icon-microphone:before{content:\"\\E727\"}.el-icon-turn-off-microphone:before{content:\"\\E728\"}.el-icon-position:before{content:\"\\E729\"}.el-icon-postcard:before{content:\"\\E72A\"}.el-icon-message:before{content:\"\\E72B\"}.el-icon-chat-line-square:before{content:\"\\E72D\"}.el-icon-chat-dot-square:before{content:\"\\E72E\"}.el-icon-chat-dot-round:before{content:\"\\E72F\"}.el-icon-chat-square:before{content:\"\\E730\"}.el-icon-chat-line-round:before{content:\"\\E731\"}.el-icon-chat-round:before{content:\"\\E732\"}.el-icon-set-up:before{content:\"\\E733\"}.el-icon-turn-off:before{content:\"\\E734\"}.el-icon-open:before{content:\"\\E735\"}.el-icon-connection:before{content:\"\\E736\"}.el-icon-link:before{content:\"\\E737\"}.el-icon-cpu:before{content:\"\\E738\"}.el-icon-thumb:before{content:\"\\E739\"}.el-icon-female:before{content:\"\\E73A\"}.el-icon-male:before{content:\"\\E73B\"}.el-icon-guide:before{content:\"\\E73C\"}.el-icon-news:before{content:\"\\E73E\"}.el-icon-price-tag:before{content:\"\\E744\"}.el-icon-discount:before{content:\"\\E745\"}.el-icon-wallet:before{content:\"\\E747\"}.el-icon-coin:before{content:\"\\E748\"}.el-icon-money:before{content:\"\\E749\"}.el-icon-bank-card:before{content:\"\\E74A\"}.el-icon-box:before{content:\"\\E74B\"}.el-icon-present:before{content:\"\\E74C\"}.el-icon-sell:before{content:\"\\E6D5\"}.el-icon-sold-out:before{content:\"\\E6D6\"}.el-icon-shopping-bag-2:before{content:\"\\E74D\"}.el-icon-shopping-bag-1:before{content:\"\\E74E\"}.el-icon-shopping-cart-2:before{content:\"\\E74F\"}.el-icon-shopping-cart-1:before{content:\"\\E750\"}.el-icon-shopping-cart-full:before{content:\"\\E751\"}.el-icon-smoking:before{content:\"\\E752\"}.el-icon-no-smoking:before{content:\"\\E753\"}.el-icon-house:before{content:\"\\E754\"}.el-icon-table-lamp:before{content:\"\\E755\"}.el-icon-school:before{content:\"\\E756\"}.el-icon-office-building:before{content:\"\\E757\"}.el-icon-toilet-paper:before{content:\"\\E758\"}.el-icon-notebook-2:before{content:\"\\E759\"}.el-icon-notebook-1:before{content:\"\\E75A\"}.el-icon-files:before{content:\"\\E75B\"}.el-icon-collection:before{content:\"\\E75C\"}.el-icon-receiving:before{content:\"\\E75D\"}.el-icon-suitcase-1:before{content:\"\\E760\"}.el-icon-suitcase:before{content:\"\\E761\"}.el-icon-film:before{content:\"\\E763\"}.el-icon-collection-tag:before{content:\"\\E765\"}.el-icon-data-analysis:before{content:\"\\E766\"}.el-icon-pie-chart:before{content:\"\\E767\"}.el-icon-data-board:before{content:\"\\E768\"}.el-icon-data-line:before{content:\"\\E76D\"}.el-icon-reading:before{content:\"\\E769\"}.el-icon-magic-stick:before{content:\"\\E76A\"}.el-icon-coordinate:before{content:\"\\E76B\"}.el-icon-mouse:before{content:\"\\E76C\"}.el-icon-brush:before{content:\"\\E76E\"}.el-icon-headset:before{content:\"\\E76F\"}.el-icon-umbrella:before{content:\"\\E770\"}.el-icon-scissors:before{content:\"\\E771\"}.el-icon-mobile:before{content:\"\\E773\"}.el-icon-attract:before{content:\"\\E774\"}.el-icon-monitor:before{content:\"\\E775\"}.el-icon-search:before{content:\"\\E778\"}.el-icon-takeaway-box:before{content:\"\\E77A\"}.el-icon-paperclip:before{content:\"\\E77D\"}.el-icon-printer:before{content:\"\\E77E\"}.el-icon-document-add:before{content:\"\\E782\"}.el-icon-document:before{content:\"\\E785\"}.el-icon-document-checked:before{content:\"\\E786\"}.el-icon-document-copy:before{content:\"\\E787\"}.el-icon-document-delete:before{content:\"\\E788\"}.el-icon-document-remove:before{content:\"\\E789\"}.el-icon-tickets:before{content:\"\\E78B\"}.el-icon-folder-checked:before{content:\"\\E77F\"}.el-icon-folder-delete:before{content:\"\\E780\"}.el-icon-folder-remove:before{content:\"\\E781\"}.el-icon-folder-add:before{content:\"\\E783\"}.el-icon-folder-opened:before{content:\"\\E784\"}.el-icon-folder:before{content:\"\\E78A\"}.el-icon-edit-outline:before{content:\"\\E764\"}.el-icon-edit:before{content:\"\\E78C\"}.el-icon-date:before{content:\"\\E78E\"}.el-icon-c-scale-to-original:before{content:\"\\E7C6\"}.el-icon-view:before{content:\"\\E6CE\"}.el-icon-loading:before{content:\"\\E6CF\"}.el-icon-rank:before{content:\"\\E6D1\"}.el-icon-sort-down:before{content:\"\\E7C4\"}.el-icon-sort-up:before{content:\"\\E7C5\"}.el-icon-sort:before{content:\"\\E6D2\"}.el-icon-finished:before{content:\"\\E6CD\"}.el-icon-refresh-left:before{content:\"\\E6C7\"}.el-icon-refresh-right:before{content:\"\\E6C8\"}.el-icon-refresh:before{content:\"\\E6D0\"}.el-icon-video-play:before{content:\"\\E7C0\"}.el-icon-video-pause:before{content:\"\\E7C1\"}.el-icon-d-arrow-right:before{content:\"\\E6DC\"}.el-icon-d-arrow-left:before{content:\"\\E6DD\"}.el-icon-arrow-up:before{content:\"\\E6E1\"}.el-icon-arrow-down:before{content:\"\\E6DF\"}.el-icon-arrow-right:before{content:\"\\E6E0\"}.el-icon-arrow-left:before{content:\"\\E6DE\"}.el-icon-top-right:before{content:\"\\E6E7\"}.el-icon-top-left:before{content:\"\\E6E8\"}.el-icon-top:before{content:\"\\E6E6\"}.el-icon-bottom:before{content:\"\\E6EB\"}.el-icon-right:before{content:\"\\E6E9\"}.el-icon-back:before{content:\"\\E6EA\"}.el-icon-bottom-right:before{content:\"\\E6EC\"}.el-icon-bottom-left:before{content:\"\\E6ED\"}.el-icon-caret-top:before{content:\"\\E78F\"}.el-icon-caret-bottom:before{content:\"\\E790\"}.el-icon-caret-right:before{content:\"\\E791\"}.el-icon-caret-left:before{content:\"\\E792\"}.el-icon-d-caret:before{content:\"\\E79A\"}.el-icon-share:before{content:\"\\E793\"}.el-icon-menu:before{content:\"\\E798\"}.el-icon-s-grid:before{content:\"\\E7A6\"}.el-icon-s-check:before{content:\"\\E7A7\"}.el-icon-s-data:before{content:\"\\E7A8\"}.el-icon-s-opportunity:before{content:\"\\E7AA\"}.el-icon-s-custom:before{content:\"\\E7AB\"}.el-icon-s-claim:before{content:\"\\E7AD\"}.el-icon-s-finance:before{content:\"\\E7AE\"}.el-icon-s-comment:before{content:\"\\E7AF\"}.el-icon-s-flag:before{content:\"\\E7B0\"}.el-icon-s-marketing:before{content:\"\\E7B1\"}.el-icon-s-shop:before{content:\"\\E7B4\"}.el-icon-s-open:before{content:\"\\E7B5\"}.el-icon-s-management:before{content:\"\\E7B6\"}.el-icon-s-ticket:before{content:\"\\E7B7\"}.el-icon-s-release:before{content:\"\\E7B8\"}.el-icon-s-home:before{content:\"\\E7B9\"}.el-icon-s-promotion:before{content:\"\\E7BA\"}.el-icon-s-operation:before{content:\"\\E7BB\"}.el-icon-s-unfold:before{content:\"\\E7BC\"}.el-icon-s-fold:before{content:\"\\E7A9\"}.el-icon-s-platform:before{content:\"\\E7BD\"}.el-icon-s-order:before{content:\"\\E7BE\"}.el-icon-s-cooperation:before{content:\"\\E7BF\"}.el-icon-bell:before{content:\"\\E725\"}.el-icon-message-solid:before{content:\"\\E799\"}.el-icon-video-camera:before{content:\"\\E772\"}.el-icon-video-camera-solid:before{content:\"\\E796\"}.el-icon-camera:before{content:\"\\E779\"}.el-icon-camera-solid:before{content:\"\\E79B\"}.el-icon-download:before{content:\"\\E77C\"}.el-icon-upload2:before{content:\"\\E77B\"}.el-icon-upload:before{content:\"\\E7C3\"}.el-icon-picture-outline-round:before{content:\"\\E75F\"}.el-icon-picture-outline:before{content:\"\\E75E\"}.el-icon-picture:before{content:\"\\E79F\"}.el-icon-close:before{content:\"\\E6DB\"}.el-icon-check:before{content:\"\\E6DA\"}.el-icon-plus:before{content:\"\\E6D9\"}.el-icon-minus:before{content:\"\\E6D8\"}.el-icon-help:before{content:\"\\E73D\"}.el-icon-s-help:before{content:\"\\E7B3\"}.el-icon-circle-close:before{content:\"\\E78D\"}.el-icon-circle-check:before{content:\"\\E720\"}.el-icon-circle-plus-outline:before{content:\"\\E723\"}.el-icon-remove-outline:before{content:\"\\E722\"}.el-icon-zoom-out:before{content:\"\\E776\"}.el-icon-zoom-in:before{content:\"\\E777\"}.el-icon-error:before{content:\"\\E79D\"}.el-icon-success:before{content:\"\\E79C\"}.el-icon-circle-plus:before{content:\"\\E7A0\"}.el-icon-remove:before{content:\"\\E7A2\"}.el-icon-info:before{content:\"\\E7A1\"}.el-icon-question:before{content:\"\\E7A4\"}.el-icon-warning-outline:before{content:\"\\E6C9\"}.el-icon-warning:before{content:\"\\E7A3\"}.el-icon-goods:before{content:\"\\E7C2\"}.el-icon-s-goods:before{content:\"\\E7B2\"}.el-icon-star-off:before{content:\"\\E717\"}.el-icon-star-on:before{content:\"\\E797\"}.el-icon-more-outline:before{content:\"\\E6CC\"}.el-icon-more:before{content:\"\\E794\"}.el-icon-phone-outline:before{content:\"\\E6CB\"}.el-icon-phone:before{content:\"\\E795\"}.el-icon-user:before{content:\"\\E6E3\"}.el-icon-user-solid:before{content:\"\\E7A5\"}.el-icon-setting:before{content:\"\\E6CA\"}.el-icon-s-tools:before{content:\"\\E7AC\"}.el-icon-delete:before{content:\"\\E6D7\"}.el-icon-delete-solid:before{content:\"\\E7C9\"}.el-icon-eleme:before{content:\"\\E7C7\"}.el-icon-platform-eleme:before{content:\"\\E7CA\"}.el-icon-loading{-webkit-animation:rotating 2s linear infinite;animation:rotating 2s linear infinite}.el-icon--right{margin-left:5px}.el-icon--left{margin-right:5px}@-webkit-keyframes rotating{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotating{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.el-pagination{white-space:nowrap;padding:2px 5px;color:#303133;font-weight:700}.el-pagination:after,.el-pagination:before{display:table;content:\"\"}.el-pagination:after{clear:both}.el-pagination button,.el-pagination span:not([class*=suffix]){display:inline-block;font-size:13px;min-width:35.5px;height:28px;line-height:28px;vertical-align:top;box-sizing:border-box}.el-pagination .el-input__inner{text-align:center;-moz-appearance:textfield;line-height:normal}.el-pagination .el-input__suffix{right:0;-webkit-transform:scale(.8);transform:scale(.8)}.el-pagination .el-select .el-input{width:100px;margin:0 5px}.el-pagination .el-select .el-input .el-input__inner{padding-right:25px;border-radius:3px}.el-pagination button{border:none;padding:0 6px;background:0 0}.el-pagination button:focus{outline:0}.el-pagination button:hover{color:#409eff}.el-pagination button:disabled{color:#c0c4cc;background-color:#fff;cursor:not-allowed}.el-pagination .btn-next,.el-pagination .btn-prev{background:50% no-repeat #fff;background-size:16px;cursor:pointer;margin:0;color:#303133}.el-pagination .btn-next .el-icon,.el-pagination .btn-prev .el-icon{display:block;font-size:12px;font-weight:700}.el-pagination .btn-prev{padding-right:12px}.el-pagination .btn-next{padding-left:12px}.el-pagination .el-pager li.disabled{color:#c0c4cc;cursor:not-allowed}.el-pager li,.el-pager li.btn-quicknext:hover,.el-pager li.btn-quickprev:hover{cursor:pointer}.el-pagination--small .btn-next,.el-pagination--small .btn-prev,.el-pagination--small .el-pager li,.el-pagination--small .el-pager li.btn-quicknext,.el-pagination--small .el-pager li.btn-quickprev,.el-pagination--small .el-pager li:last-child{border-color:transparent;font-size:12px;line-height:22px;height:22px;min-width:22px}.el-pagination--small .arrow.disabled{visibility:hidden}.el-pagination--small .more:before,.el-pagination--small li.more:before{line-height:24px}.el-pagination--small button,.el-pagination--small span:not([class*=suffix]){height:22px;line-height:22px}.el-pagination--small .el-pagination__editor,.el-pagination--small .el-pagination__editor.el-input .el-input__inner{height:22px}.el-pagination__sizes{margin:0 10px 0 0;font-weight:400;color:#606266}.el-pagination__sizes .el-input .el-input__inner{font-size:13px;padding-left:8px}.el-pagination__sizes .el-input .el-input__inner:hover{border-color:#409eff}.el-pagination__total{margin-right:10px;font-weight:400;color:#606266}.el-pagination__jump{margin-left:24px;font-weight:400;color:#606266}.el-pagination__jump .el-input__inner{padding:0 3px}.el-pagination__rightwrapper{float:right}.el-pagination__editor{line-height:18px;padding:0 2px;height:28px;text-align:center;margin:0 2px;box-sizing:border-box;border-radius:3px}.el-pager,.el-pagination.is-background .btn-next,.el-pagination.is-background .btn-prev{padding:0}.el-dialog,.el-pager li{-webkit-box-sizing:border-box}.el-pagination__editor.el-input{width:50px}.el-pagination__editor.el-input .el-input__inner{height:28px}.el-pagination__editor .el-input__inner::-webkit-inner-spin-button,.el-pagination__editor .el-input__inner::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.el-pagination.is-background .btn-next,.el-pagination.is-background .btn-prev,.el-pagination.is-background .el-pager li{margin:0 5px;background-color:#f4f4f5;color:#606266;min-width:30px;border-radius:2px}.el-pagination.is-background .btn-next.disabled,.el-pagination.is-background .btn-next:disabled,.el-pagination.is-background .btn-prev.disabled,.el-pagination.is-background .btn-prev:disabled,.el-pagination.is-background .el-pager li.disabled{color:#c0c4cc}.el-pagination.is-background .el-pager li:not(.disabled):hover{color:#409eff}.el-pagination.is-background .el-pager li:not(.disabled).active{background-color:#409eff;color:#fff}.el-pagination.is-background.el-pagination--small .btn-next,.el-pagination.is-background.el-pagination--small .btn-prev,.el-pagination.is-background.el-pagination--small .el-pager li{margin:0 3px;min-width:22px}.el-pager,.el-pager li{vertical-align:top;margin:0;display:inline-block}.el-pager{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;list-style:none;font-size:0}.el-pager .more:before{line-height:30px}.el-pager li{padding:0 4px;background:#fff;font-size:13px;min-width:35.5px;height:28px;line-height:28px;box-sizing:border-box;text-align:center}.el-pager li.btn-quicknext,.el-pager li.btn-quickprev{line-height:28px;color:#303133}.el-pager li.btn-quicknext.disabled,.el-pager li.btn-quickprev.disabled{color:#c0c4cc}.el-pager li.active+li{border-left:0}.el-pager li:hover{color:#409eff}.el-pager li.active{color:#409eff;cursor:default}@-webkit-keyframes v-modal-in{0%{opacity:0}}@-webkit-keyframes v-modal-out{to{opacity:0}}.el-dialog{position:relative;margin:0 auto 50px;background:#fff;border-radius:2px;box-shadow:0 1px 3px rgba(0,0,0,.3);box-sizing:border-box;width:50%}.el-dialog.is-fullscreen{width:100%;margin-top:0;margin-bottom:0;height:100%;overflow:auto}.el-dialog__wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:auto;margin:0}.el-dialog__header{padding:20px 20px 10px}.el-dialog__headerbtn{position:absolute;top:20px;right:20px;padding:0;background:0 0;border:none;outline:0;cursor:pointer;font-size:16px}.el-dialog__headerbtn .el-dialog__close{color:#909399}.el-dialog__headerbtn:focus .el-dialog__close,.el-dialog__headerbtn:hover .el-dialog__close{color:#409eff}.el-dialog__title{line-height:24px;font-size:18px;color:#303133}.el-dialog__body{padding:30px 20px;color:#606266;font-size:14px;word-break:break-all}.el-dialog__footer{padding:10px 20px 20px;text-align:right;box-sizing:border-box}.el-dialog--center{text-align:center}.el-dialog--center .el-dialog__body{text-align:initial;padding:25px 25px 30px}.el-dialog--center .el-dialog__footer{text-align:inherit}.dialog-fade-enter-active{-webkit-animation:dialog-fade-in .3s;animation:dialog-fade-in .3s}.dialog-fade-leave-active{-webkit-animation:dialog-fade-out .3s;animation:dialog-fade-out .3s}@-webkit-keyframes dialog-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes dialog-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@-webkit-keyframes dialog-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}@keyframes dialog-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}.el-autocomplete{position:relative;display:inline-block}.el-autocomplete-suggestion{margin:5px 0;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);border-radius:4px;border:1px solid #e4e7ed;box-sizing:border-box;background-color:#fff}.el-autocomplete-suggestion__wrap{max-height:280px;padding:10px 0;box-sizing:border-box}.el-autocomplete-suggestion__list{margin:0;padding:0}.el-autocomplete-suggestion li{padding:0 20px;margin:0;line-height:34px;cursor:pointer;color:#606266;font-size:14px;list-style:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.el-autocomplete-suggestion li.highlighted,.el-autocomplete-suggestion li:hover{background-color:#f5f7fa}.el-autocomplete-suggestion li.divider{margin-top:6px;border-top:1px solid #000}.el-autocomplete-suggestion li.divider:last-child{margin-bottom:-6px}.el-autocomplete-suggestion.is-loading li{text-align:center;height:100px;line-height:100px;font-size:20px;color:#999}.el-autocomplete-suggestion.is-loading li:after{display:inline-block;content:\"\";height:100%;vertical-align:middle}.el-autocomplete-suggestion.is-loading li:hover{background-color:#fff}.el-autocomplete-suggestion.is-loading .el-icon-loading{vertical-align:middle}.el-dropdown{display:inline-block;position:relative;color:#606266;font-size:14px}.el-dropdown .el-button-group{display:block}.el-dropdown .el-button-group .el-button{float:none}.el-dropdown .el-dropdown__caret-button{padding-left:5px;padding-right:5px;position:relative;border-left:none}.el-dropdown .el-dropdown__caret-button:before{content:\"\";position:absolute;display:block;width:1px;top:5px;bottom:5px;left:0;background:hsla(0,0%,100%,.5)}.el-dropdown .el-dropdown__caret-button.el-button--default:before{background:rgba(220,223,230,.5)}.el-dropdown .el-dropdown__caret-button:hover:not(.is-disabled):before{top:0;bottom:0}.el-dropdown .el-dropdown__caret-button .el-dropdown__icon{padding-left:0}.el-dropdown__icon{font-size:12px;margin:0 3px}.el-dropdown .el-dropdown-selfdefine:focus:active,.el-dropdown .el-dropdown-selfdefine:focus:not(.focusing){outline-width:0}.el-dropdown [disabled]{cursor:not-allowed;color:#bbb}.el-dropdown-menu{position:absolute;top:0;left:0;z-index:10;padding:10px 0;margin:5px 0;background-color:#fff;border:1px solid #ebeef5;border-radius:4px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-dropdown-menu__item,.el-menu-item{font-size:14px;padding:0 20px;cursor:pointer}.el-dropdown-menu__item{list-style:none;line-height:36px;margin:0;color:#606266;outline:0}.el-dropdown-menu__item:focus,.el-dropdown-menu__item:not(.is-disabled):hover{background-color:#ecf5ff;color:#66b1ff}.el-dropdown-menu__item i{margin-right:5px}.el-dropdown-menu__item--divided{position:relative;margin-top:6px;border-top:1px solid #ebeef5}.el-dropdown-menu__item--divided:before{content:\"\";height:6px;display:block;margin:0 -20px;background-color:#fff}.el-dropdown-menu__item.is-disabled{cursor:default;color:#bbb;pointer-events:none}.el-dropdown-menu--medium{padding:6px 0}.el-dropdown-menu--medium .el-dropdown-menu__item{line-height:30px;padding:0 17px;font-size:14px}.el-dropdown-menu--medium .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:6px}.el-dropdown-menu--medium .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:6px;margin:0 -17px}.el-dropdown-menu--small{padding:6px 0}.el-dropdown-menu--small .el-dropdown-menu__item{line-height:27px;padding:0 15px;font-size:13px}.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:4px}.el-dropdown-menu--small .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:4px;margin:0 -15px}.el-dropdown-menu--mini{padding:3px 0}.el-dropdown-menu--mini .el-dropdown-menu__item{line-height:24px;padding:0 10px;font-size:12px}.el-dropdown-menu--mini .el-dropdown-menu__item.el-dropdown-menu__item--divided{margin-top:3px}.el-dropdown-menu--mini .el-dropdown-menu__item.el-dropdown-menu__item--divided:before{height:3px;margin:0 -10px}.el-menu{border-right:1px solid #e6e6e6;list-style:none;position:relative;margin:0;padding-left:0}.el-menu,.el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,.el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,.el-menu--horizontal>.el-submenu .el-submenu__title:hover{background-color:#fff}.el-menu:after,.el-menu:before{display:table;content:\"\"}.el-breadcrumb__item:last-child .el-breadcrumb__separator,.el-menu--collapse>.el-menu-item .el-submenu__icon-arrow,.el-menu--collapse>.el-submenu>.el-submenu__title .el-submenu__icon-arrow{display:none}.el-menu:after{clear:both}.el-menu.el-menu--horizontal{border-bottom:1px solid #e6e6e6}.el-menu--horizontal{border-right:none}.el-menu--horizontal>.el-menu-item{float:left;height:60px;line-height:60px;margin:0;border-bottom:2px solid transparent;color:#909399}.el-menu--horizontal>.el-menu-item a,.el-menu--horizontal>.el-menu-item a:hover{color:inherit}.el-menu--horizontal>.el-submenu{float:left}.el-menu--horizontal>.el-submenu:focus,.el-menu--horizontal>.el-submenu:hover{outline:0}.el-menu--horizontal>.el-submenu:focus .el-submenu__title,.el-menu--horizontal>.el-submenu:hover .el-submenu__title{color:#303133}.el-menu--horizontal>.el-submenu.is-active .el-submenu__title{border-bottom:2px solid #409eff;color:#303133}.el-menu--horizontal>.el-submenu .el-submenu__title{height:60px;line-height:60px;border-bottom:2px solid transparent;color:#909399}.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow{position:static;vertical-align:middle;margin-left:8px;margin-top:-3px}.el-menu--collapse .el-submenu,.el-menu-item{position:relative}.el-menu--horizontal .el-menu .el-menu-item,.el-menu--horizontal .el-menu .el-submenu__title{background-color:#fff;float:none;height:36px;line-height:36px;padding:0 10px;color:#909399}.el-menu--horizontal .el-menu .el-menu-item.is-active,.el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title{color:#303133}.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,.el-menu--horizontal .el-menu-item:not(.is-disabled):hover{outline:0;color:#303133}.el-menu--horizontal>.el-menu-item.is-active{border-bottom:2px solid #409eff;color:#303133}.el-menu--collapse{width:64px}.el-menu--collapse>.el-menu-item [class^=el-icon-],.el-menu--collapse>.el-submenu>.el-submenu__title [class^=el-icon-]{margin:0;vertical-align:middle;width:24px;text-align:center}.el-menu--collapse>.el-menu-item span,.el-menu--collapse>.el-submenu>.el-submenu__title span{height:0;width:0;overflow:hidden;visibility:hidden;display:inline-block}.el-menu-item,.el-submenu__title{height:56px;line-height:56px;list-style:none}.el-menu--collapse>.el-menu-item.is-active i{color:inherit}.el-menu--collapse .el-menu .el-submenu{min-width:200px}.el-menu--collapse .el-submenu .el-menu{position:absolute;margin-left:5px;top:0;left:100%;z-index:10;border:1px solid #e4e7ed;border-radius:2px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-menu--collapse .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{-webkit-transform:none;transform:none}.el-menu--popup{z-index:100;min-width:200px;border:none;padding:5px 0;border-radius:2px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-menu--popup-bottom-start{margin-top:5px}.el-menu--popup-right-start{margin-left:5px;margin-right:5px}.el-menu-item{color:#303133;transition:border-color .3s,background-color .3s,color .3s;box-sizing:border-box;white-space:nowrap}.el-radio-button__inner,.el-submenu__title{-webkit-box-sizing:border-box;position:relative;white-space:nowrap}.el-menu-item *{vertical-align:middle}.el-menu-item i{color:#909399}.el-menu-item:focus,.el-menu-item:hover{outline:0;background-color:#ecf5ff}.el-menu-item.is-disabled{opacity:.25;cursor:not-allowed;background:0 0!important}.el-menu-item [class^=el-icon-]{margin-right:5px;width:24px;text-align:center;font-size:18px;vertical-align:middle}.el-menu-item.is-active{color:#409eff}.el-menu-item.is-active i{color:inherit}.el-submenu{list-style:none;margin:0;padding-left:0}.el-submenu__title{font-size:14px;color:#303133;padding:0 20px;cursor:pointer;transition:border-color .3s,background-color .3s,color .3s;box-sizing:border-box}.el-submenu__title *{vertical-align:middle}.el-submenu__title i{color:#909399}.el-submenu__title:focus,.el-submenu__title:hover{outline:0;background-color:#ecf5ff}.el-submenu__title.is-disabled{opacity:.25;cursor:not-allowed;background:0 0!important}.el-submenu__title:hover{background-color:#ecf5ff}.el-submenu .el-menu{border:none}.el-submenu .el-menu-item{height:50px;line-height:50px;padding:0 45px;min-width:200px}.el-submenu__icon-arrow{position:absolute;top:50%;right:20px;margin-top:-7px;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;font-size:12px}.el-submenu.is-active .el-submenu__title{border-bottom-color:#409eff}.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.el-submenu.is-disabled .el-menu-item,.el-submenu.is-disabled .el-submenu__title{opacity:.25;cursor:not-allowed;background:0 0!important}.el-submenu [class^=el-icon-]{vertical-align:middle;margin-right:5px;width:24px;text-align:center;font-size:18px}.el-menu-item-group>ul{padding:0}.el-menu-item-group__title{padding:7px 0 7px 20px;line-height:normal;font-size:12px;color:#909399}.el-radio-button__inner,.el-radio-group{display:inline-block;line-height:1;vertical-align:middle}.horizontal-collapse-transition .el-submenu__title .el-submenu__icon-arrow{transition:.2s;opacity:0}.el-radio-group{font-size:0}.el-radio-button{position:relative;display:inline-block;outline:0}.el-radio-button__inner{background:#fff;border:1px solid #dcdfe6;font-weight:500;border-left:0;color:#606266;-webkit-appearance:none;text-align:center;box-sizing:border-box;outline:0;margin:0;cursor:pointer;transition:all .3s cubic-bezier(.645,.045,.355,1);padding:12px 20px;font-size:14px;border-radius:0}.el-radio-button__inner.is-round{padding:12px 20px}.el-radio-button__inner:hover{color:#409eff}.el-radio-button__inner [class*=el-icon-]{line-height:.9}.el-radio-button__inner [class*=el-icon-]+span{margin-left:5px}.el-radio-button:first-child .el-radio-button__inner{border-left:1px solid #dcdfe6;border-radius:4px 0 0 4px;box-shadow:none!important}.el-radio-button__orig-radio{opacity:0;outline:0;position:absolute;z-index:-1}.el-radio-button__orig-radio:checked+.el-radio-button__inner{color:#fff;background-color:#409eff;border-color:#409eff;box-shadow:-1px 0 0 0 #409eff}.el-radio-button__orig-radio:disabled+.el-radio-button__inner{color:#c0c4cc;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5;box-shadow:none}.el-radio-button__orig-radio:disabled:checked+.el-radio-button__inner{background-color:#f2f6fc}.el-radio-button:last-child .el-radio-button__inner{border-radius:0 4px 4px 0}.el-radio-button:first-child:last-child .el-radio-button__inner{border-radius:4px}.el-radio-button--medium .el-radio-button__inner{padding:10px 20px;font-size:14px;border-radius:0}.el-radio-button--medium .el-radio-button__inner.is-round{padding:10px 20px}.el-radio-button--small .el-radio-button__inner{padding:9px 15px;font-size:12px;border-radius:0}.el-radio-button--small .el-radio-button__inner.is-round{padding:9px 15px}.el-radio-button--mini .el-radio-button__inner{padding:7px 15px;font-size:12px;border-radius:0}.el-radio-button--mini .el-radio-button__inner.is-round{padding:7px 15px}.el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled){box-shadow:0 0 2px 2px #409eff}.el-picker-panel,.el-popover,.el-select-dropdown,.el-table-filter,.el-time-panel{-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-switch{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;font-size:14px;line-height:20px;height:20px;vertical-align:middle}.el-switch__core,.el-switch__label{display:inline-block;cursor:pointer}.el-switch.is-disabled .el-switch__core,.el-switch.is-disabled .el-switch__label{cursor:not-allowed}.el-switch__label{transition:.2s;height:20px;font-size:14px;font-weight:500;vertical-align:middle;color:#303133}.el-switch__label.is-active{color:#409eff}.el-switch__label--left{margin-right:10px}.el-switch__label--right{margin-left:10px}.el-switch__label *{line-height:1;font-size:14px;display:inline-block}.el-switch__input{position:absolute;width:0;height:0;opacity:0;margin:0}.el-switch__core{margin:0;position:relative;width:40px;height:20px;border:1px solid #dcdfe6;outline:0;border-radius:10px;box-sizing:border-box;background:#dcdfe6;transition:border-color .3s,background-color .3s;vertical-align:middle}.el-input__prefix,.el-input__suffix{-webkit-transition:all .3s;color:#c0c4cc}.el-switch__core:after{content:\"\";position:absolute;top:1px;left:1px;border-radius:100%;transition:all .3s;width:16px;height:16px;background-color:#fff}.el-switch.is-checked .el-switch__core{border-color:#409eff;background-color:#409eff}.el-switch.is-checked .el-switch__core:after{left:100%;margin-left:-17px}.el-switch.is-disabled{opacity:.6}.el-switch--wide .el-switch__label.el-switch__label--left span{left:10px}.el-switch--wide .el-switch__label.el-switch__label--right span{right:10px}.el-switch .label-fade-enter,.el-switch .label-fade-leave-active{opacity:0}.el-select-dropdown{position:absolute;z-index:1001;border:1px solid #e4e7ed;border-radius:4px;background-color:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-sizing:border-box;margin:5px 0}.el-select-dropdown.is-multiple .el-select-dropdown__item{padding-right:40px}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected{color:#409eff;background-color:#fff}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover{background-color:#f5f7fa}.el-select-dropdown.is-multiple .el-select-dropdown__item.selected:after{position:absolute;right:20px;font-family:element-icons;content:\"\\E6DA\";font-size:12px;font-weight:700;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.el-select-dropdown .el-scrollbar.is-empty .el-select-dropdown__list{padding:0}.el-select-dropdown__empty{padding:10px 0;margin:0;text-align:center;color:#999;font-size:14px}.el-select-dropdown__wrap{max-height:274px}.el-select-dropdown__list{list-style:none;padding:6px 0;margin:0;box-sizing:border-box}.el-select-dropdown__item{font-size:14px;padding:0 20px;position:relative;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#606266;height:34px;line-height:34px;box-sizing:border-box;cursor:pointer}.el-select-dropdown__item.is-disabled{color:#c0c4cc;cursor:not-allowed}.el-select-dropdown__item.is-disabled:hover{background-color:#fff}.el-select-dropdown__item.hover,.el-select-dropdown__item:hover{background-color:#f5f7fa}.el-select-dropdown__item.selected{color:#409eff;font-weight:700}.el-select-group{margin:0;padding:0}.el-select-group__wrap{position:relative;list-style:none;margin:0;padding:0}.el-select-group__wrap:not(:last-of-type){padding-bottom:24px}.el-select-group__wrap:not(:last-of-type):after{content:\"\";position:absolute;display:block;left:20px;right:20px;bottom:12px;height:1px;background:#e4e7ed}.el-select-group__title{padding-left:20px;font-size:12px;color:#909399;line-height:30px}.el-select-group .el-select-dropdown__item{padding-left:20px}.el-select{display:inline-block;position:relative}.el-select .el-select__tags>span{display:contents}.el-select:hover .el-input__inner{border-color:#c0c4cc}.el-select .el-input__inner{cursor:pointer;padding-right:35px}.el-select .el-input__inner:focus{border-color:#409eff}.el-select .el-input .el-select__caret{color:#c0c4cc;font-size:14px;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;-webkit-transform:rotate(180deg);transform:rotate(180deg);cursor:pointer}.el-select .el-input .el-select__caret.is-reverse{-webkit-transform:rotate(0);transform:rotate(0)}.el-select .el-input .el-select__caret.is-show-close{font-size:14px;text-align:center;-webkit-transform:rotate(180deg);transform:rotate(180deg);border-radius:100%;color:#c0c4cc;transition:color .2s cubic-bezier(.645,.045,.355,1)}.el-select .el-input .el-select__caret.is-show-close:hover{color:#909399}.el-select .el-input.is-disabled .el-input__inner{cursor:not-allowed}.el-select .el-input.is-disabled .el-input__inner:hover{border-color:#e4e7ed}.el-range-editor.is-active,.el-range-editor.is-active:hover,.el-select .el-input.is-focus .el-input__inner{border-color:#409eff}.el-select>.el-input{display:block}.el-select__input{border:none;outline:0;padding:0;margin-left:15px;color:#666;font-size:14px;-webkit-appearance:none;-moz-appearance:none;appearance:none;height:28px;background-color:transparent}.el-select__input.is-mini{height:14px}.el-select__close{cursor:pointer;position:absolute;top:8px;z-index:1000;right:25px;color:#c0c4cc;line-height:18px;font-size:14px}.el-select__close:hover{color:#909399}.el-select__tags{position:absolute;line-height:normal;white-space:normal;z-index:1;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.el-select__tags-text{overflow:hidden;text-overflow:ellipsis}.el-select .el-tag{box-sizing:border-box;border-color:transparent;margin:2px 0 2px 6px;background-color:#f0f2f5;display:-webkit-box;display:-ms-flexbox;display:flex;max-width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-select .el-tag__close.el-icon-close{background-color:#c0c4cc;top:0;color:#fff;-ms-flex-negative:0;flex-shrink:0}.el-select .el-tag__close.el-icon-close:hover{background-color:#909399}.el-table,.el-table__expanded-cell{background-color:#fff}.el-select .el-tag__close.el-icon-close:before{display:block;-webkit-transform:translateY(.5px);transform:translateY(.5px)}.el-table{position:relative;overflow:hidden;box-sizing:border-box;-webkit-box-flex:1;-ms-flex:1;flex:1;width:100%;max-width:100%;font-size:14px;color:#606266}.el-table__empty-block{min-height:60px;text-align:center;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-table__empty-text{line-height:60px;width:50%;color:#909399}.el-table__expand-column .cell{padding:0;text-align:center}.el-table__expand-icon{position:relative;cursor:pointer;color:#666;font-size:12px;transition:-webkit-transform .2s ease-in-out;transition:transform .2s ease-in-out;transition:transform .2s ease-in-out,-webkit-transform .2s ease-in-out;height:20px}.el-table__expand-icon--expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-table__expand-icon>.el-icon{position:absolute;left:50%;top:50%;margin-left:-5px;margin-top:-5px}.el-table__expanded-cell[class*=cell]{padding:20px 50px}.el-table__expanded-cell:hover{background-color:transparent!important}.el-table__placeholder{display:inline-block;width:20px}.el-table__append-wrapper{overflow:hidden}.el-table--fit{border-right:0;border-bottom:0}.el-table--fit .el-table__cell.gutter{border-right-width:1px}.el-table--scrollable-x .el-table__body-wrapper{overflow-x:auto}.el-table--scrollable-y .el-table__body-wrapper{overflow-y:auto}.el-table thead{color:#909399;font-weight:500}.el-table thead.is-group th.el-table__cell{background:#f5f7fa}.el-table .el-table__cell{padding:12px 0;min-width:0;box-sizing:border-box;text-overflow:ellipsis;vertical-align:middle;position:relative;text-align:left}.el-table .el-table__cell.is-center{text-align:center}.el-table .el-table__cell.is-right{text-align:right}.el-table .el-table__cell.gutter{width:15px;border-right-width:0;border-bottom-width:0;padding:0}.el-table .el-table__cell.is-hidden>*{visibility:hidden}.el-table--medium .el-table__cell{padding:10px 0}.el-table--small{font-size:12px}.el-table--small .el-table__cell{padding:8px 0}.el-table--mini{font-size:12px}.el-table--mini .el-table__cell{padding:6px 0}.el-table tr{background-color:#fff}.el-table tr input[type=checkbox]{margin:0}.el-table td.el-table__cell,.el-table th.el-table__cell.is-leaf{border-bottom:1px solid #ebeef5}.el-table th.el-table__cell.is-sortable{cursor:pointer}.el-table th.el-table__cell{overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#fff}.el-table th.el-table__cell>.cell{display:inline-block;box-sizing:border-box;position:relative;vertical-align:middle;padding-left:10px;padding-right:10px;width:100%}.el-table th.el-table__cell>.cell.highlight{color:#409eff}.el-table th.el-table__cell.required>div:before{display:inline-block;content:\"\";width:8px;height:8px;border-radius:50%;background:#ff4d51;margin-right:5px;vertical-align:middle}.el-table td.el-table__cell div{box-sizing:border-box}.el-date-table td,.el-table-filter,.el-table .cell{-webkit-box-sizing:border-box}.el-table td.el-table__cell.gutter{width:0}.el-table .cell{box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;white-space:normal;word-break:break-all;line-height:23px;padding-left:10px;padding-right:10px}.el-table .cell.el-tooltip{white-space:nowrap;min-width:50px}.el-table--border,.el-table--group{border:1px solid #ebeef5}.el-table--border:after,.el-table--group:after,.el-table:before{content:\"\";position:absolute;background-color:#ebeef5;z-index:1}.el-table--border:after,.el-table--group:after{top:0;right:0;width:1px;height:100%}.el-table:before{left:0;bottom:0;width:100%;height:1px}.el-table--border{border-right:none;border-bottom:none}.el-table--border.el-loading-parent--relative{border-color:transparent}.el-table--border .el-table__cell,.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{border-right:1px solid #ebeef5}.el-table--border .el-table__cell:first-child .cell{padding-left:10px}.el-table--border th.el-table__cell.gutter:last-of-type{border-bottom:1px solid #ebeef5;border-bottom-width:1px}.el-table--border th.el-table__cell,.el-table__fixed-right-patch{border-bottom:1px solid #ebeef5}.el-table--hidden{visibility:hidden}.el-table__fixed,.el-table__fixed-right{position:absolute;top:0;left:0;overflow-x:hidden;overflow-y:hidden;box-shadow:0 0 10px rgba(0,0,0,.12)}.el-table__fixed-right:before,.el-table__fixed:before{content:\"\";position:absolute;left:0;bottom:0;width:100%;height:1px;background-color:#ebeef5;z-index:4}.el-table__fixed-right-patch{position:absolute;top:-1px;right:0;background-color:#fff}.el-table__fixed-right{top:0;left:auto;right:0}.el-table__fixed-right .el-table__fixed-body-wrapper,.el-table__fixed-right .el-table__fixed-footer-wrapper,.el-table__fixed-right .el-table__fixed-header-wrapper{left:auto;right:0}.el-table__fixed-header-wrapper{position:absolute;left:0;top:0;z-index:3}.el-table__fixed-footer-wrapper{position:absolute;left:0;bottom:0;z-index:3}.el-table__fixed-footer-wrapper tbody td.el-table__cell{border-top:1px solid #ebeef5;background-color:#f5f7fa;color:#606266}.el-table__fixed-body-wrapper{position:absolute;left:0;top:37px;overflow:hidden;z-index:3}.el-table__body-wrapper,.el-table__footer-wrapper,.el-table__header-wrapper{width:100%}.el-table__footer-wrapper{margin-top:-1px}.el-table__footer-wrapper td.el-table__cell{border-top:1px solid #ebeef5}.el-table__body,.el-table__footer,.el-table__header{table-layout:fixed;border-collapse:separate}.el-table__footer-wrapper,.el-table__header-wrapper{overflow:hidden}.el-table__footer-wrapper tbody td.el-table__cell,.el-table__header-wrapper tbody td.el-table__cell{background-color:#f5f7fa;color:#606266}.el-table__body-wrapper{overflow:hidden;position:relative}.el-table__body-wrapper.is-scrolling-left~.el-table__fixed,.el-table__body-wrapper.is-scrolling-none~.el-table__fixed,.el-table__body-wrapper.is-scrolling-none~.el-table__fixed-right,.el-table__body-wrapper.is-scrolling-right~.el-table__fixed-right{box-shadow:none}.el-table__body-wrapper .el-table--border.is-scrolling-right~.el-table__fixed-right{border-left:1px solid #ebeef5}.el-table .caret-wrapper{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:34px;width:24px;vertical-align:middle;cursor:pointer;overflow:initial;position:relative}.el-table .sort-caret{width:0;height:0;border:5px solid transparent;position:absolute;left:7px}.el-table .sort-caret.ascending{border-bottom-color:#c0c4cc;top:5px}.el-table .sort-caret.descending{border-top-color:#c0c4cc;bottom:7px}.el-table .ascending .sort-caret.ascending{border-bottom-color:#409eff}.el-table .descending .sort-caret.descending{border-top-color:#409eff}.el-table .hidden-columns{visibility:hidden;position:absolute;z-index:-1}.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{background:#fafafa}.el-table--striped .el-table__body tr.el-table__row--striped.current-row td.el-table__cell{background-color:#ecf5ff}.el-table__body tr.hover-row.current-row>td.el-table__cell,.el-table__body tr.hover-row.el-table__row--striped.current-row>td.el-table__cell,.el-table__body tr.hover-row.el-table__row--striped>td.el-table__cell,.el-table__body tr.hover-row>td.el-table__cell{background-color:#f5f7fa}.el-table__body tr.current-row>td.el-table__cell{background-color:#ecf5ff}.el-table__column-resize-proxy{position:absolute;left:200px;top:0;bottom:0;width:0;border-left:1px solid #ebeef5;z-index:10}.el-table__column-filter-trigger{display:inline-block;line-height:34px;cursor:pointer}.el-table__column-filter-trigger i{color:#909399;font-size:12px;-webkit-transform:scale(.75);transform:scale(.75)}.el-table--enable-row-transition .el-table__body td.el-table__cell{transition:background-color .25s ease}.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{background-color:#f5f7fa}.el-table--fluid-height .el-table__fixed,.el-table--fluid-height .el-table__fixed-right{bottom:0;overflow:hidden}.el-table [class*=el-table__row--level] .el-table__expand-icon{display:inline-block;width:20px;line-height:20px;height:20px;text-align:center;margin-right:3px}.el-table-column--selection .cell{padding-left:14px;padding-right:14px}.el-table-filter{border:1px solid #ebeef5;border-radius:2px;background-color:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);box-sizing:border-box;margin:2px 0}.el-table-filter__list{padding:5px 0;margin:0;list-style:none;min-width:100px}.el-table-filter__list-item{line-height:36px;padding:0 10px;cursor:pointer;font-size:14px}.el-table-filter__list-item:hover{background-color:#ecf5ff;color:#66b1ff}.el-table-filter__list-item.is-active{background-color:#409eff;color:#fff}.el-table-filter__content{min-width:100px}.el-table-filter__bottom{border-top:1px solid #ebeef5;padding:8px}.el-table-filter__bottom button{background:0 0;border:none;color:#606266;cursor:pointer;font-size:13px;padding:0 3px}.el-date-table.is-week-mode .el-date-table__row.current div,.el-date-table.is-week-mode .el-date-table__row:hover div,.el-date-table td.in-range div,.el-date-table td.in-range div:hover{background-color:#f2f6fc}.el-table-filter__bottom button:hover{color:#409eff}.el-table-filter__bottom button:focus{outline:0}.el-table-filter__bottom button.is-disabled{color:#c0c4cc;cursor:not-allowed}.el-table-filter__wrap{max-height:280px}.el-table-filter__checkbox-group{padding:10px}.el-table-filter__checkbox-group label.el-checkbox{display:block;margin-right:5px;margin-bottom:8px;margin-left:5px}.el-table-filter__checkbox-group .el-checkbox:last-child{margin-bottom:0}.el-date-table{font-size:12px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-date-table.is-week-mode .el-date-table__row:hover td.available:hover{color:#606266}.el-date-table.is-week-mode .el-date-table__row:hover td:first-child div{margin-left:5px;border-top-left-radius:15px;border-bottom-left-radius:15px}.el-date-table.is-week-mode .el-date-table__row:hover td:last-child div{margin-right:5px;border-top-right-radius:15px;border-bottom-right-radius:15px}.el-date-table td{width:32px;height:30px;padding:4px 0;box-sizing:border-box;text-align:center;cursor:pointer;position:relative}.el-date-table td div{height:30px;padding:3px 0;box-sizing:border-box}.el-date-table td span{width:24px;height:24px;display:block;margin:0 auto;line-height:24px;position:absolute;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-radius:50%}.el-date-table td.next-month,.el-date-table td.prev-month{color:#c0c4cc}.el-date-table td.today{position:relative}.el-date-table td.today span{color:#409eff;font-weight:700}.el-date-table td.today.end-date span,.el-date-table td.today.start-date span{color:#fff}.el-date-table td.available:hover{color:#409eff}.el-date-table td.current:not(.disabled) span{color:#fff;background-color:#409eff}.el-date-table td.end-date div,.el-date-table td.start-date div{color:#fff}.el-date-table td.end-date span,.el-date-table td.start-date span{background-color:#409eff}.el-date-table td.start-date div{margin-left:5px;border-top-left-radius:15px;border-bottom-left-radius:15px}.el-date-table td.end-date div{margin-right:5px;border-top-right-radius:15px;border-bottom-right-radius:15px}.el-date-table td.disabled div{background-color:#f5f7fa;opacity:1;cursor:not-allowed;color:#c0c4cc}.el-date-table td.selected div{margin-left:5px;margin-right:5px;background-color:#f2f6fc;border-radius:15px}.el-date-table td.selected div:hover{background-color:#f2f6fc}.el-date-table td.selected span{background-color:#409eff;color:#fff;border-radius:15px}.el-date-table td.week{font-size:80%;color:#606266}.el-month-table,.el-year-table{font-size:12px;border-collapse:collapse}.el-date-table th{padding:5px;color:#606266;font-weight:400;border-bottom:1px solid #ebeef5}.el-month-table{margin:-1px}.el-month-table td{text-align:center;padding:8px 0;cursor:pointer}.el-month-table td div{height:48px;padding:6px 0;box-sizing:border-box}.el-month-table td.today .cell{color:#409eff;font-weight:700}.el-month-table td.today.end-date .cell,.el-month-table td.today.start-date .cell{color:#fff}.el-month-table td.disabled .cell{background-color:#f5f7fa;cursor:not-allowed;color:#c0c4cc}.el-month-table td.disabled .cell:hover{color:#c0c4cc}.el-month-table td .cell{width:60px;height:36px;display:block;line-height:36px;color:#606266;margin:0 auto;border-radius:18px}.el-month-table td .cell:hover{color:#409eff}.el-month-table td.in-range div,.el-month-table td.in-range div:hover{background-color:#f2f6fc}.el-month-table td.end-date div,.el-month-table td.start-date div{color:#fff}.el-month-table td.end-date .cell,.el-month-table td.start-date .cell{color:#fff;background-color:#409eff}.el-month-table td.start-date div{border-top-left-radius:24px;border-bottom-left-radius:24px}.el-month-table td.end-date div{border-top-right-radius:24px;border-bottom-right-radius:24px}.el-month-table td.current:not(.disabled) .cell{color:#409eff}.el-year-table{margin:-1px}.el-year-table .el-icon{color:#303133}.el-year-table td{text-align:center;padding:20px 3px;cursor:pointer}.el-year-table td.today .cell{color:#409eff;font-weight:700}.el-year-table td.disabled .cell{background-color:#f5f7fa;cursor:not-allowed;color:#c0c4cc}.el-year-table td.disabled .cell:hover{color:#c0c4cc}.el-year-table td .cell{width:48px;height:32px;display:block;line-height:32px;color:#606266;margin:0 auto}.el-year-table td .cell:hover,.el-year-table td.current:not(.disabled) .cell{color:#409eff}.el-date-range-picker{width:646px}.el-date-range-picker.has-sidebar{width:756px}.el-date-range-picker table{table-layout:fixed;width:100%}.el-date-range-picker .el-picker-panel__body{min-width:513px}.el-date-range-picker .el-picker-panel__content{margin:0}.el-date-range-picker__header{position:relative;text-align:center;height:28px}.el-date-range-picker__header [class*=arrow-left]{float:left}.el-date-range-picker__header [class*=arrow-right]{float:right}.el-date-range-picker__header div{font-size:16px;font-weight:500;margin-right:50px}.el-date-range-picker__content{float:left;width:50%;box-sizing:border-box;margin:0;padding:16px}.el-date-range-picker__content.is-left{border-right:1px solid #e4e4e4}.el-date-range-picker__content .el-date-range-picker__header div{margin-left:50px;margin-right:50px}.el-date-range-picker__editors-wrap{box-sizing:border-box;display:table-cell}.el-date-range-picker__editors-wrap.is-right{text-align:right}.el-date-range-picker__time-header{position:relative;border-bottom:1px solid #e4e4e4;font-size:12px;padding:8px 5px 5px;display:table;width:100%;box-sizing:border-box}.el-date-range-picker__time-header>.el-icon-arrow-right{font-size:20px;vertical-align:middle;display:table-cell;color:#303133}.el-date-range-picker__time-picker-wrap{position:relative;display:table-cell;padding:0 5px}.el-date-range-picker__time-picker-wrap .el-picker-panel{position:absolute;top:13px;right:0;z-index:1;background:#fff}.el-date-picker{width:322px}.el-date-picker.has-sidebar.has-time{width:434px}.el-date-picker.has-sidebar{width:438px}.el-date-picker.has-time .el-picker-panel__body-wrapper{position:relative}.el-date-picker .el-picker-panel__content{width:292px}.el-date-picker table{table-layout:fixed;width:100%}.el-date-picker__editor-wrap{position:relative;display:table-cell;padding:0 5px}.el-date-picker__time-header{position:relative;border-bottom:1px solid #e4e4e4;font-size:12px;padding:8px 5px 5px;display:table;width:100%;box-sizing:border-box}.el-date-picker__header{margin:12px;text-align:center}.el-date-picker__header--bordered{margin-bottom:0;padding-bottom:12px;border-bottom:1px solid #ebeef5}.el-date-picker__header--bordered+.el-picker-panel__content{margin-top:0}.el-date-picker__header-label{font-size:16px;font-weight:500;padding:0 5px;line-height:22px;text-align:center;cursor:pointer;color:#606266}.el-date-picker__header-label.active,.el-date-picker__header-label:hover{color:#409eff}.el-date-picker__prev-btn{float:left}.el-date-picker__next-btn{float:right}.el-date-picker__time-wrap{padding:10px;text-align:center}.el-date-picker__time-label{float:left;cursor:pointer;line-height:30px;margin-left:10px}.time-select{margin:5px 0;min-width:0}.time-select .el-picker-panel__content{max-height:200px;margin:0}.time-select-item{padding:8px 10px;font-size:14px;line-height:20px}.time-select-item.selected:not(.disabled){color:#409eff;font-weight:700}.time-select-item.disabled{color:#e4e7ed;cursor:not-allowed}.time-select-item:hover{background-color:#f5f7fa;font-weight:700;cursor:pointer}.el-date-editor{position:relative;display:inline-block;text-align:left}.el-date-editor.el-input,.el-date-editor.el-input__inner{width:220px}.el-date-editor--monthrange.el-input,.el-date-editor--monthrange.el-input__inner{width:300px}.el-date-editor--daterange.el-input,.el-date-editor--daterange.el-input__inner,.el-date-editor--timerange.el-input,.el-date-editor--timerange.el-input__inner{width:350px}.el-date-editor--datetimerange.el-input,.el-date-editor--datetimerange.el-input__inner{width:400px}.el-date-editor--dates .el-input__inner{text-overflow:ellipsis;white-space:nowrap}.el-date-editor .el-icon-circle-close{cursor:pointer}.el-date-editor .el-range__icon{font-size:14px;margin-left:-5px;color:#c0c4cc;float:left;line-height:32px}.el-date-editor .el-range-input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:none;outline:0;display:inline-block;height:100%;margin:0;padding:0;width:39%;text-align:center;font-size:14px;color:#606266}.el-date-editor .el-range-input::-ms-input-placeholder{color:#c0c4cc}.el-date-editor .el-range-input::-webkit-input-placeholder{color:#c0c4cc}.el-date-editor .el-range-input:-ms-input-placeholder{color:#c0c4cc}.el-date-editor .el-range-input::placeholder{color:#c0c4cc}.el-date-editor .el-range-separator{display:inline-block;height:100%;padding:0 5px;margin:0;text-align:center;line-height:32px;font-size:14px;width:5%;color:#303133}.el-date-editor .el-range__close-icon{font-size:14px;color:#c0c4cc;width:25px;display:inline-block;float:right;line-height:32px}.el-range-editor.el-input__inner{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:3px 10px}.el-range-editor .el-range-input{line-height:1}.el-range-editor--medium.el-input__inner{height:36px}.el-range-editor--medium .el-range-separator{line-height:28px;font-size:14px}.el-range-editor--medium .el-range-input{font-size:14px}.el-range-editor--medium .el-range__close-icon,.el-range-editor--medium .el-range__icon{line-height:28px}.el-range-editor--small.el-input__inner{height:32px}.el-range-editor--small .el-range-separator{line-height:24px;font-size:13px}.el-range-editor--small .el-range-input{font-size:13px}.el-range-editor--small .el-range__close-icon,.el-range-editor--small .el-range__icon{line-height:24px}.el-range-editor--mini.el-input__inner{height:28px}.el-range-editor--mini .el-range-separator{line-height:20px;font-size:12px}.el-range-editor--mini .el-range-input{font-size:12px}.el-range-editor--mini .el-range__close-icon,.el-range-editor--mini .el-range__icon{line-height:20px}.el-range-editor.is-disabled{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc;cursor:not-allowed}.el-range-editor.is-disabled:focus,.el-range-editor.is-disabled:hover{border-color:#e4e7ed}.el-range-editor.is-disabled input{background-color:#f5f7fa;color:#c0c4cc;cursor:not-allowed}.el-range-editor.is-disabled input::-ms-input-placeholder{color:#c0c4cc}.el-range-editor.is-disabled input::-webkit-input-placeholder{color:#c0c4cc}.el-range-editor.is-disabled input:-ms-input-placeholder{color:#c0c4cc}.el-range-editor.is-disabled input::placeholder{color:#c0c4cc}.el-range-editor.is-disabled .el-range-separator{color:#c0c4cc}.el-picker-panel{color:#606266;border:1px solid #e4e7ed;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);background:#fff;border-radius:4px;line-height:30px;margin:5px 0}.el-picker-panel__body-wrapper:after,.el-picker-panel__body:after{content:\"\";display:table;clear:both}.el-picker-panel__content{position:relative;margin:15px}.el-picker-panel__footer{border-top:1px solid #e4e4e4;padding:4px;text-align:right;background-color:#fff;position:relative;font-size:0}.el-picker-panel__shortcut{display:block;width:100%;border:0;background-color:transparent;line-height:28px;font-size:14px;color:#606266;padding-left:12px;text-align:left;outline:0;cursor:pointer}.el-picker-panel__shortcut:hover{color:#409eff}.el-picker-panel__shortcut.active{background-color:#e6f1fe;color:#409eff}.el-picker-panel__btn{border:1px solid #dcdcdc;color:#333;line-height:24px;border-radius:2px;padding:0 20px;cursor:pointer;background-color:transparent;outline:0;font-size:12px}.el-picker-panel__btn[disabled]{color:#ccc;cursor:not-allowed}.el-picker-panel__icon-btn{font-size:12px;color:#303133;border:0;background:0 0;cursor:pointer;outline:0;margin-top:8px}.el-picker-panel__icon-btn:hover{color:#409eff}.el-picker-panel__icon-btn.is-disabled{color:#bbb}.el-picker-panel__icon-btn.is-disabled:hover{cursor:not-allowed}.el-picker-panel__link-btn{vertical-align:middle}.el-picker-panel [slot=sidebar],.el-picker-panel__sidebar{position:absolute;top:0;bottom:0;width:110px;border-right:1px solid #e4e4e4;box-sizing:border-box;padding-top:6px;background-color:#fff;overflow:auto}.el-picker-panel [slot=sidebar]+.el-picker-panel__body,.el-picker-panel__sidebar+.el-picker-panel__body{margin-left:110px}.el-time-spinner.has-seconds .el-time-spinner__wrapper{width:33.3%}.el-time-spinner__wrapper{max-height:190px;overflow:auto;display:inline-block;width:50%;vertical-align:top;position:relative}.el-time-spinner__wrapper .el-scrollbar__wrap:not(.el-scrollbar__wrap--hidden-default){padding-bottom:15px}.el-time-spinner__input.el-input .el-input__inner,.el-time-spinner__list{padding:0;text-align:center}.el-time-spinner__wrapper.is-arrow{box-sizing:border-box;text-align:center;overflow:hidden}.el-time-spinner__wrapper.is-arrow .el-time-spinner__list{-webkit-transform:translateY(-32px);transform:translateY(-32px)}.el-time-spinner__wrapper.is-arrow .el-time-spinner__item:hover:not(.disabled):not(.active){background:#fff;cursor:default}.el-time-spinner__arrow{font-size:12px;color:#909399;position:absolute;left:0;width:100%;z-index:1;text-align:center;height:30px;line-height:30px;cursor:pointer}.el-time-spinner__arrow:hover{color:#409eff}.el-time-spinner__arrow.el-icon-arrow-up{top:10px}.el-time-spinner__arrow.el-icon-arrow-down{bottom:10px}.el-time-spinner__input.el-input{width:70%}.el-time-spinner__list{margin:0;list-style:none}.el-time-spinner__list:after,.el-time-spinner__list:before{content:\"\";display:block;width:100%;height:80px}.el-time-spinner__item{height:32px;line-height:32px;font-size:12px;color:#606266}.el-time-spinner__item:hover:not(.disabled):not(.active){background:#f5f7fa;cursor:pointer}.el-time-spinner__item.active:not(.disabled){color:#303133;font-weight:700}.el-time-spinner__item.disabled{color:#c0c4cc;cursor:not-allowed}.el-time-panel{margin:5px 0;border:1px solid #e4e7ed;background-color:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);border-radius:2px;position:absolute;width:180px;left:0;z-index:1000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:content-box}.el-time-panel__content{font-size:0;position:relative;overflow:hidden}.el-time-panel__content:after,.el-time-panel__content:before{content:\"\";top:50%;position:absolute;margin-top:-15px;height:32px;z-index:-1;left:0;right:0;box-sizing:border-box;padding-top:6px;text-align:left;border-top:1px solid #e4e7ed;border-bottom:1px solid #e4e7ed}.el-time-panel__content:after{left:50%;margin-left:12%;margin-right:12%}.el-time-panel__content:before{padding-left:50%;margin-right:12%;margin-left:12%}.el-time-panel__content.has-seconds:after{left:66.66667%}.el-time-panel__content.has-seconds:before{padding-left:33.33333%}.el-time-panel__footer{border-top:1px solid #e4e4e4;padding:4px;height:36px;line-height:25px;text-align:right;box-sizing:border-box}.el-time-panel__btn{border:none;line-height:28px;padding:0 5px;margin:0 5px;cursor:pointer;background-color:transparent;outline:0;font-size:12px;color:#303133}.el-time-panel__btn.confirm{font-weight:800;color:#409eff}.el-time-range-picker{width:354px;overflow:visible}.el-time-range-picker__content{position:relative;text-align:center;padding:10px}.el-time-range-picker__cell{box-sizing:border-box;margin:0;padding:4px 7px 7px;width:50%;display:inline-block}.el-time-range-picker__header{margin-bottom:5px;text-align:center;font-size:14px}.el-time-range-picker__body{border-radius:2px;border:1px solid #e4e7ed}.el-popover{position:absolute;background:#fff;min-width:150px;border-radius:4px;border:1px solid #ebeef5;padding:12px;z-index:2000;color:#606266;line-height:1.4;text-align:justify;font-size:14px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);word-break:break-all}.el-card.is-always-shadow,.el-card.is-hover-shadow:focus,.el-card.is-hover-shadow:hover,.el-cascader__dropdown,.el-color-picker__panel,.el-message-box,.el-notification{-webkit-box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-popover--plain{padding:18px 20px}.el-popover__title{color:#303133;font-size:16px;line-height:1;margin-bottom:12px}.el-popover:focus,.el-popover:focus:active,.el-popover__reference:focus:hover,.el-popover__reference:focus:not(.focusing){outline-width:0}.v-modal-enter{-webkit-animation:v-modal-in .2s ease;animation:v-modal-in .2s ease}.v-modal-leave{-webkit-animation:v-modal-out .2s ease forwards;animation:v-modal-out .2s ease forwards}@keyframes v-modal-in{0%{opacity:0}}@keyframes v-modal-out{to{opacity:0}}.v-modal{position:fixed;left:0;top:0;width:100%;height:100%;opacity:.5;background:#000}.el-popup-parent--hidden{overflow:hidden}.el-message-box{display:inline-block;width:420px;padding-bottom:10px;vertical-align:middle;background-color:#fff;border-radius:4px;border:1px solid #ebeef5;font-size:18px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);text-align:left;overflow:hidden;-webkit-backface-visibility:hidden;backface-visibility:hidden}.el-message-box__wrapper{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center}.el-message-box__wrapper:after{content:\"\";display:inline-block;height:100%;width:0;vertical-align:middle}.el-message-box__header{position:relative;padding:15px 15px 10px}.el-message-box__title{padding-left:0;margin-bottom:0;font-size:18px;line-height:1;color:#303133}.el-message-box__headerbtn{position:absolute;top:15px;right:15px;padding:0;border:none;outline:0;background:0 0;font-size:16px;cursor:pointer}.el-form-item.is-error .el-input__inner,.el-form-item.is-error .el-input__inner:focus,.el-form-item.is-error .el-textarea__inner,.el-form-item.is-error .el-textarea__inner:focus,.el-message-box__input input.invalid,.el-message-box__input input.invalid:focus{border-color:#f56c6c}.el-message-box__headerbtn .el-message-box__close{color:#909399}.el-message-box__headerbtn:focus .el-message-box__close,.el-message-box__headerbtn:hover .el-message-box__close{color:#409eff}.el-message-box__content{padding:10px 15px;color:#606266;font-size:14px}.el-message-box__container{position:relative}.el-message-box__input{padding-top:15px}.el-message-box__status{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:24px!important}.el-message-box__status:before{padding-left:1px}.el-message-box__status+.el-message-box__message{padding-left:36px;padding-right:12px}.el-message-box__status.el-icon-success{color:#67c23a}.el-message-box__status.el-icon-info{color:#909399}.el-message-box__status.el-icon-warning{color:#e6a23c}.el-message-box__status.el-icon-error{color:#f56c6c}.el-message-box__message{margin:0}.el-message-box__message p{margin:0;line-height:24px}.el-message-box__errormsg{color:#f56c6c;font-size:12px;min-height:18px;margin-top:2px}.el-message-box__btns{padding:5px 15px 0;text-align:right}.el-message-box__btns button:nth-child(2){margin-left:10px}.el-message-box__btns-reverse{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.el-message-box--center{padding-bottom:30px}.el-message-box--center .el-message-box__header{padding-top:30px}.el-message-box--center .el-message-box__title{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-message-box--center .el-message-box__status{position:relative;top:auto;padding-right:5px;text-align:center;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.el-message-box--center .el-message-box__message{margin-left:0}.el-message-box--center .el-message-box__btns,.el-message-box--center .el-message-box__content{text-align:center}.el-message-box--center .el-message-box__content{padding-left:27px;padding-right:27px}.msgbox-fade-enter-active{-webkit-animation:msgbox-fade-in .3s;animation:msgbox-fade-in .3s}.msgbox-fade-leave-active{-webkit-animation:msgbox-fade-out .3s;animation:msgbox-fade-out .3s}@-webkit-keyframes msgbox-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes msgbox-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@-webkit-keyframes msgbox-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}@keyframes msgbox-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}.el-breadcrumb{font-size:14px;line-height:1}.el-breadcrumb:after,.el-breadcrumb:before{display:table;content:\"\"}.el-breadcrumb:after{clear:both}.el-breadcrumb__separator{margin:0 9px;font-weight:700;color:#c0c4cc}.el-breadcrumb__separator[class*=icon]{margin:0 6px;font-weight:400}.el-breadcrumb__item{float:left}.el-breadcrumb__inner{color:#606266}.el-breadcrumb__inner.is-link,.el-breadcrumb__inner a{font-weight:700;text-decoration:none;transition:color .2s cubic-bezier(.645,.045,.355,1);color:#303133}.el-breadcrumb__inner.is-link:hover,.el-breadcrumb__inner a:hover{color:#409eff;cursor:pointer}.el-breadcrumb__item:last-child .el-breadcrumb__inner,.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,.el-breadcrumb__item:last-child .el-breadcrumb__inner a,.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover{font-weight:400;color:#606266;cursor:text}.el-form--label-left .el-form-item__label{text-align:left}.el-form--label-top .el-form-item__label{float:none;display:inline-block;text-align:left;padding:0 0 10px}.el-form--inline .el-form-item{display:inline-block;margin-right:10px;vertical-align:top}.el-form--inline .el-form-item__label{float:none;display:inline-block}.el-form--inline .el-form-item__content{display:inline-block;vertical-align:top}.el-form--inline.el-form--label-top .el-form-item__content{display:block}.el-form-item{margin-bottom:22px}.el-form-item:after,.el-form-item:before{display:table;content:\"\"}.el-form-item:after{clear:both}.el-form-item .el-form-item{margin-bottom:0}.el-form-item--mini.el-form-item,.el-form-item--small.el-form-item{margin-bottom:18px}.el-form-item .el-input__validateIcon{display:none}.el-form-item--medium .el-form-item__content,.el-form-item--medium .el-form-item__label{line-height:36px}.el-form-item--small .el-form-item__content,.el-form-item--small .el-form-item__label{line-height:32px}.el-form-item--small .el-form-item__error{padding-top:2px}.el-form-item--mini .el-form-item__content,.el-form-item--mini .el-form-item__label{line-height:28px}.el-form-item--mini .el-form-item__error{padding-top:1px}.el-form-item__label-wrap{float:left}.el-form-item__label-wrap .el-form-item__label{display:inline-block;float:none}.el-form-item__label{text-align:right;vertical-align:middle;float:left;font-size:14px;color:#606266;line-height:40px;padding:0 12px 0 0;box-sizing:border-box}.el-form-item__content{line-height:40px;position:relative;font-size:14px}.el-form-item__content:after,.el-form-item__content:before{display:table;content:\"\"}.el-form-item__content:after{clear:both}.el-form-item__content .el-input-group{vertical-align:top}.el-form-item__error{color:#f56c6c;font-size:12px;line-height:1;padding-top:4px;position:absolute;top:100%;left:0}.el-form-item__error--inline{position:relative;top:auto;left:auto;display:inline-block;margin-left:10px}.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{content:\"*\";color:#f56c6c;margin-right:4px}.el-form-item.is-error .el-input-group__append .el-input__inner,.el-form-item.is-error .el-input-group__prepend .el-input__inner{border-color:transparent}.el-form-item.is-error .el-input__validateIcon{color:#f56c6c}.el-form-item--feedback .el-input__validateIcon{display:inline-block}.el-tabs__header{padding:0;position:relative;margin:0 0 15px}.el-tabs__active-bar{position:absolute;bottom:0;left:0;height:2px;background-color:#409eff;z-index:1;transition:-webkit-transform .3s cubic-bezier(.645,.045,.355,1);transition:transform .3s cubic-bezier(.645,.045,.355,1);transition:transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);list-style:none}.el-tabs__new-tab{float:right;border:1px solid #d3dce6;height:18px;width:18px;line-height:18px;margin:12px 0 9px 10px;border-radius:3px;text-align:center;font-size:12px;color:#d3dce6;cursor:pointer;transition:all .15s}.el-tabs__new-tab .el-icon-plus{-webkit-transform:scale(.8);transform:scale(.8)}.el-tabs__new-tab:hover{color:#409eff}.el-tabs__nav-wrap{overflow:hidden;margin-bottom:-1px;position:relative}.el-tabs__nav-wrap:after{content:\"\";position:absolute;left:0;bottom:0;width:100%;height:2px;background-color:#e4e7ed;z-index:1}.el-tabs__nav-wrap.is-scrollable{padding:0 20px;box-sizing:border-box}.el-tabs__nav-scroll{overflow:hidden}.el-tabs__nav-next,.el-tabs__nav-prev{position:absolute;cursor:pointer;line-height:44px;font-size:12px;color:#909399}.el-tabs__nav-next{right:0}.el-tabs__nav-prev{left:0}.el-tabs__nav{white-space:nowrap;position:relative;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;float:left;z-index:2}.el-tabs__nav.is-stretch{min-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.el-tabs__nav.is-stretch>*{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:center}.el-tabs__item{padding:0 20px;height:40px;box-sizing:border-box;line-height:40px;display:inline-block;list-style:none;font-size:14px;font-weight:500;color:#303133;position:relative}.el-tabs__item:focus,.el-tabs__item:focus:active{outline:0}.el-tabs__item:focus.is-active.is-focus:not(:active){box-shadow:inset 0 0 2px 2px #409eff;border-radius:3px}.el-tabs__item .el-icon-close{border-radius:50%;text-align:center;transition:all .3s cubic-bezier(.645,.045,.355,1);margin-left:5px}.el-tabs__item .el-icon-close:before{-webkit-transform:scale(.9);transform:scale(.9);display:inline-block}.el-tabs--card>.el-tabs__header .el-tabs__active-bar,.el-tabs--left.el-tabs--card .el-tabs__active-bar.is-left,.el-tabs--right.el-tabs--card .el-tabs__active-bar.is-right{display:none}.el-tabs__item .el-icon-close:hover{background-color:#c0c4cc;color:#fff}.el-tabs__item.is-active{color:#409eff}.el-tabs__item:hover{color:#409eff;cursor:pointer}.el-tabs__item.is-disabled{color:#c0c4cc;cursor:default}.el-tabs__content{overflow:hidden;position:relative}.el-tabs--card>.el-tabs__header{border-bottom:1px solid #e4e7ed}.el-tabs--card>.el-tabs__header .el-tabs__nav-wrap:after{content:none}.el-tabs--card>.el-tabs__header .el-tabs__nav{border:1px solid #e4e7ed;border-bottom:none;border-radius:4px 4px 0 0;box-sizing:border-box}.el-tabs--card>.el-tabs__header .el-tabs__item .el-icon-close{position:relative;font-size:12px;width:0;height:14px;vertical-align:middle;line-height:15px;overflow:hidden;top:-1px;right:-2px;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.el-tabs--card>.el-tabs__header .el-tabs__item{border-bottom:1px solid transparent;border-left:1px solid #e4e7ed;transition:color .3s cubic-bezier(.645,.045,.355,1),padding .3s cubic-bezier(.645,.045,.355,1)}.el-tabs--card>.el-tabs__header .el-tabs__item:first-child{border-left:none}.el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover{padding-left:13px;padding-right:13px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-closable:hover .el-icon-close{width:14px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active{border-bottom-color:#fff}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable{padding-left:20px;padding-right:20px}.el-tabs--card>.el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close{width:14px}.el-tabs--border-card{background:#fff;border:1px solid #dcdfe6;box-shadow:0 2px 4px 0 rgba(0,0,0,.12),0 0 6px 0 rgba(0,0,0,.04)}.el-tabs--border-card>.el-tabs__content{padding:15px}.el-tabs--border-card>.el-tabs__header{background-color:#f5f7fa;border-bottom:1px solid #e4e7ed;margin:0}.el-tabs--border-card>.el-tabs__header .el-tabs__nav-wrap:after{content:none}.el-tabs--border-card>.el-tabs__header .el-tabs__item{transition:all .3s cubic-bezier(.645,.045,.355,1);border:1px solid transparent;margin-top:-1px;color:#909399}.el-tabs--border-card>.el-tabs__header .el-tabs__item+.el-tabs__item,.el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child{margin-left:-1px}.el-col-offset-0,.el-tabs--border-card>.el-tabs__header .is-scrollable .el-tabs__item:first-child{margin-left:0}.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{color:#409eff;background-color:#fff;border-right-color:#dcdfe6;border-left-color:#dcdfe6}.el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover{color:#409eff}.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-disabled{color:#c0c4cc}.el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2),.el-tabs--bottom .el-tabs__item.is-top:nth-child(2),.el-tabs--top .el-tabs__item.is-bottom:nth-child(2),.el-tabs--top .el-tabs__item.is-top:nth-child(2){padding-left:0}.el-tabs--bottom .el-tabs__item.is-bottom:last-child,.el-tabs--bottom .el-tabs__item.is-top:last-child,.el-tabs--top .el-tabs__item.is-bottom:last-child,.el-tabs--top .el-tabs__item.is-top:last-child{padding-right:0}.el-cascader-menu:last-child .el-cascader-node,.el-tabs--bottom.el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child,.el-tabs--bottom.el-tabs--card>.el-tabs__header .el-tabs__item:last-child,.el-tabs--bottom .el-tabs--left>.el-tabs__header .el-tabs__item:last-child,.el-tabs--bottom .el-tabs--right>.el-tabs__header .el-tabs__item:last-child,.el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child,.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child,.el-tabs--top .el-tabs--left>.el-tabs__header .el-tabs__item:last-child,.el-tabs--top .el-tabs--right>.el-tabs__header .el-tabs__item:last-child{padding-right:20px}.el-tabs--bottom.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--bottom.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--bottom .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--bottom .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--top.el-tabs--border-card>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--top .el-tabs--left>.el-tabs__header .el-tabs__item:nth-child(2),.el-tabs--top .el-tabs--right>.el-tabs__header .el-tabs__item:nth-child(2){padding-left:20px}.el-tabs--bottom .el-tabs__header.is-bottom{margin-bottom:0;margin-top:10px}.el-tabs--bottom.el-tabs--border-card .el-tabs__header.is-bottom{border-bottom:0;border-top:1px solid #dcdfe6}.el-tabs--bottom.el-tabs--border-card .el-tabs__nav-wrap.is-bottom{margin-top:-1px;margin-bottom:0}.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom:not(.is-active){border:1px solid transparent}.el-tabs--bottom.el-tabs--border-card .el-tabs__item.is-bottom{margin:0 -1px -1px}.el-tabs--left,.el-tabs--right{overflow:hidden}.el-tabs--left .el-tabs__header.is-left,.el-tabs--left .el-tabs__header.is-right,.el-tabs--left .el-tabs__nav-scroll,.el-tabs--left .el-tabs__nav-wrap.is-left,.el-tabs--left .el-tabs__nav-wrap.is-right,.el-tabs--right .el-tabs__header.is-left,.el-tabs--right .el-tabs__header.is-right,.el-tabs--right .el-tabs__nav-scroll,.el-tabs--right .el-tabs__nav-wrap.is-left,.el-tabs--right .el-tabs__nav-wrap.is-right{height:100%}.el-tabs--left .el-tabs__active-bar.is-left,.el-tabs--left .el-tabs__active-bar.is-right,.el-tabs--right .el-tabs__active-bar.is-left,.el-tabs--right .el-tabs__active-bar.is-right{top:0;bottom:auto;width:2px;height:auto}.el-tabs--left .el-tabs__nav-wrap.is-left,.el-tabs--left .el-tabs__nav-wrap.is-right,.el-tabs--right .el-tabs__nav-wrap.is-left,.el-tabs--right .el-tabs__nav-wrap.is-right{margin-bottom:0}.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-next,.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-next,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-next,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-next,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev{height:30px;line-height:30px;width:100%;text-align:center;cursor:pointer}.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-next i,.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev i,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-next i,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev i,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-next i,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev i,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-next i,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev i{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-prev,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-prev{left:auto;top:0}.el-tabs--left .el-tabs__nav-wrap.is-left>.el-tabs__nav-next,.el-tabs--left .el-tabs__nav-wrap.is-right>.el-tabs__nav-next,.el-tabs--right .el-tabs__nav-wrap.is-left>.el-tabs__nav-next,.el-tabs--right .el-tabs__nav-wrap.is-right>.el-tabs__nav-next{right:auto;bottom:0}.el-tabs--left .el-tabs__active-bar.is-left,.el-tabs--left .el-tabs__nav-wrap.is-left:after{right:0;left:auto}.el-tabs--left .el-tabs__nav-wrap.is-left.is-scrollable,.el-tabs--left .el-tabs__nav-wrap.is-right.is-scrollable,.el-tabs--right .el-tabs__nav-wrap.is-left.is-scrollable,.el-tabs--right .el-tabs__nav-wrap.is-right.is-scrollable{padding:30px 0}.el-tabs--left .el-tabs__nav-wrap.is-left:after,.el-tabs--left .el-tabs__nav-wrap.is-right:after,.el-tabs--right .el-tabs__nav-wrap.is-left:after,.el-tabs--right .el-tabs__nav-wrap.is-right:after{height:100%;width:2px;bottom:auto;top:0}.el-tabs--left .el-tabs__nav.is-left,.el-tabs--left .el-tabs__nav.is-right,.el-tabs--right .el-tabs__nav.is-left,.el-tabs--right .el-tabs__nav.is-right{float:none}.el-tabs--left .el-tabs__item.is-left,.el-tabs--left .el-tabs__item.is-right,.el-tabs--right .el-tabs__item.is-left,.el-tabs--right .el-tabs__item.is-right{display:block}.el-tabs--left .el-tabs__header.is-left{float:left;margin-bottom:0;margin-right:10px}.el-button-group>.el-button:not(:last-child),.el-tabs--left .el-tabs__nav-wrap.is-left{margin-right:-1px}.el-tabs--left .el-tabs__item.is-left{text-align:right}.el-tabs--left.el-tabs--card .el-tabs__item.is-left{border-left:none;border-right:1px solid #e4e7ed;border-bottom:none;border-top:1px solid #e4e7ed;text-align:left}.el-tabs--left.el-tabs--card .el-tabs__item.is-left:first-child{border-right:1px solid #e4e7ed;border-top:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active{border:1px solid #e4e7ed;border-right-color:#fff;border-left:none;border-bottom:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:first-child{border-top:none}.el-tabs--left.el-tabs--card .el-tabs__item.is-left.is-active:last-child{border-bottom:none}.el-tabs--left.el-tabs--card .el-tabs__nav{border-radius:4px 0 0 4px;border-bottom:1px solid #e4e7ed;border-right:none}.el-tabs--left.el-tabs--card .el-tabs__new-tab{float:none}.el-tabs--left.el-tabs--border-card .el-tabs__header.is-left{border-right:1px solid #dfe4ed}.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left{border:1px solid transparent;margin:-1px 0 -1px -1px}.el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active{border-color:#d1dbe5 transparent}.el-tabs--right .el-tabs__header.is-right{float:right;margin-bottom:0;margin-left:10px}.el-tabs--right .el-tabs__nav-wrap.is-right{margin-left:-1px}.el-tabs--right .el-tabs__nav-wrap.is-right:after{left:0;right:auto}.el-tabs--right .el-tabs__active-bar.is-right{left:0}.el-tabs--right.el-tabs--card .el-tabs__item.is-right{border-bottom:none;border-top:1px solid #e4e7ed}.el-tabs--right.el-tabs--card .el-tabs__item.is-right:first-child{border-left:1px solid #e4e7ed;border-top:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active{border:1px solid #e4e7ed;border-left-color:#fff;border-right:none;border-bottom:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:first-child{border-top:none}.el-tabs--right.el-tabs--card .el-tabs__item.is-right.is-active:last-child{border-bottom:none}.el-tabs--right.el-tabs--card .el-tabs__nav{border-radius:0 4px 4px 0;border-bottom:1px solid #e4e7ed;border-left:none}.el-tabs--right.el-tabs--border-card .el-tabs__header.is-right{border-left:1px solid #dfe4ed}.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right{border:1px solid transparent;margin:-1px -1px -1px 0}.el-tabs--right.el-tabs--border-card .el-tabs__item.is-right.is-active{border-color:#d1dbe5 transparent}.slideInLeft-transition,.slideInRight-transition{display:inline-block}.slideInRight-enter{-webkit-animation:slideInRight-enter .3s;animation:slideInRight-enter .3s}.slideInRight-leave{position:absolute;left:0;right:0;-webkit-animation:slideInRight-leave .3s;animation:slideInRight-leave .3s}.slideInLeft-enter{-webkit-animation:slideInLeft-enter .3s;animation:slideInLeft-enter .3s}.slideInLeft-leave{position:absolute;left:0;right:0;-webkit-animation:slideInLeft-leave .3s;animation:slideInLeft-leave .3s}@-webkit-keyframes slideInRight-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInRight-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInRight-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0}}@keyframes slideInRight-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0}}@-webkit-keyframes slideInLeft-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes slideInLeft-enter{0%{opacity:0;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}to{opacity:1;-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0)}}@-webkit-keyframes slideInLeft-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%);opacity:0}}@keyframes slideInLeft-leave{0%{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(0);transform:translateX(0);opacity:1}to{-webkit-transform-origin:0 0;transform-origin:0 0;-webkit-transform:translateX(-100%);transform:translateX(-100%);opacity:0}}.el-tree{position:relative;cursor:default;background:#fff;color:#606266}.el-tree__empty-block{position:relative;min-height:60px;text-align:center;width:100%;height:100%}.el-tree__empty-text{position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);color:#909399;font-size:14px}.el-tree__drop-indicator{position:absolute;left:0;right:0;height:1px;background-color:#409eff}.el-tree-node{white-space:nowrap;outline:0}.el-tree-node:focus>.el-tree-node__content{background-color:#f5f7fa}.el-tree-node.is-drop-inner>.el-tree-node__content .el-tree-node__label{background-color:#409eff;color:#fff}.el-tree-node__content:hover,.el-upload-list__item:hover{background-color:#f5f7fa}.el-tree-node__content{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:26px;cursor:pointer}.el-tree-node__content>.el-tree-node__expand-icon{padding:6px}.el-tree-node__content>label.el-checkbox{margin-right:8px}.el-tree.is-dragging .el-tree-node__content{cursor:move}.el-tree.is-dragging .el-tree-node__content *{pointer-events:none}.el-tree.is-dragging.is-drop-not-allow .el-tree-node__content{cursor:not-allowed}.el-tree-node__expand-icon{cursor:pointer;color:#c0c4cc;font-size:12px;-webkit-transform:rotate(0);transform:rotate(0);transition:-webkit-transform .3s ease-in-out;transition:transform .3s ease-in-out;transition:transform .3s ease-in-out,-webkit-transform .3s ease-in-out}.el-tree-node__expand-icon.expanded{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-tree-node__expand-icon.is-leaf{color:transparent;cursor:default}.el-tree-node__label{font-size:14px}.el-tree-node__loading-icon{margin-right:8px;font-size:14px;color:#c0c4cc}.el-tree-node>.el-tree-node__children{overflow:hidden;background-color:transparent}.el-tree-node.is-expanded>.el-tree-node__children{display:block}.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{background-color:#f0f7ff}.el-alert{width:100%;padding:8px 16px;margin:0;box-sizing:border-box;border-radius:4px;position:relative;background-color:#fff;overflow:hidden;opacity:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;transition:opacity .2s}.el-alert.is-light .el-alert__closebtn{color:#c0c4cc}.el-alert.is-dark .el-alert__closebtn,.el-alert.is-dark .el-alert__description{color:#fff}.el-alert.is-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-alert--success.is-light{background-color:#f0f9eb;color:#67c23a}.el-alert--success.is-light .el-alert__description{color:#67c23a}.el-alert--success.is-dark{background-color:#67c23a;color:#fff}.el-alert--info.is-light{background-color:#f4f4f5;color:#909399}.el-alert--info.is-dark{background-color:#909399;color:#fff}.el-alert--info .el-alert__description{color:#909399}.el-alert--warning.is-light{background-color:#fdf6ec;color:#e6a23c}.el-alert--warning.is-light .el-alert__description{color:#e6a23c}.el-alert--warning.is-dark{background-color:#e6a23c;color:#fff}.el-alert--error.is-light{background-color:#fef0f0;color:#f56c6c}.el-alert--error.is-light .el-alert__description{color:#f56c6c}.el-alert--error.is-dark{background-color:#f56c6c;color:#fff}.el-alert__content{display:table-cell;padding:0 8px}.el-alert__icon{font-size:16px;width:16px}.el-alert__icon.is-big{font-size:28px;width:28px}.el-alert__title{font-size:13px;line-height:18px}.el-alert__title.is-bold{font-weight:700}.el-alert .el-alert__description{font-size:12px;margin:5px 0 0}.el-alert__closebtn{font-size:12px;opacity:1;position:absolute;top:12px;right:15px;cursor:pointer}.el-alert-fade-enter,.el-alert-fade-leave-active,.el-loading-fade-enter,.el-loading-fade-leave-active,.el-notification-fade-leave-active,.el-upload iframe{opacity:0}.el-carousel__arrow--right,.el-notification.right{right:16px}.el-alert__closebtn.is-customed{font-style:normal;font-size:13px;top:9px}.el-notification{display:-webkit-box;display:-ms-flexbox;display:flex;width:330px;padding:14px 26px 14px 13px;border-radius:8px;box-sizing:border-box;border:1px solid #ebeef5;position:fixed;background-color:#fff;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);transition:opacity .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;transition:opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;transition:opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;overflow:hidden}.el-notification.left{left:16px}.el-notification__group{margin-left:13px;margin-right:8px}.el-notification__title{font-weight:700;font-size:16px;color:#303133;margin:0}.el-notification__content{font-size:14px;line-height:21px;margin:6px 0 0;color:#606266;text-align:justify}.el-notification__content p{margin:0}.el-notification__icon{height:24px;width:24px;font-size:24px}.el-notification__closeBtn{position:absolute;top:18px;right:15px;cursor:pointer;color:#909399;font-size:16px}.el-notification__closeBtn:hover{color:#606266}.el-notification .el-icon-success{color:#67c23a}.el-notification .el-icon-error{color:#f56c6c}.el-notification .el-icon-info{color:#909399}.el-notification .el-icon-warning{color:#e6a23c}.el-notification-fade-enter.right{right:0;-webkit-transform:translateX(100%);transform:translateX(100%)}.el-notification-fade-enter.left{left:0;-webkit-transform:translateX(-100%);transform:translateX(-100%)}.el-input-number{position:relative;display:inline-block;width:180px;line-height:38px}.el-input-number .el-input{display:block}.el-input-number .el-input__inner{-webkit-appearance:none;padding-left:50px;padding-right:50px;text-align:center}.el-input-number__decrease,.el-input-number__increase{position:absolute;z-index:1;top:1px;width:40px;height:auto;text-align:center;background:#f5f7fa;color:#606266;cursor:pointer;font-size:13px}.el-input-number__decrease:hover,.el-input-number__increase:hover{color:#409eff}.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled){border-color:#409eff}.el-input-number__decrease.is-disabled,.el-input-number__increase.is-disabled{color:#c0c4cc;cursor:not-allowed}.el-input-number__increase{right:1px;border-radius:0 4px 4px 0;border-left:1px solid #dcdfe6}.el-input-number__decrease{left:1px;border-radius:4px 0 0 4px;border-right:1px solid #dcdfe6}.el-input-number.is-disabled .el-input-number__decrease,.el-input-number.is-disabled .el-input-number__increase{border-color:#e4e7ed;color:#e4e7ed}.el-input-number.is-disabled .el-input-number__decrease:hover,.el-input-number.is-disabled .el-input-number__increase:hover{color:#e4e7ed;cursor:not-allowed}.el-input-number--medium{width:200px;line-height:34px}.el-input-number--medium .el-input-number__decrease,.el-input-number--medium .el-input-number__increase{width:36px;font-size:14px}.el-input-number--medium .el-input__inner{padding-left:43px;padding-right:43px}.el-input-number--small{width:130px;line-height:30px}.el-input-number--small .el-input-number__decrease,.el-input-number--small .el-input-number__increase{width:32px;font-size:13px}.el-input-number--small .el-input-number__decrease [class*=el-icon],.el-input-number--small .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.9);transform:scale(.9)}.el-input-number--small .el-input__inner{padding-left:39px;padding-right:39px}.el-input-number--mini{width:130px;line-height:26px}.el-input-number--mini .el-input-number__decrease,.el-input-number--mini .el-input-number__increase{width:28px;font-size:12px}.el-input-number--mini .el-input-number__decrease [class*=el-icon],.el-input-number--mini .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.8);transform:scale(.8)}.el-input-number--mini .el-input__inner{padding-left:35px;padding-right:35px}.el-input-number.is-without-controls .el-input__inner{padding-left:15px;padding-right:15px}.el-input-number.is-controls-right .el-input__inner{padding-left:15px;padding-right:50px}.el-input-number.is-controls-right .el-input-number__decrease,.el-input-number.is-controls-right .el-input-number__increase{height:auto;line-height:19px}.el-input-number.is-controls-right .el-input-number__decrease [class*=el-icon],.el-input-number.is-controls-right .el-input-number__increase [class*=el-icon]{-webkit-transform:scale(.8);transform:scale(.8)}.el-input-number.is-controls-right .el-input-number__increase{border-radius:0 4px 0 0;border-bottom:1px solid #dcdfe6}.el-input-number.is-controls-right .el-input-number__decrease{right:1px;bottom:1px;top:auto;left:auto;border-right:none;border-left:1px solid #dcdfe6;border-radius:0 0 4px}.el-input-number.is-controls-right[class*=medium] [class*=decrease],.el-input-number.is-controls-right[class*=medium] [class*=increase]{line-height:17px}.el-input-number.is-controls-right[class*=small] [class*=decrease],.el-input-number.is-controls-right[class*=small] [class*=increase]{line-height:15px}.el-input-number.is-controls-right[class*=mini] [class*=decrease],.el-input-number.is-controls-right[class*=mini] [class*=increase]{line-height:13px}.el-tooltip:focus:hover,.el-tooltip:focus:not(.focusing){outline-width:0}.el-tooltip__popper{position:absolute;border-radius:4px;padding:10px;z-index:2000;font-size:12px;line-height:1.2;min-width:10px;word-wrap:break-word}.el-tooltip__popper .popper__arrow,.el-tooltip__popper .popper__arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.el-tooltip__popper .popper__arrow{border-width:6px}.el-tooltip__popper .popper__arrow:after{content:\" \";border-width:5px}.el-button-group:after,.el-button-group:before,.el-color-dropdown__main-wrapper:after,.el-link.is-underline:hover:after,.el-page-header__left:after,.el-progress-bar__inner:after,.el-row:after,.el-row:before,.el-slider:after,.el-slider:before,.el-slider__button-wrapper:after,.el-transfer-panel .el-transfer-panel__footer:after,.el-upload-cover:after,.el-upload-list--picture-card .el-upload-list__item-actions:after{content:\"\"}.el-tooltip__popper[x-placement^=top]{margin-bottom:12px}.el-tooltip__popper[x-placement^=top] .popper__arrow{bottom:-6px;border-top-color:#303133;border-bottom-width:0}.el-tooltip__popper[x-placement^=top] .popper__arrow:after{bottom:1px;margin-left:-5px;border-top-color:#303133;border-bottom-width:0}.el-tooltip__popper[x-placement^=bottom]{margin-top:12px}.el-tooltip__popper[x-placement^=bottom] .popper__arrow{top:-6px;border-top-width:0;border-bottom-color:#303133}.el-tooltip__popper[x-placement^=bottom] .popper__arrow:after{top:1px;margin-left:-5px;border-top-width:0;border-bottom-color:#303133}.el-tooltip__popper[x-placement^=right]{margin-left:12px}.el-tooltip__popper[x-placement^=right] .popper__arrow{left:-6px;border-right-color:#303133;border-left-width:0}.el-tooltip__popper[x-placement^=right] .popper__arrow:after{bottom:-5px;left:1px;border-right-color:#303133;border-left-width:0}.el-tooltip__popper[x-placement^=left]{margin-right:12px}.el-tooltip__popper[x-placement^=left] .popper__arrow{right:-6px;border-right-width:0;border-left-color:#303133}.el-tooltip__popper[x-placement^=left] .popper__arrow:after{right:1px;bottom:-5px;margin-left:-5px;border-right-width:0;border-left-color:#303133}.el-tooltip__popper.is-dark{background:#303133;color:#fff}.el-tooltip__popper.is-light{background:#fff;border:1px solid #303133}.el-tooltip__popper.is-light[x-placement^=top] .popper__arrow{border-top-color:#303133}.el-tooltip__popper.is-light[x-placement^=top] .popper__arrow:after{border-top-color:#fff}.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow{border-bottom-color:#303133}.el-tooltip__popper.is-light[x-placement^=bottom] .popper__arrow:after{border-bottom-color:#fff}.el-tooltip__popper.is-light[x-placement^=left] .popper__arrow{border-left-color:#303133}.el-tooltip__popper.is-light[x-placement^=left] .popper__arrow:after{border-left-color:#fff}.el-tooltip__popper.is-light[x-placement^=right] .popper__arrow{border-right-color:#303133}.el-tooltip__popper.is-light[x-placement^=right] .popper__arrow:after{border-right-color:#fff}.el-slider:after,.el-slider:before{display:table}.el-slider__button-wrapper .el-tooltip,.el-slider__button-wrapper:after{display:inline-block;vertical-align:middle}.el-slider:after{clear:both}.el-slider__runway{width:100%;height:6px;margin:16px 0;background-color:#e4e7ed;border-radius:3px;position:relative;cursor:pointer;vertical-align:middle}.el-slider__runway.show-input{margin-right:160px;width:auto}.el-slider__runway.disabled{cursor:default}.el-slider__runway.disabled .el-slider__bar{background-color:#c0c4cc}.el-slider__runway.disabled .el-slider__button{border-color:#c0c4cc}.el-slider__runway.disabled .el-slider__button-wrapper.dragging,.el-slider__runway.disabled .el-slider__button-wrapper.hover,.el-slider__runway.disabled .el-slider__button-wrapper:hover{cursor:not-allowed}.el-slider__runway.disabled .el-slider__button.dragging,.el-slider__runway.disabled .el-slider__button.hover,.el-slider__runway.disabled .el-slider__button:hover{-webkit-transform:scale(1);transform:scale(1);cursor:not-allowed}.el-slider__button-wrapper,.el-slider__stop{-webkit-transform:translateX(-50%);position:absolute}.el-slider__input{float:right;margin-top:3px;width:130px}.el-slider__input.el-input-number--mini{margin-top:5px}.el-slider__input.el-input-number--medium{margin-top:0}.el-slider__input.el-input-number--large{margin-top:-2px}.el-slider__bar{height:6px;background-color:#409eff;border-top-left-radius:3px;border-bottom-left-radius:3px;position:absolute}.el-slider__button-wrapper{height:36px;width:36px;z-index:1001;top:-15px;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:transparent;text-align:center;-webkit-user-select:none;user-select:none;line-height:normal}.el-image-viewer__btn,.el-slider__button,.el-slider__button-wrapper,.el-step__icon-inner{-moz-user-select:none;-ms-user-select:none}.el-slider__button-wrapper:after{height:100%}.el-slider__button-wrapper.hover,.el-slider__button-wrapper:hover{cursor:-webkit-grab;cursor:grab}.el-slider__button-wrapper.dragging{cursor:-webkit-grabbing;cursor:grabbing}.el-slider__button{width:16px;height:16px;border:2px solid #409eff;background-color:#fff;border-radius:50%;transition:.2s;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.el-slider__button.dragging,.el-slider__button.hover,.el-slider__button:hover{-webkit-transform:scale(1.2);transform:scale(1.2)}.el-slider__button.hover,.el-slider__button:hover{cursor:-webkit-grab;cursor:grab}.el-slider__button.dragging{cursor:-webkit-grabbing;cursor:grabbing}.el-slider__stop{height:6px;width:6px;border-radius:100%;background-color:#fff;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.el-slider__marks{top:0;left:12px;width:18px;height:100%}.el-slider__marks-text{position:absolute;-webkit-transform:translateX(-50%);transform:translateX(-50%);font-size:14px;color:#909399;margin-top:15px}.el-slider.is-vertical{position:relative}.el-slider.is-vertical .el-slider__runway{width:6px;height:100%;margin:0 16px}.el-slider.is-vertical .el-slider__bar{width:6px;height:auto;border-radius:0 0 3px 3px}.el-slider.is-vertical .el-slider__button-wrapper{top:auto;left:-15px}.el-slider.is-vertical .el-slider__button-wrapper,.el-slider.is-vertical .el-slider__stop{-webkit-transform:translateY(50%);transform:translateY(50%)}.el-slider.is-vertical.el-slider--with-input{padding-bottom:58px}.el-slider.is-vertical.el-slider--with-input .el-slider__input{overflow:visible;float:none;position:absolute;bottom:22px;width:36px;margin-top:15px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input__inner{text-align:center;padding-left:5px;padding-right:5px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase{top:32px;margin-top:-1px;border:1px solid #dcdfe6;line-height:20px;box-sizing:border-box;transition:border-color .2s cubic-bezier(.645,.045,.355,1)}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__decrease{width:18px;right:18px;border-bottom-left-radius:4px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase{width:19px;border-bottom-right-radius:4px}.el-slider.is-vertical.el-slider--with-input .el-slider__input .el-input-number__increase~.el-input .el-input__inner{border-bottom-left-radius:0;border-bottom-right-radius:0}.el-slider.is-vertical.el-slider--with-input .el-slider__input:hover .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input:hover .el-input-number__increase{border-color:#c0c4cc}.el-slider.is-vertical.el-slider--with-input .el-slider__input:active .el-input-number__decrease,.el-slider.is-vertical.el-slider--with-input .el-slider__input:active .el-input-number__increase{border-color:#409eff}.el-slider.is-vertical .el-slider__marks-text{margin-top:0;left:15px;-webkit-transform:translateY(50%);transform:translateY(50%)}.el-loading-parent--relative{position:relative!important}.el-loading-parent--hidden{overflow:hidden!important}.el-loading-mask{position:absolute;z-index:2000;background-color:hsla(0,0%,100%,.9);margin:0;top:0;right:0;bottom:0;left:0;transition:opacity .3s}.el-loading-mask.is-fullscreen{position:fixed}.el-loading-mask.is-fullscreen .el-loading-spinner{margin-top:-25px}.el-loading-mask.is-fullscreen .el-loading-spinner .circular{height:50px;width:50px}.el-loading-spinner{top:50%;margin-top:-21px;width:100%;text-align:center;position:absolute}.el-col-pull-0,.el-col-pull-1,.el-col-pull-2,.el-col-pull-3,.el-col-pull-4,.el-col-pull-5,.el-col-pull-6,.el-col-pull-7,.el-col-pull-8,.el-col-pull-9,.el-col-pull-10,.el-col-pull-11,.el-col-pull-12,.el-col-pull-13,.el-col-pull-14,.el-col-pull-15,.el-col-pull-16,.el-col-pull-17,.el-col-pull-18,.el-col-pull-19,.el-col-pull-20,.el-col-pull-21,.el-col-pull-22,.el-col-pull-23,.el-col-pull-24,.el-col-push-0,.el-col-push-1,.el-col-push-2,.el-col-push-3,.el-col-push-4,.el-col-push-5,.el-col-push-6,.el-col-push-7,.el-col-push-8,.el-col-push-9,.el-col-push-10,.el-col-push-11,.el-col-push-12,.el-col-push-13,.el-col-push-14,.el-col-push-15,.el-col-push-16,.el-col-push-17,.el-col-push-18,.el-col-push-19,.el-col-push-20,.el-col-push-21,.el-col-push-22,.el-col-push-23,.el-col-push-24,.el-row,.el-upload-dragger,.el-upload-list__item{position:relative}.el-loading-spinner .el-loading-text{color:#409eff;margin:3px 0;font-size:14px}.el-loading-spinner .circular{height:42px;width:42px;-webkit-animation:loading-rotate 2s linear infinite;animation:loading-rotate 2s linear infinite}.el-loading-spinner .path{-webkit-animation:loading-dash 1.5s ease-in-out infinite;animation:loading-dash 1.5s ease-in-out infinite;stroke-dasharray:90,150;stroke-dashoffset:0;stroke-width:2;stroke:#409eff;stroke-linecap:round}.el-loading-spinner i{color:#409eff}@-webkit-keyframes loading-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes loading-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes loading-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40px}to{stroke-dasharray:90,150;stroke-dashoffset:-120px}}@keyframes loading-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-40px}to{stroke-dasharray:90,150;stroke-dashoffset:-120px}}.el-row{box-sizing:border-box}.el-row:after,.el-row:before{display:table}.el-row:after{clear:both}.el-row--flex{display:-webkit-box;display:-ms-flexbox;display:flex}.el-col-0,.el-row--flex:after,.el-row--flex:before{display:none}.el-row--flex.is-justify-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-row--flex.is-justify-end{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.el-row--flex.is-justify-space-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.el-row--flex.is-justify-space-around{-ms-flex-pack:distribute;justify-content:space-around}.el-row--flex.is-align-top{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.el-row--flex.is-align-middle{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-row--flex.is-align-bottom{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}[class*=el-col-]{float:left;box-sizing:border-box}.el-col-0{width:0}.el-col-pull-0{right:0}.el-col-push-0{left:0}.el-col-1{width:4.16667%}.el-col-offset-1{margin-left:4.16667%}.el-col-pull-1{right:4.16667%}.el-col-push-1{left:4.16667%}.el-col-2{width:8.33333%}.el-col-offset-2{margin-left:8.33333%}.el-col-pull-2{right:8.33333%}.el-col-push-2{left:8.33333%}.el-col-3{width:12.5%}.el-col-offset-3{margin-left:12.5%}.el-col-pull-3{right:12.5%}.el-col-push-3{left:12.5%}.el-col-4{width:16.66667%}.el-col-offset-4{margin-left:16.66667%}.el-col-pull-4{right:16.66667%}.el-col-push-4{left:16.66667%}.el-col-5{width:20.83333%}.el-col-offset-5{margin-left:20.83333%}.el-col-pull-5{right:20.83333%}.el-col-push-5{left:20.83333%}.el-col-6{width:25%}.el-col-offset-6{margin-left:25%}.el-col-pull-6{right:25%}.el-col-push-6{left:25%}.el-col-7{width:29.16667%}.el-col-offset-7{margin-left:29.16667%}.el-col-pull-7{right:29.16667%}.el-col-push-7{left:29.16667%}.el-col-8{width:33.33333%}.el-col-offset-8{margin-left:33.33333%}.el-col-pull-8{right:33.33333%}.el-col-push-8{left:33.33333%}.el-col-9{width:37.5%}.el-col-offset-9{margin-left:37.5%}.el-col-pull-9{right:37.5%}.el-col-push-9{left:37.5%}.el-col-10{width:41.66667%}.el-col-offset-10{margin-left:41.66667%}.el-col-pull-10{right:41.66667%}.el-col-push-10{left:41.66667%}.el-col-11{width:45.83333%}.el-col-offset-11{margin-left:45.83333%}.el-col-pull-11{right:45.83333%}.el-col-push-11{left:45.83333%}.el-col-12{width:50%}.el-col-offset-12{margin-left:50%}.el-col-pull-12{right:50%}.el-col-push-12{left:50%}.el-col-13{width:54.16667%}.el-col-offset-13{margin-left:54.16667%}.el-col-pull-13{right:54.16667%}.el-col-push-13{left:54.16667%}.el-col-14{width:58.33333%}.el-col-offset-14{margin-left:58.33333%}.el-col-pull-14{right:58.33333%}.el-col-push-14{left:58.33333%}.el-col-15{width:62.5%}.el-col-offset-15{margin-left:62.5%}.el-col-pull-15{right:62.5%}.el-col-push-15{left:62.5%}.el-col-16{width:66.66667%}.el-col-offset-16{margin-left:66.66667%}.el-col-pull-16{right:66.66667%}.el-col-push-16{left:66.66667%}.el-col-17{width:70.83333%}.el-col-offset-17{margin-left:70.83333%}.el-col-pull-17{right:70.83333%}.el-col-push-17{left:70.83333%}.el-col-18{width:75%}.el-col-offset-18{margin-left:75%}.el-col-pull-18{right:75%}.el-col-push-18{left:75%}.el-col-19{width:79.16667%}.el-col-offset-19{margin-left:79.16667%}.el-col-pull-19{right:79.16667%}.el-col-push-19{left:79.16667%}.el-col-20{width:83.33333%}.el-col-offset-20{margin-left:83.33333%}.el-col-pull-20{right:83.33333%}.el-col-push-20{left:83.33333%}.el-col-21{width:87.5%}.el-col-offset-21{margin-left:87.5%}.el-col-pull-21{right:87.5%}.el-col-push-21{left:87.5%}.el-col-22{width:91.66667%}.el-col-offset-22{margin-left:91.66667%}.el-col-pull-22{right:91.66667%}.el-col-push-22{left:91.66667%}.el-col-23{width:95.83333%}.el-col-offset-23{margin-left:95.83333%}.el-col-pull-23{right:95.83333%}.el-col-push-23{left:95.83333%}.el-col-24{width:100%}.el-col-offset-24{margin-left:100%}.el-col-pull-24{right:100%}.el-col-push-24{left:100%}@media only screen and (max-width:767px){.el-col-xs-0{display:none;width:0}.el-col-xs-offset-0{margin-left:0}.el-col-xs-pull-0{position:relative;right:0}.el-col-xs-push-0{position:relative;left:0}.el-col-xs-1{width:4.16667%}.el-col-xs-offset-1{margin-left:4.16667%}.el-col-xs-pull-1{position:relative;right:4.16667%}.el-col-xs-push-1{position:relative;left:4.16667%}.el-col-xs-2{width:8.33333%}.el-col-xs-offset-2{margin-left:8.33333%}.el-col-xs-pull-2{position:relative;right:8.33333%}.el-col-xs-push-2{position:relative;left:8.33333%}.el-col-xs-3{width:12.5%}.el-col-xs-offset-3{margin-left:12.5%}.el-col-xs-pull-3{position:relative;right:12.5%}.el-col-xs-push-3{position:relative;left:12.5%}.el-col-xs-4{width:16.66667%}.el-col-xs-offset-4{margin-left:16.66667%}.el-col-xs-pull-4{position:relative;right:16.66667%}.el-col-xs-push-4{position:relative;left:16.66667%}.el-col-xs-5{width:20.83333%}.el-col-xs-offset-5{margin-left:20.83333%}.el-col-xs-pull-5{position:relative;right:20.83333%}.el-col-xs-push-5{position:relative;left:20.83333%}.el-col-xs-6{width:25%}.el-col-xs-offset-6{margin-left:25%}.el-col-xs-pull-6{position:relative;right:25%}.el-col-xs-push-6{position:relative;left:25%}.el-col-xs-7{width:29.16667%}.el-col-xs-offset-7{margin-left:29.16667%}.el-col-xs-pull-7{position:relative;right:29.16667%}.el-col-xs-push-7{position:relative;left:29.16667%}.el-col-xs-8{width:33.33333%}.el-col-xs-offset-8{margin-left:33.33333%}.el-col-xs-pull-8{position:relative;right:33.33333%}.el-col-xs-push-8{position:relative;left:33.33333%}.el-col-xs-9{width:37.5%}.el-col-xs-offset-9{margin-left:37.5%}.el-col-xs-pull-9{position:relative;right:37.5%}.el-col-xs-push-9{position:relative;left:37.5%}.el-col-xs-10{width:41.66667%}.el-col-xs-offset-10{margin-left:41.66667%}.el-col-xs-pull-10{position:relative;right:41.66667%}.el-col-xs-push-10{position:relative;left:41.66667%}.el-col-xs-11{width:45.83333%}.el-col-xs-offset-11{margin-left:45.83333%}.el-col-xs-pull-11{position:relative;right:45.83333%}.el-col-xs-push-11{position:relative;left:45.83333%}.el-col-xs-12{width:50%}.el-col-xs-offset-12{margin-left:50%}.el-col-xs-pull-12{position:relative;right:50%}.el-col-xs-push-12{position:relative;left:50%}.el-col-xs-13{width:54.16667%}.el-col-xs-offset-13{margin-left:54.16667%}.el-col-xs-pull-13{position:relative;right:54.16667%}.el-col-xs-push-13{position:relative;left:54.16667%}.el-col-xs-14{width:58.33333%}.el-col-xs-offset-14{margin-left:58.33333%}.el-col-xs-pull-14{position:relative;right:58.33333%}.el-col-xs-push-14{position:relative;left:58.33333%}.el-col-xs-15{width:62.5%}.el-col-xs-offset-15{margin-left:62.5%}.el-col-xs-pull-15{position:relative;right:62.5%}.el-col-xs-push-15{position:relative;left:62.5%}.el-col-xs-16{width:66.66667%}.el-col-xs-offset-16{margin-left:66.66667%}.el-col-xs-pull-16{position:relative;right:66.66667%}.el-col-xs-push-16{position:relative;left:66.66667%}.el-col-xs-17{width:70.83333%}.el-col-xs-offset-17{margin-left:70.83333%}.el-col-xs-pull-17{position:relative;right:70.83333%}.el-col-xs-push-17{position:relative;left:70.83333%}.el-col-xs-18{width:75%}.el-col-xs-offset-18{margin-left:75%}.el-col-xs-pull-18{position:relative;right:75%}.el-col-xs-push-18{position:relative;left:75%}.el-col-xs-19{width:79.16667%}.el-col-xs-offset-19{margin-left:79.16667%}.el-col-xs-pull-19{position:relative;right:79.16667%}.el-col-xs-push-19{position:relative;left:79.16667%}.el-col-xs-20{width:83.33333%}.el-col-xs-offset-20{margin-left:83.33333%}.el-col-xs-pull-20{position:relative;right:83.33333%}.el-col-xs-push-20{position:relative;left:83.33333%}.el-col-xs-21{width:87.5%}.el-col-xs-offset-21{margin-left:87.5%}.el-col-xs-pull-21{position:relative;right:87.5%}.el-col-xs-push-21{position:relative;left:87.5%}.el-col-xs-22{width:91.66667%}.el-col-xs-offset-22{margin-left:91.66667%}.el-col-xs-pull-22{position:relative;right:91.66667%}.el-col-xs-push-22{position:relative;left:91.66667%}.el-col-xs-23{width:95.83333%}.el-col-xs-offset-23{margin-left:95.83333%}.el-col-xs-pull-23{position:relative;right:95.83333%}.el-col-xs-push-23{position:relative;left:95.83333%}.el-col-xs-24{width:100%}.el-col-xs-offset-24{margin-left:100%}.el-col-xs-pull-24{position:relative;right:100%}.el-col-xs-push-24{position:relative;left:100%}}@media only screen and (min-width:768px){.el-col-sm-0{display:none;width:0}.el-col-sm-offset-0{margin-left:0}.el-col-sm-pull-0{position:relative;right:0}.el-col-sm-push-0{position:relative;left:0}.el-col-sm-1{width:4.16667%}.el-col-sm-offset-1{margin-left:4.16667%}.el-col-sm-pull-1{position:relative;right:4.16667%}.el-col-sm-push-1{position:relative;left:4.16667%}.el-col-sm-2{width:8.33333%}.el-col-sm-offset-2{margin-left:8.33333%}.el-col-sm-pull-2{position:relative;right:8.33333%}.el-col-sm-push-2{position:relative;left:8.33333%}.el-col-sm-3{width:12.5%}.el-col-sm-offset-3{margin-left:12.5%}.el-col-sm-pull-3{position:relative;right:12.5%}.el-col-sm-push-3{position:relative;left:12.5%}.el-col-sm-4{width:16.66667%}.el-col-sm-offset-4{margin-left:16.66667%}.el-col-sm-pull-4{position:relative;right:16.66667%}.el-col-sm-push-4{position:relative;left:16.66667%}.el-col-sm-5{width:20.83333%}.el-col-sm-offset-5{margin-left:20.83333%}.el-col-sm-pull-5{position:relative;right:20.83333%}.el-col-sm-push-5{position:relative;left:20.83333%}.el-col-sm-6{width:25%}.el-col-sm-offset-6{margin-left:25%}.el-col-sm-pull-6{position:relative;right:25%}.el-col-sm-push-6{position:relative;left:25%}.el-col-sm-7{width:29.16667%}.el-col-sm-offset-7{margin-left:29.16667%}.el-col-sm-pull-7{position:relative;right:29.16667%}.el-col-sm-push-7{position:relative;left:29.16667%}.el-col-sm-8{width:33.33333%}.el-col-sm-offset-8{margin-left:33.33333%}.el-col-sm-pull-8{position:relative;right:33.33333%}.el-col-sm-push-8{position:relative;left:33.33333%}.el-col-sm-9{width:37.5%}.el-col-sm-offset-9{margin-left:37.5%}.el-col-sm-pull-9{position:relative;right:37.5%}.el-col-sm-push-9{position:relative;left:37.5%}.el-col-sm-10{width:41.66667%}.el-col-sm-offset-10{margin-left:41.66667%}.el-col-sm-pull-10{position:relative;right:41.66667%}.el-col-sm-push-10{position:relative;left:41.66667%}.el-col-sm-11{width:45.83333%}.el-col-sm-offset-11{margin-left:45.83333%}.el-col-sm-pull-11{position:relative;right:45.83333%}.el-col-sm-push-11{position:relative;left:45.83333%}.el-col-sm-12{width:50%}.el-col-sm-offset-12{margin-left:50%}.el-col-sm-pull-12{position:relative;right:50%}.el-col-sm-push-12{position:relative;left:50%}.el-col-sm-13{width:54.16667%}.el-col-sm-offset-13{margin-left:54.16667%}.el-col-sm-pull-13{position:relative;right:54.16667%}.el-col-sm-push-13{position:relative;left:54.16667%}.el-col-sm-14{width:58.33333%}.el-col-sm-offset-14{margin-left:58.33333%}.el-col-sm-pull-14{position:relative;right:58.33333%}.el-col-sm-push-14{position:relative;left:58.33333%}.el-col-sm-15{width:62.5%}.el-col-sm-offset-15{margin-left:62.5%}.el-col-sm-pull-15{position:relative;right:62.5%}.el-col-sm-push-15{position:relative;left:62.5%}.el-col-sm-16{width:66.66667%}.el-col-sm-offset-16{margin-left:66.66667%}.el-col-sm-pull-16{position:relative;right:66.66667%}.el-col-sm-push-16{position:relative;left:66.66667%}.el-col-sm-17{width:70.83333%}.el-col-sm-offset-17{margin-left:70.83333%}.el-col-sm-pull-17{position:relative;right:70.83333%}.el-col-sm-push-17{position:relative;left:70.83333%}.el-col-sm-18{width:75%}.el-col-sm-offset-18{margin-left:75%}.el-col-sm-pull-18{position:relative;right:75%}.el-col-sm-push-18{position:relative;left:75%}.el-col-sm-19{width:79.16667%}.el-col-sm-offset-19{margin-left:79.16667%}.el-col-sm-pull-19{position:relative;right:79.16667%}.el-col-sm-push-19{position:relative;left:79.16667%}.el-col-sm-20{width:83.33333%}.el-col-sm-offset-20{margin-left:83.33333%}.el-col-sm-pull-20{position:relative;right:83.33333%}.el-col-sm-push-20{position:relative;left:83.33333%}.el-col-sm-21{width:87.5%}.el-col-sm-offset-21{margin-left:87.5%}.el-col-sm-pull-21{position:relative;right:87.5%}.el-col-sm-push-21{position:relative;left:87.5%}.el-col-sm-22{width:91.66667%}.el-col-sm-offset-22{margin-left:91.66667%}.el-col-sm-pull-22{position:relative;right:91.66667%}.el-col-sm-push-22{position:relative;left:91.66667%}.el-col-sm-23{width:95.83333%}.el-col-sm-offset-23{margin-left:95.83333%}.el-col-sm-pull-23{position:relative;right:95.83333%}.el-col-sm-push-23{position:relative;left:95.83333%}.el-col-sm-24{width:100%}.el-col-sm-offset-24{margin-left:100%}.el-col-sm-pull-24{position:relative;right:100%}.el-col-sm-push-24{position:relative;left:100%}}@media only screen and (min-width:992px){.el-col-md-0{display:none;width:0}.el-col-md-offset-0{margin-left:0}.el-col-md-pull-0{position:relative;right:0}.el-col-md-push-0{position:relative;left:0}.el-col-md-1{width:4.16667%}.el-col-md-offset-1{margin-left:4.16667%}.el-col-md-pull-1{position:relative;right:4.16667%}.el-col-md-push-1{position:relative;left:4.16667%}.el-col-md-2{width:8.33333%}.el-col-md-offset-2{margin-left:8.33333%}.el-col-md-pull-2{position:relative;right:8.33333%}.el-col-md-push-2{position:relative;left:8.33333%}.el-col-md-3{width:12.5%}.el-col-md-offset-3{margin-left:12.5%}.el-col-md-pull-3{position:relative;right:12.5%}.el-col-md-push-3{position:relative;left:12.5%}.el-col-md-4{width:16.66667%}.el-col-md-offset-4{margin-left:16.66667%}.el-col-md-pull-4{position:relative;right:16.66667%}.el-col-md-push-4{position:relative;left:16.66667%}.el-col-md-5{width:20.83333%}.el-col-md-offset-5{margin-left:20.83333%}.el-col-md-pull-5{position:relative;right:20.83333%}.el-col-md-push-5{position:relative;left:20.83333%}.el-col-md-6{width:25%}.el-col-md-offset-6{margin-left:25%}.el-col-md-pull-6{position:relative;right:25%}.el-col-md-push-6{position:relative;left:25%}.el-col-md-7{width:29.16667%}.el-col-md-offset-7{margin-left:29.16667%}.el-col-md-pull-7{position:relative;right:29.16667%}.el-col-md-push-7{position:relative;left:29.16667%}.el-col-md-8{width:33.33333%}.el-col-md-offset-8{margin-left:33.33333%}.el-col-md-pull-8{position:relative;right:33.33333%}.el-col-md-push-8{position:relative;left:33.33333%}.el-col-md-9{width:37.5%}.el-col-md-offset-9{margin-left:37.5%}.el-col-md-pull-9{position:relative;right:37.5%}.el-col-md-push-9{position:relative;left:37.5%}.el-col-md-10{width:41.66667%}.el-col-md-offset-10{margin-left:41.66667%}.el-col-md-pull-10{position:relative;right:41.66667%}.el-col-md-push-10{position:relative;left:41.66667%}.el-col-md-11{width:45.83333%}.el-col-md-offset-11{margin-left:45.83333%}.el-col-md-pull-11{position:relative;right:45.83333%}.el-col-md-push-11{position:relative;left:45.83333%}.el-col-md-12{width:50%}.el-col-md-offset-12{margin-left:50%}.el-col-md-pull-12{position:relative;right:50%}.el-col-md-push-12{position:relative;left:50%}.el-col-md-13{width:54.16667%}.el-col-md-offset-13{margin-left:54.16667%}.el-col-md-pull-13{position:relative;right:54.16667%}.el-col-md-push-13{position:relative;left:54.16667%}.el-col-md-14{width:58.33333%}.el-col-md-offset-14{margin-left:58.33333%}.el-col-md-pull-14{position:relative;right:58.33333%}.el-col-md-push-14{position:relative;left:58.33333%}.el-col-md-15{width:62.5%}.el-col-md-offset-15{margin-left:62.5%}.el-col-md-pull-15{position:relative;right:62.5%}.el-col-md-push-15{position:relative;left:62.5%}.el-col-md-16{width:66.66667%}.el-col-md-offset-16{margin-left:66.66667%}.el-col-md-pull-16{position:relative;right:66.66667%}.el-col-md-push-16{position:relative;left:66.66667%}.el-col-md-17{width:70.83333%}.el-col-md-offset-17{margin-left:70.83333%}.el-col-md-pull-17{position:relative;right:70.83333%}.el-col-md-push-17{position:relative;left:70.83333%}.el-col-md-18{width:75%}.el-col-md-offset-18{margin-left:75%}.el-col-md-pull-18{position:relative;right:75%}.el-col-md-push-18{position:relative;left:75%}.el-col-md-19{width:79.16667%}.el-col-md-offset-19{margin-left:79.16667%}.el-col-md-pull-19{position:relative;right:79.16667%}.el-col-md-push-19{position:relative;left:79.16667%}.el-col-md-20{width:83.33333%}.el-col-md-offset-20{margin-left:83.33333%}.el-col-md-pull-20{position:relative;right:83.33333%}.el-col-md-push-20{position:relative;left:83.33333%}.el-col-md-21{width:87.5%}.el-col-md-offset-21{margin-left:87.5%}.el-col-md-pull-21{position:relative;right:87.5%}.el-col-md-push-21{position:relative;left:87.5%}.el-col-md-22{width:91.66667%}.el-col-md-offset-22{margin-left:91.66667%}.el-col-md-pull-22{position:relative;right:91.66667%}.el-col-md-push-22{position:relative;left:91.66667%}.el-col-md-23{width:95.83333%}.el-col-md-offset-23{margin-left:95.83333%}.el-col-md-pull-23{position:relative;right:95.83333%}.el-col-md-push-23{position:relative;left:95.83333%}.el-col-md-24{width:100%}.el-col-md-offset-24{margin-left:100%}.el-col-md-pull-24{position:relative;right:100%}.el-col-md-push-24{position:relative;left:100%}}@media only screen and (min-width:1200px){.el-col-lg-0{display:none;width:0}.el-col-lg-offset-0{margin-left:0}.el-col-lg-pull-0{position:relative;right:0}.el-col-lg-push-0{position:relative;left:0}.el-col-lg-1{width:4.16667%}.el-col-lg-offset-1{margin-left:4.16667%}.el-col-lg-pull-1{position:relative;right:4.16667%}.el-col-lg-push-1{position:relative;left:4.16667%}.el-col-lg-2{width:8.33333%}.el-col-lg-offset-2{margin-left:8.33333%}.el-col-lg-pull-2{position:relative;right:8.33333%}.el-col-lg-push-2{position:relative;left:8.33333%}.el-col-lg-3{width:12.5%}.el-col-lg-offset-3{margin-left:12.5%}.el-col-lg-pull-3{position:relative;right:12.5%}.el-col-lg-push-3{position:relative;left:12.5%}.el-col-lg-4{width:16.66667%}.el-col-lg-offset-4{margin-left:16.66667%}.el-col-lg-pull-4{position:relative;right:16.66667%}.el-col-lg-push-4{position:relative;left:16.66667%}.el-col-lg-5{width:20.83333%}.el-col-lg-offset-5{margin-left:20.83333%}.el-col-lg-pull-5{position:relative;right:20.83333%}.el-col-lg-push-5{position:relative;left:20.83333%}.el-col-lg-6{width:25%}.el-col-lg-offset-6{margin-left:25%}.el-col-lg-pull-6{position:relative;right:25%}.el-col-lg-push-6{position:relative;left:25%}.el-col-lg-7{width:29.16667%}.el-col-lg-offset-7{margin-left:29.16667%}.el-col-lg-pull-7{position:relative;right:29.16667%}.el-col-lg-push-7{position:relative;left:29.16667%}.el-col-lg-8{width:33.33333%}.el-col-lg-offset-8{margin-left:33.33333%}.el-col-lg-pull-8{position:relative;right:33.33333%}.el-col-lg-push-8{position:relative;left:33.33333%}.el-col-lg-9{width:37.5%}.el-col-lg-offset-9{margin-left:37.5%}.el-col-lg-pull-9{position:relative;right:37.5%}.el-col-lg-push-9{position:relative;left:37.5%}.el-col-lg-10{width:41.66667%}.el-col-lg-offset-10{margin-left:41.66667%}.el-col-lg-pull-10{position:relative;right:41.66667%}.el-col-lg-push-10{position:relative;left:41.66667%}.el-col-lg-11{width:45.83333%}.el-col-lg-offset-11{margin-left:45.83333%}.el-col-lg-pull-11{position:relative;right:45.83333%}.el-col-lg-push-11{position:relative;left:45.83333%}.el-col-lg-12{width:50%}.el-col-lg-offset-12{margin-left:50%}.el-col-lg-pull-12{position:relative;right:50%}.el-col-lg-push-12{position:relative;left:50%}.el-col-lg-13{width:54.16667%}.el-col-lg-offset-13{margin-left:54.16667%}.el-col-lg-pull-13{position:relative;right:54.16667%}.el-col-lg-push-13{position:relative;left:54.16667%}.el-col-lg-14{width:58.33333%}.el-col-lg-offset-14{margin-left:58.33333%}.el-col-lg-pull-14{position:relative;right:58.33333%}.el-col-lg-push-14{position:relative;left:58.33333%}.el-col-lg-15{width:62.5%}.el-col-lg-offset-15{margin-left:62.5%}.el-col-lg-pull-15{position:relative;right:62.5%}.el-col-lg-push-15{position:relative;left:62.5%}.el-col-lg-16{width:66.66667%}.el-col-lg-offset-16{margin-left:66.66667%}.el-col-lg-pull-16{position:relative;right:66.66667%}.el-col-lg-push-16{position:relative;left:66.66667%}.el-col-lg-17{width:70.83333%}.el-col-lg-offset-17{margin-left:70.83333%}.el-col-lg-pull-17{position:relative;right:70.83333%}.el-col-lg-push-17{position:relative;left:70.83333%}.el-col-lg-18{width:75%}.el-col-lg-offset-18{margin-left:75%}.el-col-lg-pull-18{position:relative;right:75%}.el-col-lg-push-18{position:relative;left:75%}.el-col-lg-19{width:79.16667%}.el-col-lg-offset-19{margin-left:79.16667%}.el-col-lg-pull-19{position:relative;right:79.16667%}.el-col-lg-push-19{position:relative;left:79.16667%}.el-col-lg-20{width:83.33333%}.el-col-lg-offset-20{margin-left:83.33333%}.el-col-lg-pull-20{position:relative;right:83.33333%}.el-col-lg-push-20{position:relative;left:83.33333%}.el-col-lg-21{width:87.5%}.el-col-lg-offset-21{margin-left:87.5%}.el-col-lg-pull-21{position:relative;right:87.5%}.el-col-lg-push-21{position:relative;left:87.5%}.el-col-lg-22{width:91.66667%}.el-col-lg-offset-22{margin-left:91.66667%}.el-col-lg-pull-22{position:relative;right:91.66667%}.el-col-lg-push-22{position:relative;left:91.66667%}.el-col-lg-23{width:95.83333%}.el-col-lg-offset-23{margin-left:95.83333%}.el-col-lg-pull-23{position:relative;right:95.83333%}.el-col-lg-push-23{position:relative;left:95.83333%}.el-col-lg-24{width:100%}.el-col-lg-offset-24{margin-left:100%}.el-col-lg-pull-24{position:relative;right:100%}.el-col-lg-push-24{position:relative;left:100%}}@media only screen and (min-width:1920px){.el-col-xl-0{display:none;width:0}.el-col-xl-offset-0{margin-left:0}.el-col-xl-pull-0{position:relative;right:0}.el-col-xl-push-0{position:relative;left:0}.el-col-xl-1{width:4.16667%}.el-col-xl-offset-1{margin-left:4.16667%}.el-col-xl-pull-1{position:relative;right:4.16667%}.el-col-xl-push-1{position:relative;left:4.16667%}.el-col-xl-2{width:8.33333%}.el-col-xl-offset-2{margin-left:8.33333%}.el-col-xl-pull-2{position:relative;right:8.33333%}.el-col-xl-push-2{position:relative;left:8.33333%}.el-col-xl-3{width:12.5%}.el-col-xl-offset-3{margin-left:12.5%}.el-col-xl-pull-3{position:relative;right:12.5%}.el-col-xl-push-3{position:relative;left:12.5%}.el-col-xl-4{width:16.66667%}.el-col-xl-offset-4{margin-left:16.66667%}.el-col-xl-pull-4{position:relative;right:16.66667%}.el-col-xl-push-4{position:relative;left:16.66667%}.el-col-xl-5{width:20.83333%}.el-col-xl-offset-5{margin-left:20.83333%}.el-col-xl-pull-5{position:relative;right:20.83333%}.el-col-xl-push-5{position:relative;left:20.83333%}.el-col-xl-6{width:25%}.el-col-xl-offset-6{margin-left:25%}.el-col-xl-pull-6{position:relative;right:25%}.el-col-xl-push-6{position:relative;left:25%}.el-col-xl-7{width:29.16667%}.el-col-xl-offset-7{margin-left:29.16667%}.el-col-xl-pull-7{position:relative;right:29.16667%}.el-col-xl-push-7{position:relative;left:29.16667%}.el-col-xl-8{width:33.33333%}.el-col-xl-offset-8{margin-left:33.33333%}.el-col-xl-pull-8{position:relative;right:33.33333%}.el-col-xl-push-8{position:relative;left:33.33333%}.el-col-xl-9{width:37.5%}.el-col-xl-offset-9{margin-left:37.5%}.el-col-xl-pull-9{position:relative;right:37.5%}.el-col-xl-push-9{position:relative;left:37.5%}.el-col-xl-10{width:41.66667%}.el-col-xl-offset-10{margin-left:41.66667%}.el-col-xl-pull-10{position:relative;right:41.66667%}.el-col-xl-push-10{position:relative;left:41.66667%}.el-col-xl-11{width:45.83333%}.el-col-xl-offset-11{margin-left:45.83333%}.el-col-xl-pull-11{position:relative;right:45.83333%}.el-col-xl-push-11{position:relative;left:45.83333%}.el-col-xl-12{width:50%}.el-col-xl-offset-12{margin-left:50%}.el-col-xl-pull-12{position:relative;right:50%}.el-col-xl-push-12{position:relative;left:50%}.el-col-xl-13{width:54.16667%}.el-col-xl-offset-13{margin-left:54.16667%}.el-col-xl-pull-13{position:relative;right:54.16667%}.el-col-xl-push-13{position:relative;left:54.16667%}.el-col-xl-14{width:58.33333%}.el-col-xl-offset-14{margin-left:58.33333%}.el-col-xl-pull-14{position:relative;right:58.33333%}.el-col-xl-push-14{position:relative;left:58.33333%}.el-col-xl-15{width:62.5%}.el-col-xl-offset-15{margin-left:62.5%}.el-col-xl-pull-15{position:relative;right:62.5%}.el-col-xl-push-15{position:relative;left:62.5%}.el-col-xl-16{width:66.66667%}.el-col-xl-offset-16{margin-left:66.66667%}.el-col-xl-pull-16{position:relative;right:66.66667%}.el-col-xl-push-16{position:relative;left:66.66667%}.el-col-xl-17{width:70.83333%}.el-col-xl-offset-17{margin-left:70.83333%}.el-col-xl-pull-17{position:relative;right:70.83333%}.el-col-xl-push-17{position:relative;left:70.83333%}.el-col-xl-18{width:75%}.el-col-xl-offset-18{margin-left:75%}.el-col-xl-pull-18{position:relative;right:75%}.el-col-xl-push-18{position:relative;left:75%}.el-col-xl-19{width:79.16667%}.el-col-xl-offset-19{margin-left:79.16667%}.el-col-xl-pull-19{position:relative;right:79.16667%}.el-col-xl-push-19{position:relative;left:79.16667%}.el-col-xl-20{width:83.33333%}.el-col-xl-offset-20{margin-left:83.33333%}.el-col-xl-pull-20{position:relative;right:83.33333%}.el-col-xl-push-20{position:relative;left:83.33333%}.el-col-xl-21{width:87.5%}.el-col-xl-offset-21{margin-left:87.5%}.el-col-xl-pull-21{position:relative;right:87.5%}.el-col-xl-push-21{position:relative;left:87.5%}.el-col-xl-22{width:91.66667%}.el-col-xl-offset-22{margin-left:91.66667%}.el-col-xl-pull-22{position:relative;right:91.66667%}.el-col-xl-push-22{position:relative;left:91.66667%}.el-col-xl-23{width:95.83333%}.el-col-xl-offset-23{margin-left:95.83333%}.el-col-xl-pull-23{position:relative;right:95.83333%}.el-col-xl-push-23{position:relative;left:95.83333%}.el-col-xl-24{width:100%}.el-col-xl-offset-24{margin-left:100%}.el-col-xl-pull-24{position:relative;right:100%}.el-col-xl-push-24{position:relative;left:100%}}@-webkit-keyframes progress{0%{background-position:0 0}to{background-position:32px 0}}.el-upload{display:inline-block;text-align:center;cursor:pointer;outline:0}.el-upload__input{display:none}.el-upload__tip{font-size:12px;color:#606266;margin-top:7px}.el-upload iframe{position:absolute;z-index:-1;top:0;left:0;filter:alpha(opacity=0)}.el-upload--picture-card{background-color:#fbfdff;border:1px dashed #c0ccda;border-radius:6px;box-sizing:border-box;width:148px;height:148px;cursor:pointer;line-height:146px;vertical-align:top}.el-upload--picture-card i{font-size:28px;color:#8c939d}.el-upload--picture-card:hover,.el-upload:focus{border-color:#409eff;color:#409eff}.el-upload:focus .el-upload-dragger{border-color:#409eff}.el-upload-dragger{background-color:#fff;border:1px dashed #d9d9d9;border-radius:6px;box-sizing:border-box;width:360px;height:180px;text-align:center;cursor:pointer;overflow:hidden}.el-upload-dragger .el-icon-upload{font-size:67px;color:#c0c4cc;margin:40px 0 16px;line-height:50px}.el-upload-dragger+.el-upload__tip{text-align:center}.el-upload-dragger~.el-upload__files{border-top:1px solid #dcdfe6;margin-top:7px;padding-top:5px}.el-upload-dragger .el-upload__text{color:#606266;font-size:14px;text-align:center}.el-upload-dragger .el-upload__text em{color:#409eff;font-style:normal}.el-upload-dragger:hover{border-color:#409eff}.el-upload-dragger.is-dragover{background-color:rgba(32,159,255,.06);border:2px dashed #409eff}.el-upload-list{margin:0;padding:0;list-style:none}.el-upload-list__item{transition:all .5s cubic-bezier(.55,0,.1,1);font-size:14px;color:#606266;line-height:1.8;margin-top:5px;box-sizing:border-box;border-radius:4px;width:100%}.el-upload-list__item .el-progress{position:absolute;top:20px;width:100%}.el-upload-list__item .el-progress__text{position:absolute;right:0;top:-13px}.el-upload-list__item .el-progress-bar{margin-right:0;padding-right:0}.el-upload-list__item:first-child{margin-top:10px}.el-upload-list__item .el-icon-upload-success{color:#67c23a}.el-upload-list__item .el-icon-close{display:none;position:absolute;top:5px;right:5px;cursor:pointer;opacity:.75;color:#606266}.el-upload-list__item .el-icon-close:hover{opacity:1}.el-upload-list__item .el-icon-close-tip{display:none;position:absolute;top:5px;right:5px;font-size:12px;cursor:pointer;opacity:1;color:#409eff}.el-upload-list__item:hover .el-icon-close{display:inline-block}.el-upload-list__item:hover .el-progress__text{display:none}.el-upload-list__item.is-success .el-upload-list__item-status-label{display:block}.el-upload-list__item.is-success .el-upload-list__item-name:focus,.el-upload-list__item.is-success .el-upload-list__item-name:hover{color:#409eff;cursor:pointer}.el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip{display:inline-block}.el-upload-list__item.is-success:active,.el-upload-list__item.is-success:not(.focusing):focus{outline-width:0}.el-upload-list__item.is-success:active .el-icon-close-tip,.el-upload-list__item.is-success:focus .el-upload-list__item-status-label,.el-upload-list__item.is-success:hover .el-upload-list__item-status-label,.el-upload-list__item.is-success:not(.focusing):focus .el-icon-close-tip{display:none}.el-upload-list.is-disabled .el-upload-list__item:hover .el-upload-list__item-status-label{display:block}.el-upload-list__item-name{color:#606266;display:block;margin-right:40px;overflow:hidden;padding-left:4px;text-overflow:ellipsis;transition:color .3s;white-space:nowrap}.el-upload-list__item-name [class^=el-icon]{height:100%;margin-right:7px;color:#909399;line-height:inherit}.el-upload-list__item-status-label{position:absolute;right:5px;top:0;line-height:inherit;display:none}.el-upload-list__item-delete{position:absolute;right:10px;top:0;font-size:12px;color:#606266;display:none}.el-upload-list__item-delete:hover{color:#409eff}.el-upload-list--picture-card{margin:0;display:inline;vertical-align:top}.el-upload-list--picture-card .el-upload-list__item{overflow:hidden;background-color:#fff;border:1px solid #c0ccda;border-radius:6px;box-sizing:border-box;width:148px;height:148px;margin:0 8px 8px 0;display:inline-block}.el-upload-list--picture-card .el-upload-list__item .el-icon-check,.el-upload-list--picture-card .el-upload-list__item .el-icon-circle-check{color:#fff}.el-upload-list--picture-card .el-upload-list__item .el-icon-close,.el-upload-list--picture-card .el-upload-list__item:hover .el-upload-list__item-status-label{display:none}.el-upload-list--picture-card .el-upload-list__item:hover .el-progress__text{display:block}.el-upload-list--picture-card .el-upload-list__item-name{display:none}.el-upload-list--picture-card .el-upload-list__item-thumbnail{width:100%;height:100%}.el-upload-list--picture-card .el-upload-list__item-status-label{position:absolute;right:-15px;top:-6px;width:40px;height:24px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);box-shadow:0 0 1pc 1px rgba(0,0,0,.2)}.el-upload-list--picture-card .el-upload-list__item-status-label i{font-size:12px;margin-top:11px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.el-upload-list--picture-card .el-upload-list__item-actions{position:absolute;width:100%;height:100%;left:0;top:0;cursor:default;text-align:center;color:#fff;opacity:0;font-size:20px;background-color:rgba(0,0,0,.5);transition:opacity .3s}.el-upload-list--picture-card .el-upload-list__item-actions:after{display:inline-block;height:100%;vertical-align:middle}.el-upload-list--picture-card .el-upload-list__item-actions span{display:none;cursor:pointer}.el-upload-list--picture-card .el-upload-list__item-actions span+span{margin-left:15px}.el-upload-list--picture-card .el-upload-list__item-actions .el-upload-list__item-delete{position:static;font-size:inherit;color:inherit}.el-upload-list--picture-card .el-upload-list__item-actions:hover{opacity:1}.el-upload-list--picture-card .el-upload-list__item-actions:hover span{display:inline-block}.el-upload-list--picture-card .el-progress{top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);bottom:auto;width:126px}.el-upload-list--picture-card .el-progress .el-progress__text{top:50%}.el-upload-list--picture .el-upload-list__item{overflow:hidden;z-index:0;background-color:#fff;border:1px solid #c0ccda;border-radius:6px;box-sizing:border-box;margin-top:10px;padding:10px 10px 10px 90px;height:92px}.el-upload-list--picture .el-upload-list__item .el-icon-check,.el-upload-list--picture .el-upload-list__item .el-icon-circle-check{color:#fff}.el-upload-list--picture .el-upload-list__item:hover .el-upload-list__item-status-label{background:0 0;box-shadow:none;top:-2px;right:-12px}.el-upload-list--picture .el-upload-list__item:hover .el-progress__text{display:block}.el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name{line-height:70px;margin-top:0}.el-upload-list--picture .el-upload-list__item.is-success .el-upload-list__item-name i{display:none}.el-upload-list--picture .el-upload-list__item-thumbnail{vertical-align:middle;display:inline-block;width:70px;height:70px;float:left;position:relative;z-index:1;margin-left:-80px;background-color:#fff}.el-upload-list--picture .el-upload-list__item-name{display:block;margin-top:20px}.el-upload-list--picture .el-upload-list__item-name i{font-size:70px;line-height:1;position:absolute;left:9px;top:10px}.el-upload-list--picture .el-upload-list__item-status-label{position:absolute;right:-17px;top:-7px;width:46px;height:26px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);box-shadow:0 1px 1px #ccc}.el-upload-list--picture .el-upload-list__item-status-label i{font-size:12px;margin-top:12px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.el-upload-list--picture .el-progress{position:relative;top:-7px}.el-upload-cover{position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden;z-index:10;cursor:default}.el-upload-cover:after{display:inline-block;height:100%;vertical-align:middle}.el-upload-cover img{display:block;width:100%;height:100%}.el-upload-cover__label{position:absolute;right:-15px;top:-6px;width:40px;height:24px;background:#13ce66;text-align:center;-webkit-transform:rotate(45deg);transform:rotate(45deg);box-shadow:0 0 1pc 1px rgba(0,0,0,.2)}.el-upload-cover__label i{font-size:12px;margin-top:11px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);color:#fff}.el-upload-cover__progress{display:inline-block;vertical-align:middle;position:static;width:243px}.el-upload-cover__progress+.el-upload__inner{opacity:0}.el-upload-cover__content{position:absolute;top:0;left:0;width:100%;height:100%}.el-upload-cover__interact{position:absolute;bottom:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,.72);text-align:center}.el-upload-cover__interact .btn{display:inline-block;color:#fff;font-size:14px;cursor:pointer;vertical-align:middle;transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);margin-top:60px}.el-upload-cover__interact .btn span{opacity:0;transition:opacity .15s linear}.el-upload-cover__interact .btn:not(:first-child){margin-left:35px}.el-upload-cover__interact .btn:hover{-webkit-transform:translateY(-13px);transform:translateY(-13px)}.el-upload-cover__interact .btn:hover span{opacity:1}.el-upload-cover__interact .btn i{color:#fff;display:block;font-size:24px;line-height:inherit;margin:0 auto 5px}.el-upload-cover__title{position:absolute;bottom:0;left:0;background-color:#fff;height:36px;width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:400;text-align:left;padding:0 10px;margin:0;line-height:36px;font-size:14px;color:#303133}.el-upload-cover+.el-upload__inner{opacity:0;position:relative;z-index:1}.el-progress{position:relative;line-height:1}.el-progress__text{font-size:14px;color:#606266;display:inline-block;vertical-align:middle;margin-left:10px;line-height:1}.el-progress__text i{vertical-align:middle;display:block}.el-progress--circle,.el-progress--dashboard{display:inline-block}.el-progress--circle .el-progress__text,.el-progress--dashboard .el-progress__text{position:absolute;top:50%;left:0;width:100%;text-align:center;margin:0;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-progress--circle .el-progress__text i,.el-progress--dashboard .el-progress__text i{vertical-align:middle;display:inline-block}.el-progress--without-text .el-progress__text{display:none}.el-progress--without-text .el-progress-bar{padding-right:0;margin-right:0;display:block}.el-progress--text-inside .el-progress-bar{padding-right:0;margin-right:0}.el-progress.is-success .el-progress-bar__inner{background-color:#67c23a}.el-progress.is-success .el-progress__text{color:#67c23a}.el-progress.is-warning .el-progress-bar__inner{background-color:#e6a23c}.el-badge__content,.el-progress.is-exception .el-progress-bar__inner{background-color:#f56c6c}.el-progress.is-warning .el-progress__text{color:#e6a23c}.el-progress.is-exception .el-progress__text{color:#f56c6c}.el-progress-bar{padding-right:50px;display:inline-block;vertical-align:middle;width:100%;margin-right:-55px;box-sizing:border-box}.el-card__header,.el-message,.el-step__icon{-webkit-box-sizing:border-box}.el-progress-bar__outer{height:6px;border-radius:100px;background-color:#ebeef5;overflow:hidden;position:relative;vertical-align:middle}.el-progress-bar__inner{position:absolute;left:0;top:0;height:100%;background-color:#409eff;text-align:right;border-radius:100px;line-height:1;white-space:nowrap;transition:width .6s ease}.el-progress-bar__inner:after{display:inline-block;height:100%;vertical-align:middle}.el-progress-bar__innerText{display:inline-block;vertical-align:middle;color:#fff;font-size:12px;margin:0 5px}@keyframes progress{0%{background-position:0 0}to{background-position:32px 0}}.el-time-spinner{width:100%;white-space:nowrap}.el-spinner{display:inline-block;vertical-align:middle}.el-spinner-inner{-webkit-animation:rotate 2s linear infinite;animation:rotate 2s linear infinite;width:50px;height:50px}.el-spinner-inner .path{stroke:#ececec;stroke-linecap:round;-webkit-animation:dash 1.5s ease-in-out infinite;animation:dash 1.5s ease-in-out infinite}@-webkit-keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@-webkit-keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.el-message{min-width:380px;box-sizing:border-box;border-radius:4px;border:1px solid #ebeef5;position:fixed;left:50%;top:20px;-webkit-transform:translateX(-50%);transform:translateX(-50%);background-color:#edf2fc;transition:opacity .3s,top .4s,-webkit-transform .4s;transition:opacity .3s,transform .4s,top .4s;transition:opacity .3s,transform .4s,top .4s,-webkit-transform .4s;overflow:hidden;padding:15px 15px 15px 20px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-message.is-center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-message.is-closable .el-message__content{padding-right:16px}.el-message p{margin:0}.el-message--info .el-message__content{color:#909399}.el-message--success{background-color:#f0f9eb;border-color:#e1f3d8}.el-message--success .el-message__content{color:#67c23a}.el-message--warning{background-color:#fdf6ec;border-color:#faecd8}.el-message--warning .el-message__content{color:#e6a23c}.el-message--error{background-color:#fef0f0;border-color:#fde2e2}.el-message--error .el-message__content{color:#f56c6c}.el-message__icon{margin-right:10px}.el-message__content{padding:0;font-size:14px;line-height:1}.el-message__content:focus{outline-width:0}.el-message__closeBtn{position:absolute;top:50%;right:15px;-webkit-transform:translateY(-50%);transform:translateY(-50%);cursor:pointer;color:#c0c4cc;font-size:16px}.el-message__closeBtn:focus{outline-width:0}.el-message__closeBtn:hover{color:#909399}.el-message .el-icon-success{color:#67c23a}.el-message .el-icon-error{color:#f56c6c}.el-message .el-icon-info{color:#909399}.el-message .el-icon-warning{color:#e6a23c}.el-message-fade-enter,.el-message-fade-leave-active{opacity:0;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.el-badge{position:relative;vertical-align:middle;display:inline-block}.el-badge__content{border-radius:10px;color:#fff;display:inline-block;font-size:12px;height:18px;line-height:18px;padding:0 6px;text-align:center;white-space:nowrap;border:1px solid #fff}.el-badge__content.is-fixed{position:absolute;top:0;right:10px;-webkit-transform:translateY(-50%) translateX(100%);transform:translateY(-50%) translateX(100%)}.el-rate__icon,.el-rate__item{position:relative;display:inline-block}.el-badge__content.is-fixed.is-dot{right:5px}.el-badge__content.is-dot{height:8px;width:8px;padding:0;right:0;border-radius:50%}.el-badge__content--primary{background-color:#409eff}.el-badge__content--success{background-color:#67c23a}.el-badge__content--warning{background-color:#e6a23c}.el-badge__content--info{background-color:#909399}.el-badge__content--danger{background-color:#f56c6c}.el-card{border-radius:4px;border:1px solid #ebeef5;background-color:#fff;overflow:hidden;color:#303133;transition:.3s}.el-card.is-always-shadow,.el-card.is-hover-shadow:focus,.el-card.is-hover-shadow:hover{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-card__header{padding:18px 20px;border-bottom:1px solid #ebeef5;box-sizing:border-box}.el-card__body,.el-main{padding:20px}.el-rate{height:20px;line-height:1}.el-rate:active,.el-rate:focus{outline-width:0}.el-rate__item{font-size:0;vertical-align:middle}.el-rate__icon{font-size:18px;margin-right:6px;color:#c0c4cc;transition:.3s}.el-rate__decimal,.el-rate__icon .path2{position:absolute;top:0;left:0}.el-rate__icon.hover{-webkit-transform:scale(1.15);transform:scale(1.15)}.el-rate__decimal{display:inline-block;overflow:hidden}.el-step.is-vertical,.el-steps{display:-webkit-box;display:-ms-flexbox}.el-rate__text{font-size:14px;vertical-align:middle}.el-steps{display:-webkit-box;display:-ms-flexbox;display:flex}.el-steps--simple{padding:13px 8%;border-radius:4px;background:#f5f7fa}.el-steps--horizontal{white-space:nowrap}.el-steps--vertical{height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column;flex-flow:column}.el-step{position:relative;-ms-flex-negative:1;flex-shrink:1}.el-step:last-of-type .el-step__line{display:none}.el-step:last-of-type.is-flex{-ms-flex-preferred-size:auto!important;flex-basis:auto!important;-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}.el-step:last-of-type .el-step__description,.el-step:last-of-type .el-step__main{padding-right:0}.el-step__head{position:relative;width:100%}.el-step__head.is-process{color:#303133;border-color:#303133}.el-step__head.is-wait{color:#c0c4cc;border-color:#c0c4cc}.el-step__head.is-success{color:#67c23a;border-color:#67c23a}.el-step__head.is-error{color:#f56c6c;border-color:#f56c6c}.el-step__head.is-finish{color:#409eff;border-color:#409eff}.el-step__icon{position:relative;z-index:1;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:24px;height:24px;font-size:14px;box-sizing:border-box;background:#fff;transition:.15s ease-out}.el-step.is-horizontal,.el-step__icon-inner{display:inline-block}.el-step__icon.is-text{border-radius:50%;border:2px solid;border-color:inherit}.el-step__icon.is-icon{width:40px}.el-step__icon-inner{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;text-align:center;font-weight:700;line-height:1;color:inherit}.el-step__icon-inner[class*=el-icon]:not(.is-status){font-size:25px;font-weight:400}.el-step__icon-inner.is-status{-webkit-transform:translateY(1px);transform:translateY(1px)}.el-step__line{position:absolute;border-color:inherit;background-color:#c0c4cc}.el-step__line-inner{display:block;border-width:1px;border-style:solid;border-color:inherit;transition:.15s ease-out;box-sizing:border-box;width:0;height:0}.el-step__main{white-space:normal;text-align:left}.el-step__title{font-size:16px;line-height:38px}.el-step__title.is-process{font-weight:700;color:#303133}.el-step__title.is-wait{color:#c0c4cc}.el-step__title.is-success{color:#67c23a}.el-step__title.is-error{color:#f56c6c}.el-step__title.is-finish{color:#409eff}.el-step__description{padding-right:10%;margin-top:-5px;font-size:12px;line-height:20px;font-weight:400}.el-step__description.is-process{color:#303133}.el-step__description.is-wait{color:#c0c4cc}.el-step__description.is-success{color:#67c23a}.el-step__description.is-error{color:#f56c6c}.el-step__description.is-finish{color:#409eff}.el-step.is-horizontal .el-step__line{height:2px;top:11px;left:0;right:0}.el-step.is-vertical{display:-webkit-box;display:-ms-flexbox;display:flex}.el-step.is-vertical .el-step__head{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;width:24px}.el-step.is-vertical .el-step__main{padding-left:10px;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.el-step.is-vertical .el-step__title{line-height:24px;padding-bottom:8px}.el-step.is-vertical .el-step__line{width:2px;top:0;bottom:0;left:11px}.el-step.is-vertical .el-step__icon.is-icon{width:24px}.el-step.is-center .el-step__head,.el-step.is-center .el-step__main{text-align:center}.el-step.is-center .el-step__description{padding-left:20%;padding-right:20%}.el-step.is-center .el-step__line{left:50%;right:-50%}.el-step.is-simple{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-step.is-simple .el-step__head{width:auto;font-size:0;padding-right:10px}.el-step.is-simple .el-step__icon{background:0 0;width:16px;height:16px;font-size:12px}.el-step.is-simple .el-step__icon-inner[class*=el-icon]:not(.is-status){font-size:18px}.el-step.is-simple .el-step__icon-inner.is-status{-webkit-transform:scale(.8) translateY(1px);transform:scale(.8) translateY(1px)}.el-step.is-simple .el-step__main{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.el-step.is-simple .el-step__title{font-size:16px;line-height:20px}.el-step.is-simple:not(:last-of-type) .el-step__title{max-width:50%;word-break:break-all}.el-step.is-simple .el-step__arrow{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.el-step.is-simple .el-step__arrow:after,.el-step.is-simple .el-step__arrow:before{content:\"\";display:inline-block;position:absolute;height:15px;width:1px;background:#c0c4cc}.el-step.is-simple .el-step__arrow:before{-webkit-transform:rotate(-45deg) translateY(-4px);transform:rotate(-45deg) translateY(-4px);-webkit-transform-origin:0 0;transform-origin:0 0}.el-step.is-simple .el-step__arrow:after{-webkit-transform:rotate(45deg) translateY(4px);transform:rotate(45deg) translateY(4px);-webkit-transform-origin:100% 100%;transform-origin:100% 100%}.el-step.is-simple:last-of-type .el-step__arrow{display:none}.el-carousel{position:relative}.el-carousel--horizontal{overflow-x:hidden}.el-carousel--vertical{overflow-y:hidden}.el-carousel__container{position:relative;height:300px}.el-carousel__arrow{border:none;outline:0;padding:0;margin:0;height:36px;width:36px;cursor:pointer;transition:.3s;border-radius:50%;background-color:rgba(31,45,61,.11);color:#fff;position:absolute;top:50%;z-index:10;-webkit-transform:translateY(-50%);transform:translateY(-50%);text-align:center;font-size:12px}.el-carousel__arrow--left{left:16px}.el-carousel__arrow:hover{background-color:rgba(31,45,61,.23)}.el-carousel__arrow i{cursor:pointer}.el-carousel__indicators{position:absolute;list-style:none;margin:0;padding:0;z-index:2}.el-carousel__indicators--horizontal{bottom:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.el-carousel__indicators--vertical{right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-carousel__indicators--outside{bottom:26px;text-align:center;position:static;-webkit-transform:none;transform:none}.el-carousel__indicators--outside .el-carousel__indicator:hover button{opacity:.64}.el-carousel__indicators--outside button{background-color:#c0c4cc;opacity:.24}.el-carousel__indicators--labels{left:0;right:0;-webkit-transform:none;transform:none;text-align:center}.el-carousel__indicators--labels .el-carousel__button{height:auto;width:auto;padding:2px 18px;font-size:12px}.el-carousel__indicators--labels .el-carousel__indicator{padding:6px 4px}.el-carousel__indicator{background-color:transparent;cursor:pointer}.el-carousel__indicator:hover button{opacity:.72}.el-carousel__indicator--horizontal{display:inline-block;padding:12px 4px}.el-carousel__indicator--vertical{padding:4px 12px}.el-carousel__indicator--vertical .el-carousel__button{width:2px;height:15px}.el-carousel__indicator.is-active button{opacity:1}.el-carousel__button{display:block;opacity:.48;width:30px;height:2px;background-color:#fff;border:none;outline:0;padding:0;margin:0;cursor:pointer;transition:.3s}.el-carousel__item,.el-carousel__mask{height:100%;position:absolute;top:0;left:0}.carousel-arrow-left-enter,.carousel-arrow-left-leave-active{-webkit-transform:translateY(-50%) translateX(-10px);transform:translateY(-50%) translateX(-10px);opacity:0}.carousel-arrow-right-enter,.carousel-arrow-right-leave-active{-webkit-transform:translateY(-50%) translateX(10px);transform:translateY(-50%) translateX(10px);opacity:0}.el-carousel__item{width:100%;display:inline-block;overflow:hidden;z-index:0}.el-carousel__item.is-active{z-index:2}.el-carousel__item--card,.el-carousel__item.is-animating{transition:-webkit-transform .4s ease-in-out;transition:transform .4s ease-in-out;transition:transform .4s ease-in-out,-webkit-transform .4s ease-in-out}.el-carousel__item--card{width:50%}.el-carousel__item--card.is-in-stage{cursor:pointer;z-index:1}.el-carousel__item--card.is-in-stage.is-hover .el-carousel__mask,.el-carousel__item--card.is-in-stage:hover .el-carousel__mask{opacity:.12}.el-carousel__item--card.is-active{z-index:2}.el-carousel__mask{width:100%;background-color:#fff;opacity:.24;transition:.2s}.fade-in-linear-enter-active,.fade-in-linear-leave-active{transition:opacity .2s linear}.fade-in-linear-enter,.fade-in-linear-leave,.fade-in-linear-leave-active{opacity:0}.el-fade-in-linear-enter-active,.el-fade-in-linear-leave-active{transition:opacity .2s linear}.el-fade-in-linear-enter,.el-fade-in-linear-leave,.el-fade-in-linear-leave-active{opacity:0}.el-fade-in-enter-active,.el-fade-in-leave-active{transition:all .3s cubic-bezier(.55,0,.1,1)}.el-fade-in-enter,.el-fade-in-leave-active{opacity:0}.el-zoom-in-center-enter-active,.el-zoom-in-center-leave-active{transition:all .3s cubic-bezier(.55,0,.1,1)}.el-zoom-in-center-enter,.el-zoom-in-center-leave-active{opacity:0;-webkit-transform:scaleX(0);transform:scaleX(0)}.el-zoom-in-top-enter-active,.el-zoom-in-top-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center top;transform-origin:center top}.el-zoom-in-top-enter,.el-zoom-in-top-leave-active{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.el-zoom-in-bottom-enter-active,.el-zoom-in-bottom-leave-active{opacity:1;-webkit-transform:scaleY(1);transform:scaleY(1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:center bottom;transform-origin:center bottom}.el-zoom-in-bottom-enter,.el-zoom-in-bottom-leave-active{opacity:0;-webkit-transform:scaleY(0);transform:scaleY(0)}.el-zoom-in-left-enter-active,.el-zoom-in-left-leave-active{opacity:1;-webkit-transform:scale(1);transform:scale(1);transition:opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1);transition:transform .3s cubic-bezier(.23,1,.32,1),opacity .3s cubic-bezier(.23,1,.32,1),-webkit-transform .3s cubic-bezier(.23,1,.32,1);-webkit-transform-origin:top left;transform-origin:top left}.el-zoom-in-left-enter,.el-zoom-in-left-leave-active{opacity:0;-webkit-transform:scale(.45);transform:scale(.45)}.collapse-transition{transition:height .3s ease-in-out,padding-top .3s ease-in-out,padding-bottom .3s ease-in-out}.horizontal-collapse-transition{transition:width .3s ease-in-out,padding-left .3s ease-in-out,padding-right .3s ease-in-out}.el-list-enter-active,.el-list-leave-active{transition:all 1s}.el-list-enter,.el-list-leave-active{opacity:0;-webkit-transform:translateY(-30px);transform:translateY(-30px)}.el-opacity-transition{transition:opacity .3s cubic-bezier(.55,0,.1,1)}.el-collapse{border-top:1px solid #ebeef5;border-bottom:1px solid #ebeef5}.el-collapse-item.is-disabled .el-collapse-item__header{color:#bbb;cursor:not-allowed}.el-collapse-item__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:48px;line-height:48px;background-color:#fff;color:#303133;cursor:pointer;border-bottom:1px solid #ebeef5;font-size:13px;font-weight:500;transition:border-bottom-color .3s;outline:0}.el-collapse-item__arrow{margin:0 8px 0 auto;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;font-weight:300}.el-collapse-item__arrow.is-active{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.el-collapse-item__header.focusing:focus:not(:hover){color:#409eff}.el-collapse-item__header.is-active{border-bottom-color:transparent}.el-collapse-item__wrap{will-change:height;background-color:#fff;overflow:hidden;box-sizing:border-box;border-bottom:1px solid #ebeef5}.el-cascader__search-input,.el-cascader__tags,.el-tag{-webkit-box-sizing:border-box}.el-collapse-item__content{padding-bottom:25px;font-size:13px;color:#303133;line-height:1.769230769230769}.el-collapse-item:last-child{margin-bottom:-1px}.el-popper .popper__arrow,.el-popper .popper__arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.el-cascader,.el-tag{display:inline-block}.el-popper .popper__arrow{border-width:6px;-webkit-filter:drop-shadow(0 2px 12px rgba(0,0,0,.03));filter:drop-shadow(0 2px 12px rgba(0,0,0,.03))}.el-popper .popper__arrow:after{content:\" \";border-width:6px}.el-popper[x-placement^=top]{margin-bottom:12px}.el-popper[x-placement^=top] .popper__arrow{bottom:-6px;left:50%;margin-right:3px;border-top-color:#ebeef5;border-bottom-width:0}.el-popper[x-placement^=top] .popper__arrow:after{bottom:1px;margin-left:-6px;border-top-color:#fff;border-bottom-width:0}.el-popper[x-placement^=bottom]{margin-top:12px}.el-popper[x-placement^=bottom] .popper__arrow{top:-6px;left:50%;margin-right:3px;border-top-width:0;border-bottom-color:#ebeef5}.el-popper[x-placement^=bottom] .popper__arrow:after{top:1px;margin-left:-6px;border-top-width:0;border-bottom-color:#fff}.el-popper[x-placement^=right]{margin-left:12px}.el-popper[x-placement^=right] .popper__arrow{top:50%;left:-6px;margin-bottom:3px;border-right-color:#ebeef5;border-left-width:0}.el-popper[x-placement^=right] .popper__arrow:after{bottom:-6px;left:1px;border-right-color:#fff;border-left-width:0}.el-popper[x-placement^=left]{margin-right:12px}.el-popper[x-placement^=left] .popper__arrow{top:50%;right:-6px;margin-bottom:3px;border-right-width:0;border-left-color:#ebeef5}.el-popper[x-placement^=left] .popper__arrow:after{right:1px;bottom:-6px;margin-left:-6px;border-right-width:0;border-left-color:#fff}.el-tag{background-color:#ecf5ff;border:1px solid #d9ecff;height:32px;padding:0 10px;line-height:30px;font-size:12px;color:#409eff;border-radius:4px;box-sizing:border-box;white-space:nowrap}.el-tag.is-hit{border-color:#409eff}.el-tag .el-tag__close{color:#409eff}.el-tag .el-tag__close:hover{color:#fff;background-color:#409eff}.el-tag.el-tag--info{background-color:#f4f4f5;border-color:#e9e9eb;color:#909399}.el-tag.el-tag--info.is-hit{border-color:#909399}.el-tag.el-tag--info .el-tag__close{color:#909399}.el-tag.el-tag--info .el-tag__close:hover{color:#fff;background-color:#909399}.el-tag.el-tag--success{background-color:#f0f9eb;border-color:#e1f3d8;color:#67c23a}.el-tag.el-tag--success.is-hit{border-color:#67c23a}.el-tag.el-tag--success .el-tag__close{color:#67c23a}.el-tag.el-tag--success .el-tag__close:hover{color:#fff;background-color:#67c23a}.el-tag.el-tag--warning{background-color:#fdf6ec;border-color:#faecd8;color:#e6a23c}.el-tag.el-tag--warning.is-hit{border-color:#e6a23c}.el-tag.el-tag--warning .el-tag__close{color:#e6a23c}.el-tag.el-tag--warning .el-tag__close:hover{color:#fff;background-color:#e6a23c}.el-tag.el-tag--danger{background-color:#fef0f0;border-color:#fde2e2;color:#f56c6c}.el-tag.el-tag--danger.is-hit{border-color:#f56c6c}.el-tag.el-tag--danger .el-tag__close{color:#f56c6c}.el-tag.el-tag--danger .el-tag__close:hover{color:#fff;background-color:#f56c6c}.el-tag .el-icon-close{border-radius:50%;text-align:center;position:relative;cursor:pointer;font-size:12px;height:16px;width:16px;line-height:16px;vertical-align:middle;top:-1px;right:-5px}.el-tag .el-icon-close:before{display:block}.el-tag--dark{background-color:#409eff;color:#fff}.el-tag--dark,.el-tag--dark.is-hit{border-color:#409eff}.el-tag--dark .el-tag__close{color:#fff}.el-tag--dark .el-tag__close:hover{color:#fff;background-color:#66b1ff}.el-tag--dark.el-tag--info{background-color:#909399;border-color:#909399;color:#fff}.el-tag--dark.el-tag--info.is-hit{border-color:#909399}.el-tag--dark.el-tag--info .el-tag__close{color:#fff}.el-tag--dark.el-tag--info .el-tag__close:hover{color:#fff;background-color:#a6a9ad}.el-tag--dark.el-tag--success{background-color:#67c23a;border-color:#67c23a;color:#fff}.el-tag--dark.el-tag--success.is-hit{border-color:#67c23a}.el-tag--dark.el-tag--success .el-tag__close{color:#fff}.el-tag--dark.el-tag--success .el-tag__close:hover{color:#fff;background-color:#85ce61}.el-tag--dark.el-tag--warning{background-color:#e6a23c;border-color:#e6a23c;color:#fff}.el-tag--dark.el-tag--warning.is-hit{border-color:#e6a23c}.el-tag--dark.el-tag--warning .el-tag__close{color:#fff}.el-tag--dark.el-tag--warning .el-tag__close:hover{color:#fff;background-color:#ebb563}.el-tag--dark.el-tag--danger{background-color:#f56c6c;border-color:#f56c6c;color:#fff}.el-tag--dark.el-tag--danger.is-hit{border-color:#f56c6c}.el-tag--dark.el-tag--danger .el-tag__close{color:#fff}.el-tag--dark.el-tag--danger .el-tag__close:hover{color:#fff;background-color:#f78989}.el-tag--plain{background-color:#fff;border-color:#b3d8ff;color:#409eff}.el-tag--plain.is-hit{border-color:#409eff}.el-tag--plain .el-tag__close{color:#409eff}.el-tag--plain .el-tag__close:hover{color:#fff;background-color:#409eff}.el-tag--plain.el-tag--info{background-color:#fff;border-color:#d3d4d6;color:#909399}.el-tag--plain.el-tag--info.is-hit{border-color:#909399}.el-tag--plain.el-tag--info .el-tag__close{color:#909399}.el-tag--plain.el-tag--info .el-tag__close:hover{color:#fff;background-color:#909399}.el-tag--plain.el-tag--success{background-color:#fff;border-color:#c2e7b0;color:#67c23a}.el-tag--plain.el-tag--success.is-hit{border-color:#67c23a}.el-tag--plain.el-tag--success .el-tag__close{color:#67c23a}.el-tag--plain.el-tag--success .el-tag__close:hover{color:#fff;background-color:#67c23a}.el-tag--plain.el-tag--warning{background-color:#fff;border-color:#f5dab1;color:#e6a23c}.el-tag--plain.el-tag--warning.is-hit{border-color:#e6a23c}.el-tag--plain.el-tag--warning .el-tag__close{color:#e6a23c}.el-tag--plain.el-tag--warning .el-tag__close:hover{color:#fff;background-color:#e6a23c}.el-tag--plain.el-tag--danger{background-color:#fff;border-color:#fbc4c4;color:#f56c6c}.el-tag--plain.el-tag--danger.is-hit{border-color:#f56c6c}.el-tag--plain.el-tag--danger .el-tag__close{color:#f56c6c}.el-tag--plain.el-tag--danger .el-tag__close:hover{color:#fff;background-color:#f56c6c}.el-tag--medium{height:28px;line-height:26px}.el-tag--medium .el-icon-close{-webkit-transform:scale(.8);transform:scale(.8)}.el-tag--small{height:24px;padding:0 8px;line-height:22px}.el-tag--small .el-icon-close{-webkit-transform:scale(.8);transform:scale(.8)}.el-tag--mini{height:20px;padding:0 5px;line-height:19px}.el-tag--mini .el-icon-close{margin-left:-3px;-webkit-transform:scale(.7);transform:scale(.7)}.el-cascader{position:relative;font-size:14px;line-height:40px}.el-cascader:not(.is-disabled):hover .el-input__inner{cursor:pointer;border-color:#c0c4cc}.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input.is-focus .el-input__inner{border-color:#409eff}.el-cascader .el-input{cursor:pointer}.el-cascader .el-input .el-input__inner{text-overflow:ellipsis}.el-cascader .el-input .el-icon-arrow-down{transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s;font-size:14px}.el-cascader .el-input .el-icon-arrow-down.is-reverse{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.el-cascader .el-input .el-icon-circle-close:hover{color:#909399}.el-cascader--medium{font-size:14px;line-height:36px}.el-cascader--small{font-size:13px;line-height:32px}.el-cascader--mini{font-size:12px;line-height:28px}.el-cascader.is-disabled .el-cascader__label{z-index:2;color:#c0c4cc}.el-cascader__dropdown{margin:5px 0;font-size:14px;background:#fff;border:1px solid #e4e7ed;border-radius:4px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-cascader__tags{position:absolute;left:0;right:30px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;line-height:normal;text-align:left;box-sizing:border-box}.el-cascader__tags .el-tag{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;max-width:100%;margin:2px 0 2px 6px;text-overflow:ellipsis;background:#f0f2f5}.el-cascader__tags .el-tag:not(.is-hit){border-color:transparent}.el-cascader__tags .el-tag>span{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:hidden;text-overflow:ellipsis}.el-cascader__tags .el-tag .el-icon-close{-webkit-box-flex:0;-ms-flex:none;flex:none;background-color:#c0c4cc;color:#fff}.el-cascader__tags .el-tag .el-icon-close:hover{background-color:#909399}.el-cascader__suggestion-panel{border-radius:4px}.el-cascader__suggestion-list{max-height:204px;margin:0;padding:6px 0;font-size:14px;color:#606266;text-align:center}.el-cascader__suggestion-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:34px;padding:0 15px;text-align:left;outline:0;cursor:pointer}.el-cascader__suggestion-item:focus,.el-cascader__suggestion-item:hover{background:#f5f7fa}.el-cascader__suggestion-item.is-checked{color:#409eff;font-weight:700}.el-cascader__suggestion-item>span{margin-right:10px}.el-cascader__empty-text{margin:10px 0;color:#c0c4cc}.el-cascader__search-input{-webkit-box-flex:1;-ms-flex:1;flex:1;height:24px;min-width:60px;margin:2px 0 2px 15px;padding:0;color:#606266;border:none;outline:0;box-sizing:border-box}.el-cascader__search-input::-ms-input-placeholder{color:#c0c4cc}.el-cascader__search-input::-webkit-input-placeholder{color:#c0c4cc}.el-cascader__search-input:-ms-input-placeholder{color:#c0c4cc}.el-cascader__search-input::placeholder{color:#c0c4cc}.el-color-predefine{font-size:12px;margin-top:8px;width:280px}.el-color-predefine,.el-color-predefine__colors{display:-webkit-box;display:-ms-flexbox;display:flex}.el-color-predefine__colors{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-wrap:wrap;flex-wrap:wrap}.el-color-predefine__color-selector{margin:0 0 8px 8px;width:20px;height:20px;border-radius:4px;cursor:pointer}.el-color-predefine__color-selector:nth-child(10n+1){margin-left:0}.el-color-predefine__color-selector.selected{box-shadow:0 0 3px 2px #409eff}.el-color-predefine__color-selector>div{display:-webkit-box;display:-ms-flexbox;display:flex;height:100%;border-radius:3px}.el-color-predefine__color-selector.is-alpha{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-hue-slider{position:relative;box-sizing:border-box;width:280px;height:12px;background-color:red;padding:0 2px}.el-color-hue-slider__bar{position:relative;background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red);height:100%}.el-color-hue-slider__thumb{position:absolute;cursor:pointer;box-sizing:border-box;left:0;top:0;width:4px;height:100%;border-radius:1px;background:#fff;border:1px solid #f0f0f0;box-shadow:0 0 2px rgba(0,0,0,.6);z-index:1}.el-color-hue-slider.is-vertical{width:12px;height:180px;padding:2px 0}.el-color-hue-slider.is-vertical .el-color-hue-slider__bar{background:linear-gradient(180deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.el-color-hue-slider.is-vertical .el-color-hue-slider__thumb{left:0;top:0;width:100%;height:4px}.el-color-svpanel{position:relative;width:280px;height:180px}.el-color-svpanel__black,.el-color-svpanel__white{position:absolute;top:0;left:0;right:0;bottom:0}.el-color-svpanel__white{background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.el-color-svpanel__black{background:linear-gradient(0deg,#000,transparent)}.el-color-svpanel__cursor{position:absolute}.el-color-svpanel__cursor>div{cursor:head;width:4px;height:4px;box-shadow:0 0 0 1.5px #fff,inset 0 0 1px 1px rgba(0,0,0,.3),0 0 1px 2px rgba(0,0,0,.4);border-radius:50%;-webkit-transform:translate(-2px,-2px);transform:translate(-2px,-2px)}.el-color-alpha-slider{position:relative;box-sizing:border-box;width:280px;height:12px;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-alpha-slider__bar{position:relative;background:linear-gradient(90deg,hsla(0,0%,100%,0) 0,#fff);height:100%}.el-color-alpha-slider__thumb{position:absolute;cursor:pointer;box-sizing:border-box;left:0;top:0;width:4px;height:100%;border-radius:1px;background:#fff;border:1px solid #f0f0f0;box-shadow:0 0 2px rgba(0,0,0,.6);z-index:1}.el-color-alpha-slider.is-vertical{width:20px;height:180px}.el-color-alpha-slider.is-vertical .el-color-alpha-slider__bar{background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,#fff)}.el-color-alpha-slider.is-vertical .el-color-alpha-slider__thumb{left:0;top:0;width:100%;height:4px}.el-color-dropdown{width:300px}.el-color-dropdown__main-wrapper{margin-bottom:6px}.el-color-dropdown__main-wrapper:after{display:table;clear:both}.el-color-dropdown__btns{margin-top:6px;text-align:right}.el-color-dropdown__value{float:left;line-height:26px;font-size:12px;color:#000;width:160px}.el-color-dropdown__btn{border:1px solid #dcdcdc;color:#333;line-height:24px;border-radius:2px;padding:0 20px;cursor:pointer;background-color:transparent;outline:0;font-size:12px}.el-color-dropdown__btn[disabled]{color:#ccc;cursor:not-allowed}.el-color-dropdown__btn:hover{color:#409eff;border-color:#409eff}.el-color-dropdown__link-btn{cursor:pointer;color:#409eff;text-decoration:none;padding:15px;font-size:12px}.el-color-dropdown__link-btn:hover{color:tint(#409eff,20%)}.el-color-picker{display:inline-block;position:relative;line-height:normal;height:40px}.el-color-picker.is-disabled .el-color-picker__trigger{cursor:not-allowed}.el-color-picker--medium{height:36px}.el-color-picker--medium .el-color-picker__trigger{height:36px;width:36px}.el-color-picker--medium .el-color-picker__mask{height:34px;width:34px}.el-color-picker--small{height:32px}.el-color-picker--small .el-color-picker__trigger{height:32px;width:32px}.el-color-picker--small .el-color-picker__mask{height:30px;width:30px}.el-color-picker--small .el-color-picker__empty,.el-color-picker--small .el-color-picker__icon{-webkit-transform:translate3d(-50%,-50%,0) scale(.8);transform:translate3d(-50%,-50%,0) scale(.8)}.el-color-picker--mini{height:28px}.el-color-picker--mini .el-color-picker__trigger{height:28px;width:28px}.el-color-picker--mini .el-color-picker__mask{height:26px;width:26px}.el-color-picker--mini .el-color-picker__empty,.el-color-picker--mini .el-color-picker__icon{-webkit-transform:translate3d(-50%,-50%,0) scale(.8);transform:translate3d(-50%,-50%,0) scale(.8)}.el-color-picker__mask{height:38px;width:38px;border-radius:4px;position:absolute;top:1px;left:1px;z-index:1;cursor:not-allowed;background-color:hsla(0,0%,100%,.7)}.el-color-picker__trigger{display:inline-block;box-sizing:border-box;height:40px;width:40px;padding:4px;border:1px solid #e6e6e6;border-radius:4px;font-size:0;position:relative;cursor:pointer}.el-color-picker__color{position:relative;display:block;box-sizing:border-box;border:1px solid #999;border-radius:2px;width:100%;height:100%;text-align:center}.el-color-picker__icon,.el-input,.el-textarea{display:inline-block;width:100%}.el-color-picker__color.is-alpha{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)}.el-color-picker__color-inner{position:absolute;left:0;top:0;right:0;bottom:0}.el-color-picker__empty{color:#999}.el-color-picker__empty,.el-color-picker__icon{font-size:12px;position:absolute;top:50%;left:50%;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0)}.el-color-picker__icon{color:#fff;text-align:center}.el-input__prefix,.el-input__suffix{position:absolute;top:0;text-align:center}.el-color-picker__panel{position:absolute;z-index:10;padding:6px;box-sizing:content-box;background-color:#fff;border:1px solid #ebeef5;border-radius:4px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.el-input__inner,.el-textarea__inner,.el-transfer-panel{-webkit-box-sizing:border-box}.el-textarea{position:relative;vertical-align:bottom;font-size:14px}.el-textarea__inner{display:block;resize:vertical;padding:5px 15px;line-height:1.5;box-sizing:border-box;width:100%;font-size:inherit;color:#606266;background-color:#fff;background-image:none;border:1px solid #dcdfe6;border-radius:4px;transition:border-color .2s cubic-bezier(.645,.045,.355,1)}.el-textarea__inner::-ms-input-placeholder{color:#c0c4cc}.el-textarea__inner::-webkit-input-placeholder{color:#c0c4cc}.el-textarea__inner:-ms-input-placeholder{color:#c0c4cc}.el-textarea__inner::placeholder{color:#c0c4cc}.el-textarea__inner:hover{border-color:#c0c4cc}.el-textarea__inner:focus{outline:0;border-color:#409eff}.el-textarea .el-input__count{color:#909399;background:#fff;position:absolute;font-size:12px;bottom:5px;right:10px}.el-textarea.is-disabled .el-textarea__inner{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc;cursor:not-allowed}.el-textarea.is-disabled .el-textarea__inner::-ms-input-placeholder{color:#c0c4cc}.el-textarea.is-disabled .el-textarea__inner::-webkit-input-placeholder{color:#c0c4cc}.el-textarea.is-disabled .el-textarea__inner:-ms-input-placeholder{color:#c0c4cc}.el-textarea.is-disabled .el-textarea__inner::placeholder{color:#c0c4cc}.el-textarea.is-exceed .el-textarea__inner{border-color:#f56c6c}.el-textarea.is-exceed .el-input__count{color:#f56c6c}.el-input{position:relative;font-size:14px}.el-input::-webkit-scrollbar{z-index:11;width:6px}.el-input::-webkit-scrollbar:horizontal{height:6px}.el-input::-webkit-scrollbar-thumb{border-radius:5px;width:6px;background:#b4bccc}.el-input::-webkit-scrollbar-corner,.el-input::-webkit-scrollbar-track{background:#fff}.el-input::-webkit-scrollbar-track-piece{background:#fff;width:6px}.el-input .el-input__clear{color:#c0c4cc;font-size:14px;cursor:pointer;transition:color .2s cubic-bezier(.645,.045,.355,1)}.el-input .el-input__clear:hover{color:#909399}.el-input .el-input__count{height:100%;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#909399;font-size:12px}.el-input-group__append .el-button,.el-input-group__append .el-input,.el-input-group__prepend .el-button,.el-input-group__prepend .el-input,.el-input__inner{font-size:inherit}.el-input .el-input__count .el-input__count-inner{background:#fff;line-height:normal;display:inline-block;padding:0 5px}.el-input__inner{-webkit-appearance:none;background-color:#fff;background-image:none;border-radius:4px;border:1px solid #dcdfe6;box-sizing:border-box;color:#606266;display:inline-block;height:40px;line-height:40px;outline:0;padding:0 15px;transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%}.el-input__inner::-ms-reveal{display:none}.el-input__inner::-ms-input-placeholder{color:#c0c4cc}.el-input__inner::-webkit-input-placeholder{color:#c0c4cc}.el-input__inner:-ms-input-placeholder{color:#c0c4cc}.el-input__inner::placeholder{color:#c0c4cc}.el-input__inner:hover{border-color:#c0c4cc}.el-input.is-active .el-input__inner,.el-input__inner:focus{border-color:#409eff;outline:0}.el-input__suffix{height:100%;right:5px;transition:all .3s;pointer-events:none}.el-input__suffix-inner{pointer-events:all}.el-input__prefix{height:100%;left:5px;transition:all .3s}.el-input__icon{height:100%;width:25px;text-align:center;transition:all .3s;line-height:40px}.el-input__icon:after{content:\"\";height:100%;width:0;display:inline-block;vertical-align:middle}.el-input__validateIcon{pointer-events:none}.el-input.is-disabled .el-input__inner{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc;cursor:not-allowed}.el-input.is-disabled .el-input__inner::-ms-input-placeholder{color:#c0c4cc}.el-input.is-disabled .el-input__inner::-webkit-input-placeholder{color:#c0c4cc}.el-input.is-disabled .el-input__inner:-ms-input-placeholder{color:#c0c4cc}.el-input.is-disabled .el-input__inner::placeholder{color:#c0c4cc}.el-input.is-disabled .el-input__icon{cursor:not-allowed}.el-image-viewer__btn,.el-image__preview,.el-link,.el-transfer-panel__filter .el-icon-circle-close{cursor:pointer}.el-input.is-exceed .el-input__inner{border-color:#f56c6c}.el-input.is-exceed .el-input__suffix .el-input__count{color:#f56c6c}.el-input--suffix .el-input__inner{padding-right:30px}.el-input--prefix .el-input__inner{padding-left:30px}.el-input--medium{font-size:14px}.el-input--medium .el-input__inner{height:36px;line-height:36px}.el-input--medium .el-input__icon{line-height:36px}.el-input--small{font-size:13px}.el-input--small .el-input__inner{height:32px;line-height:32px}.el-input--small .el-input__icon{line-height:32px}.el-input--mini{font-size:12px}.el-input--mini .el-input__inner{height:28px;line-height:28px}.el-input--mini .el-input__icon{line-height:28px}.el-input-group{line-height:normal;display:inline-table;width:100%;border-collapse:separate;border-spacing:0}.el-input-group>.el-input__inner{vertical-align:middle;display:table-cell}.el-input-group__append,.el-input-group__prepend{background-color:#f5f7fa;color:#909399;vertical-align:middle;display:table-cell;position:relative;border:1px solid #dcdfe6;border-radius:4px;padding:0 20px;width:1px;white-space:nowrap}.el-input-group--append .el-input__inner,.el-input-group__prepend{border-top-right-radius:0;border-bottom-right-radius:0}.el-input-group__append:focus,.el-input-group__prepend:focus{outline:0}.el-input-group__append .el-button,.el-input-group__append .el-select,.el-input-group__prepend .el-button,.el-input-group__prepend .el-select{display:inline-block;margin:-10px -20px}.el-input-group__append button.el-button,.el-input-group__append div.el-select .el-input__inner,.el-input-group__append div.el-select:hover .el-input__inner,.el-input-group__prepend button.el-button,.el-input-group__prepend div.el-select .el-input__inner,.el-input-group__prepend div.el-select:hover .el-input__inner{border-color:transparent;background-color:transparent;color:inherit;border-top:0;border-bottom:0}.el-input-group__prepend{border-right:0}.el-input-group__append{border-left:0;border-top-left-radius:0;border-bottom-left-radius:0}.el-input-group--append .el-select .el-input.is-focus .el-input__inner,.el-input-group--prepend .el-select .el-input.is-focus .el-input__inner{border-color:transparent}.el-input-group--prepend .el-input__inner{border-top-left-radius:0;border-bottom-left-radius:0}.el-input__inner::-ms-clear{display:none;width:0;height:0}.el-transfer{font-size:14px}.el-transfer__buttons{display:inline-block;vertical-align:middle;padding:0 30px}.el-transfer__button{display:block;margin:0 auto;padding:10px;border-radius:50%;color:#fff;background-color:#409eff;font-size:0}.el-button-group>.el-button+.el-button,.el-transfer-panel__item+.el-transfer-panel__item,.el-transfer__button [class*=el-icon-]+span{margin-left:0}.el-divider__text,.el-image__error,.el-link,.el-timeline,.el-transfer__button i,.el-transfer__button span{font-size:14px}.el-transfer__button.is-with-texts{border-radius:4px}.el-transfer__button.is-disabled,.el-transfer__button.is-disabled:hover{border:1px solid #dcdfe6;background-color:#f5f7fa;color:#c0c4cc}.el-transfer__button:first-child{margin-bottom:10px}.el-transfer__button:nth-child(2){margin:0}.el-transfer-panel{border:1px solid #ebeef5;border-radius:4px;overflow:hidden;background:#fff;display:inline-block;vertical-align:middle;width:200px;max-height:100%;box-sizing:border-box;position:relative}.el-transfer-panel__body{height:246px}.el-transfer-panel__body.is-with-footer{padding-bottom:40px}.el-transfer-panel__list{margin:0;padding:6px 0;list-style:none;height:246px;overflow:auto;box-sizing:border-box}.el-transfer-panel__list.is-filterable{height:194px;padding-top:0}.el-transfer-panel__item{height:30px;line-height:30px;padding-left:15px;display:block!important}.el-transfer-panel__item.el-checkbox{color:#606266}.el-transfer-panel__item:hover{color:#409eff}.el-transfer-panel__item.el-checkbox .el-checkbox__label{width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;display:block;box-sizing:border-box;padding-left:24px;line-height:30px}.el-transfer-panel__item .el-checkbox__input{position:absolute;top:8px}.el-transfer-panel__filter{text-align:center;margin:15px;box-sizing:border-box;display:block;width:auto}.el-transfer-panel__filter .el-input__inner{height:32px;width:100%;font-size:12px;display:inline-block;box-sizing:border-box;border-radius:16px;padding-right:10px;padding-left:30px}.el-transfer-panel__filter .el-input__icon{margin-left:5px}.el-transfer-panel .el-transfer-panel__header{height:40px;line-height:40px;background:#f5f7fa;margin:0;padding-left:15px;border-bottom:1px solid #ebeef5;box-sizing:border-box;color:#000}.el-container,.el-header{-webkit-box-sizing:border-box}.el-transfer-panel .el-transfer-panel__header .el-checkbox{display:block;line-height:40px}.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{font-size:16px;color:#303133;font-weight:400}.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label span{position:absolute;right:15px;color:#909399;font-size:12px;font-weight:400}.el-transfer-panel .el-transfer-panel__footer{height:40px;background:#fff;margin:0;padding:0;border-top:1px solid #ebeef5;position:absolute;bottom:0;left:0;width:100%;z-index:1}.el-transfer-panel .el-transfer-panel__footer:after{display:inline-block;height:100%;vertical-align:middle}.el-container,.el-timeline-item__node{display:-webkit-box;display:-ms-flexbox}.el-transfer-panel .el-transfer-panel__footer .el-checkbox{padding-left:20px;color:#606266}.el-transfer-panel .el-transfer-panel__empty{margin:0;height:30px;line-height:30px;padding:6px 15px 0;color:#909399;text-align:center}.el-transfer-panel .el-checkbox__label{padding-left:8px}.el-transfer-panel .el-checkbox__inner{height:14px;width:14px;border-radius:3px}.el-transfer-panel .el-checkbox__inner:after{height:6px;width:3px;left:4px}.el-container{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto;box-sizing:border-box;min-width:0}.el-container.is-vertical,.el-drawer,.el-empty,.el-result{-webkit-box-orient:vertical;-webkit-box-direction:normal}.el-container.is-vertical{-ms-flex-direction:column;flex-direction:column}.el-header{padding:0 20px}.el-aside,.el-header{box-sizing:border-box;-ms-flex-negative:0;flex-shrink:0}.el-aside,.el-main{overflow:auto}.el-main{display:block;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto}.el-footer,.el-main{box-sizing:border-box}.el-footer{padding:0 20px;-ms-flex-negative:0;flex-shrink:0}.el-timeline{margin:0;list-style:none}.el-timeline .el-timeline-item:last-child .el-timeline-item__tail{display:none}.el-timeline-item{position:relative;padding-bottom:20px}.el-timeline-item__wrapper{position:relative;padding-left:28px;top:-3px}.el-timeline-item__tail{position:absolute;left:4px;height:100%;border-left:2px solid #e4e7ed}.el-timeline-item__icon{color:#fff;font-size:13px}.el-timeline-item__node{position:absolute;background-color:#e4e7ed;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-image__error,.el-timeline-item__dot{display:-webkit-box;display:-ms-flexbox}.el-timeline-item__node--normal{left:-1px;width:12px;height:12px}.el-timeline-item__node--large{left:-2px;width:14px;height:14px}.el-timeline-item__node--primary{background-color:#409eff}.el-timeline-item__node--success{background-color:#67c23a}.el-timeline-item__node--warning{background-color:#e6a23c}.el-timeline-item__node--danger{background-color:#f56c6c}.el-timeline-item__node--info{background-color:#909399}.el-timeline-item__dot{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-timeline-item__content{color:#303133}.el-timeline-item__timestamp{color:#909399;line-height:1;font-size:13px}.el-timeline-item__timestamp.is-top{margin-bottom:8px;padding-top:4px}.el-timeline-item__timestamp.is-bottom{margin-top:8px}.el-link{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;vertical-align:middle;position:relative;text-decoration:none;outline:0;padding:0;font-weight:500}.el-link.is-underline:hover:after{position:absolute;left:0;right:0;height:0;bottom:0;border-bottom:1px solid #409eff}.el-link.el-link--default:after,.el-link.el-link--primary.is-underline:hover:after,.el-link.el-link--primary:after{border-color:#409eff}.el-link.is-disabled{cursor:not-allowed}.el-link [class*=el-icon-]+span{margin-left:5px}.el-link.el-link--default{color:#606266}.el-link.el-link--default:hover{color:#409eff}.el-link.el-link--default.is-disabled{color:#c0c4cc}.el-link.el-link--primary{color:#409eff}.el-link.el-link--primary:hover{color:#66b1ff}.el-link.el-link--primary.is-disabled{color:#a0cfff}.el-link.el-link--danger.is-underline:hover:after,.el-link.el-link--danger:after{border-color:#f56c6c}.el-link.el-link--danger{color:#f56c6c}.el-link.el-link--danger:hover{color:#f78989}.el-link.el-link--danger.is-disabled{color:#fab6b6}.el-link.el-link--success.is-underline:hover:after,.el-link.el-link--success:after{border-color:#67c23a}.el-link.el-link--success{color:#67c23a}.el-link.el-link--success:hover{color:#85ce61}.el-link.el-link--success.is-disabled{color:#b3e19d}.el-link.el-link--warning.is-underline:hover:after,.el-link.el-link--warning:after{border-color:#e6a23c}.el-link.el-link--warning{color:#e6a23c}.el-link.el-link--warning:hover{color:#ebb563}.el-link.el-link--warning.is-disabled{color:#f3d19e}.el-link.el-link--info.is-underline:hover:after,.el-link.el-link--info:after{border-color:#909399}.el-link.el-link--info{color:#909399}.el-link.el-link--info:hover{color:#a6a9ad}.el-link.el-link--info.is-disabled{color:#c8c9cc}.el-divider{background-color:#dcdfe6;position:relative}.el-divider--horizontal{display:block;height:1px;width:100%;margin:24px 0}.el-divider--vertical{display:inline-block;width:1px;height:1em;margin:0 8px;vertical-align:middle;position:relative}.el-divider__text{position:absolute;background-color:#fff;padding:0 20px;font-weight:500;color:#303133}.el-image__error,.el-image__placeholder{background:#f5f7fa}.el-divider__text.is-left{left:20px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-divider__text.is-center{left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}.el-divider__text.is-right{right:20px;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-image__error,.el-image__inner,.el-image__placeholder{width:100%;height:100%}.el-image{position:relative;display:inline-block;overflow:hidden}.el-image__inner{vertical-align:top}.el-image__inner--center{position:relative;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);display:block}.el-image__error{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#c0c4cc;vertical-align:middle}.el-image-viewer__wrapper{position:fixed;top:0;right:0;bottom:0;left:0}.el-image-viewer__btn{position:absolute;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:50%;opacity:.8;box-sizing:border-box;user-select:none}.el-button,.el-checkbox,.el-checkbox-button__inner,.el-empty__image img,.el-image-viewer__btn,.el-radio{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.el-image-viewer__close{top:40px;right:40px;width:40px;height:40px;font-size:24px;color:#fff;background-color:#606266}.el-image-viewer__canvas{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-image-viewer__actions{left:50%;bottom:30px;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:282px;height:44px;padding:0 23px;background-color:#606266;border-color:#fff;border-radius:22px}.el-image-viewer__actions__inner{width:100%;height:100%;text-align:justify;cursor:default;font-size:23px;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-pack:distribute;justify-content:space-around}.el-image-viewer__next,.el-image-viewer__prev{width:44px;height:44px;font-size:24px;color:#fff;background-color:#606266;border-color:#fff;top:50%}.el-image-viewer__prev{left:40px}.el-image-viewer__next,.el-image-viewer__prev{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.el-image-viewer__next{right:40px;text-indent:2px}.el-image-viewer__mask{position:absolute;width:100%;height:100%;top:0;left:0;opacity:.5;background:#000}.viewer-fade-enter-active{-webkit-animation:viewer-fade-in .3s;animation:viewer-fade-in .3s}.viewer-fade-leave-active{-webkit-animation:viewer-fade-out .3s;animation:viewer-fade-out .3s}@-webkit-keyframes viewer-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@keyframes viewer-fade-in{0%{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}to{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}}@-webkit-keyframes viewer-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}@keyframes viewer-fade-out{0%{-webkit-transform:translateZ(0);transform:translateZ(0);opacity:1}to{-webkit-transform:translate3d(0,-20px,0);transform:translate3d(0,-20px,0);opacity:0}}.el-button{display:inline-block;line-height:1;white-space:nowrap;cursor:pointer;background:#fff;border:1px solid #dcdfe6;color:#606266;-webkit-appearance:none;text-align:center;box-sizing:border-box;outline:0;margin:0;transition:.1s;font-weight:500;padding:12px 20px;font-size:14px;border-radius:4px}.el-button+.el-button,.el-checkbox.is-bordered+.el-checkbox.is-bordered{margin-left:10px}.el-button:focus,.el-button:hover{color:#409eff;border-color:#c6e2ff;background-color:#ecf5ff}.el-button:active{color:#3a8ee6;border-color:#3a8ee6;outline:0}.el-button::-moz-focus-inner{border:0}.el-button [class*=el-icon-]+span{margin-left:5px}.el-button.is-plain:focus,.el-button.is-plain:hover{background:#fff;border-color:#409eff;color:#409eff}.el-button.is-active,.el-button.is-plain:active{color:#3a8ee6;border-color:#3a8ee6}.el-button.is-plain:active{background:#fff;outline:0}.el-button.is-disabled,.el-button.is-disabled:focus,.el-button.is-disabled:hover{color:#c0c4cc;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5}.el-button.is-disabled.el-button--text{background-color:transparent}.el-button.is-disabled.is-plain,.el-button.is-disabled.is-plain:focus,.el-button.is-disabled.is-plain:hover{background-color:#fff;border-color:#ebeef5;color:#c0c4cc}.el-button.is-loading{position:relative;pointer-events:none}.el-button.is-loading:before{pointer-events:none;content:\"\";position:absolute;left:-1px;top:-1px;right:-1px;bottom:-1px;border-radius:inherit;background-color:hsla(0,0%,100%,.35)}.el-button.is-round{border-radius:20px;padding:12px 23px}.el-button.is-circle{border-radius:50%;padding:12px}.el-button--primary{color:#fff;background-color:#409eff;border-color:#409eff}.el-button--primary:focus,.el-button--primary:hover{background:#66b1ff;border-color:#66b1ff;color:#fff}.el-button--primary.is-active,.el-button--primary:active{background:#3a8ee6;border-color:#3a8ee6;color:#fff}.el-button--primary:active{outline:0}.el-button--primary.is-disabled,.el-button--primary.is-disabled:active,.el-button--primary.is-disabled:focus,.el-button--primary.is-disabled:hover{color:#fff;background-color:#a0cfff;border-color:#a0cfff}.el-button--primary.is-plain{color:#409eff;background:#ecf5ff;border-color:#b3d8ff}.el-button--primary.is-plain:focus,.el-button--primary.is-plain:hover{background:#409eff;border-color:#409eff;color:#fff}.el-button--primary.is-plain:active{background:#3a8ee6;border-color:#3a8ee6;color:#fff;outline:0}.el-button--primary.is-plain.is-disabled,.el-button--primary.is-plain.is-disabled:active,.el-button--primary.is-plain.is-disabled:focus,.el-button--primary.is-plain.is-disabled:hover{color:#8cc5ff;background-color:#ecf5ff;border-color:#d9ecff}.el-button--success{color:#fff;background-color:#67c23a;border-color:#67c23a}.el-button--success:focus,.el-button--success:hover{background:#85ce61;border-color:#85ce61;color:#fff}.el-button--success.is-active,.el-button--success:active{background:#5daf34;border-color:#5daf34;color:#fff}.el-button--success:active{outline:0}.el-button--success.is-disabled,.el-button--success.is-disabled:active,.el-button--success.is-disabled:focus,.el-button--success.is-disabled:hover{color:#fff;background-color:#b3e19d;border-color:#b3e19d}.el-button--success.is-plain{color:#67c23a;background:#f0f9eb;border-color:#c2e7b0}.el-button--success.is-plain:focus,.el-button--success.is-plain:hover{background:#67c23a;border-color:#67c23a;color:#fff}.el-button--success.is-plain:active{background:#5daf34;border-color:#5daf34;color:#fff;outline:0}.el-button--success.is-plain.is-disabled,.el-button--success.is-plain.is-disabled:active,.el-button--success.is-plain.is-disabled:focus,.el-button--success.is-plain.is-disabled:hover{color:#a4da89;background-color:#f0f9eb;border-color:#e1f3d8}.el-button--warning{color:#fff;background-color:#e6a23c;border-color:#e6a23c}.el-button--warning:focus,.el-button--warning:hover{background:#ebb563;border-color:#ebb563;color:#fff}.el-button--warning.is-active,.el-button--warning:active{background:#cf9236;border-color:#cf9236;color:#fff}.el-button--warning:active{outline:0}.el-button--warning.is-disabled,.el-button--warning.is-disabled:active,.el-button--warning.is-disabled:focus,.el-button--warning.is-disabled:hover{color:#fff;background-color:#f3d19e;border-color:#f3d19e}.el-button--warning.is-plain{color:#e6a23c;background:#fdf6ec;border-color:#f5dab1}.el-button--warning.is-plain:focus,.el-button--warning.is-plain:hover{background:#e6a23c;border-color:#e6a23c;color:#fff}.el-button--warning.is-plain:active{background:#cf9236;border-color:#cf9236;color:#fff;outline:0}.el-button--warning.is-plain.is-disabled,.el-button--warning.is-plain.is-disabled:active,.el-button--warning.is-plain.is-disabled:focus,.el-button--warning.is-plain.is-disabled:hover{color:#f0c78a;background-color:#fdf6ec;border-color:#faecd8}.el-button--danger{color:#fff;background-color:#f56c6c;border-color:#f56c6c}.el-button--danger:focus,.el-button--danger:hover{background:#f78989;border-color:#f78989;color:#fff}.el-button--danger.is-active,.el-button--danger:active{background:#dd6161;border-color:#dd6161;color:#fff}.el-button--danger:active{outline:0}.el-button--danger.is-disabled,.el-button--danger.is-disabled:active,.el-button--danger.is-disabled:focus,.el-button--danger.is-disabled:hover{color:#fff;background-color:#fab6b6;border-color:#fab6b6}.el-button--danger.is-plain{color:#f56c6c;background:#fef0f0;border-color:#fbc4c4}.el-button--danger.is-plain:focus,.el-button--danger.is-plain:hover{background:#f56c6c;border-color:#f56c6c;color:#fff}.el-button--danger.is-plain:active{background:#dd6161;border-color:#dd6161;color:#fff;outline:0}.el-button--danger.is-plain.is-disabled,.el-button--danger.is-plain.is-disabled:active,.el-button--danger.is-plain.is-disabled:focus,.el-button--danger.is-plain.is-disabled:hover{color:#f9a7a7;background-color:#fef0f0;border-color:#fde2e2}.el-button--info{color:#fff;background-color:#909399;border-color:#909399}.el-button--info:focus,.el-button--info:hover{background:#a6a9ad;border-color:#a6a9ad;color:#fff}.el-button--info.is-active,.el-button--info:active{background:#82848a;border-color:#82848a;color:#fff}.el-button--info:active{outline:0}.el-button--info.is-disabled,.el-button--info.is-disabled:active,.el-button--info.is-disabled:focus,.el-button--info.is-disabled:hover{color:#fff;background-color:#c8c9cc;border-color:#c8c9cc}.el-button--info.is-plain{color:#909399;background:#f4f4f5;border-color:#d3d4d6}.el-button--info.is-plain:focus,.el-button--info.is-plain:hover{background:#909399;border-color:#909399;color:#fff}.el-button--info.is-plain:active{background:#82848a;border-color:#82848a;color:#fff;outline:0}.el-button--info.is-plain.is-disabled,.el-button--info.is-plain.is-disabled:active,.el-button--info.is-plain.is-disabled:focus,.el-button--info.is-plain.is-disabled:hover{color:#bcbec2;background-color:#f4f4f5;border-color:#e9e9eb}.el-button--medium{padding:10px 20px;font-size:14px;border-radius:4px}.el-button--medium.is-round{padding:10px 20px}.el-button--medium.is-circle{padding:10px}.el-button--small{padding:9px 15px;font-size:12px;border-radius:3px}.el-button--small.is-round{padding:9px 15px}.el-button--small.is-circle{padding:9px}.el-button--mini,.el-button--mini.is-round{padding:7px 15px}.el-button--mini{font-size:12px;border-radius:3px}.el-button--mini.is-circle{padding:7px}.el-button--text{border-color:transparent;color:#409eff;background:0 0;padding-left:0;padding-right:0}.el-button--text:focus,.el-button--text:hover{color:#66b1ff;border-color:transparent;background-color:transparent}.el-button--text:active{color:#3a8ee6;background-color:transparent}.el-button--text.is-disabled,.el-button--text.is-disabled:focus,.el-button--text.is-disabled:hover,.el-button--text:active{border-color:transparent}.el-button-group .el-button--danger:last-child,.el-button-group .el-button--danger:not(:first-child):not(:last-child),.el-button-group .el-button--info:last-child,.el-button-group .el-button--info:not(:first-child):not(:last-child),.el-button-group .el-button--primary:last-child,.el-button-group .el-button--primary:not(:first-child):not(:last-child),.el-button-group .el-button--success:last-child,.el-button-group .el-button--success:not(:first-child):not(:last-child),.el-button-group .el-button--warning:last-child,.el-button-group .el-button--warning:not(:first-child):not(:last-child),.el-button-group>.el-dropdown>.el-button{border-left-color:hsla(0,0%,100%,.5)}.el-button-group .el-button--danger:first-child,.el-button-group .el-button--danger:not(:first-child):not(:last-child),.el-button-group .el-button--info:first-child,.el-button-group .el-button--info:not(:first-child):not(:last-child),.el-button-group .el-button--primary:first-child,.el-button-group .el-button--primary:not(:first-child):not(:last-child),.el-button-group .el-button--success:first-child,.el-button-group .el-button--success:not(:first-child):not(:last-child),.el-button-group .el-button--warning:first-child,.el-button-group .el-button--warning:not(:first-child):not(:last-child){border-right-color:hsla(0,0%,100%,.5)}.el-button-group{display:inline-block;vertical-align:middle}.el-button-group:after,.el-button-group:before{display:table}.el-button-group:after{clear:both}.el-button-group>.el-button{float:left;position:relative}.el-button-group>.el-button.is-disabled{z-index:1}.el-button-group>.el-button:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.el-button-group>.el-button:last-child{border-top-left-radius:0;border-bottom-left-radius:0}.el-button-group>.el-button:first-child:last-child{border-radius:4px}.el-button-group>.el-button:first-child:last-child.is-round{border-radius:20px}.el-button-group>.el-button:first-child:last-child.is-circle{border-radius:50%}.el-button-group>.el-button:not(:first-child):not(:last-child){border-radius:0}.el-button-group>.el-button.is-active,.el-button-group>.el-button:not(.is-disabled):active,.el-button-group>.el-button:not(.is-disabled):focus,.el-button-group>.el-button:not(.is-disabled):hover{z-index:1}.el-button-group>.el-dropdown>.el-button{border-top-left-radius:0;border-bottom-left-radius:0}.el-calendar{background-color:#fff}.el-calendar__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 20px;border-bottom:1px solid #ebeef5}.el-backtop,.el-page-header{display:-webkit-box;display:-ms-flexbox}.el-calendar__title{color:#000;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.el-calendar__body{padding:12px 20px 35px}.el-calendar-table{table-layout:fixed;width:100%}.el-calendar-table thead th{padding:12px 0;color:#606266;font-weight:400}.el-calendar-table:not(.is-range) td.next,.el-calendar-table:not(.is-range) td.prev{color:#c0c4cc}.el-backtop,.el-calendar-table td.is-today{color:#409eff}.el-calendar-table td{border-bottom:1px solid #ebeef5;border-right:1px solid #ebeef5;vertical-align:top;transition:background-color .2s ease}.el-calendar-table td.is-selected{background-color:#f2f8fe}.el-calendar-table tr:first-child td{border-top:1px solid #ebeef5}.el-calendar-table tr td:first-child{border-left:1px solid #ebeef5}.el-calendar-table tr.el-calendar-table__row--hide-border td{border-top:none}.el-calendar-table .el-calendar-day{box-sizing:border-box;padding:8px;height:85px}.el-calendar-table .el-calendar-day:hover{cursor:pointer;background-color:#f2f8fe}.el-backtop{position:fixed;background-color:#fff;width:40px;height:40px;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:20px;box-shadow:0 0 6px rgba(0,0,0,.12);cursor:pointer;z-index:5}.el-backtop:hover{background-color:#f2f6fc}.el-page-header{line-height:24px}.el-page-header,.el-page-header__left{display:-webkit-box;display:-ms-flexbox;display:flex}.el-page-header__left{cursor:pointer;margin-right:40px;position:relative}.el-page-header__left:after{position:absolute;width:1px;height:16px;right:-20px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-color:#dcdfe6}.el-checkbox,.el-checkbox__input{display:inline-block;position:relative;white-space:nowrap}.el-page-header__left .el-icon-back{font-size:18px;margin-right:6px;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center}.el-page-header__title{font-size:14px;font-weight:500}.el-page-header__content{font-size:18px;color:#303133}.el-checkbox{color:#606266;font-weight:500;font-size:14px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;margin-right:30px}.el-checkbox.is-bordered{padding:9px 20px 9px 10px;border-radius:4px;border:1px solid #dcdfe6;box-sizing:border-box;line-height:normal;height:40px}.el-checkbox.is-bordered.is-checked{border-color:#409eff}.el-checkbox.is-bordered.is-disabled{border-color:#ebeef5;cursor:not-allowed}.el-checkbox.is-bordered.el-checkbox--medium{padding:7px 20px 7px 10px;border-radius:4px;height:36px}.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label{line-height:17px;font-size:14px}.el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__inner{height:14px;width:14px}.el-checkbox.is-bordered.el-checkbox--small{padding:5px 15px 5px 10px;border-radius:3px;height:32px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__label{line-height:15px;font-size:12px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner{height:12px;width:12px}.el-checkbox.is-bordered.el-checkbox--small .el-checkbox__inner:after{height:6px;width:2px}.el-checkbox.is-bordered.el-checkbox--mini{padding:3px 15px 3px 10px;border-radius:3px;height:28px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__label{line-height:12px;font-size:12px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner{height:12px;width:12px}.el-checkbox.is-bordered.el-checkbox--mini .el-checkbox__inner:after{height:6px;width:2px}.el-checkbox__input{cursor:pointer;outline:0;line-height:1;vertical-align:middle}.el-checkbox__input.is-disabled .el-checkbox__inner{background-color:#edf2fc;border-color:#dcdfe6;cursor:not-allowed}.el-checkbox__input.is-disabled .el-checkbox__inner:after{cursor:not-allowed;border-color:#c0c4cc}.el-checkbox__input.is-disabled .el-checkbox__inner+.el-checkbox__label{cursor:not-allowed}.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{background-color:#f2f6fc;border-color:#dcdfe6}.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner:after{border-color:#c0c4cc}.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner{background-color:#f2f6fc;border-color:#dcdfe6}.el-checkbox__input.is-disabled.is-indeterminate .el-checkbox__inner:before{background-color:#c0c4cc;border-color:#c0c4cc}.el-checkbox__input.is-checked .el-checkbox__inner,.el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color:#409eff;border-color:#409eff}.el-checkbox__input.is-disabled+span.el-checkbox__label{color:#c0c4cc;cursor:not-allowed}.el-checkbox__input.is-checked .el-checkbox__inner:after{-webkit-transform:rotate(45deg) scaleY(1);transform:rotate(45deg) scaleY(1)}.el-checkbox__input.is-checked+.el-checkbox__label{color:#409eff}.el-checkbox__input.is-focus .el-checkbox__inner{border-color:#409eff}.el-checkbox__input.is-indeterminate .el-checkbox__inner:before{content:\"\";position:absolute;display:block;background-color:#fff;height:2px;-webkit-transform:scale(.5);transform:scale(.5);left:0;right:0;top:5px}.el-checkbox__input.is-indeterminate .el-checkbox__inner:after{display:none}.el-checkbox__inner{display:inline-block;position:relative;border:1px solid #dcdfe6;border-radius:2px;box-sizing:border-box;width:14px;height:14px;background-color:#fff;z-index:1;transition:border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46)}.el-checkbox__inner:hover{border-color:#409eff}.el-checkbox__inner:after{box-sizing:content-box;content:\"\";border:1px solid #fff;border-left:0;border-top:0;height:7px;left:4px;position:absolute;top:1px;-webkit-transform:rotate(45deg) scaleY(0);transform:rotate(45deg) scaleY(0);width:3px;transition:-webkit-transform .15s ease-in .05s;transition:transform .15s ease-in .05s;transition:transform .15s ease-in .05s,-webkit-transform .15s ease-in .05s;-webkit-transform-origin:center;transform-origin:center}.el-checkbox__original{opacity:0;outline:0;position:absolute;margin:0;width:0;height:0;z-index:-1}.el-checkbox-button,.el-checkbox-button__inner{display:inline-block;position:relative}.el-checkbox__label{display:inline-block;padding-left:10px;line-height:19px;font-size:14px}.el-checkbox:last-of-type{margin-right:0}.el-checkbox-button__inner{line-height:1;font-weight:500;white-space:nowrap;vertical-align:middle;cursor:pointer;background:#fff;border:1px solid #dcdfe6;border-left:0;color:#606266;-webkit-appearance:none;text-align:center;box-sizing:border-box;outline:0;margin:0;transition:all .3s cubic-bezier(.645,.045,.355,1);padding:12px 20px;font-size:14px;border-radius:0}.el-checkbox-button__inner.is-round{padding:12px 20px}.el-checkbox-button__inner:hover{color:#409eff}.el-checkbox-button__inner [class*=el-icon-]{line-height:.9}.el-checkbox-button__inner [class*=el-icon-]+span{margin-left:5px}.el-checkbox-button__original{opacity:0;outline:0;position:absolute;margin:0;z-index:-1}.el-radio,.el-radio__inner,.el-radio__input{position:relative;display:inline-block}.el-checkbox-button.is-checked .el-checkbox-button__inner{color:#fff;background-color:#409eff;border-color:#409eff;box-shadow:-1px 0 0 0 #8cc5ff}.el-checkbox-button.is-checked:first-child .el-checkbox-button__inner{border-left-color:#409eff}.el-checkbox-button.is-disabled .el-checkbox-button__inner{color:#c0c4cc;cursor:not-allowed;background-image:none;background-color:#fff;border-color:#ebeef5;box-shadow:none}.el-checkbox-button.is-disabled:first-child .el-checkbox-button__inner{border-left-color:#ebeef5}.el-checkbox-button:first-child .el-checkbox-button__inner{border-left:1px solid #dcdfe6;border-radius:4px 0 0 4px;box-shadow:none!important}.el-checkbox-button.is-focus .el-checkbox-button__inner{border-color:#409eff}.el-checkbox-button:last-child .el-checkbox-button__inner{border-radius:0 4px 4px 0}.el-checkbox-button--medium .el-checkbox-button__inner{padding:10px 20px;font-size:14px;border-radius:0}.el-checkbox-button--medium .el-checkbox-button__inner.is-round{padding:10px 20px}.el-checkbox-button--small .el-checkbox-button__inner{padding:9px 15px;font-size:12px;border-radius:0}.el-checkbox-button--small .el-checkbox-button__inner.is-round{padding:9px 15px}.el-checkbox-button--mini .el-checkbox-button__inner{padding:7px 15px;font-size:12px;border-radius:0}.el-checkbox-button--mini .el-checkbox-button__inner.is-round{padding:7px 15px}.el-checkbox-group{font-size:0}.el-avatar,.el-cascader-panel,.el-radio,.el-radio--medium.is-bordered .el-radio__label,.el-radio__label{font-size:14px}.el-radio{color:#606266;font-weight:500;line-height:1;cursor:pointer;white-space:nowrap;outline:0;margin-right:30px}.el-cascader-node>.el-radio,.el-radio:last-child{margin-right:0}.el-radio.is-bordered{padding:12px 20px 0 10px;border-radius:4px;border:1px solid #dcdfe6;box-sizing:border-box;height:40px}.el-cascader-menu,.el-cascader-menu__list,.el-radio__inner{-webkit-box-sizing:border-box}.el-radio.is-bordered.is-checked{border-color:#409eff}.el-radio.is-bordered.is-disabled{cursor:not-allowed;border-color:#ebeef5}.el-radio__input.is-disabled .el-radio__inner,.el-radio__input.is-disabled.is-checked .el-radio__inner{background-color:#f5f7fa;border-color:#e4e7ed}.el-radio.is-bordered+.el-radio.is-bordered{margin-left:10px}.el-radio--medium.is-bordered{padding:10px 20px 0 10px;border-radius:4px;height:36px}.el-radio--mini.is-bordered .el-radio__label,.el-radio--small.is-bordered .el-radio__label{font-size:12px}.el-radio--medium.is-bordered .el-radio__inner{height:14px;width:14px}.el-radio--small.is-bordered{padding:8px 15px 0 10px;border-radius:3px;height:32px}.el-radio--small.is-bordered .el-radio__inner{height:12px;width:12px}.el-radio--mini.is-bordered{padding:6px 15px 0 10px;border-radius:3px;height:28px}.el-radio--mini.is-bordered .el-radio__inner{height:12px;width:12px}.el-radio__input{white-space:nowrap;cursor:pointer;outline:0;line-height:1;vertical-align:middle}.el-radio__input.is-disabled .el-radio__inner{cursor:not-allowed}.el-radio__input.is-disabled .el-radio__inner:after{cursor:not-allowed;background-color:#f5f7fa}.el-radio__input.is-disabled .el-radio__inner+.el-radio__label{cursor:not-allowed}.el-radio__input.is-disabled.is-checked .el-radio__inner:after{background-color:#c0c4cc}.el-radio__input.is-disabled+span.el-radio__label{color:#c0c4cc;cursor:not-allowed}.el-radio__input.is-checked .el-radio__inner{border-color:#409eff;background:#409eff}.el-radio__input.is-checked .el-radio__inner:after{-webkit-transform:translate(-50%,-50%) scale(1);transform:translate(-50%,-50%) scale(1)}.el-radio__input.is-checked+.el-radio__label{color:#409eff}.el-radio__input.is-focus .el-radio__inner{border-color:#409eff}.el-radio__inner{border:1px solid #dcdfe6;border-radius:100%;width:14px;height:14px;background-color:#fff;cursor:pointer;box-sizing:border-box}.el-radio__inner:hover{border-color:#409eff}.el-radio__inner:after{width:4px;height:4px;border-radius:100%;background-color:#fff;content:\"\";position:absolute;left:50%;top:50%;-webkit-transform:translate(-50%,-50%) scale(0);transform:translate(-50%,-50%) scale(0);transition:-webkit-transform .15s ease-in;transition:transform .15s ease-in;transition:transform .15s ease-in,-webkit-transform .15s ease-in}.el-radio__original{opacity:0;outline:0;position:absolute;z-index:-1;top:0;left:0;right:0;bottom:0;margin:0}.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner{box-shadow:0 0 2px 2px #409eff}.el-radio__label{padding-left:10px}.el-scrollbar{overflow:hidden;position:relative}.el-scrollbar:active>.el-scrollbar__bar,.el-scrollbar:focus>.el-scrollbar__bar,.el-scrollbar:hover>.el-scrollbar__bar{opacity:1;transition:opacity .34s ease-out}.el-scrollbar__wrap{overflow:scroll;height:100%}.el-scrollbar__wrap--hidden-default{scrollbar-width:none}.el-scrollbar__wrap--hidden-default::-webkit-scrollbar{width:0;height:0}.el-scrollbar__thumb{position:relative;display:block;width:0;height:0;cursor:pointer;border-radius:inherit;background-color:hsla(220,4%,58%,.3);transition:background-color .3s}.el-scrollbar__thumb:hover{background-color:hsla(220,4%,58%,.5)}.el-scrollbar__bar{position:absolute;right:2px;bottom:2px;z-index:1;border-radius:4px;opacity:0;transition:opacity .12s ease-out}.el-scrollbar__bar.is-vertical{width:6px;top:2px}.el-scrollbar__bar.is-vertical>div{width:100%}.el-scrollbar__bar.is-horizontal{height:6px;left:2px}.el-scrollbar__bar.is-horizontal>div{height:100%}.el-cascader-panel{display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:4px}.el-cascader-panel.is-bordered{border:1px solid #e4e7ed;border-radius:4px}.el-cascader-menu{min-width:180px;box-sizing:border-box;color:#606266;border-right:1px solid #e4e7ed}.el-cascader-menu:last-child{border-right:none}.el-cascader-menu__wrap{height:204px}.el-cascader-menu__list{position:relative;min-height:100%;margin:0;padding:6px 0;list-style:none;box-sizing:border-box}.el-cascader-menu__hover-zone{position:absolute;top:0;left:0;width:100%;height:100%;pointer-events:none}.el-cascader-menu__empty-text{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);text-align:center;color:#c0c4cc}.el-cascader-node{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 30px 0 20px;height:34px;line-height:34px;outline:0}.el-cascader-node.is-selectable.in-active-path{color:#606266}.el-cascader-node.in-active-path,.el-cascader-node.is-active,.el-cascader-node.is-selectable.in-checked-path{color:#409eff;font-weight:700}.el-cascader-node:not(.is-disabled){cursor:pointer}.el-cascader-node:not(.is-disabled):focus,.el-cascader-node:not(.is-disabled):hover{background:#f5f7fa}.el-cascader-node.is-disabled{color:#c0c4cc;cursor:not-allowed}.el-cascader-node__prefix{position:absolute;left:10px}.el-cascader-node__postfix{position:absolute;right:10px}.el-cascader-node__label{-webkit-box-flex:1;-ms-flex:1;flex:1;padding:0 10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.el-cascader-node>.el-radio .el-radio__label{padding-left:0}.el-avatar{display:inline-block;box-sizing:border-box;text-align:center;overflow:hidden;color:#fff;background:#c0c4cc;width:40px;height:40px;line-height:40px}.el-drawer,.el-drawer__body>*{-webkit-box-sizing:border-box}.el-avatar>img{display:block;height:100%;vertical-align:middle}.el-empty__image img,.el-empty__image svg{vertical-align:top;height:100%;width:100%}.el-avatar--circle{border-radius:50%}.el-avatar--square{border-radius:4px}.el-avatar--icon{font-size:18px}.el-avatar--large{width:40px;height:40px;line-height:40px}.el-avatar--medium{width:36px;height:36px;line-height:36px}.el-avatar--small{width:28px;height:28px;line-height:28px}@-webkit-keyframes el-drawer-fade-in{0%{opacity:0}to{opacity:1}}@keyframes el-drawer-fade-in{0%{opacity:0}to{opacity:1}}@-webkit-keyframes rtl-drawer-in{0%{-webkit-transform:translate(100%);transform:translate(100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes rtl-drawer-in{0%{-webkit-transform:translate(100%);transform:translate(100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes rtl-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(100%);transform:translate(100%)}}@keyframes rtl-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(100%);transform:translate(100%)}}@-webkit-keyframes ltr-drawer-in{0%{-webkit-transform:translate(-100%);transform:translate(-100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ltr-drawer-in{0%{-webkit-transform:translate(-100%);transform:translate(-100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ltr-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(-100%);transform:translate(-100%)}}@keyframes ltr-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translate(-100%);transform:translate(-100%)}}@-webkit-keyframes ttb-drawer-in{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes ttb-drawer-in{0%{-webkit-transform:translateY(-100%);transform:translateY(-100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes ttb-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@keyframes ttb-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}}@-webkit-keyframes btt-drawer-in{0%{-webkit-transform:translateY(100%);transform:translateY(100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@keyframes btt-drawer-in{0%{-webkit-transform:translateY(100%);transform:translateY(100%)}to{-webkit-transform:translate(0);transform:translate(0)}}@-webkit-keyframes btt-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translateY(100%);transform:translateY(100%)}}@keyframes btt-drawer-out{0%{-webkit-transform:translate(0);transform:translate(0)}to{-webkit-transform:translateY(100%);transform:translateY(100%)}}.el-drawer{position:absolute;box-sizing:border-box;background-color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12);overflow:hidden;outline:0}.el-drawer.rtl{-webkit-animation:rtl-drawer-out .3s;animation:rtl-drawer-out .3s;right:0}.el-drawer__open .el-drawer.rtl{-webkit-animation:rtl-drawer-in .3s 1ms;animation:rtl-drawer-in .3s 1ms}.el-drawer.ltr{-webkit-animation:ltr-drawer-out .3s;animation:ltr-drawer-out .3s;left:0}.el-drawer__open .el-drawer.ltr{-webkit-animation:ltr-drawer-in .3s 1ms;animation:ltr-drawer-in .3s 1ms}.el-drawer.ttb{-webkit-animation:ttb-drawer-out .3s;animation:ttb-drawer-out .3s;top:0}.el-drawer__open .el-drawer.ttb{-webkit-animation:ttb-drawer-in .3s 1ms;animation:ttb-drawer-in .3s 1ms}.el-drawer.btt{-webkit-animation:btt-drawer-out .3s;animation:btt-drawer-out .3s;bottom:0}.el-drawer__open .el-drawer.btt{-webkit-animation:btt-drawer-in .3s 1ms;animation:btt-drawer-in .3s 1ms}.el-drawer__wrapper{position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;margin:0}.el-drawer__header{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#72767b;display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:32px;padding:20px 20px 0}.el-drawer__header>:first-child,.el-drawer__title{-webkit-box-flex:1;-ms-flex:1;flex:1}.el-drawer__title{margin:0;line-height:inherit;font-size:1rem}.el-drawer__close-btn{border:none;cursor:pointer;font-size:20px;color:inherit;background-color:transparent}.el-drawer__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow:auto}.el-drawer__body>*{box-sizing:border-box}.el-drawer.ltr,.el-drawer.rtl{height:100%;top:0;bottom:0}.el-drawer.btt,.el-drawer.ttb,.el-drawer__container{width:100%;left:0;right:0}.el-drawer__container{position:relative;top:0;bottom:0;height:100%}.el-drawer-fade-enter-active{-webkit-animation:el-drawer-fade-in .3s;animation:el-drawer-fade-in .3s}.el-drawer-fade-leave-active{-webkit-animation:el-drawer-fade-in .3s reverse;animation:el-drawer-fade-in .3s reverse}.el-statistic{width:100%;box-sizing:border-box;margin:0;padding:0;color:#000;font-variant:tabular-nums;list-style:none;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";text-align:center}.el-statistic .head{margin-bottom:4px;color:#606266;font-size:13px}.el-statistic .con{font-family:Sans-serif;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#303133}.el-statistic .con .number{font-size:20px;padding:0 4px}.el-statistic .con span{display:inline-block;margin:0;line-height:100%}.el-popconfirm__main,.el-skeleton__image{display:-ms-flexbox;-webkit-box-align:center;display:-webkit-box}.el-popconfirm__main{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;-webkit-box-align:center;align-items:center}.el-popconfirm__icon{margin-right:5px}.el-popconfirm__action{text-align:right;margin:0}@-webkit-keyframes el-skeleton-loading{0%{background-position:100% 50%}to{background-position:0 50%}}@keyframes el-skeleton-loading{0%{background-position:100% 50%}to{background-position:0 50%}}.el-skeleton{width:100%}.el-skeleton__first-line,.el-skeleton__paragraph{height:16px;margin-top:16px;background:#f2f2f2}.el-skeleton.is-animated .el-skeleton__item{background:linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);background-size:400% 100%;-webkit-animation:el-skeleton-loading 1.4s ease infinite;animation:el-skeleton-loading 1.4s ease infinite}.el-skeleton__item{background:#f2f2f2;display:inline-block;height:16px;border-radius:4px;width:100%}.el-skeleton__circle{border-radius:50%;width:36px;height:36px;line-height:36px}.el-skeleton__circle--lg{width:40px;height:40px;line-height:40px}.el-skeleton__circle--md{width:28px;height:28px;line-height:28px}.el-skeleton__button{height:40px;width:64px;border-radius:4px}.el-skeleton__p{width:100%}.el-skeleton__p.is-last{width:61%}.el-skeleton__p.is-first{width:33%}.el-skeleton__text{width:100%;height:13px}.el-skeleton__caption{height:12px}.el-skeleton__h1{height:20px}.el-skeleton__h3{height:18px}.el-skeleton__h5{height:16px}.el-skeleton__image{width:unset;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-align:center;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:0}.el-skeleton__image svg{fill:#dcdde0;width:22%;height:22%}.el-empty{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;box-sizing:border-box;padding:40px 0}.el-empty__image{width:160px}.el-empty__image img{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-o-object-fit:contain;object-fit:contain}.el-empty__image svg{fill:#dcdde0}.el-empty__description{margin-top:20px}.el-empty__description p{margin:0;font-size:14px;color:#909399}.el-empty__bottom,.el-result__title{margin-top:20px}.el-descriptions{box-sizing:border-box;font-size:14px;color:#303133}.el-descriptions__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:20px}.el-descriptions__title{font-size:16px;font-weight:700}.el-descriptions--mini,.el-descriptions--small{font-size:12px}.el-descriptions__body{color:#606266;background-color:#fff}.el-descriptions__body .el-descriptions__table{border-collapse:collapse;width:100%;table-layout:fixed}.el-descriptions__body .el-descriptions__table .el-descriptions-item__cell{box-sizing:border-box;text-align:left;font-weight:400;line-height:1.5}.el-descriptions__body .el-descriptions__table .el-descriptions-item__cell.is-left{text-align:left}.el-descriptions__body .el-descriptions__table .el-descriptions-item__cell.is-center{text-align:center}.el-descriptions__body .el-descriptions__table .el-descriptions-item__cell.is-right{text-align:right}.el-descriptions .is-bordered{table-layout:auto}.el-descriptions .is-bordered .el-descriptions-item__cell{border:1px solid #ebeef5;padding:12px 10px}.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{padding-bottom:12px}.el-descriptions--medium.is-bordered .el-descriptions-item__cell{padding:10px}.el-descriptions--medium:not(.is-bordered) .el-descriptions-item__cell{padding-bottom:10px}.el-descriptions--small.is-bordered .el-descriptions-item__cell{padding:8px 10px}.el-descriptions--small:not(.is-bordered) .el-descriptions-item__cell{padding-bottom:8px}.el-descriptions--mini.is-bordered .el-descriptions-item__cell{padding:6px 10px}.el-descriptions--mini:not(.is-bordered) .el-descriptions-item__cell{padding-bottom:6px}.el-descriptions-item{vertical-align:top}.el-descriptions-item__container{display:-webkit-box;display:-ms-flexbox;display:flex}.el-descriptions-item__container .el-descriptions-item__content,.el-descriptions-item__container .el-descriptions-item__label{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:baseline;-ms-flex-align:baseline;align-items:baseline}.el-descriptions-item__container .el-descriptions-item__content{-webkit-box-flex:1;-ms-flex:1;flex:1}.el-descriptions-item__label.has-colon:after{content:\":\";position:relative;top:-.5px}.el-descriptions-item__label.is-bordered-label{font-weight:700;color:#909399;background:#fafafa}.el-descriptions-item__label:not(.is-bordered-label){margin-right:10px}.el-descriptions-item__content{word-break:break-word;overflow-wrap:break-word}.el-result{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-direction:column;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;text-align:center;box-sizing:border-box;padding:40px 30px}.el-result__icon svg{width:64px;height:64px}.el-result__title p{margin:0;font-size:20px;color:#303133;line-height:1.3}.el-result__subtitle{margin-top:10px}.el-result__subtitle p{margin:0;font-size:14px;color:#606266;line-height:1.3}.el-result__extra{margin-top:30px}.el-result .icon-success{fill:#67c23a}.el-result .icon-error{fill:#f56c6c}.el-result .icon-info{fill:#909399}.el-result .icon-warning{fill:#e6a23c}", ""]);

// exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".rf24-pair[data-v-18dbe8f7]{padding:4px 2px}.rf-pair-warning[data-v-18dbe8f7]{margin-bottom:12px}.rf-toolbar[data-v-18dbe8f7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;margin-bottom:14px}.rf-connected[data-v-18dbe8f7]{color:#67c23a;font-size:14px}.rf-desc[data-v-18dbe8f7]{margin-bottom:16px}.rf-addr[data-v-18dbe8f7]{margin-left:8px;color:#909399;font-size:12px;font-family:monospace}.rf-actions[data-v-18dbe8f7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:10px;margin:14px 0}.rf-empty[data-v-18dbe8f7]{color:#909399;font-size:14px;padding:22px;text-align:center;background:#fafafa;border-radius:8px}.rf-led-hint[data-v-18dbe8f7]{margin-top:8px;color:#909399;font-size:13px;line-height:1.6}.rf-led-hint.success[data-v-18dbe8f7]{margin-top:10px;padding:9px 12px;background:#f0f9eb;color:#529b2e;border-radius:8px;font-size:14px}.rf-led[data-v-18dbe8f7]{display:inline-block;width:8px;height:8px;border-radius:50%;margin:0 3px;vertical-align:middle}.rf-led.red[data-v-18dbe8f7]{background:#f56c6c}.rf-led.green[data-v-18dbe8f7]{background:#67c23a}.rf-table[data-v-18dbe8f7]{margin-bottom:8px}.rf-steps[data-v-18dbe8f7]{margin-top:8px}.rf-msg[data-v-18dbe8f7]{margin-top:12px;padding:10px 14px;border-radius:8px;font-size:14px}.rf-msg.info[data-v-18dbe8f7]{background:#ecf5ff;color:#409eff}.rf-msg.success[data-v-18dbe8f7]{background:#f0f9eb;color:#67c23a}.rf-msg.error[data-v-18dbe8f7]{background:#fef0f0;color:#f56c6c}", ""]);

// exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, "#app[data-v-5d452c8f]{font-family:Segoe UI,Helvetica,sans-serif;text-align:center;background:#f0f2f5;min-height:100vh;padding:20px 40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:24px}.main-card[data-v-5d452c8f]{position:relative;max-width:900px;-webkit-box-flex:1;-ms-flex:1;flex:1;padding:30px 40px;background:#fff;border-radius:16px;box-shadow:0 2px 16px rgba(0,0,0,.08)}.main-help-btn[data-v-5d452c8f]{position:absolute;top:16px;right:18px;z-index:20;width:34px;height:34px;padding:0;font-size:18px;font-weight:700;color:#909399;background:#fff;border-color:#dcdfe6;box-shadow:0 1px 4px rgba(0,0,0,.08)}.main-help-btn[data-v-5d452c8f]:hover{color:#409eff;border-color:#409eff}.main-help-menu[data-v-5d452c8f]{padding:2px 0}.main-help-item[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:9px 12px;border-radius:6px;color:#303133;font-size:14px;cursor:pointer}.main-help-item[data-v-5d452c8f]:hover{color:#409eff;background:#ecf5ff}.connect-loading-mask[data-v-5d452c8f]{position:fixed;top:0;left:0;right:0;bottom:0;z-index:3000;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background:rgba(0,0,0,.35)}.connect-loading-box[data-v-5d452c8f]{min-width:270px;padding:26px 30px;background:#fff;border-radius:14px;box-shadow:0 10px 40px rgba(0,0,0,.25);text-align:center}.connect-spinner[data-v-5d452c8f]{width:44px;height:44px;margin:0 auto 14px;border:4px solid #d9ecff;border-top-color:#409eff;border-radius:50%;-webkit-animation:connect-spin-data-v-5d452c8f .8s linear infinite;animation:connect-spin-data-v-5d452c8f .8s linear infinite}@-webkit-keyframes connect-spin-data-v-5d452c8f{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes connect-spin-data-v-5d452c8f{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.connect-loading-title[data-v-5d452c8f]{font-size:18px;font-weight:700;color:#303133}.connect-loading-prompt[data-v-5d452c8f]{max-width:300px;font-size:18px;font-weight:600;line-height:1.7;color:#303133}.connection-tip-row[data-v-5d452c8f]{margin:0 0 18px;padding:10px 14px;border-top:1px solid #ebeef5;border-bottom:1px solid #ebeef5;background:#fff9e6;color:#8a7340;font-size:13px;line-height:1.7;text-align:center}.connection-tip-row i[data-v-5d452c8f]{margin-right:4px;color:#e6a23c}.connection-tip-row strong[data-v-5d452c8f]{color:#d4880f}.main-help-back[data-v-5d452c8f]{margin-bottom:4px;padding:6px 12px;border-bottom:1px solid #ebeef5;color:#909399;font-size:12px;cursor:pointer}.main-help-back[data-v-5d452c8f]:hover{color:#409eff}.sidebar-card[data-v-5d452c8f]{width:270px;-ms-flex-negative:0;flex-shrink:0;background:linear-gradient(135deg,#fff,#fafbff);border-radius:18px;padding:22px;box-shadow:0 4px 24px rgba(64,158,255,.1);font-size:14px;position:-webkit-sticky;position:sticky;top:20px;max-height:calc(100vh - 40px);overflow-y:auto;text-align:left;border:1px solid #e0e8f5}.right-tip-bar[data-v-5d452c8f]{position:fixed;right:14px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background:linear-gradient(180deg,#fff9e6,#fff5d6);border-radius:12px;padding:16px 18px;box-shadow:0 4px 16px rgba(212,136,15,.2);border:1px solid #f5e6b8;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px;z-index:1000;width:210px;max-width:210px;-webkit-animation:slideInRight-data-v-5d452c8f .3s ease-out;animation:slideInRight-data-v-5d452c8f .3s ease-out}@-webkit-keyframes slideInRight-data-v-5d452c8f{0%{right:-70px;opacity:0}to{right:14px;opacity:1}}@keyframes slideInRight-data-v-5d452c8f{0%{right:-70px;opacity:0}to{right:14px;opacity:1}}.right-tip-bar .tip-icon[data-v-5d452c8f]{width:36px;height:36px;background:linear-gradient(135deg,#ffb800,#ff9500);border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:#fff;font-size:18px;box-shadow:0 2px 8px rgba(255,184,0,.4);-ms-flex-negative:0;flex-shrink:0}.right-tip-bar .tip-content[data-v-5d452c8f]{text-align:left;opacity:1}.right-tip-bar .tip-title[data-v-5d452c8f]{font-weight:700;color:#d4880f;font-size:15px;margin-bottom:6px}.right-tip-bar .tip-desc[data-v-5d452c8f]{color:#8a7340;font-size:14px;line-height:1.6;white-space:normal}.right-tip-close[data-v-5d452c8f]{position:absolute;top:4px;right:4px;width:30px;height:30px;padding:0;border:1px solid rgba(212,136,15,.35);border-radius:50%;background:#fff7df;color:#c07800;font-size:24px;font-weight:700;line-height:26px;cursor:pointer;z-index:1}.right-tip-close[data-v-5d452c8f]:hover{background:#ffe7b0;color:#b35c00;border-color:#d4880f}.success-message[data-v-5d452c8f]{min-width:280px!important;padding:20px 28px!important}.success-message .el-message__content[data-v-5d452c8f]{font-size:16px!important;font-weight:700!important;color:#67c23a!important}.success-message .el-message__icon[data-v-5d452c8f]{font-size:32px!important}.change-language[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.el-row[data-v-5d452c8f]{margin-bottom:18px}img[data-v-5d452c8f]{width:500px}.light[data-v-5d452c8f]{color:#409eff}.normal[data-v-5d452c8f]{color:#606266}.el-button[data-v-5d452c8f]{border-radius:8px}.el-button--primary[data-v-5d452c8f]{border-radius:10px}.backlight-card[data-v-5d452c8f]{margin-bottom:20px;padding:20px;background:#fafafa;border:1px solid #ebeef5;border-radius:12px}.key-card[data-v-5d452c8f]{margin-bottom:16px;padding:16px 20px;background:#fff;border:1px solid #e4e7ed;border-radius:10px;box-shadow:0 1px 4px rgba(0,0,0,.04)}.e6-collapse-card[data-v-5d452c8f]{padding:0;overflow:hidden}.e6-collapse-head[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px;padding:14px 18px;background:#fafcff;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.e6-collapse-head[data-v-5d452c8f]:hover{background:#ecf5ff}.e6-collapse-left[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:14px;min-width:0;text-align:left}.e6-collapse-name[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;color:#303133;font-size:15px;font-weight:700}.e6-collapse-value[data-v-5d452c8f]{min-width:0;overflow:hidden;color:#409eff;font-size:16px;font-weight:600;text-overflow:ellipsis;white-space:nowrap}.e6-collapse-head i[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;color:#409eff;font-size:18px;font-weight:700}.e6-collapse-body[data-v-5d452c8f]{padding:16px 20px;border-top:1px solid #ebeef5}.d2-mode-card[data-v-5d452c8f]{margin-bottom:22px;padding:22px 26px;background:linear-gradient(135deg,#ecf5ff,#f5f7fa 55%,#fff6ec);border:1px solid #d9ecff;border-radius:14px;box-shadow:0 2px 8px rgba(64,158,255,.06)}.d2-mode-title[data-v-5d452c8f]{margin:0 0 18px;font-size:18px;font-weight:700;color:#2b68cb;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.d2-mode-title i[data-v-5d452c8f]{font-size:22px;color:#409eff}.d2-mode-tip[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px;margin:-6px 0 16px;padding:10px 14px;background:#fff7e6;border:1px solid #ffe1b3;border-radius:8px;color:#8a5a00;font-size:13px;line-height:1.7}.d2-mode-tip i[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;margin-top:2px;font-size:15px;color:#e6a23c}.d2-mode-tip-body[data-v-5d452c8f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:0}.d2-mode-tip-line[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:2px}.d2-mode-tip-line+.d2-mode-tip-line[data-v-5d452c8f]{margin-top:4px}.d2-mode-tip-key[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;font-weight:700;color:#7a4e00}.d2-field-row[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:16px;gap:14px}.d2-field-label[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;min-width:88px;font-size:14px;font-weight:600;color:#303133;line-height:40px}.d2-page-label[data-v-5d452c8f]{-ms-flex-item-align:start;align-self:flex-start;line-height:44px}.d2-run-mode-group .el-radio[data-v-5d452c8f]{font-size:14px;margin-right:22px;padding:6px 14px;border:1px solid transparent;border-radius:8px;transition:all .2s ease}.d2-run-mode-group .el-radio[data-v-5d452c8f]:hover{background:rgba(64,158,255,.06);border-color:#c6e2ff}.d2-page-action-group[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:10px;-webkit-box-flex:1;-ms-flex:1;flex:1;max-width:560px}.d2-page-action-item[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:10px 14px;background:#fff;border:1px solid #ebeef5;border-radius:10px;box-shadow:0 1px 2px rgba(0,0,0,.02);transition:all .2s ease}.d2-page-action-item[data-v-5d452c8f]:hover{border-color:#c6e2ff;box-shadow:0 3px 10px rgba(64,158,255,.08);-webkit-transform:translateY(-1px);transform:translateY(-1px)}.d2-pa-index[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;width:28px;height:28px;border-radius:50%;color:#fff;font-size:14px;font-weight:700;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.d2-page-action-item:first-child .d2-pa-index[data-v-5d452c8f]{background:#409eff}.d2-page-action-item:nth-child(2) .d2-pa-index[data-v-5d452c8f]{background:#67c23a}.d2-page-action-item:nth-child(3) .d2-pa-index[data-v-5d452c8f]{background:#e6a23c}.d2-page-action-item:nth-child(4) .d2-pa-index[data-v-5d452c8f]{background:#909399}.d2-pa-name[data-v-5d452c8f]{font-weight:600;color:#303133;font-size:14px}.d2-page-action-group .el-radio[data-v-5d452c8f]{margin-right:0}.d2-page-action-group .el-radio[data-v-5d452c8f],.d2-subtitle[data-v-5d452c8f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.d2-subtitle[data-v-5d452c8f]{gap:6px;font-size:15px;font-weight:700;color:#303133;margin-bottom:12px;padding:4px 12px;border-left:4px solid #409eff;background:rgba(64,158,255,.05);border-radius:0 6px 6px 0}.d2-subtitle i[data-v-5d452c8f]{color:#409eff;font-size:16px}.d2-firm-block[data-v-5d452c8f]{margin-top:24px}.d2-firm-table[data-v-5d452c8f]{width:100%;border-collapse:separate;border-spacing:0;border-radius:10px;overflow:hidden;border:1px solid #ebeef5;box-shadow:0 1px 4px rgba(0,0,0,.03);margin-bottom:20px;font-size:13px;background:#fff}.d2-firm-table thead tr[data-v-5d452c8f]{background:linear-gradient(90deg,#409eff,#66b1ff)}.d2-firm-table th[data-v-5d452c8f]{padding:11px 14px;color:#fff;font-weight:600;text-align:left;letter-spacing:.3px}.d2-firm-table th i[data-v-5d452c8f]{color:#fff}.d2-firm-table td[data-v-5d452c8f]{padding:11px 14px;color:#606266;border-bottom:1px solid #f2f6fc;line-height:1.6}.d2-firm-table tbody tr:last-child td[data-v-5d452c8f]{border-bottom:none}.d2-firm-table tbody tr[data-v-5d452c8f]:nth-child(2n){background:#fafbfc}.d2-firm-table tbody tr[data-v-5d452c8f]:hover{background:#ecf5ff!important;transition:background .15s ease}.d2-fw-id[data-v-5d452c8f]{font-weight:700;font-size:13px;letter-spacing:.5px}.d2-fw-1[data-v-5d452c8f]{color:#409eff}.d2-fw-2[data-v-5d452c8f]{color:#67c23a}.d2-fw-3[data-v-5d452c8f]{color:#e6a23c}.d2-fw-4[data-v-5d452c8f]{color:#909399}.d2-notes-block[data-v-5d452c8f]{margin-top:8px}.d2-notes-block>.d2-subtitle[data-v-5d452c8f]{border-left-color:#e6a23c;background:rgba(230,162,60,.06)}.d2-notes-block>.d2-subtitle i[data-v-5d452c8f]{color:#e6a23c}.d2-note-item[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:12px;padding:12px 14px;border-radius:10px;border-left:4px solid;margin-bottom:10px;font-size:13px;line-height:1.65;color:#606266}.d2-note-item i[data-v-5d452c8f]{-ms-flex-negative:0;flex-shrink:0;margin-top:2px;font-size:18px}.d2-note-1[data-v-5d452c8f]{background:#ecf5ff;border-left-color:#409eff}.d2-note-1 i[data-v-5d452c8f]{color:#409eff}.d2-note-2[data-v-5d452c8f]{background:#f0f9eb;border-left-color:#67c23a}.d2-note-2 i[data-v-5d452c8f]{color:#67c23a}.d2-note-3[data-v-5d452c8f]{background:#fdf6ec;border-left-color:#e6a23c}.d2-note-3 i[data-v-5d452c8f]{color:#e6a23c}.d2-note-body[data-v-5d452c8f]{-webkit-box-flex:1;-ms-flex:1;flex:1}@media (max-width:720px){.d2-mode-card[data-v-5d452c8f]{padding:18px 16px}.d2-field-row[data-v-5d452c8f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:4px}.d2-page-label[data-v-5d452c8f]{line-height:22px}.d2-field-label[data-v-5d452c8f]{line-height:24px}.d2-firm-table td[data-v-5d452c8f],.d2-firm-table th[data-v-5d452c8f]{padding:9px 10px;font-size:12px}}.b3-key-schematic[data-v-5d452c8f]{margin-bottom:22px;padding:24px 28px;background:#f5f5f5;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,.06);position:relative;overflow:hidden}.b3-key-schematic[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-20%;right:-10%;width:80px;height:80px;background:rgba(0,0,0,.03);border-radius:50%}.b3-key-schematic[data-v-5d452c8f]:after{content:\"\";position:absolute;bottom:-15%;left:-8%;width:60px;height:60px;background:rgba(0,0,0,.02);border-radius:50%}.b3-sch-title[data-v-5d452c8f]{margin:0 0 20px;font-size:18px;font-weight:700;color:#303133;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;position:relative;z-index:1}.b3-sch-title i[data-v-5d452c8f]{font-size:22px}.b3-sch-grid[data-v-5d452c8f]{gap:16px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:1}.b3-sch-grid[data-v-5d452c8f],.b3-sch-key[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.b3-sch-key[data-v-5d452c8f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:140px;max-width:180px;padding:22px 16px 24px;background:hsla(0,0%,100%,.95);border-radius:14px;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;box-shadow:0 2px 8px rgba(0,0,0,.08);border:5px solid var(--backlight-color,#c0c4cc);box-sizing:border-box}.b3-sch-key[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px;border-radius:19px;border:4px solid var(--backlight-color,#c0c4cc);opacity:.6;pointer-events:none;transition:opacity .25s}.b3-sch-key[data-v-5d452c8f]:hover:before{opacity:.9}.b3-sch-key[data-v-5d452c8f]:hover{-webkit-transform:translateY(-4px) scale(1.02);transform:translateY(-4px) scale(1.02);box-shadow:0 8px 24px rgba(102,126,234,.25),0 0 24px var(--backlight-color,#c0c4cc)}.b3-sch-key[data-v-5d452c8f]:active{-webkit-transform:translateY(-2px) scale(.98);transform:translateY(-2px) scale(.98)}.b3-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#409eff,#66b1ff)!important;box-shadow:0 6px 20px rgba(64,158,255,.35)!important}.b3-sch-active .b3-sch-key-label[data-v-5d452c8f],.b3-sch-active .b3-sch-key-num[data-v-5d452c8f],.b3-sch-active .b3-sch-key-value[data-v-5d452c8f]{color:#fff!important}.b3-sch-active .b3-sch-key-num[data-v-5d452c8f]{background:hsla(0,0%,100%,.25)!important;border-color:hsla(0,0%,100%,.4)!important}.b3-sch-key-num[data-v-5d452c8f]{width:44px;height:44px;border-radius:50%;background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;font-size:20px;font-weight:800;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:10px;border:3px solid rgba(102,126,234,.15);box-shadow:0 3px 8px rgba(102,126,234,.2)}.b3-sch-key-label[data-v-5d452c8f]{font-size:14px;font-weight:600;color:#303133;margin-bottom:6px}.b3-sch-key-value[data-v-5d452c8f]{font-size:13px;font-weight:500;color:#909399;text-align:center;line-height:1.5;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.b3-sch-active .b3-sch-key-value[data-v-5d452c8f]{font-weight:600}.main-header[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:16px;margin-bottom:20px;padding:0 10px}.main-header h1[data-v-5d452c8f]{width:100%;margin:0;text-align:center}.main-header-actions[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px}.main-header-actions .el-button+.el-button[data-v-5d452c8f]{margin-left:0}.key-test-modal .el-dialog__body[data-v-5d452c8f]{padding-top:8px}.video-tutorial-btn[data-v-5d452c8f]{font-weight:700!important;font-size:16px!important;padding:10px 22px!important;min-width:130px;border-radius:8px!important;background:linear-gradient(135deg,#e6a23c,#eebe77)!important;border:1.5px solid #f5dab9!important;color:#fff!important;box-shadow:0 3px 10px rgba(230,162,60,.3)!important;letter-spacing:.5px;transition:all .25s ease}.video-tutorial-btn[data-v-5d452c8f]:hover{-webkit-transform:translateY(-2px);transform:translateY(-2px);box-shadow:0 5px 16px rgba(230,162,60,.4)!important}.video-tutorial-btn[data-v-5d452c8f]:active{-webkit-transform:translateY(0);transform:translateY(0)}.video-modal .el-dialog__header[data-v-5d452c8f]{background:linear-gradient(135deg,#667eea,#764ba2);padding:20px 24px}.video-modal .el-dialog__title[data-v-5d452c8f]{color:#fff;font-size:18px;font-weight:700}.video-modal .el-dialog__headerbtn .el-dialog__close[data-v-5d452c8f]{color:hsla(0,0%,100%,.8);font-size:20px}.video-modal .el-dialog__body[data-v-5d452c8f]{padding:0}.video-container[data-v-5d452c8f]{width:100%;background:#000;border-radius:8px;overflow:hidden}.video-player[data-v-5d452c8f]{width:100%;height:450px;display:block}@media (max-width:768px){.main-header[data-v-5d452c8f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:12px}.main-header-actions[data-v-5d452c8f]{-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.key-test-modal[data-v-5d452c8f]{width:96vw!important}.video-modal[data-v-5d452c8f]{width:95vw!important}.video-player[data-v-5d452c8f]{height:300px}}.c4-key-schematic[data-v-5d452c8f]{margin-bottom:22px;padding:24px 28px;background:#f5f5f5;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,.06);position:relative;overflow:hidden}.c4-key-schematic[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-20%;right:-10%;width:80px;height:80px;background:rgba(0,0,0,.03);border-radius:50%}.c4-key-schematic[data-v-5d452c8f]:after{content:\"\";position:absolute;bottom:-15%;left:-8%;width:60px;height:60px;background:rgba(0,0,0,.02);border-radius:50%}.c4-sch-title[data-v-5d452c8f]{margin:0 0 20px;font-size:18px;font-weight:700;color:#303133;letter-spacing:.5px;gap:8px}.c4-sch-layout[data-v-5d452c8f],.c4-sch-title[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;z-index:1}.c4-sch-layout[data-v-5d452c8f]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:30px}.c4-sch-grid[data-v-5d452c8f]{display:-ms-grid;display:grid;-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr);gap:12px}.c4-sch-key[data-v-5d452c8f]{min-width:120px;max-width:150px;padding:18px 14px 20px;background:hsla(0,0%,100%,.95);border-radius:14px;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;box-shadow:0 2px 8px rgba(0,0,0,.08);border:5px solid var(--backlight-color,#c0c4cc);box-sizing:border-box}.c4-sch-key[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px;border-radius:19px;border:4px solid var(--backlight-color,#c0c4cc);opacity:.6;pointer-events:none;transition:opacity .25s}.c4-sch-key[data-v-5d452c8f]:hover:before{opacity:.9}.c4-sch-key[data-v-5d452c8f]:hover{-webkit-transform:translateY(-4px) scale(1.02);transform:translateY(-4px) scale(1.02);box-shadow:0 8px 24px rgba(102,126,234,.25),0 0 24px var(--backlight-color,#c0c4cc)}.c4-sch-key.c4-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#409eff,#66b1ff)!important;color:#fff!important;border-color:#409eff!important}.c4-sch-key.c4-sch-active[data-v-5d452c8f]:before{border-color:hsla(0,0%,100%,.5)!important}.c4-sch-key-num[data-v-5d452c8f]{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#409eff,#66b1ff);color:#fff;font-size:16px;font-weight:800;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:8px;box-shadow:0 3px 8px rgba(64,158,255,.3)}.c4-sch-key.c4-sch-active .c4-sch-key-num[data-v-5d452c8f]{background:hsla(0,0%,100%,.3)!important}.c4-sch-key-label[data-v-5d452c8f]{font-size:13px;color:#606266;margin-bottom:6px;font-weight:500}.c4-sch-key.c4-sch-active .c4-sch-key-label[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)!important}.c4-sch-key-value[data-v-5d452c8f]{font-size:12px;color:#909399;text-align:center;line-height:1.5;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.c4-sch-key.c4-sch-active .c4-sch-key-value[data-v-5d452c8f]{color:#fff!important;font-weight:600}.c4-sch-knob-container[data-v-5d452c8f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.c4-sch-knob-container[data-v-5d452c8f],.c4-sch-knob-row[data-v-5d452c8f]{gap:12px}.c4-sch-knob-arrow[data-v-5d452c8f],.c4-sch-knob-container[data-v-5d452c8f],.c4-sch-knob-row[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.c4-sch-knob-arrow[data-v-5d452c8f]{width:100px;height:80px;background:transparent;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);position:relative;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.c4-sch-knob-arrow[data-v-5d452c8f]:before{content:\"\";position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:0;height:0;border-top:28px solid transparent;border-bottom:28px solid transparent}.c4-sch-knob-arrow.left[data-v-5d452c8f]:before{border-right:40px solid hsla(0,0%,100%,.95)}.c4-sch-knob-arrow.right[data-v-5d452c8f]:before{border-left:40px solid hsla(0,0%,100%,.95)}.c4-sch-knob-arrow[data-v-5d452c8f]:after{content:\"\";position:absolute;top:2px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);width:0;height:0;border-top:24px solid transparent;border-bottom:24px solid transparent}.c4-sch-knob-arrow.left[data-v-5d452c8f]:after{border-right:35px solid #909399}.c4-sch-knob-arrow.right[data-v-5d452c8f]:after{border-left:35px solid #909399}.c4-sch-knob-arrow[data-v-5d452c8f]:hover{-webkit-transform:scale(1.08);transform:scale(1.08)}.c4-sch-knob-arrow[data-v-5d452c8f]:hover:after{border-right-color:#409eff}.c4-sch-knob-arrow.right[data-v-5d452c8f]:hover:after{border-left-color:#409eff}.c4-sch-knob-arrow.c4-sch-active.left[data-v-5d452c8f]:before{border-right-color:#409eff}.c4-sch-knob-arrow.c4-sch-active.right[data-v-5d452c8f]:before{border-left-color:#409eff}.c4-sch-knob-arrow.c4-sch-active.left[data-v-5d452c8f]:after{border-right-color:#fff}.c4-sch-knob-arrow.c4-sch-active.right[data-v-5d452c8f]:after{border-left-color:#fff}.c4-sch-knob-arrow-value[data-v-5d452c8f]{font-size:11px;color:#909399;text-align:center;margin-top:60px;max-width:100px;overflow:hidden;line-height:1.4;z-index:1}.c4-sch-knob-arrow.c4-sch-active .c4-sch-knob-arrow-value[data-v-5d452c8f]{color:#fff;font-weight:600}.c4-sch-knob[data-v-5d452c8f]{width:90px;height:90px;border-radius:50%;background:hsla(0,0%,100%,.95);border:4px solid #909399;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.08)}.c4-sch-knob[data-v-5d452c8f]:hover{-webkit-transform:scale(1.05);transform:scale(1.05);box-shadow:0 4px 16px hsla(220,4%,58%,.2)}.c4-sch-knob.c4-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#409eff,#66b1ff);border-color:#409eff}.c4-sch-knob-inner[data-v-5d452c8f]{font-size:36px;font-weight:700;color:#67c23a;line-height:1}.c4-sch-knob.c4-sch-active .c4-sch-knob-inner[data-v-5d452c8f]{color:#fff}.c4-sch-knob-value-inner[data-v-5d452c8f]{font-size:12px;color:#909399;text-align:center;margin-top:4px;max-width:70px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.c4-sch-knob.c4-sch-active .c4-sch-knob-value-inner[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)}.c4-sch-knob-label[data-v-5d452c8f]{font-size:14px;color:#606266;font-weight:500}.c4-sch-knob-container.c4-sch-active .c4-sch-knob-label[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)}.b6-key-schematic[data-v-5d452c8f]{margin-bottom:22px;padding:24px 28px;background:#f5f5f5;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,.06);position:relative;overflow:hidden}.b6-key-schematic[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-20%;right:-10%;width:80px;height:80px;background:rgba(0,0,0,.03);border-radius:50%}.b6-key-schematic[data-v-5d452c8f]:after{content:\"\";position:absolute;bottom:-15%;left:-8%;width:60px;height:60px;background:rgba(0,0,0,.02);border-radius:50%}.b6-sch-title[data-v-5d452c8f]{margin:0 0 20px;font-size:18px;font-weight:700;color:#303133;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;position:relative;z-index:1}.b6-sch-grid[data-v-5d452c8f]{display:-ms-grid;display:grid;-ms-grid-columns:(1fr)[3];grid-template-columns:repeat(3,1fr);gap:14px;position:relative;z-index:1}.b6-sch-key[data-v-5d452c8f]{padding:18px 12px 20px;background:hsla(0,0%,100%,.95);border-radius:14px;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;box-shadow:0 2px 8px rgba(0,0,0,.08);border:5px solid var(--backlight-color,#c0c4cc);box-sizing:border-box}.b6-sch-key[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px;border-radius:19px;border:4px solid var(--backlight-color,#c0c4cc);opacity:.6;pointer-events:none;transition:opacity .25s}.b6-sch-key[data-v-5d452c8f]:hover:before{opacity:.9}.b6-sch-key[data-v-5d452c8f]:hover{-webkit-transform:translateY(-4px) scale(1.02);transform:translateY(-4px) scale(1.02);box-shadow:0 8px 24px rgba(102,126,234,.25),0 0 24px var(--backlight-color,#c0c4cc)}.b6-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#409eff,#66b1ff)!important;color:#fff!important;border-color:#409eff!important}.b6-sch-active[data-v-5d452c8f]:before{border-color:hsla(0,0%,100%,.5)!important}.b6-sch-key-num[data-v-5d452c8f]{width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#409eff,#66b1ff);color:#fff;font-size:14px;font-weight:800;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:6px;box-shadow:0 3px 8px rgba(64,158,255,.3)}.b6-sch-active .b6-sch-key-num[data-v-5d452c8f]{background:hsla(0,0%,100%,.3)!important}.b6-sch-key-label[data-v-5d452c8f]{font-size:12px;color:#606266;margin-bottom:4px;font-weight:500}.b6-sch-active .b6-sch-key-label[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)!important}.b6-sch-key-value[data-v-5d452c8f]{font-size:11px;color:#909399;text-align:center;line-height:1.4;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.b6-sch-active .b6-sch-key-value[data-v-5d452c8f]{color:#fff!important;font-weight:600}.b4-key-schematic[data-v-5d452c8f]{margin-bottom:22px;padding:24px 28px;background:#f5f5f5;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,.06);position:relative;overflow:hidden}.b4-key-schematic[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-20%;right:-10%;width:80px;height:80px;background:rgba(0,0,0,.03);border-radius:50%}.b4-key-schematic[data-v-5d452c8f]:after{content:\"\";position:absolute;bottom:-15%;left:-8%;width:60px;height:60px;background:rgba(0,0,0,.02);border-radius:50%}.b4-sch-title[data-v-5d452c8f]{margin:0 0 20px;font-size:18px;font-weight:700;color:#303133;letter-spacing:.5px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.b4-sch-grid[data-v-5d452c8f],.b4-sch-title[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;z-index:1}.b4-sch-grid[data-v-5d452c8f]{gap:14px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.b4-sch-key[data-v-5d452c8f]{-webkit-box-flex:1;-ms-flex:1;flex:1;min-width:100px;max-width:140px;padding:18px 12px 20px;background:hsla(0,0%,100%,.95);border-radius:14px;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;box-shadow:0 2px 8px rgba(0,0,0,.08);border:5px solid var(--backlight-color,#c0c4cc);box-sizing:border-box}.b4-sch-key[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px;border-radius:19px;border:4px solid var(--backlight-color,#c0c4cc);opacity:.6;pointer-events:none;transition:opacity .25s}.b4-sch-key[data-v-5d452c8f]:hover:before{opacity:.9}.b4-sch-key[data-v-5d452c8f]:hover{-webkit-transform:translateY(-4px) scale(1.02);transform:translateY(-4px) scale(1.02);box-shadow:0 8px 24px rgba(102,126,234,.25),0 0 24px var(--backlight-color,#c0c4cc)}.b4-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#409eff,#66b1ff)!important;color:#fff!important;border-color:#409eff!important}.b4-sch-active[data-v-5d452c8f]:before{border-color:hsla(0,0%,100%,.5)!important}.b4-sch-key-num[data-v-5d452c8f]{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#409eff,#66b1ff);color:#fff;font-size:16px;font-weight:800;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:8px;box-shadow:0 3px 8px rgba(64,158,255,.3)}.b4-sch-active .b4-sch-key-num[data-v-5d452c8f]{background:hsla(0,0%,100%,.3)!important}.b4-sch-key-label[data-v-5d452c8f]{font-size:13px;color:#606266;margin-bottom:6px;font-weight:500}.b4-sch-active .b4-sch-key-label[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)!important}.b4-sch-key-value[data-v-5d452c8f]{font-size:12px;color:#909399;text-align:center;line-height:1.5;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.b4-sch-active .b4-sch-key-value[data-v-5d452c8f]{color:#fff!important;font-weight:600}@media (max-width:600px){.c4-sch-layout[data-v-5d452c8f]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:20px}.c4-sch-grid[data-v-5d452c8f]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr)}.c4-sch-key[data-v-5d452c8f]{min-width:100px;padding:14px 10px 16px}.c4-sch-key-num[data-v-5d452c8f]{width:28px;height:28px;font-size:14px}.c4-sch-knob-arrow[data-v-5d452c8f],.c4-sch-knob[data-v-5d452c8f]{width:70px;height:70px}.c4-sch-knob-arrow[data-v-5d452c8f]:before{border-top:22px solid transparent;border-bottom:22px solid transparent}.c4-sch-knob-arrow.left[data-v-5d452c8f]:before{border-right:32px solid hsla(0,0%,100%,.95)}.c4-sch-knob-arrow.right[data-v-5d452c8f]:before{border-left:32px solid hsla(0,0%,100%,.95)}.c4-sch-knob-arrow[data-v-5d452c8f]:after{border-top:19px solid transparent;border-bottom:19px solid transparent;top:2px}.c4-sch-knob-arrow.left[data-v-5d452c8f]:after{border-right:28px solid #909399}.c4-sch-knob-arrow.right[data-v-5d452c8f]:after{border-left:28px solid #909399}.c4-sch-knob-arrow-value[data-v-5d452c8f]{margin-top:48px;font-size:10px;max-width:70px}.c4-sch-knob-inner[data-v-5d452c8f]{font-size:28px}.b6-sch-grid[data-v-5d452c8f]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr)}}.e6-mode-card[data-v-5d452c8f]{margin-bottom:22px;padding:22px 26px;background:linear-gradient(135deg,#e8fff4,#f5f7fa 55%,#eaf1ff);border:1px solid #c9eddc;border-radius:14px;box-shadow:0 2px 8px rgba(103,194,58,.08)}.e6-mode-title[data-v-5d452c8f]{margin:0 0 16px;font-size:18px;font-weight:700;color:#268f4b;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.e6-mode-title i[data-v-5d452c8f]{font-size:22px;color:#67c23a}.e6-field-label[data-v-5d452c8f]{display:inline-block;min-width:88px;font-size:14px;font-weight:600;color:#303133;line-height:40px}.e6-device-mode-group .el-radio[data-v-5d452c8f]{font-size:14px;margin-right:22px;padding:6px 14px;border:1px solid transparent;border-radius:8px;transition:all .2s ease}.e6-device-mode-group .el-radio[data-v-5d452c8f]:hover{background:rgba(103,194,58,.08);border-color:#c2edd5}.e6-device-mode-group .el-radio.is-checked[data-v-5d452c8f]{background:rgba(103,194,58,.12);border-color:#67c23a}.e6-mode-tip[data-v-5d452c8f]{margin-top:6px;padding:10px 14px;background:#fff9e6;border-radius:8px;color:#8a7340;font-size:13px;line-height:1.6;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;gap:8px;text-align:left}.e6-mode-tip i[data-v-5d452c8f]{color:#e6a23c;-ms-flex-negative:0;flex-shrink:0;margin-top:2px}.e6-key-schematic[data-v-5d452c8f]{margin-bottom:22px;padding:24px 28px;background:#f5f5f5;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,.06);position:relative;overflow:hidden}.e6-key-schematic[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-20%;right:-10%;width:80px;height:80px;background:rgba(0,0,0,.03);border-radius:50%}.e6-key-schematic[data-v-5d452c8f]:after{content:\"\";position:absolute;bottom:-15%;left:-8%;width:60px;height:60px;background:rgba(0,0,0,.02);border-radius:50%}.e6-sch-title[data-v-5d452c8f]{margin:0 0 20px;font-size:18px;font-weight:700;color:#303133;letter-spacing:.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px;position:relative;z-index:1}.e6-sch-grid[data-v-5d452c8f]{display:-ms-grid;display:grid;-ms-grid-columns:(1fr)[3];grid-template-columns:repeat(3,1fr);gap:14px;position:relative;z-index:1}.e6-sch-key[data-v-5d452c8f]{padding:18px 12px 20px;background:hsla(0,0%,100%,.95);border-radius:14px;cursor:pointer;transition:all .25s cubic-bezier(.4,0,.2,1);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;box-shadow:0 2px 8px rgba(0,0,0,.08);border:5px solid #67c23a;box-sizing:border-box}.e6-sch-key[data-v-5d452c8f]:before{content:\"\";position:absolute;top:-8px;left:-8px;right:-8px;bottom:-8px;border-radius:19px;border:4px solid #67c23a;opacity:.6;pointer-events:none;transition:opacity .25s}.e6-sch-key[data-v-5d452c8f]:hover:before{opacity:.9}.e6-sch-key[data-v-5d452c8f]:hover{-webkit-transform:translateY(-4px) scale(1.02);transform:translateY(-4px) scale(1.02);box-shadow:0 8px 24px rgba(103,194,58,.25),0 0 24px rgba(103,194,58,.4)}.e6-sch-active[data-v-5d452c8f]{background:linear-gradient(135deg,#67c23a,#85ce61)!important;color:#fff!important;border-color:#67c23a!important}.e6-sch-active[data-v-5d452c8f]:before{border-color:hsla(0,0%,100%,.5)!important}.e6-sch-key-num[data-v-5d452c8f]{width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#67c23a,#85ce61);color:#fff;font-size:14px;font-weight:800;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:6px;box-shadow:0 3px 8px rgba(103,194,58,.3)}.e6-sch-active .e6-sch-key-num[data-v-5d452c8f]{background:hsla(0,0%,100%,.3)!important}.e6-sch-key-label[data-v-5d452c8f]{font-size:12px;color:#606266;margin-bottom:4px;font-weight:500}.e6-sch-active .e6-sch-key-label[data-v-5d452c8f]{color:hsla(0,0%,100%,.9)!important}.e6-sch-key-value[data-v-5d452c8f]{font-size:11px;color:#909399;text-align:center;line-height:1.4;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.e6-sch-active .e6-sch-key-value[data-v-5d452c8f]{color:#fff!important;font-weight:600}@media (max-width:600px){.e6-sch-grid[data-v-5d452c8f]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr)}.e6-device-mode-group .el-radio[data-v-5d452c8f]{display:block;margin-bottom:8px;margin-right:0}}.factory-dialog .el-dialog__title[data-v-5d452c8f]{font-size:22px;font-weight:700}.factory-dialog .el-dialog__body[data-v-5d452c8f]{font-size:16px}.factory-toolbar[data-v-5d452c8f]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:16px;margin-bottom:16px;-ms-flex-wrap:wrap;flex-wrap:wrap}.factory-toolbar .el-button[data-v-5d452c8f]{font-size:16px;height:40px;padding:0 18px}.factory-toolbar .el-checkbox__label[data-v-5d452c8f]{font-size:16px}.factory-error[data-v-5d452c8f]{color:#f56c6c;font-size:15px}.factory-led-tip[data-v-5d452c8f]{margin-bottom:14px;padding:10px 14px;border-radius:8px;background:#fdf6ec;border:1px solid #f5dab1;color:#b88230;font-size:15px;line-height:1.6}.factory-banner[data-v-5d452c8f]{padding:13px 16px;border-radius:10px;font-weight:700;font-size:17px;margin-bottom:14px}.factory-banner.pass[data-v-5d452c8f]{background:#67c23a;color:#fff}.factory-banner.fail[data-v-5d452c8f]{background:#f56c6c;color:#fff}.factory-dialog .el-table[data-v-5d452c8f]{font-size:16px}.factory-dialog .el-table th .cell[data-v-5d452c8f]{font-size:16px;font-weight:700}.factory-dialog .el-table td .cell[data-v-5d452c8f]{font-size:16px;line-height:1.6}.factory-result[data-v-5d452c8f]{font-size:17px;font-weight:700;white-space:nowrap}.factory-result.pass[data-v-5d452c8f]{color:#529b2e}.factory-result.fail[data-v-5d452c8f]{color:#c45656}.factory-result.wait[data-v-5d452c8f]{color:#909399;font-weight:500}.factory-result.info[data-v-5d452c8f]{color:#c0c4cc;font-weight:500}.factory-raw[data-v-5d452c8f]{margin-top:12px;background:#f5f7fa;padding:10px;font-size:14px;overflow:auto}.factory-note[data-v-5d452c8f]{color:#909399;font-size:14px;margin-top:10px}.el-table .factory-ok td[data-v-5d452c8f]{background:#f0f9eb!important;color:#529b2e!important;font-weight:600}.el-table .factory-bad td[data-v-5d452c8f]{background:#fef0f0!important;color:#c45656!important;font-weight:600}", ""]);

// exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".tester-card[data-v-5e1146cd]{padding:24px;border:1px solid #cbdcf4;border-radius:12px;background:#fff;margin:18px 0}.test-heading[data-v-5e1146cd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;gap:12px}h2[data-v-5e1146cd]{font-size:18px;margin:0}h3[data-v-5e1146cd]{font-size:14px;margin-bottom:0}.hint[data-v-5e1146cd]{font-size:12px;color:#67768b;line-height:1.7}.test-toolbar[data-v-5e1146cd]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:8px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:14px 0}.test-toolbar .el-button+.el-button[data-v-5e1146cd]{margin-left:0}.test-toolbar>span[data-v-5e1146cd]{font-size:12px;margin-left:auto;color:#64738a}.test-toolbar b[data-v-5e1146cd]{color:#315e9f}.test-pad[data-v-5e1146cd]{border:2px dashed #c5d2e4;border-radius:10px;padding:22px;background:#f8faff;outline:none;min-height:105px}.test-pad.active[data-v-5e1146cd]{border-style:solid;border-color:#4384df;background:#eff6ff;box-shadow:0 0 0 3px #e6effc}.test-pad strong[data-v-5e1146cd]{font-size:14px}.test-pad p[data-v-5e1146cd]{font-size:12px;color:#687c96;line-height:1.7}.held[data-v-5e1146cd]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:7px;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;font-size:12px;min-height:25px}kbd[data-v-5e1146cd]{padding:5px 9px;background:#3e75c6;color:#fff;border-radius:5px}.text-preview[data-v-5e1146cd]{white-space:pre-wrap;overflow-wrap:anywhere;background:#f5f7fa;border:1px solid #e1e7f0;border-radius:8px;min-height:50px;max-height:150px;overflow:auto;padding:12px;font-size:14px;-moz-tab-size:4;-o-tab-size:4;tab-size:4}.placeholder[data-v-5e1146cd]{color:#95a0ae;font-size:12px}.event-details summary[data-v-5e1146cd]{cursor:pointer;font-weight:600;font-size:13px;padding:12px 0}.event-scroll[data-v-5e1146cd]{overflow:auto;max-height:240px;border:1px solid #e5eaf2;border-radius:8px}table[data-v-5e1146cd]{width:100%;text-align:left;border-collapse:collapse;font-size:12px}td[data-v-5e1146cd],th[data-v-5e1146cd]{padding:9px 10px;border-bottom:1px solid #edf0f5;white-space:nowrap}th[data-v-5e1146cd]{position:-webkit-sticky;position:sticky;top:0;background:#f4f7fc;color:#61718a}.event-down[data-v-5e1146cd]{color:#2265b7}.event-up[data-v-5e1146cd]{color:#458455}.event-repeat[data-v-5e1146cd]{color:#a1711d}.draft-warning[data-v-5e1146cd],.test-limit[data-v-5e1146cd]{font-size:12px;color:#876529;background:#fff8e9;border-radius:7px;padding:10px 12px;line-height:1.8}.retention[data-v-5e1146cd]{margin-bottom:0}@media(max-width:650px){.tester-card[data-v-5e1146cd]{padding:16px}.test-toolbar>span[data-v-5e1146cd]{width:100%;margin:8px 0 0}.test-pad[data-v-5e1146cd]{padding:16px}}", ""]);

// exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(27)(undefined);
// imports


// module
exports.push([module.i, ".el-row[data-v-be7af0ec]{margin-bottom:20px}.key-config-wrapper[data-v-be7af0ec]{width:100%}.key-header-row[data-v-be7af0ec]{margin-bottom:12px;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.quick-toggle-col[data-v-be7af0ec]{margin-left:auto;-ms-flex-negative:0;flex-shrink:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-ms-flex-item-align:start;align-self:flex-start;gap:4px}.quick-toggle-btn[data-v-be7af0ec]{-ms-flex-negative:0;flex-shrink:0;font-weight:700!important;font-size:17px!important;padding:11px 24px!important;height:auto!important;min-width:140px;border-radius:8px!important;box-shadow:0 3px 10px rgba(64,158,255,.3)!important;background:linear-gradient(135deg,#409eff,#66b1ff)!important;border:1.5px solid #b3d8ff!important;color:#fff!important;letter-spacing:.5px;text-shadow:0 1px 1px rgba(30,80,150,.2)}.quick-toggle-btn[data-v-be7af0ec]:hover{-webkit-transform:translateY(-1px);transform:translateY(-1px);box-shadow:0 5px 16px rgba(64,158,255,.42)!important}.quick-toggle-btn[data-v-be7af0ec]:active{-webkit-transform:translateY(0);transform:translateY(0)}.quick-toggle-hint[data-v-be7af0ec]{font-size:12px;font-weight:500;color:#606266;background:linear-gradient(135deg,#ecf5ff,#f5f0ff);border:1px solid #d3e3ff;padding:3px 11px;border-radius:12px;line-height:1.5;box-shadow:0 1px 2px rgba(64,158,255,.08);white-space:nowrap}.normal-key-lowercase-hint[data-v-be7af0ec]{margin-top:8px;margin-left:auto;margin-right:auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;font-size:11px;color:#e6a23c;background:#fdf6ec;border:1px solid #f5dab9;padding:4px 10px;border-radius:4px;line-height:1.5}.normal-key-lowercase-hint .el-icon-info[data-v-be7af0ec]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:15px;height:15px;border-radius:50%;border:1px solid #e6a23c;color:#e6a23c;font-size:10px;margin-right:5px;background:transparent}.mix-key-hint[data-v-be7af0ec]{margin-top:6px;margin-bottom:12px}.quick-setting-row[data-v-be7af0ec]{margin-bottom:18px}.quick-setting-card[data-v-be7af0ec]{margin-left:56px;padding:9px 11px 8px;background:#fafbff;border:1px solid #e4e9f5;border-radius:8px;box-shadow:0 1px 3px rgba(90,110,170,.05)}.qs-header[data-v-be7af0ec]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:14px;padding:6px 4px 10px;margin-bottom:10px;border-bottom:1px solid #e4e9f5}.qs-header[data-v-be7af0ec],.qs-title[data-v-be7af0ec]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.qs-title[data-v-be7af0ec]{font-size:16px;font-weight:700;color:#303133;letter-spacing:.3px}.qs-title i[data-v-be7af0ec]{color:#e6a23c!important;font-size:17px;margin-right:8px!important}.qs-search[data-v-be7af0ec]{width:400px;max-width:100%}.qs-search[data-v-be7af0ec] .el-input__inner{border-radius:6px!important;height:38px!important;border:1.5px solid #b3d8ff!important;font-weight:600;font-size:14px!important;padding:0 14px!important;box-shadow:inset 0 1px 3px rgba(64,158,255,.1)}.qs-search[data-v-be7af0ec] .el-input__inner:focus{border-color:#409eff!important;box-shadow:0 0 0 3px rgba(64,158,255,.15),inset 0 1px 3px rgba(64,158,255,.1)}.qs-categories[data-v-be7af0ec]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:5px;margin-bottom:6px}.qs-categories[data-v-be7af0ec] .el-button{padding:4px 9px!important;height:auto!important;font-weight:500!important;border-radius:5px!important;font-size:11px!important}.qs-grid[data-v-be7af0ec]{display:-ms-grid;display:grid;-ms-grid-columns:(minmax(120px,1fr))[auto-fill];grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:6px;max-height:320px;overflow-y:auto;padding:5px 2px 5px 0}.qs-grid[data-v-be7af0ec]::-webkit-scrollbar{width:5px}.qs-grid[data-v-be7af0ec]::-webkit-scrollbar-thumb{background:#c0c4cc;border-radius:3px}.qs-grid[data-v-be7af0ec]::-webkit-scrollbar-track{background:#f4f4f5;border-radius:3px}.qs-card[data-v-be7af0ec]{padding:6px 8px 5px;background:#fff;border:1px solid #ebeef5;border-radius:6px;cursor:pointer;transition:all .18s ease;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;overflow:hidden;box-shadow:0 1px 2px rgba(100,120,180,.04)}.qs-card[data-v-be7af0ec]:before{content:\"\";position:absolute;top:0;left:0;width:2px;height:100%;background:linear-gradient(180deg,#409eff,#8b5cf6)}.qs-card[data-v-be7af0ec]:hover{-webkit-transform:translateY(-1px);transform:translateY(-1px);border-color:#409eff;box-shadow:0 2px 6px rgba(64,158,255,.14);background:#f5faff}.qs-card[data-v-be7af0ec]:active{-webkit-transform:translateY(0);transform:translateY(0);box-shadow:0 1px 3px rgba(64,158,255,.1)}.qs-card-active[data-v-be7af0ec]{border-color:#67c23a!important;background:#f0f9eb!important;box-shadow:0 2px 8px rgba(103,194,58,.2)!important}.qs-card-active[data-v-be7af0ec]:hover{border-color:#67c23a!important;background:#e8f8df!important;box-shadow:0 2px 10px rgba(103,194,58,.25)!important}.qs-card-active[data-v-be7af0ec]:before{background:linear-gradient(180deg,#67c23a,#52b415)!important}.qs-card-name[data-v-be7af0ec]{font-size:13px;font-weight:600;color:#303133;padding-left:2px;margin-bottom:4px}.qs-card-hotkey[data-v-be7af0ec],.qs-card-name[data-v-be7af0ec]{line-height:1.4;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.qs-card-hotkey[data-v-be7af0ec]{font-size:11px;font-weight:500;color:#606266;background:#f5f7fa;border:1px solid #e4e7ed;padding:2px 7px;border-radius:4px;display:inline-block;max-width:100%;font-family:Consolas,Courier New,Menlo,Monaco,monospace;margin-left:2px}.qs-footer-tip[data-v-be7af0ec]{margin-top:8px;padding:6px 9px;background:#f4f6fb;border-radius:5px;font-size:11px;font-weight:500;color:#606266;line-height:1.55}@media (max-width:900px){.quick-setting-card[data-v-be7af0ec]{margin-left:0}.qs-search[data-v-be7af0ec]{width:100%}.qs-grid[data-v-be7af0ec]{-ms-grid-columns:(minmax(110px,1fr))[auto-fill];grid-template-columns:repeat(auto-fill,minmax(110px,1fr))}.quick-toggle-btn[data-v-be7af0ec]{min-width:auto;padding:5px 12px!important;height:32px!important;font-size:12px!important}.quick-toggle-hint[data-v-be7af0ec]{display:none}}", ""]);

// exports


/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/video_tutorial.mp4";

/***/ }),
/* 251 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(259);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 263 */,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "732389ded34cb9c52dd88271f1345af9.ttf";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "535877f50039c0cb49a6196a5b7517cd.woff";

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyConfig_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7af0ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyConfig_vue__ = __webpack_require__(272);
function injectStyle (ssrContext) {
  __webpack_require__(276)
}
var normalizeComponent = __webpack_require__(42)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-be7af0ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be7af0ec_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyboardTester_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1146cd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyboardTester_vue__ = __webpack_require__(271);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(42)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e1146cd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyboardTester_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e1146cd_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyboardTester_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rf24Pair_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18dbe8f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rf24Pair_vue__ = __webpack_require__(269);
function injectStyle (ssrContext) {
  __webpack_require__(273)
}
var normalizeComponent = __webpack_require__(42)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18dbe8f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rf24Pair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18dbe8f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Rf24Pair_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rf24-pair"},[_c('el-alert',{staticClass:"rf-pair-warning",attrs:{"title":_vm.$t('rf24Pair.warningTitle'),"description":_vm.$t('rf24Pair.warningDesc'),"type":"warning","closable":false,"show-icon":""}}),_vm._v(" "),(!_vm.serialSupported)?_c('el-alert',{attrs:{"title":_vm.$t('rf24Pair.serialUnsupported'),"type":"warning","closable":false,"show-icon":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rf-toolbar"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-connection","loading":_vm.connecting,"disabled":_vm.connected},on:{"click":_vm.connect}},[_vm._v(_vm._s(_vm.$t('rf24Pair.connect')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","icon":"el-icon-switch-button","disabled":!_vm.connected},on:{"click":_vm.disconnect}},[_vm._v(_vm._s(_vm.$t('rf24Pair.disconnect')))]),_vm._v(" "),(_vm.connected)?_c('span',{staticClass:"rf-connected"},[_c('i',{staticClass:"el-icon-success"}),_vm._v(" "+_vm._s(_vm.$t('rf24Pair.connected')))]):_vm._e()],1),_vm._v(" "),(_vm.connected)?[_c('el-descriptions',{staticClass:"rf-desc",attrs:{"column":2,"border":"","size":"small"}},[_c('el-descriptions-item',{attrs:{"label":_vm.$t('rf24Pair.receiverId')}},[_vm._v(_vm._s(_vm.localIdHex || '--'))]),_vm._v(" "),_c('el-descriptions-item',{attrs:{"label":_vm.$t('rf24Pair.currentPair')}},[_c('el-tag',{attrs:{"type":_vm.pairFlag ? 'success' : 'info',"size":"mini"}},[_vm._v(_vm._s(_vm.pairFlag ? _vm.$t('rf24Pair.paired') : _vm.$t('rf24Pair.unpaired')))]),_vm._v(" "),(_vm.pairFlag)?_c('span',{staticClass:"rf-addr"},[_vm._v(_vm._s(_vm.addrHex))]):_vm._e()],1),_vm._v(" "),_c('el-descriptions-item',{attrs:{"label":_vm.$t('rf24Pair.runState')}},[_vm._v(_vm._s(_vm.stateText))]),_vm._v(" "),_c('el-descriptions-item',{attrs:{"label":_vm.$t('rf24Pair.protocolVersion')}},[_vm._v(_vm._s(_vm.protoVer))])],1),_vm._v(" "),_c('div',{staticClass:"rf-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","loading":_vm.scanning},on:{"click":_vm.startScan}},[_vm._v("\n        "+_vm._s(_vm.scanning ? _vm.$t('rf24Pair.scanning') : _vm.$t('rf24Pair.search'))+"\n      ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh","disabled":!_vm.scanning},on:{"click":_vm.loadResults}},[_vm._v(_vm._s(_vm.$t('rf24Pair.refresh')))]),_vm._v(" "),(_vm.scanning)?_c('el-tag',{attrs:{"type":"warning","size":"small"}},[_vm._v(_vm._s(_vm.$t('rf24Pair.remaining'))+" "+_vm._s(_vm.countdown)+"s")]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-close","disabled":!_vm.scanning},on:{"click":_vm.cancelScan}},[_vm._v(_vm._s(_vm.$t('rf24Pair.cancelSearch')))])],1),_vm._v(" "),(_vm.devices.length)?_c('el-table',{staticClass:"rf-table",attrs:{"data":_vm.devices,"size":"small","highlight-current-row":""},on:{"current-change":_vm.onRowSelect}},[_c('el-table-column',{attrs:{"width":"46"},scopedSlots:_vm._u([{key:"default",fn:function(s){return [_c('el-radio',{attrs:{"label":s.row.idHex},model:{value:(_vm.selectedId),callback:function ($$v) {_vm.selectedId=$$v},expression:"selectedId"}},[_vm._v(" ")])]}}],null,false,1016765128)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"idHex","label":_vm.$t('rf24Pair.deviceId'),"min-width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"modelText","label":_vm.$t('rf24Pair.model'),"width":"110"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('rf24Pair.actions'),"width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(s){return [_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.doPair(s.row)}}},[_vm._v(_vm._s(_vm.$t('rf24Pair.pair')))])]}}],null,false,2642168945)})],1):_c('div',{staticClass:"rf-empty"},[(_vm.scanning)?[_vm._v("\n        "+_vm._s(_vm.$t('rf24Pair.scanHint'))+"\n        "),_c('div',{staticClass:"rf-led-hint"},[_c('span',{staticClass:"rf-led red"}),_c('span',{staticClass:"rf-led green"}),_vm._v(_vm._s(_vm.$t('rf24Pair.ledHint')))])]:[_vm._v("\n        "+_vm._s(_vm.$t('rf24Pair.searchHint'))+"\n      ")]],2),_vm._v(" "),(_vm.pairState)?_c('el-steps',{staticClass:"rf-steps",attrs:{"active":_vm.pairActive,"finish-status":"success","simple":""}},[_c('el-step',{attrs:{"title":_vm.$t('rf24Pair.step1')}}),_vm._v(" "),_c('el-step',{attrs:{"title":_vm.$t('rf24Pair.step2')}}),_vm._v(" "),_c('el-step',{attrs:{"title":_vm.$t('rf24Pair.step3')}})],1):_vm._e(),_vm._v(" "),(_vm.pairState===3)?_c('div',{staticClass:"rf-led-hint success"},[_c('i',{staticClass:"el-icon-success"}),_vm._v(" "+_vm._s(_vm.$t('rf24Pair.successHint'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"rf-actions"},[_c('el-button',{attrs:{"type":"danger","plain":"","icon":"el-icon-delete","disabled":!_vm.pairFlag},on:{"click":_vm.unpair}},[_vm._v(_vm._s(_vm.$t('rf24Pair.unpair')))]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":_vm.refreshInfo}},[_vm._v(_vm._s(_vm.$t('rf24Pair.refreshState')))])],1),_vm._v(" "),(_vm.message)?_c('div',{class:['rf-msg', _vm.messageType]},[_vm._v(_vm._s(_vm.message))]):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.deviceType && !_vm.sendLabel)?_c('div',{staticClass:"sidebar-card"},[_c('div',{staticStyle:{"font-weight":"bold","font-size":"17px","color":"#303133","margin-bottom":"14px","padding-bottom":"10px","border-bottom":"2px solid #409EFF"}},[_vm._v(_vm._s(_vm.$t('index.shortcutTitle')))]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"16px","padding":"12px 14px","background":"#fff9e6","border-radius":"12px","border":"1px solid #f5e6b8"}},[_c('div',{staticStyle:{"font-weight":"bold","color":"#D4880F","font-size":"14px","margin-bottom":"4px"}},[_vm._v(_vm._s(_vm.$t('index.shortcutTip')))]),_vm._v(" "),_c('div',{staticStyle:{"color":"#8a7340","font-size":"13px","line-height":"1.6"}},[_vm._v(_vm._s(_vm.$t('index.shortcutTipDesc')))])]),_vm._v(" "),_vm._l((_vm.shortcutGroups),function(group,gi){return _c('div',{key:gi,staticStyle:{"margin-bottom":"18px"}},[_c('div',{staticStyle:{"font-weight":"bold","color":"#606266","font-size":"14px","margin-bottom":"6px","padding-left":"4px"}},[_vm._v(_vm._s(group.name))]),_vm._v(" "),_vm._l((group.items),function(item,ii){return _c('div',{key:ii,staticStyle:{"padding":"4px 4px","display":"flex","align-items":"center","gap":"10px","border-radius":"4px"}},[_c('code',{staticStyle:{"background":"#e6f0ff","color":"#409EFF","padding":"2px 8px","border-radius":"6px","font-size":"13px","white-space":"nowrap","font-family":"monospace","min-width":"90px","text-align":"center"}},[_vm._v(_vm._s(item.key))]),_vm._v(" "),_c('span',{staticStyle:{"color":"#606266","font-size":"13px"}},[_vm._v(_vm._s(item.desc))])])})],2)})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-card"},[_c('el-popover',{attrs:{"placement":"bottom-end","width":"210","trigger":"click","popper-class":"main-help-popover"},on:{"show":function($event){_vm.showMoreMenu = false},"hide":function($event){_vm.showMoreMenu = false}},model:{value:(_vm.showMainHelp),callback:function ($$v) {_vm.showMainHelp=$$v},expression:"showMainHelp"}},[_c('div',{staticClass:"main-help-menu"},[(!_vm.showMoreMenu)?_c('div',{staticClass:"main-help-item",on:{"click":function($event){_vm.showMoreMenu = true}}},[_c('span',[_vm._v(_vm._s(_vm.$t('index.more')))]),_vm._v(" "),_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e(),_vm._v(" "),(!_vm.showMoreMenu)?_c('div',{staticClass:"main-help-item",on:{"click":_vm.showAbout}},[_c('span',[_vm._v(_vm._s(_vm.$t('index.about')))])]):[_c('div',{staticClass:"main-help-back",on:{"click":function($event){_vm.showMoreMenu = false}}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v(" "+_vm._s(_vm.$t('index.back'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"main-help-item",on:{"click":_vm.openRf24PairFromHelp}},[_c('span',[_vm._v(_vm._s(_vm.$t('rf24Pair.entry')))])])]],2),_vm._v(" "),_c('el-button',{staticClass:"main-help-btn",attrs:{"slot":"reference","circle":"","icon":"el-icon-question","title":_vm.$t('index.more')},slot:"reference"})],1),_vm._v(" "),(_vm.deviceType && !_vm.sendLabel && !_vm.rightTipClosed)?_c('div',{staticClass:"right-tip-bar"},[_c('button',{staticClass:"right-tip-close",attrs:{"type":"button"},on:{"click":function($event){_vm.rightTipClosed = true}}},[_vm._v("×")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"tip-content"},[_c('div',{staticClass:"tip-title"},[_vm._v(_vm._s(_vm.$t('index.submitTipTitle')))]),_vm._v(" "),_c('div',{staticClass:"tip-desc"},[_vm._v(_vm._s(_vm.$t('index.submitTipDesc')))])]),_vm._v(" "),_c('div',{staticClass:"tip-arrow"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-header"},[_c('h1',[_vm._v(_vm._s(_vm.$t('index.pageTitle')))]),_vm._v(" "),_c('div',{staticClass:"main-header-actions"},[((_vm.deviceType==='D6' || _vm.deviceType==='D9' || _vm.deviceType==='D2') && !_vm.sendLabel)?_c('el-button',{attrs:{"type":"info","plain":"","size":"large","icon":"el-icon-s-tools"},on:{"click":_vm.openFactoryTest}},[_vm._v(_vm._s(_vm.$t('index.factoryTest')))]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","size":"large","icon":"el-icon-thumb"},on:{"click":function($event){_vm.showKeyTester = true}}},[_vm._v(_vm._s(_vm.$t('workspace.test')))]),_vm._v(" "),_c('el-button',{staticClass:"video-tutorial-btn",attrs:{"type":"warning","size":"large"},on:{"click":function($event){_vm.showVideoModal = true}}},[_c('i',{staticClass:"el-icon-video-play"}),_vm._v(_vm._s(_vm.$t('keyConfig.videoTutorial'))+"\n          ")])],1)]),_vm._v(" "),(_vm.deviceType==='C4')?_c('el-row',{staticStyle:{"margin-bottom":"20px","display":"flex","justify-content":"center"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","gap":"24px","padding":"16px 30px","background":"#f8f9fa","border-radius":"16px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","gap":"8px"}},[_c('div',{staticStyle:{"display":"flex","gap":"8px"}},[_c('div',{staticStyle:{"width":"54px","height":"54px","background":"linear-gradient(135deg, #e6f0ff, #d4e5ff)","border":"2px solid #409EFF","border-radius":"10px","display":"flex","align-items":"center","justify-content":"center","font-size":"18px","font-weight":"bold","color":"#409EFF","box-shadow":"0 2px 6px rgba(64,158,255,0.25)"}},[_vm._v("1")]),_vm._v(" "),_c('div',{staticStyle:{"width":"54px","height":"54px","background":"linear-gradient(135deg, #e6f0ff, #d4e5ff)","border":"2px solid #409EFF","border-radius":"10px","display":"flex","align-items":"center","justify-content":"center","font-size":"18px","font-weight":"bold","color":"#409EFF","box-shadow":"0 2px 6px rgba(64,158,255,0.25)"}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","gap":"8px"}},[_c('div',{staticStyle:{"width":"54px","height":"54px","background":"linear-gradient(135deg, #e6f0ff, #d4e5ff)","border":"2px solid #409EFF","border-radius":"10px","display":"flex","align-items":"center","justify-content":"center","font-size":"18px","font-weight":"bold","color":"#409EFF","box-shadow":"0 2px 6px rgba(64,158,255,0.25)"}},[_vm._v("3")]),_vm._v(" "),_c('div',{staticStyle:{"width":"54px","height":"54px","background":"linear-gradient(135deg, #e6f0ff, #d4e5ff)","border":"2px solid #409EFF","border-radius":"10px","display":"flex","align-items":"center","justify-content":"center","font-size":"18px","font-weight":"bold","color":"#409EFF","box-shadow":"0 2px 6px rgba(64,158,255,0.25)"}},[_vm._v("4")])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"72px","height":"72px","background":"linear-gradient(135deg, #f0f2f5, #e4e7ed)","border":"3px solid #909399","border-radius":"50%","display":"flex","align-items":"center","justify-content":"center","font-size":"16px","font-weight":"bold","color":"#606266","box-shadow":"0 2px 10px rgba(0,0,0,0.1)"}},[_vm._v(_vm._s(_vm.$t('index.knobLabel')))])])]):_vm._e(),_vm._v(" "),_c('el-row',{staticClass:"change-language"},[_c('el-button',{class:[_vm.$i18n.locale === 'zh' ? 'light' : 'normal'],attrs:{"type":"text"},on:{"click":function($event){return _vm.changeLang('zh')}}},[_vm._v("中文")]),_vm._v(" "),_c('span',[_vm._v(" | ")]),_vm._v(" "),_c('el-button',{class:[_vm.$i18n.locale === 'en' ? 'light' : 'normal'],attrs:{"type":"text"},on:{"click":function($event){return _vm.changeLang('en')}}},[_vm._v("English")])],1),_vm._v(" "),_c('el-row',[_c('el-popover',{attrs:{"placement":"bottom","width":"800","trigger":"click"}},[_c('div',{staticStyle:{"text-align":"left","font-family":"Helvetica, sans-serif","padding":"0 15px","max-height":"600px","overflow-y":"auto"}},[_c('el-row',{staticStyle:{"margin-bottom":"12px","text-align":"center"}},[_c('h2',[_vm._v(_vm._s(_vm.$t('index.helpTitle')))])]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"8px","font-size":"15px","font-weight":"bold","color":"#303133"}},[_vm._v(_vm._s(_vm.$t('index.helpTips0')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips1')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px","color":"#909399"}},[_vm._v(_vm._s(_vm.$t('index.helpTips1_1')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips2')))]),_vm._v(" "),(_vm.deviceType!=='D6' && _vm.deviceType!=='D9')?_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px","color":"#909399"}},[_vm._v(_vm._s(_vm.$t('index.helpTips2_1')))]):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips3')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips4')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips5')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"6px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.helpTips6')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"8px","font-size":"15px","font-weight":"bold","color":"#303133","margin-top":"15px","border-top":"1px dashed #ebeef5","padding-top":"10px"}},[_vm._v(_vm._s(_vm.$t('index.troubleshootTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot1')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot1_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot2')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot2_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot3')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot3_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot4')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot4_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot5')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot5_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot6')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot6_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.troubleshoot7')))]),_vm._v(": "+_vm._s(_vm.$t('index.troubleshoot7_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"8px","font-size":"15px","font-weight":"bold","color":"#303133","margin-top":"15px","border-top":"1px dashed #ebeef5","padding-top":"10px"}},[_vm._v(_vm._s(_vm.$t('index.windowsTipsTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.windowsTips1')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.windowsTips2')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.windowsTips3')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_vm._v(_vm._s(_vm.$t('index.windowsTips4')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"8px","font-size":"15px","font-weight":"bold","color":"#303133","margin-top":"15px","border-top":"1px dashed #ebeef5","padding-top":"10px"}},[_vm._v(_vm._s(_vm.$t('index.macTipsTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips1')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips1_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips2')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips2_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips3')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips3_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips4')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips4_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips5')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips5_desc')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"4px","padding-left":"15px"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('index.macTips6')))]),_vm._v(": "+_vm._s(_vm.$t('index.macTips6_desc')))])],1),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference","type":"info","icon":"el-icon-chat-dot-round"},slot:"reference"},[_vm._v(_vm._s(_vm.$t('index.helpButton')))])],1)],1),_vm._v(" "),_c('el-row',[_c('el-button',{staticStyle:{"font-size":"18px","height":"50px","width":"220px"},attrs:{"type":_vm.conButtonType,"disabled":_vm.savingV62 || _vm.deviceConnecting,"icon":"el-icon-cpu"},on:{"click":function($event){return _vm.conClick()}}},[_vm._v(_vm._s(_vm.conButton))])],1),_vm._v(" "),_c('div',{staticClass:"connection-tip-row"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v("\n        "+_vm._s(_vm.$t('index.connectionTip1'))+"\n        "),_c('strong',[_vm._v("3mode_6key")]),_vm._v(" "+_vm._s(_vm.$t('index.connectionTip2'))+" "),_c('strong',[_vm._v("3mode_9key")]),_vm._v(_vm._s(_vm.$t('index.connectionTip3'))+" "),_c('strong',[_vm._v("2.4 RX Head")]),_vm._v(_vm._s(_vm.$t('index.connectionTip4'))+"\n      ")]),_vm._v(" "),(!_vm.sendLabel)?_c('div',[(_vm.deviceType && _vm.deviceType!=='B3' && _vm.deviceType!=='C4' && _vm.deviceType!=='B6' && _vm.deviceType!=='D2' && _vm.deviceType!=='B4' && _vm.deviceType!=='E6' && _vm.deviceType!=='D6' && _vm.deviceType!=='D9')?_c('div',[_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"key1config",attrs:{"labelstr":_vm.$t('index.b3key1'),"stringshow":true,"mouseoptshow":true,"mousedoubleEnable":_vm.deviceType==='B2' && _vm.deviceVersion==='02'}})],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('index.loopInterval'))+" - "+_vm._s(_vm.$t('index.hour'))+": ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"120px"},attrs:{"min":0,"max":23,"controls":true},model:{value:(_vm.timerHour),callback:function ($$v) {_vm.timerHour=$$v},expression:"timerHour"}}),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t('index.minute'))+": ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"120px"},attrs:{"min":0,"max":59,"controls":true},model:{value:(_vm.timerMinute),callback:function ($$v) {_vm.timerMinute=$$v},expression:"timerMinute"}}),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.$t('index.second'))+": ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"120px"},attrs:{"min":0,"max":59,"controls":true},model:{value:(_vm.timerSecond),callback:function ($$v) {_vm.timerSecond=$$v},expression:"timerSecond"}})],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"20px"}},[_c('label',[_vm._v(_vm._s(_vm.$t('index.triggerMode'))+": ")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},model:{value:(_vm.triggerMode),callback:function ($$v) {_vm.triggerMode=$$v},expression:"triggerMode"}},[_c('el-option',{attrs:{"label":_vm.$t('index.triggerModeManual'),"value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('index.triggerModeTimer'),"value":1}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('index.triggerModeBoth'),"value":2}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.deviceType==='B3')?_c('div',[_c('div',{staticClass:"b3-key-schematic"},[_c('h4',{staticClass:"b3-sch-title"},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(_vm._s(_vm.$t('index.schematicTitle')))]),_vm._v(" "),_c('div',{staticClass:"b3-sch-grid"},[_c('div',{staticClass:"b3-sch-key",class:{ 'b3-sch-active': _vm.selectedB3Key === 1 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColor1) }),on:{"click":function($event){return _vm.selectB3Key(1)}}},[_c('div',{staticClass:"b3-sch-key-num"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b3key1')))]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-value"},[_vm._v(_vm._s(_vm.b3KeyDesc1))])]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key",class:{ 'b3-sch-active': _vm.selectedB3Key === 2 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColor2) }),on:{"click":function($event){return _vm.selectB3Key(2)}}},[_c('div',{staticClass:"b3-sch-key-num"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b3key2')))]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-value"},[_vm._v(_vm._s(_vm.b3KeyDesc2))])]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key",class:{ 'b3-sch-active': _vm.selectedB3Key === 3 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColor3) }),on:{"click":function($event){return _vm.selectB3Key(3)}}},[_c('div',{staticClass:"b3-sch-key-num"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b3key3')))]),_vm._v(" "),_c('div',{staticClass:"b3-sch-key-value"},[_vm._v(_vm._s(_vm.b3KeyDesc3))])])])]),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b3key1config",attrs:{"labelstr":_vm.$t('index.b3key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":parseInt(_vm.deviceVersion,10)>=2,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b3key2config",attrs:{"labelstr":_vm.$t('index.b3key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":parseInt(_vm.deviceVersion,10)>=2,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b3key3config",attrs:{"labelstr":_vm.$t('index.b3key3'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":parseInt(_vm.deviceVersion,10)>=2,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),(_vm.deviceType==='B3')?_c('div',{staticClass:"backlight-card"},[_c('h4',{staticStyle:{"margin-top":"0","margin-bottom":"12px","color":"#606266"}},[_vm._v(_vm._s(_vm.$t('index.backlightTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightMode'))+":")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.backlightMode),callback:function ($$v) {_vm.backlightMode=$$v},expression:"backlightMode"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v(_vm._s(_vm.$t('index.backlightMode0')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('index.backlightMode1')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('index.backlightMode2')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('index.backlightMode3')))]),_vm._v(" "),(parseInt(_vm.deviceVersion,10)>=2)?_c('el-radio',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.$t('index.backlightMode4')))]):_vm._e()],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor1'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColor1),callback:function ($$v) {_vm.backlightColor1=$$v},expression:"backlightColor1"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 15px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor2'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColor2),callback:function ($$v) {_vm.backlightColor2=$$v},expression:"backlightColor2"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 15px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor3'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColor3),callback:function ($$v) {_vm.backlightColor3=$$v},expression:"backlightColor3"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('index.backlightBrightness'))+":")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-slider',{staticStyle:{"width":"300px"},attrs:{"min":0,"max":255},model:{value:(_vm.backlightBrightness),callback:function ($$v) {_vm.backlightBrightness=$$v},expression:"backlightBrightness"}})],1)])],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.deviceType==='C4')?_c('div',[_c('div',{staticClass:"c4-key-schematic"},[_c('h4',{staticClass:"c4-sch-title"},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(_vm._s(_vm.$t('index.schematicTitle')))]),_vm._v(" "),_c('div',{staticClass:"c4-sch-layout"},[_c('div',{staticClass:"c4-sch-grid"},[_c('div',{staticClass:"c4-sch-key",class:{ 'c4-sch-active': _vm.selectedC4Key === 1 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorC4_1) }),on:{"click":function($event){return _vm.selectC4Key(1)}}},[_c('div',{staticClass:"c4-sch-key-num"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.c4key1')))]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-value"},[_vm._v(_vm._s(_vm.c4KeyDesc1))])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key",class:{ 'c4-sch-active': _vm.selectedC4Key === 2 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorC4_2) }),on:{"click":function($event){return _vm.selectC4Key(2)}}},[_c('div',{staticClass:"c4-sch-key-num"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.c4key2')))]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-value"},[_vm._v(_vm._s(_vm.c4KeyDesc2))])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key",class:{ 'c4-sch-active': _vm.selectedC4Key === 3 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorC4_3) }),on:{"click":function($event){return _vm.selectC4Key(3)}}},[_c('div',{staticClass:"c4-sch-key-num"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.c4key3')))]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-value"},[_vm._v(_vm._s(_vm.c4KeyDesc3))])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key",class:{ 'c4-sch-active': _vm.selectedC4Key === 4 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorC4_4) }),on:{"click":function($event){return _vm.selectC4Key(4)}}},[_c('div',{staticClass:"c4-sch-key-num"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.c4key4')))]),_vm._v(" "),_c('div',{staticClass:"c4-sch-key-value"},[_vm._v(_vm._s(_vm.c4KeyDesc4))])])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-knob-container"},[_c('div',{staticClass:"c4-sch-knob-row"},[_c('div',{staticClass:"c4-sch-knob-arrow left",class:{ 'c4-sch-active': _vm.selectedC4Key === 6 },on:{"click":function($event){return _vm.selectC4Key(6)}}},[_c('span',{staticClass:"c4-sch-knob-arrow-value"},[_vm._v(_vm._s(_vm.c4Ec11CCWDesc))])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-knob",class:{ 'c4-sch-active': _vm.selectedC4Key === 7 },on:{"click":function($event){return _vm.selectC4Key(7)}}},[_c('span',{staticClass:"c4-sch-knob-inner"},[_vm._v("O")]),_vm._v(" "),_c('span',{staticClass:"c4-sch-knob-value-inner"},[_vm._v(_vm._s(_vm.c4Ec11BtnDesc))])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-knob-arrow right",class:{ 'c4-sch-active': _vm.selectedC4Key === 5 },on:{"click":function($event){return _vm.selectC4Key(5)}}},[_c('span',{staticClass:"c4-sch-knob-arrow-value"},[_vm._v(_vm._s(_vm.c4Ec11CWDesc))])])]),_vm._v(" "),_c('div',{staticClass:"c4-sch-knob-label"},[_vm._v(_vm._s(_vm.$t('index.knobLabel')))])])])]),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"c4key1config",attrs:{"labelstr":_vm.$t('index.c4key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"c4key2config",attrs:{"labelstr":_vm.$t('index.c4key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"c4key3config",attrs:{"labelstr":_vm.$t('index.c4key3'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"c4key4config",attrs:{"labelstr":_vm.$t('index.c4key4'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10}})],1)],1),_vm._v(" "),_c('div',{staticClass:"backlight-card"},[_c('h4',{staticStyle:{"margin-top":"0","margin-bottom":"12px","color":"#606266"}},[_vm._v(_vm._s(_vm.$t('index.ec11Title')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('index.ec11CW'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px","margin-right":"10px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_func),callback:function ($$v) {_vm.ec11CW_func=$$v},expression:"ec11CW_func"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11FuncKey')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11FuncMedia')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11FuncFn')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.ec11FuncScroll')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11FuncMouse')}}),_vm._v(" "),(parseInt(_vm.deviceVersion,10)>=3)?_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.ec11FuncMix')}}):_vm._e()],1),_vm._v(" "),(_vm.ec11CW_func===0)?[_c('span',{staticStyle:{"margin-right":"5px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.ec11KeyCode'))+":")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"70px"},attrs:{"maxlength":"1","size":"small","show-word-limit":""},model:{value:(_vm.ec11CW_keyChar),callback:function ($$v) {_vm.ec11CW_keyChar=$$v},expression:"ec11CW_keyChar"}})]:_vm._e(),_vm._v(" "),(_vm.ec11CW_func===1)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_mediaVal),callback:function ($$v) {_vm.ec11CW_mediaVal=$$v},expression:"ec11CW_mediaVal"}},_vm._l((_vm.mediaKeyOptions),function(m,i){return _c('el-option',{key:i,attrs:{"value":m.value,"label":m.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11CW_func===2)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_fnVal),callback:function ($$v) {_vm.ec11CW_fnVal=$$v},expression:"ec11CW_fnVal"}},_vm._l((_vm.fnKeyOptions),function(f,i){return _c('el-option',{key:i,attrs:{"value":f.value,"label":f.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11CW_func===3)?[_c('el-select',{staticStyle:{"width":"120px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_scrollDir),callback:function ($$v) {_vm.ec11CW_scrollDir=$$v},expression:"ec11CW_scrollDir"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11ScrollUp')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11ScrollDown')}})],1)]:_vm._e(),_vm._v(" "),(_vm.ec11CW_func===4)?[_c('el-select',{staticStyle:{"width":"100px","margin-right":"8px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_mouseBtn),callback:function ($$v) {_vm.ec11CW_mouseBtn=$$v},expression:"ec11CW_mouseBtn"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11MouseLeft')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11MouseMiddle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11MouseRight')}})],1),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px"},attrs:{"size":"small"},model:{value:(_vm.ec11CW_mouseMode),callback:function ($$v) {_vm.ec11CW_mouseMode=$$v},expression:"ec11CW_mouseMode"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11ClickSingle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11ClickContinuous')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11ClickPress')}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.ec11CW_func===5 && parseInt(_vm.deviceVersion,10)>=3)?[_c('el-row',{staticStyle:{"margin-top":"4px"}},[(_vm.ec11CW_mixCountArray[0])?[(_vm.ec11CW_mixShowArray[0])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CW_mixFuncSelectValue[0]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixFuncSelectValue, 0, $$v)},expression:"ec11CW_mixFuncSelectValue[0]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CW_mixShowArray[0])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CW_mixText[0]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixText, 0, $$v)},expression:"ec11CW_mixText[0]"}}):_vm._e(),_vm._v(" "),(_vm.ec11CW_mixCountArray[1])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11CW_mixShowArray[1])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CW_mixFuncSelectValue[1]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixFuncSelectValue, 1, $$v)},expression:"ec11CW_mixFuncSelectValue[1]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CW_mixShowArray[1])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CW_mixText[1]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixText, 1, $$v)},expression:"ec11CW_mixText[1]"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ec11CW_mixCountArray[2])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11CW_mixShowArray[2])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CW_mixFuncSelectValue[2]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixFuncSelectValue, 2, $$v)},expression:"ec11CW_mixFuncSelectValue[2]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CW_mixShowArray[2])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CW_mixText[2]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixText, 2, $$v)},expression:"ec11CW_mixText[2]"}}):_vm._e()],1):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.ec11CW_mixCountArray[3])?_c('el-row',{staticStyle:{"margin-top":"4px"}},[_vm._v("\n          +\n          "),(_vm.ec11CW_mixShowArray[3])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CW_mixFuncSelectValue[3]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixFuncSelectValue, 3, $$v)},expression:"ec11CW_mixFuncSelectValue[3]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CW_mixShowArray[3])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CW_mixText[3]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixText, 3, $$v)},expression:"ec11CW_mixText[3]"}}):_vm._e(),_vm._v(" "),(_vm.ec11CW_mixCountArray[4])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n          +\n            "),(_vm.ec11CW_mixShowArray[4])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CW_mixFuncSelectValue[4]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixFuncSelectValue, 4, $$v)},expression:"ec11CW_mixFuncSelectValue[4]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CW_mixShowArray[4])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CW_mixText[4]),callback:function ($$v) {_vm.$set(_vm.ec11CW_mixText, 4, $$v)},expression:"ec11CW_mixText[4]"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.ec11CW_mixTips)}})]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11CWMixAdd(1)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix1')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11CWMixAdd(2)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix2')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11CWMixDelete()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix3')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11CWMixReset()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix4')))])],1)]:_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('index.ec11CCW'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px","margin-right":"10px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_func),callback:function ($$v) {_vm.ec11CCW_func=$$v},expression:"ec11CCW_func"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11FuncKey')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11FuncMedia')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11FuncFn')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.ec11FuncScroll')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11FuncMouse')}}),_vm._v(" "),(parseInt(_vm.deviceVersion,10)>=3)?_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.ec11FuncMix')}}):_vm._e()],1),_vm._v(" "),(_vm.ec11CCW_func===0)?[_c('span',{staticStyle:{"margin-right":"5px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.ec11KeyCode'))+":")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"70px"},attrs:{"maxlength":"1","size":"small","show-word-limit":""},model:{value:(_vm.ec11CCW_keyChar),callback:function ($$v) {_vm.ec11CCW_keyChar=$$v},expression:"ec11CCW_keyChar"}})]:_vm._e(),_vm._v(" "),(_vm.ec11CCW_func===1)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_mediaVal),callback:function ($$v) {_vm.ec11CCW_mediaVal=$$v},expression:"ec11CCW_mediaVal"}},_vm._l((_vm.mediaKeyOptions),function(m,i){return _c('el-option',{key:i,attrs:{"value":m.value,"label":m.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11CCW_func===2)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_fnVal),callback:function ($$v) {_vm.ec11CCW_fnVal=$$v},expression:"ec11CCW_fnVal"}},_vm._l((_vm.fnKeyOptions),function(f,i){return _c('el-option',{key:i,attrs:{"value":f.value,"label":f.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11CCW_func===3)?[_c('el-select',{staticStyle:{"width":"120px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_scrollDir),callback:function ($$v) {_vm.ec11CCW_scrollDir=$$v},expression:"ec11CCW_scrollDir"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11ScrollUp')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11ScrollDown')}})],1)]:_vm._e(),_vm._v(" "),(_vm.ec11CCW_func===4)?[_c('el-select',{staticStyle:{"width":"100px","margin-right":"8px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_mouseBtn),callback:function ($$v) {_vm.ec11CCW_mouseBtn=$$v},expression:"ec11CCW_mouseBtn"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11MouseLeft')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11MouseMiddle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11MouseRight')}})],1),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px"},attrs:{"size":"small"},model:{value:(_vm.ec11CCW_mouseMode),callback:function ($$v) {_vm.ec11CCW_mouseMode=$$v},expression:"ec11CCW_mouseMode"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11ClickSingle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11ClickContinuous')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11ClickPress')}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.ec11CCW_func===5 && parseInt(_vm.deviceVersion,10)>=3)?[_c('el-row',{staticStyle:{"margin-top":"4px"}},[(_vm.ec11CCW_mixCountArray[0])?[(_vm.ec11CCW_mixShowArray[0])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CCW_mixFuncSelectValue[0]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixFuncSelectValue, 0, $$v)},expression:"ec11CCW_mixFuncSelectValue[0]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CCW_mixShowArray[0])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CCW_mixText[0]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixText, 0, $$v)},expression:"ec11CCW_mixText[0]"}}):_vm._e(),_vm._v(" "),(_vm.ec11CCW_mixCountArray[1])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11CCW_mixShowArray[1])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CCW_mixFuncSelectValue[1]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixFuncSelectValue, 1, $$v)},expression:"ec11CCW_mixFuncSelectValue[1]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CCW_mixShowArray[1])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CCW_mixText[1]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixText, 1, $$v)},expression:"ec11CCW_mixText[1]"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ec11CCW_mixCountArray[2])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11CCW_mixShowArray[2])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CCW_mixFuncSelectValue[2]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixFuncSelectValue, 2, $$v)},expression:"ec11CCW_mixFuncSelectValue[2]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CCW_mixShowArray[2])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CCW_mixText[2]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixText, 2, $$v)},expression:"ec11CCW_mixText[2]"}}):_vm._e()],1):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.ec11CCW_mixCountArray[3])?_c('el-row',{staticStyle:{"margin-top":"4px"}},[_vm._v("\n          +\n          "),(_vm.ec11CCW_mixShowArray[3])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CCW_mixFuncSelectValue[3]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixFuncSelectValue, 3, $$v)},expression:"ec11CCW_mixFuncSelectValue[3]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CCW_mixShowArray[3])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CCW_mixText[3]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixText, 3, $$v)},expression:"ec11CCW_mixText[3]"}}):_vm._e(),_vm._v(" "),(_vm.ec11CCW_mixCountArray[4])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n          +\n            "),(_vm.ec11CCW_mixShowArray[4])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11CCW_mixFuncSelectValue[4]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixFuncSelectValue, 4, $$v)},expression:"ec11CCW_mixFuncSelectValue[4]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11CCW_mixShowArray[4])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11CCW_mixText[4]),callback:function ($$v) {_vm.$set(_vm.ec11CCW_mixText, 4, $$v)},expression:"ec11CCW_mixText[4]"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.ec11CCW_mixTips)}})]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11CCWMixAdd(1)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix1')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11CCWMixAdd(2)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix2')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11CCWMixDelete()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix3')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11CCWMixReset()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix4')))])],1)]:_vm._e(),_vm._v(" "),_c('el-row',[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t('index.ec11Btn'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px","margin-right":"10px"},attrs:{"size":"small"},model:{value:(_vm.ec11Btn_func),callback:function ($$v) {_vm.ec11Btn_func=$$v},expression:"ec11Btn_func"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11FuncKey')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11FuncMedia')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11FuncFn')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11FuncMouse')}}),_vm._v(" "),(parseInt(_vm.deviceVersion,10)>=2)?_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.ec11FuncMix')}}):_vm._e()],1),_vm._v(" "),(_vm.ec11Btn_func===0)?[_c('span',{staticStyle:{"margin-right":"5px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.ec11KeyCode'))+":")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"70px"},attrs:{"maxlength":"1","size":"small","show-word-limit":""},model:{value:(_vm.ec11Btn_keyChar),callback:function ($$v) {_vm.ec11Btn_keyChar=$$v},expression:"ec11Btn_keyChar"}})]:_vm._e(),_vm._v(" "),(_vm.ec11Btn_func===1)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11Btn_mediaVal),callback:function ($$v) {_vm.ec11Btn_mediaVal=$$v},expression:"ec11Btn_mediaVal"}},_vm._l((_vm.mediaKeyOptions),function(m,i){return _c('el-option',{key:i,attrs:{"value":m.value,"label":m.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11Btn_func===2)?[_c('el-select',{staticStyle:{"width":"180px"},attrs:{"size":"small"},model:{value:(_vm.ec11Btn_fnVal),callback:function ($$v) {_vm.ec11Btn_fnVal=$$v},expression:"ec11Btn_fnVal"}},_vm._l((_vm.fnKeyOptions),function(f,i){return _c('el-option',{key:i,attrs:{"value":f.value,"label":f.label}})}),1)]:_vm._e(),_vm._v(" "),(_vm.ec11Btn_func===4)?[_c('el-select',{staticStyle:{"width":"100px","margin-right":"8px"},attrs:{"size":"small"},model:{value:(_vm.ec11Btn_mouseBtn),callback:function ($$v) {_vm.ec11Btn_mouseBtn=$$v},expression:"ec11Btn_mouseBtn"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11MouseLeft')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.ec11MouseMiddle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11MouseRight')}})],1),_vm._v(" "),_c('el-select',{staticStyle:{"width":"120px"},attrs:{"size":"small"},model:{value:(_vm.ec11Btn_mouseMode),callback:function ($$v) {_vm.ec11Btn_mouseMode=$$v},expression:"ec11Btn_mouseMode"}},[_c('el-option',{attrs:{"value":0,"label":_vm.$t('index.ec11ClickSingle')}}),_vm._v(" "),_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.ec11ClickContinuous')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.ec11ClickPress')}})],1)]:_vm._e()],2),_vm._v(" "),(_vm.ec11Btn_func===5 && parseInt(_vm.deviceVersion,10)>=2)?[_c('el-row',{staticStyle:{"margin-top":"4px"}},[(_vm.ec11Btn_mixCountArray[0])?[(_vm.ec11Btn_mixShowArray[0])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11Btn_mixFuncSelectValue[0]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixFuncSelectValue, 0, $$v)},expression:"ec11Btn_mixFuncSelectValue[0]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11Btn_mixShowArray[0])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11Btn_mixText[0]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixText, 0, $$v)},expression:"ec11Btn_mixText[0]"}}):_vm._e(),_vm._v(" "),(_vm.ec11Btn_mixCountArray[1])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11Btn_mixShowArray[1])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11Btn_mixFuncSelectValue[1]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixFuncSelectValue, 1, $$v)},expression:"ec11Btn_mixFuncSelectValue[1]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11Btn_mixShowArray[1])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11Btn_mixText[1]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixText, 1, $$v)},expression:"ec11Btn_mixText[1]"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ec11Btn_mixCountArray[2])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n            +\n              "),(_vm.ec11Btn_mixShowArray[2])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11Btn_mixFuncSelectValue[2]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixFuncSelectValue, 2, $$v)},expression:"ec11Btn_mixFuncSelectValue[2]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11Btn_mixShowArray[2])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11Btn_mixText[2]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixText, 2, $$v)},expression:"ec11Btn_mixText[2]"}}):_vm._e()],1):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.ec11Btn_mixCountArray[3])?_c('el-row',{staticStyle:{"margin-top":"4px"}},[_vm._v("\n          +\n          "),(_vm.ec11Btn_mixShowArray[3])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11Btn_mixFuncSelectValue[3]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixFuncSelectValue, 3, $$v)},expression:"ec11Btn_mixFuncSelectValue[3]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11Btn_mixShowArray[3])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11Btn_mixText[3]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixText, 3, $$v)},expression:"ec11Btn_mixText[3]"}}):_vm._e(),_vm._v(" "),(_vm.ec11Btn_mixCountArray[4])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n          +\n            "),(_vm.ec11Btn_mixShowArray[4])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.ec11Btn_mixFuncSelectValue[4]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixFuncSelectValue, 4, $$v)},expression:"ec11Btn_mixFuncSelectValue[4]"}},_vm._l((_vm.fnKeyOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.ec11Btn_mixShowArray[4])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.ec11Btn_mixText[4]),callback:function ($$v) {_vm.$set(_vm.ec11Btn_mixText, 4, $$v)},expression:"ec11Btn_mixText[4]"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('label',{domProps:{"innerHTML":_vm._s(_vm.ec11Btn_mixTips)}})]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"4px"}},[_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11BtnMixAdd(1)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix1')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","size":"mini"},on:{"click":function($event){return _vm.ec11BtnMixAdd(2)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix2')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11BtnMixDelete()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix3')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":function($event){return _vm.ec11BtnMixReset()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix4')))])],1)]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"backlight-card"},[_c('h4',{staticStyle:{"margin-top":"0","margin-bottom":"12px","color":"#606266"}},[_vm._v(_vm._s(_vm.$t('index.backlightTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightMode'))+":")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.backlightModeC4),callback:function ($$v) {_vm.backlightModeC4=$$v},expression:"backlightModeC4"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v(_vm._s(_vm.$t('index.backlightMode0')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('index.backlightMode1')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('index.backlightMode2')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('index.backlightMode3')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.$t('index.backlightMode4')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor1'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorC4_1),callback:function ($$v) {_vm.backlightColorC4_1=$$v},expression:"backlightColorC4_1"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor2'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorC4_2),callback:function ($$v) {_vm.backlightColorC4_2=$$v},expression:"backlightColorC4_2"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor3'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorC4_3),callback:function ($$v) {_vm.backlightColorC4_3=$$v},expression:"backlightColorC4_3"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor4'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorC4_4),callback:function ($$v) {_vm.backlightColorC4_4=$$v},expression:"backlightColorC4_4"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('index.backlightBrightness'))+":")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-slider',{staticStyle:{"width":"300px"},attrs:{"min":0,"max":255},model:{value:(_vm.backlightBrightnessC4),callback:function ($$v) {_vm.backlightBrightnessC4=$$v},expression:"backlightBrightnessC4"}})],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='B6')?_c('div',[_c('div',{staticClass:"b6-key-schematic"},[_c('h4',{staticClass:"b6-sch-title"},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(_vm._s(_vm.$t('index.schematicTitle')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-grid"},[_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 1 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_1) }),on:{"click":function($event){return _vm.selectB6Key(1)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key1')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc1))])]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 2 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_2) }),on:{"click":function($event){return _vm.selectB6Key(2)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key2')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc2))])]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 3 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_3) }),on:{"click":function($event){return _vm.selectB6Key(3)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key3')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc3))])]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 4 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_4) }),on:{"click":function($event){return _vm.selectB6Key(4)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key4')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc4))])]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 5 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_5) }),on:{"click":function($event){return _vm.selectB6Key(5)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key5')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc5))])]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key",class:{ 'b6-sch-active': _vm.selectedB6Key === 6 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB6_6) }),on:{"click":function($event){return _vm.selectB6Key(6)}}},[_c('div',{staticClass:"b6-sch-key-num"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b6key6')))]),_vm._v(" "),_c('div',{staticClass:"b6-sch-key-value"},[_vm._v(_vm._s(_vm.b6KeyDesc6))])])])]),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key1config",attrs:{"labelstr":_vm.$t('index.b6key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key2config",attrs:{"labelstr":_vm.$t('index.b6key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key3config",attrs:{"labelstr":_vm.$t('index.b6key3'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key4config",attrs:{"labelstr":_vm.$t('index.b6key4'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key5config",attrs:{"labelstr":_vm.$t('index.b6key5'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b6key6config",attrs:{"labelstr":_vm.$t('index.b6key6'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"backlight-card"},[_c('h4',{staticStyle:{"margin-top":"0","margin-bottom":"12px","color":"#606266"}},[_vm._v(_vm._s(_vm.$t('index.backlightTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightMode'))+":")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.backlightModeB6),callback:function ($$v) {_vm.backlightModeB6=$$v},expression:"backlightModeB6"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v(_vm._s(_vm.$t('index.backlightMode0')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('index.backlightMode1')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('index.backlightMode2')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('index.backlightMode3')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.$t('index.backlightMode4')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor1'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_1),callback:function ($$v) {_vm.backlightColorB6_1=$$v},expression:"backlightColorB6_1"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor2'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_2),callback:function ($$v) {_vm.backlightColorB6_2=$$v},expression:"backlightColorB6_2"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor3'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_3),callback:function ($$v) {_vm.backlightColorB6_3=$$v},expression:"backlightColorB6_3"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor4'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_4),callback:function ($$v) {_vm.backlightColorB6_4=$$v},expression:"backlightColorB6_4"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor5'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_5),callback:function ($$v) {_vm.backlightColorB6_5=$$v},expression:"backlightColorB6_5"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor6'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB6_6),callback:function ($$v) {_vm.backlightColorB6_6=$$v},expression:"backlightColorB6_6"}},_vm._l((_vm.colorOptions),function(c){return _c('el-option',{key:c.value,attrs:{"value":c.value,"label":c.label}})}),1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('index.backlightBrightness'))+":")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-slider',{staticStyle:{"width":"300px"},attrs:{"min":0,"max":255},model:{value:(_vm.backlightBrightnessB6),callback:function ($$v) {_vm.backlightBrightnessB6=$$v},expression:"backlightBrightnessB6"}})],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='D2')?_c('div',[_c('div',{staticClass:"d2-mode-card"},[_c('h4',{staticClass:"d2-mode-title"},[_c('i',{staticClass:"el-icon-mobile-phone"}),_vm._v(_vm._s(_vm.$t('index.d2RunModeTitle')))]),_vm._v(" "),_c('div',{staticClass:"d2-mode-tip"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(" "),_c('div',{staticClass:"d2-mode-tip-body"},[_c('div',{staticClass:"d2-mode-tip-line"},[_c('span',{staticClass:"d2-mode-tip-key"},[_vm._v(_vm._s(_vm.$t('index.d2ModeTipKbd')))]),_vm._v(_vm._s(_vm.$t('index.d2ModeTipKbdDesc')))]),_vm._v(" "),_c('div',{staticClass:"d2-mode-tip-line"},[_c('span',{staticClass:"d2-mode-tip-key"},[_vm._v(_vm._s(_vm.$t('index.d2ModeTipPage')))]),_vm._v(_vm._s(_vm.$t('index.d2ModeTipPageDesc')))])])]),_vm._v(" "),_c('div',{staticClass:"d2-field-row"},[_c('span',{staticClass:"d2-field-label"},[_vm._v(_vm._s(_vm.$t('index.d2RunMode'))+":")]),_vm._v(" "),_c('el-radio-group',{staticClass:"d2-run-mode-group",model:{value:(_vm.d2RunMode),callback:function ($$v) {_vm.d2RunMode=$$v},expression:"d2RunMode"}},[_c('el-radio',{attrs:{"label":0}},[_c('i',{staticClass:"el-icon-keyboard",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('index.d2RunModeKeyboard')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_c('i',{staticClass:"el-icon-document-checked",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('index.d2RunModePage')))])],1)],1),_vm._v(" "),(_vm.d2RunMode===1)?_c('div',{staticClass:"d2-field-row d2-page-row"},[_c('span',{staticClass:"d2-field-label d2-page-label"},[_vm._v(_vm._s(_vm.$t('index.d2PageAction'))+":")]),_vm._v(" "),_c('el-radio-group',{staticClass:"d2-page-action-group",model:{value:(_vm.d2PageAction),callback:function ($$v) {_vm.d2PageAction=$$v},expression:"d2PageAction"}},[_c('div',{staticClass:"d2-page-action-item"},[_c('div',{staticClass:"d2-pa-index"},[_vm._v("1")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0}},[_c('span',{staticClass:"d2-pa-name"},[_vm._v(_vm._s(_vm.$t('index.d2PagePrev')))])])],1),_vm._v(" "),_c('div',{staticClass:"d2-page-action-item"},[_c('div',{staticClass:"d2-pa-index"},[_vm._v("2")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_c('span',{staticClass:"d2-pa-name"},[_vm._v(_vm._s(_vm.$t('index.d2PageNext')))])])],1),_vm._v(" "),_c('div',{staticClass:"d2-page-action-item"},[_c('div',{staticClass:"d2-pa-index"},[_vm._v("3")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_c('span',{staticClass:"d2-pa-name"},[_vm._v(_vm._s(_vm.$t('index.d2PagePlayPause')))])])],1),_vm._v(" "),_c('div',{staticClass:"d2-page-action-item"},[_c('div',{staticClass:"d2-pa-index"},[_vm._v("4")]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_c('span',{staticClass:"d2-pa-name"},[_vm._v(_vm._s(_vm.$t('index.d2PageHome')))])])],1)])],1):_vm._e(),_vm._v(" "),(_vm.d2RunMode===1)?_c('div',{staticClass:"d2-firm-block"},[_c('div',{staticClass:"d2-subtitle"},[_c('i',{staticClass:"el-icon-data-analysis"}),_vm._v(_vm._s(_vm.$t('index.d2PageTableTitle')))]),_vm._v(" "),_c('table',{staticClass:"d2-firm-table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"width":"15%"}},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(" "+_vm._s(_vm.$t('index.d2TableFirmware')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"25%"}},[_vm._v(_vm._s(_vm.$t('index.d2TableFunction')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"60%"}},[_vm._v(_vm._s(_vm.$t('index.d2TableScenario')))])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"d2-fw-id d2-fw-1"},[_vm._v(_vm._s(_vm.$t('index.firmware1')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm1Func')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm1Scenario')))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"d2-fw-id d2-fw-2"},[_vm._v(_vm._s(_vm.$t('index.firmware2')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm2Func')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm2Scenario')))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"d2-fw-id d2-fw-3"},[_vm._v(_vm._s(_vm.$t('index.firmware3')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm3Func')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm3Scenario')))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"d2-fw-id d2-fw-4"},[_vm._v(_vm._s(_vm.$t('index.firmware4')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm4Func')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('index.d2Firm4Scenario')))])])])]),_vm._v(" "),_c('div',{staticClass:"d2-notes-block"},[_c('div',{staticClass:"d2-subtitle"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v(_vm._s(_vm.$t('index.d2NotesTitle')))]),_vm._v(" "),_c('div',{staticClass:"d2-note-item d2-note-1"},[_c('i',{staticClass:"el-icon-apple"}),_vm._v(" "),_c('div',{staticClass:"d2-note-body"},[_vm._v(_vm._s(_vm.$t('index.d2Note1')))])]),_vm._v(" "),_c('div',{staticClass:"d2-note-item d2-note-2"},[_c('i',{staticClass:"el-icon-reading"}),_vm._v(" "),_c('div',{staticClass:"d2-note-body"},[_vm._v(_vm._s(_vm.$t('index.d2Note2')))])]),_vm._v(" "),_c('div',{staticClass:"d2-note-item d2-note-3"},[_c('i',{staticClass:"el-icon-collection-tag"}),_vm._v(" "),_c('div',{staticClass:"d2-note-body"},[_vm._v(_vm._s(_vm.$t('index.d2Note3')))])])])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.d2RunMode===0),expression:"d2RunMode===0"}],staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"d2key1config",attrs:{"labelstr":_vm.$t('index.d2key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.d2RunMode===0),expression:"d2RunMode===0"}],staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"d2key2config",attrs:{"labelstr":_vm.$t('index.d2key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='B4')?_c('div',[_c('div',{staticClass:"b4-key-schematic"},[_c('h4',{staticClass:"b4-sch-title"},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(_vm._s(_vm.$t('index.schematicTitle')))]),_vm._v(" "),_c('div',{staticClass:"b4-sch-grid"},[_c('div',{staticClass:"b4-sch-key",class:{ 'b4-sch-active': _vm.selectedB4Key === 1 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB4_1) }),on:{"click":function($event){return _vm.selectB4Key(1)}}},[_c('div',{staticClass:"b4-sch-key-num"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b4key1')))]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-value"},[_vm._v(_vm._s(_vm.b4KeyDesc1))])]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key",class:{ 'b4-sch-active': _vm.selectedB4Key === 2 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB4_2) }),on:{"click":function($event){return _vm.selectB4Key(2)}}},[_c('div',{staticClass:"b4-sch-key-num"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b4key2')))]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-value"},[_vm._v(_vm._s(_vm.b4KeyDesc2))])]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key",class:{ 'b4-sch-active': _vm.selectedB4Key === 3 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB4_3) }),on:{"click":function($event){return _vm.selectB4Key(3)}}},[_c('div',{staticClass:"b4-sch-key-num"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b4key3')))]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-value"},[_vm._v(_vm._s(_vm.b4KeyDesc3))])]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key",class:{ 'b4-sch-active': _vm.selectedB4Key === 4 },style:({ '--backlight-color': _vm.getBacklightColor(_vm.backlightColorB4_4) }),on:{"click":function($event){return _vm.selectB4Key(4)}}},[_c('div',{staticClass:"b4-sch-key-num"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.b4key4')))]),_vm._v(" "),_c('div',{staticClass:"b4-sch-key-value"},[_vm._v(_vm._s(_vm.b4KeyDesc4))])])])]),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b4key1config",attrs:{"labelstr":_vm.$t('index.b4key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b4key2config",attrs:{"labelstr":_vm.$t('index.b4key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b4key3config",attrs:{"labelstr":_vm.$t('index.b4key3'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"key-card"},[_c('el-row',[_c('key-config',{ref:"b4key4config",attrs:{"labelstr":_vm.$t('index.b4key4'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":10,"hidden-media-values":_vm.compactKeyboardHiddenMediaValues}})],1)],1),_vm._v(" "),_c('div',{staticClass:"backlight-card"},[_c('h4',{staticStyle:{"margin-top":"0","margin-bottom":"12px","color":"#606266"}},[_vm._v(_vm._s(_vm.$t('index.backlightTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightMode'))+":")]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.backlightModeB4),callback:function ($$v) {_vm.backlightModeB4=$$v},expression:"backlightModeB4"}},[_c('el-radio',{attrs:{"label":0}},[_vm._v(_vm._s(_vm.$t('index.backlightMode0')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('index.backlightMode1')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('index.backlightMode2')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('index.backlightMode3')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.$t('index.backlightMode4')))])],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticStyle:{"margin-right":"10px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor1'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB4_1),callback:function ($$v) {_vm.backlightColorB4_1=$$v},expression:"backlightColorB4_1"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 15px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor2'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB4_2),callback:function ($$v) {_vm.backlightColorB4_2=$$v},expression:"backlightColorB4_2"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 15px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor3'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB4_3),callback:function ($$v) {_vm.backlightColorB4_3=$$v},expression:"backlightColorB4_3"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1),_vm._v(" "),_c('span',{staticStyle:{"margin":"0 15px","line-height":"40px"}},[_vm._v(_vm._s(_vm.$t('index.backlightColor4'))+":")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small"},model:{value:(_vm.backlightColorB4_4),callback:function ($$v) {_vm.backlightColorB4_4=$$v},expression:"backlightColorB4_4"}},[_c('el-option',{attrs:{"value":1,"label":_vm.$t('index.colorBlue')}}),_vm._v(" "),_c('el-option',{attrs:{"value":2,"label":_vm.$t('index.colorGreen')}}),_vm._v(" "),_c('el-option',{attrs:{"value":3,"label":_vm.$t('index.colorRed')}}),_vm._v(" "),_c('el-option',{attrs:{"value":4,"label":_vm.$t('index.colorYellow')}}),_vm._v(" "),_c('el-option',{attrs:{"value":5,"label":_vm.$t('index.colorCyan')}}),_vm._v(" "),_c('el-option',{attrs:{"value":6,"label":_vm.$t('index.colorPurple')}}),_vm._v(" "),_c('el-option',{attrs:{"value":7,"label":_vm.$t('index.colorWhite')}})],1)],1),_vm._v(" "),_c('el-row',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$t('index.backlightBrightness'))+":")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('el-slider',{staticStyle:{"width":"300px"},attrs:{"min":0,"max":255},model:{value:(_vm.backlightBrightnessB4),callback:function ($$v) {_vm.backlightBrightnessB4=$$v},expression:"backlightBrightnessB4"}})],1)])],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='E6' || _vm.deviceType==='D6' || _vm.deviceType==='D9')?_c('div',[_c('div',{staticClass:"e6-mode-card"},[_c('h4',{staticClass:"e6-mode-title"},[_c('i',{staticClass:"el-icon-connection"}),_vm._v(_vm._s(_vm.$t('index.e6ModeTitle')))]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('span',{staticClass:"e6-field-label"},[_vm._v(_vm._s(_vm.$t('index.e6DeviceMode'))+":")]),_vm._v(" "),_c('el-radio-group',{staticClass:"e6-device-mode-group",model:{value:(_vm.e6DeviceMode),callback:function ($$v) {_vm.e6DeviceMode=$$v},expression:"e6DeviceMode"}},[_c('el-radio',{attrs:{"label":0x11}},[_c('i',{staticClass:"el-icon-wifi",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('index.e6ModeBle')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":0x24}},[_c('i',{staticClass:"el-icon-connection",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('index.e6ModeRf24')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":0x6b}},[_c('i',{staticClass:"el-icon-cpu",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('index.e6ModeUsb')))])],1)],1),_vm._v(" "),_c('div',{staticClass:"e6-mode-tip"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(_vm._s(_vm.$t('index.e6ModeTip'))+"\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"e6-key-schematic"},[_c('h4',{staticClass:"e6-sch-title"},[_c('i',{staticClass:"el-icon-magic-stick"}),_vm._v(_vm._s(_vm.$t('index.schematicTitle')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-grid"},[_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 1 },on:{"click":function($event){return _vm.selectE6Key(1)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key1')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc1))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 2 },on:{"click":function($event){return _vm.selectE6Key(2)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key2')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc2))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 3 },on:{"click":function($event){return _vm.selectE6Key(3)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key3')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc3))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 4 },on:{"click":function($event){return _vm.selectE6Key(4)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key4')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc4))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 5 },on:{"click":function($event){return _vm.selectE6Key(5)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key5')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc5))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 6 },on:{"click":function($event){return _vm.selectE6Key(6)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.e6key6')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc6))])]),_vm._v(" "),(_vm.deviceType==='D9')?[_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 7 },on:{"click":function($event){return _vm.selectE6Key(7)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.d9key7')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc7))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 8 },on:{"click":function($event){return _vm.selectE6Key(8)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.d9key8')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc8))])]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key",class:{ 'e6-sch-active': _vm.selectedE6Key === 9 },on:{"click":function($event){return _vm.selectE6Key(9)}}},[_c('div',{staticClass:"e6-sch-key-num"},[_vm._v("9")]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-label"},[_vm._v(_vm._s(_vm.$t('index.d9key9')))]),_vm._v(" "),_c('div',{staticClass:"e6-sch-key-value"},[_vm._v(_vm._s(_vm.e6KeyDesc9))])])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard1"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(0)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key1')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc1 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[0] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[0]),expression:"e6KeyOpen[0]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key1config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key1'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard2"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(1)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key2')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc2 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[1] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[1]),expression:"e6KeyOpen[1]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key2config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key2'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard3"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(2)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key3')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc3 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[2] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[2]),expression:"e6KeyOpen[2]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key3config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key3'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard4"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(3)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key4')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc4 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[3] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[3]),expression:"e6KeyOpen[3]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key4config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key4'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard5"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(4)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key5')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc5 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[4] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[4]),expression:"e6KeyOpen[4]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key5config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key5'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard6"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(5)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.e6key6')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc6 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[5] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[5]),expression:"e6KeyOpen[5]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key6config",attrs:{"hid-normal-key":_vm.deviceType==='D6'||_vm.deviceType==='D9',"labelstr":_vm.$t('index.e6key6'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":_vm.deviceType==='D6'||_vm.deviceType==='D9'?20:30}})],1)],1)]),_vm._v(" "),(_vm.deviceType==='D9')?_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard7"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(6)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.d9key7')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc7 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[6] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[6]),expression:"e6KeyOpen[6]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key7config",attrs:{"hid-normal-key":true,"labelstr":_vm.$t('index.d9key7'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":20}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='D9')?_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard8"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(7)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.d9key8')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc8 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[7] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[7]),expression:"e6KeyOpen[7]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key8config",attrs:{"hid-normal-key":true,"labelstr":_vm.$t('index.d9key8'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":20}})],1)],1)]):_vm._e(),_vm._v(" "),(_vm.deviceType==='D9')?_c('div',{staticClass:"key-card e6-collapse-card",attrs:{"id":"e6keycard9"}},[_c('div',{staticClass:"e6-collapse-head",on:{"click":function($event){return _vm.toggleE6Key(8)}}},[_c('div',{staticClass:"e6-collapse-left"},[_c('span',{staticClass:"e6-collapse-name"},[_vm._v(_vm._s(_vm.$t('index.d9key9')))]),_vm._v(" "),_c('span',{staticClass:"e6-collapse-value"},[_vm._v(_vm._s(_vm.e6KeyDesc9 || _vm.$t('keyConfig.notSet')))])]),_vm._v(" "),_c('i',{class:_vm.e6KeyOpen[8] ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.e6KeyOpen[8]),expression:"e6KeyOpen[8]"}],staticClass:"e6-collapse-body"},[_c('el-row',[_c('key-config',{ref:"e6key9config",attrs:{"hid-normal-key":true,"labelstr":_vm.$t('index.d9key9'),"stringshow":true,"mouseoptshow":true,"mouseclickonly":true,"mousedoubleEnable":true,"stringsize":20}})],1)],1)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.deviceType)?_c('el-row',{staticStyle:{"margin-bottom":"10px","color":"#909399","font-size":"14px","display":"flex","align-items":"center","justify-content":"center","text-align":"center","gap":"8px","flex-wrap":"wrap"}},[_c('span',[_vm._v(_vm._s(_vm.$t('index.deviceTypeLabel'))+": "+_vm._s(_vm.deviceType)+"  |  "+_vm._s(_vm.$t('index.deviceVersionLabel'))+": v"+_vm._s(_vm.deviceVersion))]),_vm._v(" "),(_vm.deviceType==='D6' || _vm.deviceType==='D9' || _vm.deviceType==='E6')?_c('span',[_vm._v("  |  "+_vm._s(_vm.$t('index.configSeqLabel'))+": "+_vm._s(_vm.e6TimeSeq))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"12px"}},[_c('el-button',{staticStyle:{"width":"300px","height":"60px","font-size":"20px","border-radius":"12px"},attrs:{"type":"primary","loading":_vm.savingV62,"disabled":_vm.sendLabel || _vm.savingV62},on:{"click":function($event){return _vm.sendClick()}}},[_vm._v(_vm._s(_vm.sendText))])],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"30px"}},[_c('el-button',{staticStyle:{"width":"300px","height":"50px","font-size":"18px","border-radius":"12px"},attrs:{"type":"warning","plain":"","icon":"el-icon-switch-button","disabled":_vm.savingV62},on:{"click":function($event){return _vm.conClick()}}},[_vm._v(_vm._s(_vm.$t('index.disconnect')))])],1)],1):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.$t('index.factoryTest'),"visible":_vm.showFactoryTest,"width":"780px","top":"6vh","custom-class":"factory-dialog","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showFactoryTest=$event},"close":_vm.closeFactoryTest}},[_c('div',{staticClass:"factory-toolbar"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-refresh","loading":_vm.factoryReading,"disabled":_vm.savingV62},on:{"click":_vm.readFactoryTest}},[_vm._v(_vm._s(_vm.$t('index.readStatus')))]),_vm._v(" "),_c('el-checkbox',{on:{"change":_vm.factoryAutoChanged},model:{value:(_vm.factoryAuto),callback:function ($$v) {_vm.factoryAuto=$$v},expression:"factoryAuto"}},[_vm._v(_vm._s(_vm.$t('index.autoRefresh')))]),_vm._v(" "),(_vm.factoryError)?_c('span',{staticClass:"factory-error"},[_vm._v(_vm._s(_vm.factoryError))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"factory-led-tip"},[_c('i',{staticClass:"el-icon-warning-outline"}),_vm._v(" "+_vm._s(_vm.$t('index.factoryLedTip')))]),_vm._v(" "),(_vm.factoryAbnormal)?_c('div',{staticClass:"factory-banner fail"},[_vm._v(_vm._s(_vm.$t('index.factoryAbnormal')))]):(_vm.factoryPass)?_c('div',{staticClass:"factory-banner pass"},[_vm._v(_vm._s(_vm.$t('index.factoryPassPrefix'))+_vm._s(_vm.factoryKeyCount)+_vm._s(_vm.$t('index.factoryPassSuffix')))]):_vm._e(),_vm._v(" "),(_vm.factoryData)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.factoryRows,"row-class-name":_vm.factoryRowClass,"cell-style":_vm.factoryCellStyle,"border":"","size":"medium"}},[_c('el-table-column',{attrs:{"prop":"name","label":_vm.$t('index.factoryItem'),"width":"210"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"value","label":_vm.$t('index.factoryValue')}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('index.factoryResult'),"width":"130","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.result==='pass')?_c('span',{staticClass:"factory-result pass"},[_c('i',{staticClass:"el-icon-check"}),_vm._v(" "+_vm._s(_vm.$t('index.factoryPassShort')))]):(scope.row.result==='fail')?_c('span',{staticClass:"factory-result fail"},[_c('i',{staticClass:"el-icon-close"}),_vm._v(" "+_vm._s(_vm.$t('index.factoryFailShort')))]):(scope.row.result==='wait')?_c('span',{staticClass:"factory-result wait"},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$t('index.factoryWait')))]):_c('span',{staticClass:"factory-result info"},[_vm._v("—")])]}}],null,false,1462092576)})],1):_vm._e(),_vm._v(" "),(_vm.factoryRaw)?_c('pre',{staticClass:"factory-raw"},[_vm._v(_vm._s(_vm.factoryRaw))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"factory-note"},[_vm._v(_vm._s(_vm.$t('index.factoryNote')))])],1),_vm._v(" "),_c('el-dialog',{staticClass:"key-test-modal",attrs:{"title":_vm.$t('workspace.test'),"visible":_vm.showKeyTester,"width":"860px","top":"4vh","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showKeyTester=$event}}},[_c('keyboard-tester',{ref:"keyTester",attrs:{"disabled":_vm.savingV62}})],1),_vm._v(" "),_c('el-dialog',{staticClass:"rf24-pair-modal",attrs:{"title":_vm.$t('rf24Pair.title'),"visible":_vm.showRf24Pair,"width":"720px","top":"6vh","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showRf24Pair=$event}}},[_c('rf24-pair',{ref:"rf24Pair"})],1),_vm._v(" "),_c('el-dialog',{staticClass:"video-modal",attrs:{"title":_vm.$t('index.videoTitle'),"visible":_vm.showVideoModal,"width":"800px","top":"5vh","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showVideoModal=$event}}},[_c('div',{staticClass:"video-container"},[_c('video',{staticClass:"video-player",attrs:{"controls":"","autoplay":"","loop":"","muted":"","playsinline":"","webkit-playsinline":"","x5-video-player-type":"h5","x5-video-player-fullscreen":"true"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}}),_vm._v("\n            "+_vm._s(_vm.$t('index.videoUnsupported'))+"\n          ")])])]),_vm._v(" "),_c('el-row',{staticStyle:{"text-align":"center","padding-top":"30px","border-top":"1px solid #ebeef5","font-size":"18px"}},[_c('div',{staticStyle:{"margin-bottom":"8px"}},[_vm._v(_vm._s(_vm.$t('index.keyTestPrompt')))]),_vm._v(" "),_c('div',{staticStyle:{"margin-bottom":"6px"}},[_c('a',{staticStyle:{"color":"#409EFF","font-size":"18px","text-decoration":"none","font-weight":"bold"},attrs:{"href":_vm.$t('index.keyTestUrl'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('index.keyTestLabel')))])]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"color":"#409EFF","font-size":"18px","text-decoration":"none","font-weight":"bold"},attrs:{"href":_vm.$t('index.keyTestUrl2'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('index.keyTestLabel2')))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"6px"}},[_c('a',{staticStyle:{"color":"#67C23A","font-size":"18px","text-decoration":"none","font-weight":"bold"},attrs:{"href":_vm.$t('index.keyTestUrl3'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('index.keyTestLabel3')))])]),_vm._v(" "),_c('div',[_c('a',{staticStyle:{"color":"#67C23A","font-size":"18px","text-decoration":"none","font-weight":"bold"},attrs:{"href":_vm.$t('index.keyTestUrl4'),"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('index.keyTestLabel4')))])])])],1),_vm._v(" "),(_vm.deviceConnecting)?_c('div',{staticClass:"connect-loading-mask"},[_c('div',{staticClass:"connect-loading-box"},[_c('div',{staticClass:"connect-spinner"}),_vm._v(" "),(_vm.serialPortSelected)?[_c('div',{staticClass:"connect-loading-title"},[_vm._v(_vm._s(_vm.$t('index.connecting')))])]:[_c('div',{staticClass:"connect-loading-prompt"},[_vm._v(_vm._s(_vm.$t('index.selectSerialPort')))])]],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-icon"},[_c('i',{staticClass:"el-icon-info"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tester-card",attrs:{"aria-labelledby":"tester-title"}},[_c('div',{staticClass:"test-heading"},[_c('div',[_c('h2',{attrs:{"id":"tester-title"}},[_vm._v(_vm._s(_vm.$t('workspace.test')))]),_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.t('subtitle')))])]),_c('el-tag',{attrs:{"type":_vm.active?'success':'info'}},[_vm._v(_vm._s(_vm.t(_vm.active?'active':_vm.started?'paused':'idle')))])],1),_vm._v(" "),(_vm.dirty)?_c('p',{staticClass:"draft-warning"},[_vm._v(_vm._s(_vm.t('draft')))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"test-toolbar"},[_c('el-button',{attrs:{"type":"primary","disabled":_vm.disabled},on:{"click":_vm.start}},[_vm._v(_vm._s(_vm.t('start')))]),_c('el-button',{attrs:{"disabled":!_vm.active},on:{"click":_vm.stop}},[_vm._v(_vm._s(_vm.t('stop')))]),_c('el-button',{on:{"click":_vm.clear}},[_vm._v(_vm._s(_vm.t('clear')))]),_c('span',[_vm._v(_vm._s(_vm.t('total'))+" "),_c('b',[_vm._v(_vm._s(_vm.state.downs))]),_vm._v(" · "+_vm._s(_vm.t('repeats'))+" "),_c('b',[_vm._v(_vm._s(_vm.state.repeats))]),_vm._v(" · "+_vm._s(_vm.t('mouse'))+" "),_c('b',[_vm._v(_vm._s(_vm.state.mouse))])])],1),_vm._v(" "),_c('div',{ref:"pad",staticClass:"test-pad",class:{active: _vm.active},attrs:{"tabindex":"0","role":"group","aria-label":_vm.$t('workspace.test'),"aria-describedby":"test-scope test-limits"},on:{"focus":_vm.activate,"blur":_vm.pause,"keydown":_vm.onKey,"keyup":_vm.onKey,"mousedown":_vm.onMouse,"mouseup":_vm.onMouse,"wheel":_vm.onMouse,"contextmenu":_vm.onContext,"auxclick":_vm.onContext}},[_c('strong',[_vm._v(_vm._s(_vm.t(_vm.active?'listening':'focus')))]),_c('p',[_vm._v(_vm._s(_vm.t('focusHint')))]),_vm._v(" "),_c('div',{staticClass:"held"},[_c('span',[_vm._v(_vm._s(_vm.t('held'))+":")]),_vm._l((_vm.state.held),function(value,id){return _c('kbd',{key:id},[_vm._v(_vm._s(_vm.heldName(id,value)))])}),(!Object.keys(_vm.state.held).length)?_c('span',[_vm._v(_vm._s(_vm.t('none')))]):_vm._e()],2)]),_vm._v(" "),(_vm.started)?_c('div',{staticClass:"test-output"},[_c('h3',[_vm._v(_vm._s(_vm.t('text')))]),_c('p',{staticClass:"hint"},[_vm._v(_vm._s(_vm.t('textHint')))]),_c('pre',{staticClass:"text-preview",class:{placeholder:!_vm.state.text},domProps:{"textContent":_vm._s(_vm.state.text||_vm.t('textEmpty'))}})]):_vm._e(),_vm._v(" "),(_vm.started)?_c('details',{staticClass:"event-details",attrs:{"open":""}},[_c('summary',[_vm._v(_vm._s(_vm.t('history'))+" ("+_vm._s(_vm.state.events.length)+"/80)")]),_c('div',{staticClass:"event-scroll"},[_c('table',[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.t('time')))]),_c('th',[_vm._v(_vm._s(_vm.t('event')))]),_c('th',[_vm._v(_vm._s(_vm.t('value')))]),_c('th',[_vm._v(_vm._s(_vm.t('code')))])])]),_c('tbody',[_vm._l((_vm.state.events),function(event){return _c('tr',{key:event.id},[_c('td',[_vm._v(_vm._s(event.time))]),_c('td',[_c('span',{class:'event-'+event.kind},[_vm._v(_vm._s(_vm.t(event.kind)))])]),_c('td',[_vm._v(_vm._s(_vm.eventLabel(event)))]),_c('td',[_c('code',[_vm._v(_vm._s(event.code))])])])}),(!_vm.state.events.length)?_c('tr',[_c('td',{attrs:{"colspan":"4"}},[_vm._v(_vm._s(_vm.t('empty')))])]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"hint",attrs:{"id":"test-scope"}},[_vm._v(_vm._s(_vm.t('scope')))]),_c('p',{staticClass:"test-limit",attrs:{"id":"test-limits"}},[_vm._v(_vm._s(_vm.t('limits')))]),_c('p',{staticClass:"hint retention"},[_vm._v(_vm._s(_vm.t('hint')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"key-config-wrapper"},[_c('el-row',{staticClass:"key-header-row"},[_c('label',{staticStyle:{"margin-right":"12px","font-weight":"600","font-size":"15px","color":"#303133","min-width":"52px","display":"inline-block"}},[_vm._v(_vm._s(_vm.labelstr)+":")]),_vm._v(" "),(!_vm.normalOnly)?_c('el-radio-group',{on:{"change":function($event){return _vm.fucChange()}},model:{value:(_vm.keyradio),callback:function ($$v) {_vm.keyradio=$$v},expression:"keyradio"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes1')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":2}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes2')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":3}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes3')))]),_vm._v(" "),_c('el-radio',{attrs:{"label":4}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes4')))]),_vm._v(" "),(_vm.stringshow)?_c('el-radio',{attrs:{"label":5}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes5')))]):_vm._e(),_vm._v(" "),(_vm.mouseoptshow)?[_c('el-radio',{attrs:{"label":6}},[_vm._v(_vm._s(_vm.$t('keyConfig.keyDes6')))])]:_vm._e(),_vm._v(" "),(_vm.scrolloptshow)?_c('el-radio',{attrs:{"label":7}},[_vm._v(_vm._s(_vm.$t('workspace.tester.wheel')))]):_vm._e()],2):_vm._e(),_vm._v(" "),(!_vm.normalOnly)?_c('div',{staticClass:"quick-toggle-col"},[_c('el-button',{staticClass:"quick-toggle-btn",attrs:{"size":"large","type":_vm.quickPanelOpen ? 'warning' : 'primary',"icon":_vm.quickPanelOpen ? 'el-icon-arrow-up' : 'el-icon-lightning'},on:{"click":function($event){_vm.quickPanelOpen = !_vm.quickPanelOpen}}},[_vm._v("\n          "+_vm._s(_vm.$t('keyConfig.quickSetting'))+_vm._s(_vm.quickPanelOpen ? '' : '...')+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"quick-toggle-hint"},[_vm._v(_vm._s(_vm.$t('keyConfig.quickToggleHint')))])],1):_vm._e()],1),_vm._v(" "),_c('el-row',{directives:[{name:"show",rawName:"v-show",value:(_vm.quickPanelOpen),expression:"quickPanelOpen"}],staticClass:"quick-setting-row"},[_c('div',{staticClass:"quick-setting-card"},[_c('div',{staticClass:"qs-header"},[_c('div',{staticClass:"qs-title"},[_c('i',{staticClass:"el-icon-lightning",staticStyle:{"color":"#E6A23C","margin-right":"6px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('keyConfig.quickSetting')))])]),_vm._v(" "),_c('el-input',{staticClass:"qs-search",attrs:{"size":"small","clearable":"","placeholder":_vm.$t('keyConfig.quickSearchPlaceholder'),"prefix-icon":"el-icon-search"},model:{value:(_vm.quickSearch),callback:function ($$v) {_vm.quickSearch=$$v},expression:"quickSearch"}})],1),_vm._v(" "),_c('div',{staticClass:"qs-categories"},_vm._l((_vm.quickCategories),function(cat){return _c('el-button',{key:cat.value,attrs:{"size":"mini","type":_vm.quickCategory === cat.value ? 'primary' : '',"plain":_vm.quickCategory !== cat.value},on:{"click":function($event){_vm.quickCategory = cat.value}}},[_vm._v("\n            "+_vm._s(cat.label)+"\n          ")])}),1),_vm._v(" "),_c('div',{staticClass:"qs-grid"},_vm._l((_vm.filteredQuickList),function(item){return _c('div',{key:item.id,staticClass:"qs-card",class:{ 'qs-card-active': _vm.quickActiveId === item.id },attrs:{"title":item.name + '（' + item.hotkey + '）'},on:{"click":function($event){return _vm.applyQuickSetting(item)}}},[_c('div',{staticClass:"qs-card-name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"qs-card-hotkey"},[_vm._v(_vm._s(item.hotkey))])])}),0),_vm._v(" "),_c('div',{staticClass:"qs-footer-tip"},[_c('i',{staticClass:"el-icon-info",staticStyle:{"color":"#909399","margin-right":"4px"}}),_vm._v("\n          "+_vm._s(_vm.$t('keyConfig.quickTip2'))+"\n        ")])])]),_vm._v(" "),_c('el-row',[(_vm.funcselectshow)?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.funcselectvalue),callback:function ($$v) {_vm.funcselectvalue=$$v},expression:"funcselectvalue"}},_vm._l((_vm.funcoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.mediaselectshow)?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mediaselectvalue),callback:function ($$v) {_vm.mediaselectvalue=$$v},expression:"mediaselectvalue"}},_vm._l((_vm.mediaoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(_vm.mediaselectshow)?_c('div',{staticStyle:{"margin-top":"6px","color":"#E6A23C","font-size":"12px"}},[_c('i',{staticClass:"el-icon-warning",staticStyle:{"margin-right":"4px"}}),_vm._v(_vm._s(_vm.$t('keyConfig.mediaKeyTip'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.input1show)?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.text1),callback:function ($$v) {_vm.text1=$$v},expression:"text1"}}):_vm._e(),_vm._v(" "),(_vm.input1show)?_c('span',{staticStyle:{"margin-left":"8px","font-size":"22px","font-weight":"900","vertical-align":"middle"}},[_c('i',{staticClass:"el-icon-check",style:({color: _vm.isText1Valid ? '#67C23A' : '#C0C4CC'})}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"4px","color":"#909399","font-size":"12px"}},[_vm._v(_vm._s(_vm.$t('keyConfig.normalKeyTip')))])]):_vm._e(),_vm._v(" "),(_vm.input1show)?_c('div',{staticClass:"normal-key-lowercase-hint"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(_vm._s(_vm.$t('keyConfig.normalKeyLowercaseHint'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.input2show)?_c('el-input',{staticStyle:{"width":"350px"},attrs:{"type":"text","maxlength":_vm.stringsize,"show-word-limit":"","clearable":""},model:{value:(_vm.text2),callback:function ($$v) {_vm.text2=$$v},expression:"text2"}}):_vm._e(),_vm._v(" "),(_vm.scrollshow)?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.scrollvalue),callback:function ($$v) {_vm.scrollvalue=$$v},expression:"scrollvalue"}},[_c('el-option',{attrs:{"label":_vm.$t('workspace.tester.upWheel'),"value":0}}),_vm._v(" "),_c('el-option',{attrs:{"label":_vm.$t('workspace.tester.downWheel'),"value":1}})],1):_vm._e(),_vm._v(" "),(_vm.input2show)?_c('el-checkbox',{staticStyle:{"margin-left":"20px"},model:{value:(_vm.stringcheck),callback:function ($$v) {_vm.stringcheck=$$v},expression:"stringcheck"}},[_vm._v(_vm._s(_vm.stringchecktxt))]):_vm._e(),_vm._v(" "),(_vm.mouseshow)?_c('div',[(_vm.mouseselectshow)?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},on:{"change":function($event){return _vm.mousecheckchange()}},model:{value:(_vm.mouseselectvalue),callback:function ($$v) {_vm.mouseselectvalue=$$v},expression:"mouseselectvalue"}},_vm._l((_vm.mouseoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),_c('label',{staticStyle:{"margin-left":"20px"}},[_vm._v(_vm._s(_vm.mouseinputtxt))]),_vm._v(" "),(_vm.mouseinputshow)?_c('el-input-number',{attrs:{"step":1,"min":1,"max":120},model:{value:(_vm.mouseinput),callback:function ($$v) {_vm.mouseinput=$$v},expression:"mouseinput"}}):_vm._e(),_vm._v(" "),(_vm.mousescroolshow)?_c('el-input-number',{attrs:{"step":1,"min":1,"max":5},model:{value:(_vm.mousescrool),callback:function ($$v) {_vm.mousescrool=$$v},expression:"mousescrool"}}):_vm._e(),_vm._v(" "),(_vm.mousecheckshow)?_c('el-checkbox',{staticStyle:{"margin-left":"20px"},on:{"change":function($event){return _vm.mousecheckpress1()}},model:{value:(_vm.mousecheck),callback:function ($$v) {_vm.mousecheck=$$v},expression:"mousecheck"}},[_vm._v(_vm._s(_vm.mousechecktxt))]):_vm._e(),_vm._v(" "),(_vm.mousepresscheckshow)?_c('el-checkbox',{staticStyle:{"margin-left":"20px"},on:{"change":function($event){return _vm.mousecheckpress2()}},model:{value:(_vm.mousepresscheck),callback:function ($$v) {_vm.mousepresscheck=$$v},expression:"mousepresscheck"}},[_vm._v(_vm._s(_vm.mousepresschecktxt))]):_vm._e(),_vm._v(" "),(_vm.mousedoubleshow)?_c('el-checkbox',{staticStyle:{"margin-left":"20px"},on:{"change":function($event){return _vm.mousedoublechange()}},model:{value:(_vm.mousedouble),callback:function ($$v) {_vm.mousedouble=$$v},expression:"mousedouble"}},[_vm._v(_vm._s(_vm.mousedoubletxt))]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.mixshow)?_c('div',[(_vm.mixcountarray[0])?_c('el-row',[(_vm.mixshowarray[0])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mixfuncselectvalue[0]),callback:function ($$v) {_vm.$set(_vm.mixfuncselectvalue, 0, $$v)},expression:"mixfuncselectvalue[0]"}},_vm._l((_vm.mixfuncoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.mixshowarray[0])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.mixtext[0]),callback:function ($$v) {_vm.$set(_vm.mixtext, 0, $$v)},expression:"mixtext[0]"}}):_vm._e(),_vm._v(" "),(_vm.mixcountarray[1])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n    +\n      "),(_vm.mixshowarray[1])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mixfuncselectvalue[1]),callback:function ($$v) {_vm.$set(_vm.mixfuncselectvalue, 1, $$v)},expression:"mixfuncselectvalue[1]"}},_vm._l((_vm.mixfuncoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.mixshowarray[1])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.mixtext[1]),callback:function ($$v) {_vm.$set(_vm.mixtext, 1, $$v)},expression:"mixtext[1]"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mixcountarray[2])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n    +\n    "),(_vm.mixshowarray[2])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mixfuncselectvalue[2]),callback:function ($$v) {_vm.$set(_vm.mixfuncselectvalue, 2, $$v)},expression:"mixfuncselectvalue[2]"}},_vm._l((_vm.mixfuncoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.mixshowarray[2])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.mixtext[2]),callback:function ($$v) {_vm.$set(_vm.mixtext, 2, $$v)},expression:"mixtext[2]"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.mixcountarray[3])?_c('el-row',[_vm._v("\n    +\n    "),(_vm.mixshowarray[3])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mixfuncselectvalue[3]),callback:function ($$v) {_vm.$set(_vm.mixfuncselectvalue, 3, $$v)},expression:"mixfuncselectvalue[3]"}},_vm._l((_vm.mixfuncoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.mixshowarray[3])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.mixtext[3]),callback:function ($$v) {_vm.$set(_vm.mixtext, 3, $$v)},expression:"mixtext[3]"}}):_vm._e(),_vm._v(" "),(_vm.mixcountarray[4])?_c('div',{staticStyle:{"display":"inline-block"}},[_vm._v("\n    +\n    "),(_vm.mixshowarray[4])?_c('el-select',{staticStyle:{"width":"200px"},attrs:{"placeholder":_vm.$t('keyConfig.select')},model:{value:(_vm.mixfuncselectvalue[4]),callback:function ($$v) {_vm.$set(_vm.mixfuncselectvalue, 4, $$v)},expression:"mixfuncselectvalue[4]"}},_vm._l((_vm.mixfuncoptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1):_vm._e(),_vm._v(" "),(!_vm.mixshowarray[4])?_c('el-input',{staticStyle:{"width":"70px"},attrs:{"type":"text","maxlength":"1","show-word-limit":""},model:{value:(_vm.mixtext[4]),callback:function ($$v) {_vm.$set(_vm.mixtext, 4, $$v)},expression:"mixtext[4]"}}):_vm._e()],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('label',{domProps:{"innerHTML":_vm._s(_vm.mixtips)}})]),_vm._v(" "),_c('div',{staticClass:"normal-key-lowercase-hint mix-key-hint"},[_c('i',{staticClass:"el-icon-info"}),_vm._v(_vm._s(_vm.$t('keyConfig.normalKeyLowercaseHint'))+"\n  ")]),_vm._v(" "),_c('el-row',[_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.mixadd(1)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix1')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"success"},on:{"click":function($event){return _vm.mixadd(2)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix2')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.mixdelete()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix3')))]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.mixreset()}}},[_vm._v(_vm._s(_vm.$t('keyConfig.mix4')))]),_vm._v(" "),_c('el-popover',{directives:[{name:"show",rawName:"v-show",value:(_vm.commonshow),expression:"commonshow"}],ref:"popover",attrs:{"placement":"left","width":"630","trigger":"click"}},[_c('div',{staticStyle:{"text-align":"center","font-family":"Helvetica, sans-serif"}},[_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('keyConfig.mixtip')))])]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-bottom":"10px"}},[_c('el-table',{staticStyle:{"width":"120%"},attrs:{"data":_vm.tableData,"height":"600","header-cell-style":{textAlign: 'center'},"cell-style":{textAlign: 'center'}}},[_c('el-table-column',{attrs:{"prop":"keys","label":_vm.$t('keyConfig.mixcommon1'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":_vm.$t('keyConfig.mixcommon2'),"width":"250"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":_vm.$t('keyConfig.mixcommon3'),"width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"type":"success","size":"small"},on:{"click":function($event){return _vm.handleCommonClick(scope.row)}}},[_vm._v(_vm._s(_vm.$t('keyConfig.set')))])]}}],null,false,1267118759)})],1)],1)],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"slot":"reference","type":"info","icon":"el-icon-paperclip"},slot:"reference"},[_vm._v(_vm._s(_vm.$t('keyConfig.mix5')))])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(226);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(43)("3d010924", content, true);

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(227);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(43)("78311b74", content, true);

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(43)("743d40e4", content, true);

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(229);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(43)("491665eb", content, true);

/***/ }),
/* 277 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ })
],[162]);


// WEBPACK FOOTER //
// index.js?6e775876c0ac4f6ec1b2